/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Clovie API
 * Salon management API
 * OpenAPI spec version: 0.0.1
 */
import { useInfiniteQuery, useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type {
  CreateSurveyBody,
  DeleteMarketingBulkEmailIdPhoto200,
  DeleteMarketingBulkSmsId200,
  DeleteMarketingSettingsAdTrackingMetaPixelTestEventCode200,
  GetMarketingAnalyticsBio200,
  GetMarketingAnalyticsBioExportParams,
  GetMarketingAnalyticsBioParams,
  GetMarketingAnalyticsCampaigns200,
  GetMarketingAnalyticsCampaignsExportParams,
  GetMarketingAnalyticsCampaignsIdReport200,
  GetMarketingAnalyticsCampaignsIdReportParams,
  GetMarketingAnalyticsCampaignsParams,
  GetMarketingBulkEmailIdBookings200,
  GetMarketingBulkEmailIdBookingsParams,
  GetMarketingBulkEmailIdRecipients200,
  GetMarketingBulkEmailIdRecipientsParams,
  GetMarketingBulkSms200,
  GetMarketingBulkSmsId200,
  GetMarketingBulkSmsIdPlanQuote200,
  GetMarketingBulkSmsParams,
  GetMarketingCampaignCopyTargets200,
  GetMarketingCampaigns200,
  GetMarketingCampaignsId200,
  GetMarketingCampaignsIdAdSpend200,
  GetMarketingCampaignsIdAdTracking200,
  GetMarketingCampaignsIdAutomation200,
  GetMarketingCampaignsIdAutomationActivity200,
  GetMarketingCampaignsIdGiveaway200,
  GetMarketingCampaignsIdGiveawayLiveDraw200,
  GetMarketingCampaignsIdGiveawayLiveDrawParams,
  GetMarketingCampaignsIdGiveawaySummary200,
  GetMarketingCampaignsIdGiveawayThankYouGiftsPreview200,
  GetMarketingCampaignsIdLanding200,
  GetMarketingCampaignsIdMetaAds200,
  GetMarketingCampaignsIdQr200,
  GetMarketingCampaignsIdQrParams,
  GetMarketingCampaignsIdVoucher200,
  GetMarketingCampaignsIdVoucherPrintKit200,
  GetMarketingCampaignsIdVoucherResults200,
  GetMarketingCampaignsIdVoucherResultsParams,
  GetMarketingCampaignsIdVoucherTextClients200,
  GetMarketingCampaignsParams,
  GetMarketingClientImports200,
  GetMarketingCommentAutomations200,
  GetMarketingCommentAutomationsId200,
  GetMarketingCommentAutomationsIdActivity200,
  GetMarketingCommentAutomationsIdActivityParams,
  GetMarketingCommentAutomationsParams,
  GetMarketingCommentAutomationsPosts200,
  GetMarketingCommentAutomationsPostsParams,
  GetMarketingCommentAutomationsSalonPages200,
  GetMarketingCommentDmAutoReply200,
  GetMarketingGoogleBusinessConnection200,
  GetMarketingGoogleBusinessLocations200,
  GetMarketingGoogleBusinessLocationsLocationIdPreview200,
  GetMarketingGoogleBusinessLocationsParams,
  GetMarketingGoogleBusinessSuggestions200,
  GetMarketingGoogleReviewsSource200,
  GetMarketingLeads200,
  GetMarketingLeadsExportParams,
  GetMarketingLeadsFollowUpCount200,
  GetMarketingLeadsId200,
  GetMarketingLeadsParams,
  GetMarketingLeadsSummary200,
  GetMarketingLeadsSummaryParams,
  GetMarketingMetaAttention200,
  GetMarketingMetaSocialConnection200,
  GetMarketingNewClientOffer200,
  GetMarketingNewClientOfferClaims200,
  GetMarketingNewClientOfferClaimsId200,
  GetMarketingNewClientOfferClaimsParams,
  GetMarketingNewClientOfferOverview200,
  GetMarketingNewClientOfferOverviewParams,
  GetMarketingNewClientOfferPage200,
  GetMarketingNewClientOfferShareQrPngParams,
  GetMarketingOwnerReport200,
  GetMarketingOwnerReportParams,
  GetMarketingOwnerReportShare200,
  GetMarketingQrCodes200,
  GetMarketingQrCodesFor200,
  GetMarketingQrCodesForParams,
  GetMarketingReviewsAttention200,
  GetMarketingReviewsAttentionCount200,
  GetMarketingReviewsQr200,
  GetMarketingReviewsQrParams,
  GetMarketingReviewsReplies200,
  GetMarketingReviewsRepliesParams,
  GetMarketingReviewsReplySettings200,
  GetMarketingReviewsReplyStats200,
  GetMarketingReviewsRequests200,
  GetMarketingReviewsRequestsParams,
  GetMarketingReviewsSummary200,
  GetMarketingReviewsSummaryParams,
  GetMarketingReviewsTechnicians200,
  GetMarketingReviewsTechniciansParams,
  GetMarketingSettingsAdTracking200,
  GetMarketingSettingsAdTrackingEvents200,
  GetMarketingSettingsAdTrackingEventsParams,
  GetMarketingSettingsAdTrackingMetaAds200,
  GetMarketingSettingsAverageTicket200,
  GetMarketingSettingsCompliance200,
  GetMarketingSettingsConsentCopy200,
  GetMarketingSettingsLegalPages200,
  GetMarketingSettingsVisibility200,
  GetMarketingSocialReport200,
  GetMarketingSocialReportParams,
  GetMarketingSocialReportPdfParams,
  GetMarketingSocialReportShare200,
  GetMarketingSurveyTemplates200,
  GetMarketingSurveys200,
  GetMarketingSurveysId200,
  GetMarketingSurveysIdResponses200,
  GetMarketingSurveysIdResponsesParams,
  GetMarketingSurveysIdResults200,
  GetMarketingSurveysIdTextClients200,
  GetMarketingSurveysIdTextSends200,
  GetMarketingTextKeywords200,
  GetMarketingTextKeywordsAvailability200,
  GetMarketingTextKeywordsAvailabilityParams,
  GetMarketingTextKeywordsId200,
  GetMarketingTextKeywordsIdParams,
  GetMarketingTextKeywordsIdPeopleCsvParams,
  GetMarketingTextKeywordsParams,
  GetMarketingWorkspace200,
  PatchMarketingBulkEmailId200,
  PatchMarketingBulkEmailIdBody,
  PatchMarketingBulkSmsId200,
  PatchMarketingBulkSmsIdBody,
  PatchMarketingBulkSmsIdChannel200,
  PatchMarketingBulkSmsIdChannelBody,
  PatchMarketingCampaignsCampaignIdLandingVisibility200,
  PatchMarketingCampaignsCampaignIdLandingVisibilityBody,
  PatchMarketingCampaignsId200,
  PatchMarketingCampaignsIdAdSpendEntryId200,
  PatchMarketingCampaignsIdAdSpendEntryIdBody,
  PatchMarketingCampaignsIdBody,
  PatchMarketingCampaignsIdLandingDraft200,
  PatchMarketingCampaignsIdLandingDraft400,
  PatchMarketingCampaignsIdLandingDraft409,
  PatchMarketingCampaignsIdLandingDraftBody,
  PatchMarketingCommentAutomationsId200,
  PatchMarketingCommentAutomationsIdBody,
  PatchMarketingNewClientOffer200,
  PatchMarketingNewClientOffer400,
  PatchMarketingNewClientOffer409,
  PatchMarketingNewClientOfferBody,
  PatchMarketingQrCodesIdTarget200,
  PatchMarketingQrCodesIdTargetBody,
  PatchMarketingReviewsReplySettings200,
  PatchMarketingReviewsReplySettingsBody,
  PatchMarketingSurveysId200,
  PatchMarketingTextKeywordsId200,
  PostMarketingBulkEmailIdPhoto200,
  PostMarketingBulkEmailIdPhotoBody,
  PostMarketingBulkEmailIdTest200,
  PostMarketingBulkEmailIdWriteWithAi200,
  PostMarketingBulkEmailIdWriteWithAiBody,
  PostMarketingBulkSms201,
  PostMarketingBulkSmsBody,
  PostMarketingBulkSmsIdCancel200,
  PostMarketingBulkSmsIdPause200,
  PostMarketingBulkSmsIdResume200,
  PostMarketingBulkSmsIdSend200,
  PostMarketingBulkSmsIdSendBody,
  PostMarketingCampaigns201,
  PostMarketingCampaignsBody,
  PostMarketingCampaignsIdAdSpend201,
  PostMarketingCampaignsIdAdSpendBody,
  PostMarketingCampaignsIdArchive200,
  PostMarketingCampaignsIdCopyToSalons201,
  PostMarketingCampaignsIdCopyToSalonsBody,
  PostMarketingCampaignsIdDuplicate201,
  PostMarketingCampaignsIdGiveawayDrawsDrawIdAward200,
  PostMarketingCampaignsIdGiveawayDrawsDrawIdVoid200,
  PostMarketingCampaignsIdGiveawayDrawsDrawIdVoidBody,
  PostMarketingCampaignsIdGiveawayPrizesPrizeIdDraws200,
  PostMarketingCampaignsIdGiveawayPrizesPrizeIdDrawsBody,
  PostMarketingCampaignsIdGiveawayThankYouGifts200,
  PostMarketingCampaignsIdGiveawayThankYouGiftsBody,
  PostMarketingCampaignsIdLandingAiBuild200,
  PostMarketingCampaignsIdLandingAiBuild400,
  PostMarketingCampaignsIdLandingAiBuild404,
  PostMarketingCampaignsIdLandingAiBuild409,
  PostMarketingCampaignsIdLandingAiBuild429,
  PostMarketingCampaignsIdLandingAiBuild503,
  PostMarketingCampaignsIdLandingAiBuildBody,
  PostMarketingCampaignsIdLandingRewrite200,
  PostMarketingCampaignsIdLandingRewrite503,
  PostMarketingCampaignsIdLandingRewriteBody,
  PostMarketingCampaignsIdPause200,
  PostMarketingCampaignsIdPublish200,
  PostMarketingCampaignsIdResume200,
  PostMarketingCampaignsIdUnpublish200,
  PostMarketingClientImports201,
  PostMarketingClientImportsBatchIdCompleteBody,
  PostMarketingClientImportsBatchIdRows200,
  PostMarketingClientImportsBatchIdRows400,
  PostMarketingClientImportsBatchIdRows409,
  PostMarketingClientImportsBatchIdRowsBody,
  PostMarketingClientImportsBody,
  PostMarketingCommentAutomations201,
  PostMarketingCommentAutomationsBody,
  PostMarketingCommentAutomationsIdPause200,
  PostMarketingCommentAutomationsIdResume200,
  PostMarketingGoogleBusinessLocationsRefresh202,
  PostMarketingGoogleBusinessOauthComplete200,
  PostMarketingGoogleBusinessOauthCompleteBody,
  PostMarketingGoogleBusinessOauthStart200,
  PostMarketingGoogleBusinessOauthStartParams,
  PostMarketingGoogleReviewsSearch200,
  PostMarketingGoogleReviewsSearchBody,
  PostMarketingGoogleReviewsSourceRefresh200,
  PostMarketingMetaSocialConnect200,
  PostMarketingMetaSocialConnectBody,
  PostMarketingMetaSocialOauthComplete200,
  PostMarketingMetaSocialOauthCompleteBody,
  PostMarketingMetaSocialOauthStart200,
  PostMarketingNewClientOffer201,
  PostMarketingNewClientOffer409,
  PostMarketingNewClientOfferGoLive200,
  PostMarketingNewClientOfferGoLive400,
  PostMarketingNewClientOfferGoLive409,
  PostMarketingNewClientOfferGoLiveBody,
  PostMarketingNewClientOfferPause200,
  PostMarketingNewClientOfferPause409,
  PostMarketingOwnerReportShare200,
  PostMarketingOwnerReportShareReset200,
  PostMarketingReviewsAttentionKindIdResolve200,
  PostMarketingReviewsRepliesReviewIdPost202,
  PostMarketingReviewsRepliesReviewIdPostBody,
  PostMarketingReviewsRepliesReviewIdRewrite200,
  PostMarketingReviewsRepliesReviewIdRewriteBody,
  PostMarketingReviewsRepliesReviewIdSkip200,
  PostMarketingReviewsRepliesSync200,
  PostMarketingSettingsAdTrackingMetaPixelTestEvent200,
  PostMarketingSettingsConsentCopyVersions200,
  PostMarketingSettingsConsentCopyVersions422,
  PostMarketingSettingsConsentCopyVersionsBody,
  PostMarketingSettingsMessagingSync200,
  PostMarketingSocialReportShare200,
  PostMarketingSocialReportShareReset200,
  PostMarketingSurveys201,
  PostMarketingSurveysIdClose200,
  PostMarketingSurveysIdDuplicate201,
  PostMarketingSurveysIdOpen200,
  PostMarketingTextKeywords201,
  PostMarketingTextKeywordsIdStatus200,
  PostMarketingTextKeywordsIdStatusBody,
  PutMarketingCampaignsIdAutomation200,
  PutMarketingCampaignsIdAutomation400,
  PutMarketingCampaignsIdAutomation409,
  PutMarketingCampaignsIdAutomationBody,
  PutMarketingCampaignsIdGiveaway200,
  PutMarketingCampaignsIdGiveawayBody,
  PutMarketingCampaignsIdMetaAdsOverrides200,
  PutMarketingCampaignsIdMetaAdsOverridesBody,
  PutMarketingCampaignsIdVoucher200,
  PutMarketingCampaignsIdVoucherBody,
  PutMarketingCommentDmAutoReply200,
  PutMarketingCommentDmAutoReplyBody,
  PutMarketingGoogleReviewsSource200,
  PutMarketingGoogleReviewsSourceBody,
  PutMarketingNewClientOfferMessages200,
  PutMarketingNewClientOfferMessages400,
  PutMarketingNewClientOfferMessages409,
  PutMarketingNewClientOfferMessagesBody,
  PutMarketingNewClientOfferPage200,
  PutMarketingNewClientOfferPage400,
  PutMarketingNewClientOfferPage409,
  PutMarketingNewClientOfferPageBody,
  PutMarketingOwnerReportNotesMonth200,
  PutMarketingOwnerReportNotesMonthBody,
  PutMarketingReviewsSettings200,
  PutMarketingReviewsSettingsBody,
  PutMarketingSettingsAdTrackingMetaAdsLink200,
  PutMarketingSettingsAdTrackingMetaAdsLinkBody,
  PutMarketingSettingsAdTrackingMetaPixel200,
  PutMarketingSettingsAdTrackingMetaPixelBody,
  PutMarketingSettingsAverageTicket200,
  PutMarketingSettingsAverageTicketBody,
  PutMarketingSettingsBulkSmsBudget200,
  PutMarketingSettingsBulkSmsBudgetBody,
  PutMarketingSettingsLegalPages200,
  PutMarketingSettingsLegalPagesBody,
  PutMarketingSettingsQuietHours200,
  PutMarketingSettingsQuietHoursBody,
  SaveTextKeywordBody,
  UpdateSurveyBody,
  VoucherPrintConflictError,
} from '.././schemas';

import { customInstance } from '../../axios-instance';

/**
 * @summary Marketing workspace facts for the current salon (web address, apex host)
 */
export const getMarketingWorkspace = (signal?: AbortSignal) => {
  return customInstance<GetMarketingWorkspace200>({
    url: `/marketing/workspace`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingWorkspaceInfiniteQueryKey = () => {
  return ['infinite', `/marketing/workspace`] as const;
};

export const getGetMarketingWorkspaceQueryKey = () => {
  return [`/marketing/workspace`] as const;
};

export const getGetMarketingWorkspaceInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingWorkspace>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingWorkspace>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingWorkspaceInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingWorkspace>>> = ({ signal }) =>
    getMarketingWorkspace(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingWorkspace>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingWorkspaceInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingWorkspace>>
>;
export type GetMarketingWorkspaceInfiniteQueryError = unknown;

export function useGetMarketingWorkspaceInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingWorkspace>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingWorkspace>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingWorkspace>>,
          TError,
          Awaited<ReturnType<typeof getMarketingWorkspace>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingWorkspaceInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingWorkspace>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingWorkspace>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingWorkspace>>,
          TError,
          Awaited<ReturnType<typeof getMarketingWorkspace>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingWorkspaceInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingWorkspace>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingWorkspace>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Marketing workspace facts for the current salon (web address, apex host)
 */

export function useGetMarketingWorkspaceInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingWorkspace>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingWorkspace>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingWorkspaceInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingWorkspaceQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingWorkspace>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingWorkspace>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingWorkspaceQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingWorkspace>>> = ({ signal }) =>
    getMarketingWorkspace(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingWorkspace>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingWorkspaceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingWorkspace>>
>;
export type GetMarketingWorkspaceQueryError = unknown;

export function useGetMarketingWorkspace<
  TData = Awaited<ReturnType<typeof getMarketingWorkspace>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingWorkspace>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingWorkspace>>,
          TError,
          Awaited<ReturnType<typeof getMarketingWorkspace>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingWorkspace<
  TData = Awaited<ReturnType<typeof getMarketingWorkspace>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingWorkspace>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingWorkspace>>,
          TError,
          Awaited<ReturnType<typeof getMarketingWorkspace>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingWorkspace<
  TData = Awaited<ReturnType<typeof getMarketingWorkspace>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingWorkspace>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Marketing workspace facts for the current salon (web address, apex host)
 */

export function useGetMarketingWorkspace<
  TData = Awaited<ReturnType<typeof getMarketingWorkspace>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingWorkspace>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingWorkspaceQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingWorkspaceSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingWorkspace>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingWorkspace>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingWorkspaceQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingWorkspace>>> = ({ signal }) =>
    getMarketingWorkspace(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingWorkspace>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingWorkspaceSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingWorkspace>>
>;
export type GetMarketingWorkspaceSuspenseQueryError = unknown;

export function useGetMarketingWorkspaceSuspense<
  TData = Awaited<ReturnType<typeof getMarketingWorkspace>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingWorkspace>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingWorkspaceSuspense<
  TData = Awaited<ReturnType<typeof getMarketingWorkspace>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingWorkspace>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingWorkspaceSuspense<
  TData = Awaited<ReturnType<typeof getMarketingWorkspace>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingWorkspace>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Marketing workspace facts for the current salon (web address, apex host)
 */

export function useGetMarketingWorkspaceSuspense<
  TData = Awaited<ReturnType<typeof getMarketingWorkspace>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingWorkspace>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingWorkspaceSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List campaigns (filter by displayed status, sort, cursor paginated; archived hidden by default)
 */
export const getMarketingCampaigns = (
  params?: GetMarketingCampaignsParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingCampaigns200>({
    url: `/marketing/campaigns`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingCampaignsInfiniteQueryKey = (params?: GetMarketingCampaignsParams) => {
  return ['infinite', `/marketing/campaigns`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingCampaignsQueryKey = (params?: GetMarketingCampaignsParams) => {
  return [`/marketing/campaigns`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingCampaignsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaigns>>>,
  TError = unknown,
>(
  params?: GetMarketingCampaignsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingCampaigns>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaigns>>> = ({ signal }) =>
    getMarketingCampaigns(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaigns>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaigns>>
>;
export type GetMarketingCampaignsInfiniteQueryError = unknown;

export function useGetMarketingCampaignsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaigns>>>,
  TError = unknown,
>(
  params: undefined | GetMarketingCampaignsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingCampaigns>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaigns>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaigns>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaigns>>>,
  TError = unknown,
>(
  params?: GetMarketingCampaignsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingCampaigns>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaigns>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaigns>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaigns>>>,
  TError = unknown,
>(
  params?: GetMarketingCampaignsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingCampaigns>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List campaigns (filter by displayed status, sort, cursor paginated; archived hidden by default)
 */

export function useGetMarketingCampaignsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaigns>>>,
  TError = unknown,
>(
  params?: GetMarketingCampaignsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingCampaigns>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaigns>>,
  TError = unknown,
>(
  params?: GetMarketingCampaignsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaigns>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaigns>>> = ({ signal }) =>
    getMarketingCampaigns(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaigns>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaigns>>
>;
export type GetMarketingCampaignsQueryError = unknown;

export function useGetMarketingCampaigns<
  TData = Awaited<ReturnType<typeof getMarketingCampaigns>>,
  TError = unknown,
>(
  params: undefined | GetMarketingCampaignsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaigns>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaigns>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaigns>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaigns<
  TData = Awaited<ReturnType<typeof getMarketingCampaigns>>,
  TError = unknown,
>(
  params?: GetMarketingCampaignsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaigns>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaigns>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaigns>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaigns<
  TData = Awaited<ReturnType<typeof getMarketingCampaigns>>,
  TError = unknown,
>(
  params?: GetMarketingCampaignsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaigns>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List campaigns (filter by displayed status, sort, cursor paginated; archived hidden by default)
 */

export function useGetMarketingCampaigns<
  TData = Awaited<ReturnType<typeof getMarketingCampaigns>>,
  TError = unknown,
>(
  params?: GetMarketingCampaignsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaigns>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaigns>>,
  TError = unknown,
>(
  params?: GetMarketingCampaignsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaigns>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaigns>>> = ({ signal }) =>
    getMarketingCampaigns(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaigns>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaigns>>
>;
export type GetMarketingCampaignsSuspenseQueryError = unknown;

export function useGetMarketingCampaignsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaigns>>,
  TError = unknown,
>(
  params: undefined | GetMarketingCampaignsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaigns>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaigns>>,
  TError = unknown,
>(
  params?: GetMarketingCampaignsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaigns>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaigns>>,
  TError = unknown,
>(
  params?: GetMarketingCampaignsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaigns>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List campaigns (filter by displayed status, sort, cursor paginated; archived hidden by default)
 */

export function useGetMarketingCampaignsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaigns>>,
  TError = unknown,
>(
  params?: GetMarketingCampaignsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaigns>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a campaign (optionally from a flyer + text page input) and open its hub
 */
export const postMarketingCampaigns = (
  postMarketingCampaignsBody: PostMarketingCampaignsBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingCampaigns201>({
    url: `/marketing/campaigns`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingCampaignsBody,
    signal,
  });
};

export const getPostMarketingCampaignsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingCampaigns>>,
    TError,
    { data: PostMarketingCampaignsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingCampaigns>>,
  TError,
  { data: PostMarketingCampaignsBody },
  TContext
> => {
  const mutationKey = ['postMarketingCampaigns'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingCampaigns>>,
    { data: PostMarketingCampaignsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMarketingCampaigns(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingCampaignsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingCampaigns>>
>;
export type PostMarketingCampaignsMutationBody = PostMarketingCampaignsBody;
export type PostMarketingCampaignsMutationError = unknown;

/**
 * @summary Create a campaign (optionally from a flyer + text page input) and open its hub
 */
export const usePostMarketingCampaigns = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingCampaigns>>,
      TError,
      { data: PostMarketingCampaignsBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingCampaigns>>,
  TError,
  { data: PostMarketingCampaignsBody },
  TContext
> => {
  const mutationOptions = getPostMarketingCampaignsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Campaign detail for the hub (readiness, urls, landing summary)
 */
export const getMarketingCampaignsId = (id: string, signal?: AbortSignal) => {
  return customInstance<GetMarketingCampaignsId200>({
    url: `/marketing/campaigns/${id}`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingCampaignsIdInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/marketing/campaigns/${id}`] as const;
};

export const getGetMarketingCampaignsIdQueryKey = (id?: string) => {
  return [`/marketing/campaigns/${id}`] as const;
};

export const getGetMarketingCampaignsIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsId>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsId>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsId>>> = ({
    signal,
  }) => getMarketingCampaignsId(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsId>>
>;
export type GetMarketingCampaignsIdInfiniteQueryError = unknown;

export function useGetMarketingCampaignsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsId>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsId>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsId>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Campaign detail for the hub (readiness, urls, landing summary)
 */

export function useGetMarketingCampaignsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsId>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsId>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsId>>> = ({
    signal,
  }) => getMarketingCampaignsId(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsId>>
>;
export type GetMarketingCampaignsIdQueryError = unknown;

export function useGetMarketingCampaignsId<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsId>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsId<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsId<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Campaign detail for the hub (readiness, urls, landing summary)
 */

export function useGetMarketingCampaignsId<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsId>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsId>>> = ({
    signal,
  }) => getMarketingCampaignsId(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsId>>
>;
export type GetMarketingCampaignsIdSuspenseQueryError = unknown;

export function useGetMarketingCampaignsIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsId>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Campaign detail for the hub (readiness, urls, landing summary)
 */

export function useGetMarketingCampaignsIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update campaign basics (name, link, note, dates, traffic source)
 */
export const patchMarketingCampaignsId = (
  id: string,
  patchMarketingCampaignsIdBody: PatchMarketingCampaignsIdBody
) => {
  return customInstance<PatchMarketingCampaignsId200>({
    url: `/marketing/campaigns/${id}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchMarketingCampaignsIdBody,
  });
};

export const getPatchMarketingCampaignsIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMarketingCampaignsId>>,
    TError,
    { id: string; data: PatchMarketingCampaignsIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMarketingCampaignsId>>,
  TError,
  { id: string; data: PatchMarketingCampaignsIdBody },
  TContext
> => {
  const mutationKey = ['patchMarketingCampaignsId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMarketingCampaignsId>>,
    { id: string; data: PatchMarketingCampaignsIdBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return patchMarketingCampaignsId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMarketingCampaignsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchMarketingCampaignsId>>
>;
export type PatchMarketingCampaignsIdMutationBody = PatchMarketingCampaignsIdBody;
export type PatchMarketingCampaignsIdMutationError = unknown;

/**
 * @summary Update campaign basics (name, link, note, dates, traffic source)
 */
export const usePatchMarketingCampaignsId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchMarketingCampaignsId>>,
      TError,
      { id: string; data: PatchMarketingCampaignsIdBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchMarketingCampaignsId>>,
  TError,
  { id: string; data: PatchMarketingCampaignsIdBody },
  TContext
> => {
  const mutationOptions = getPatchMarketingCampaignsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Archive the campaign (page offline, read-only)
 */
export const postMarketingCampaignsIdArchive = (id: string, signal?: AbortSignal) => {
  return customInstance<PostMarketingCampaignsIdArchive200>({
    url: `/marketing/campaigns/${id}/archive`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingCampaignsIdArchiveMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingCampaignsIdArchive>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingCampaignsIdArchive>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postMarketingCampaignsIdArchive'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingCampaignsIdArchive>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postMarketingCampaignsIdArchive(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingCampaignsIdArchiveMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingCampaignsIdArchive>>
>;

export type PostMarketingCampaignsIdArchiveMutationError = unknown;

/**
 * @summary Archive the campaign (page offline, read-only)
 */
export const usePostMarketingCampaignsIdArchive = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingCampaignsIdArchive>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingCampaignsIdArchive>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostMarketingCampaignsIdArchiveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Publish the draft landing page (copies draft → live)
 */
export const postMarketingCampaignsIdPublish = (id: string, signal?: AbortSignal) => {
  return customInstance<PostMarketingCampaignsIdPublish200>({
    url: `/marketing/campaigns/${id}/publish`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingCampaignsIdPublishMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingCampaignsIdPublish>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingCampaignsIdPublish>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postMarketingCampaignsIdPublish'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingCampaignsIdPublish>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postMarketingCampaignsIdPublish(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingCampaignsIdPublishMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingCampaignsIdPublish>>
>;

export type PostMarketingCampaignsIdPublishMutationError = unknown;

/**
 * @summary Publish the draft landing page (copies draft → live)
 */
export const usePostMarketingCampaignsIdPublish = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingCampaignsIdPublish>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingCampaignsIdPublish>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostMarketingCampaignsIdPublishMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Pause a live campaign (page stays up, form closed)
 */
export const postMarketingCampaignsIdPause = (id: string, signal?: AbortSignal) => {
  return customInstance<PostMarketingCampaignsIdPause200>({
    url: `/marketing/campaigns/${id}/pause`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingCampaignsIdPauseMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingCampaignsIdPause>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingCampaignsIdPause>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postMarketingCampaignsIdPause'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingCampaignsIdPause>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postMarketingCampaignsIdPause(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingCampaignsIdPauseMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingCampaignsIdPause>>
>;

export type PostMarketingCampaignsIdPauseMutationError = unknown;

/**
 * @summary Pause a live campaign (page stays up, form closed)
 */
export const usePostMarketingCampaignsIdPause = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingCampaignsIdPause>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingCampaignsIdPause>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostMarketingCampaignsIdPauseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Resume a paused campaign
 */
export const postMarketingCampaignsIdResume = (id: string, signal?: AbortSignal) => {
  return customInstance<PostMarketingCampaignsIdResume200>({
    url: `/marketing/campaigns/${id}/resume`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingCampaignsIdResumeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingCampaignsIdResume>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingCampaignsIdResume>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postMarketingCampaignsIdResume'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingCampaignsIdResume>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postMarketingCampaignsIdResume(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingCampaignsIdResumeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingCampaignsIdResume>>
>;

export type PostMarketingCampaignsIdResumeMutationError = unknown;

/**
 * @summary Resume a paused campaign
 */
export const usePostMarketingCampaignsIdResume = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingCampaignsIdResume>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingCampaignsIdResume>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostMarketingCampaignsIdResumeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Take the page offline and return to draft
 */
export const postMarketingCampaignsIdUnpublish = (id: string, signal?: AbortSignal) => {
  return customInstance<PostMarketingCampaignsIdUnpublish200>({
    url: `/marketing/campaigns/${id}/unpublish`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingCampaignsIdUnpublishMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingCampaignsIdUnpublish>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingCampaignsIdUnpublish>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postMarketingCampaignsIdUnpublish'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingCampaignsIdUnpublish>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postMarketingCampaignsIdUnpublish(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingCampaignsIdUnpublishMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingCampaignsIdUnpublish>>
>;

export type PostMarketingCampaignsIdUnpublishMutationError = unknown;

/**
 * @summary Take the page offline and return to draft
 */
export const usePostMarketingCampaignsIdUnpublish = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingCampaignsIdUnpublish>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingCampaignsIdUnpublish>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostMarketingCampaignsIdUnpublishMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Duplicate a campaign as a new draft (page + automations copied; no dates, sign-ups or stats)
 */
export const postMarketingCampaignsIdDuplicate = (id: string, signal?: AbortSignal) => {
  return customInstance<PostMarketingCampaignsIdDuplicate201>({
    url: `/marketing/campaigns/${id}/duplicate`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingCampaignsIdDuplicateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingCampaignsIdDuplicate>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingCampaignsIdDuplicate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postMarketingCampaignsIdDuplicate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingCampaignsIdDuplicate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postMarketingCampaignsIdDuplicate(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingCampaignsIdDuplicateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingCampaignsIdDuplicate>>
>;

export type PostMarketingCampaignsIdDuplicateMutationError = unknown;

/**
 * @summary Duplicate a campaign as a new draft (page + automations copied; no dates, sign-ups or stats)
 */
export const usePostMarketingCampaignsIdDuplicate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingCampaignsIdDuplicate>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingCampaignsIdDuplicate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostMarketingCampaignsIdDuplicateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @deprecated
 * @summary Deprecated (use /marketing/qr-codes/for): flyer QR of a campaign whose page is up (permanent scan link, PNG data URL + printable SVG card); 409 NOT_PUBLISHED otherwise
 */
export const getMarketingCampaignsIdQr = (
  id: string,
  params?: GetMarketingCampaignsIdQrParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingCampaignsIdQr200>({
    url: `/marketing/campaigns/${id}/qr`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingCampaignsIdQrInfiniteQueryKey = (
  id?: string,
  params?: GetMarketingCampaignsIdQrParams
) => {
  return ['infinite', `/marketing/campaigns/${id}/qr`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingCampaignsIdQrQueryKey = (
  id?: string,
  params?: GetMarketingCampaignsIdQrParams
) => {
  return [`/marketing/campaigns/${id}/qr`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingCampaignsIdQrInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>>,
  TError = unknown,
>(
  id: string,
  params?: GetMarketingCampaignsIdQrParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCampaignsIdQrInfiniteQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>> = ({
    signal,
  }) => getMarketingCampaignsIdQr(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdQrInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>
>;
export type GetMarketingCampaignsIdQrInfiniteQueryError = unknown;

export function useGetMarketingCampaignsIdQrInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>>,
  TError = unknown,
>(
  id: string,
  params: undefined | GetMarketingCampaignsIdQrParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdQrInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>>,
  TError = unknown,
>(
  id: string,
  params?: GetMarketingCampaignsIdQrParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdQrInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>>,
  TError = unknown,
>(
  id: string,
  params?: GetMarketingCampaignsIdQrParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @deprecated
 * @summary Deprecated (use /marketing/qr-codes/for): flyer QR of a campaign whose page is up (permanent scan link, PNG data URL + printable SVG card); 409 NOT_PUBLISHED otherwise
 */

export function useGetMarketingCampaignsIdQrInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>>,
  TError = unknown,
>(
  id: string,
  params?: GetMarketingCampaignsIdQrParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdQrInfiniteQueryOptions(id, params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdQrQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>,
  TError = unknown,
>(
  id: string,
  params?: GetMarketingCampaignsIdQrParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdQrQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>> = ({
    signal,
  }) => getMarketingCampaignsIdQr(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdQrQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>
>;
export type GetMarketingCampaignsIdQrQueryError = unknown;

export function useGetMarketingCampaignsIdQr<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>,
  TError = unknown,
>(
  id: string,
  params: undefined | GetMarketingCampaignsIdQrParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdQr<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>,
  TError = unknown,
>(
  id: string,
  params?: GetMarketingCampaignsIdQrParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdQr<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>,
  TError = unknown,
>(
  id: string,
  params?: GetMarketingCampaignsIdQrParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @deprecated
 * @summary Deprecated (use /marketing/qr-codes/for): flyer QR of a campaign whose page is up (permanent scan link, PNG data URL + printable SVG card); 409 NOT_PUBLISHED otherwise
 */

export function useGetMarketingCampaignsIdQr<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>,
  TError = unknown,
>(
  id: string,
  params?: GetMarketingCampaignsIdQrParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdQrQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdQrSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>,
  TError = unknown,
>(
  id: string,
  params?: GetMarketingCampaignsIdQrParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdQrQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>> = ({
    signal,
  }) => getMarketingCampaignsIdQr(id, params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdQrSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>
>;
export type GetMarketingCampaignsIdQrSuspenseQueryError = unknown;

export function useGetMarketingCampaignsIdQrSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>,
  TError = unknown,
>(
  id: string,
  params: undefined | GetMarketingCampaignsIdQrParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdQrSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>,
  TError = unknown,
>(
  id: string,
  params?: GetMarketingCampaignsIdQrParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdQrSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>,
  TError = unknown,
>(
  id: string,
  params?: GetMarketingCampaignsIdQrParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @deprecated
 * @summary Deprecated (use /marketing/qr-codes/for): flyer QR of a campaign whose page is up (permanent scan link, PNG data URL + printable SVG card); 409 NOT_PUBLISHED otherwise
 */

export function useGetMarketingCampaignsIdQrSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>,
  TError = unknown,
>(
  id: string,
  params?: GetMarketingCampaignsIdQrParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdQr>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdQrSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Every flyer QR of the salon (always-ready, live campaigns, handed-out ended campaigns), minting missing codes
 */
export const getMarketingQrCodes = (signal?: AbortSignal) => {
  return customInstance<GetMarketingQrCodes200>({
    url: `/marketing/qr-codes`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingQrCodesInfiniteQueryKey = () => {
  return ['infinite', `/marketing/qr-codes`] as const;
};

export const getGetMarketingQrCodesQueryKey = () => {
  return [`/marketing/qr-codes`] as const;
};

export const getGetMarketingQrCodesInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingQrCodes>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodes>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingQrCodesInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingQrCodes>>> = ({ signal }) =>
    getMarketingQrCodes(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingQrCodes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingQrCodesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingQrCodes>>
>;
export type GetMarketingQrCodesInfiniteQueryError = unknown;

export function useGetMarketingQrCodesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingQrCodes>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodes>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingQrCodes>>,
          TError,
          Awaited<ReturnType<typeof getMarketingQrCodes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingQrCodesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingQrCodes>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodes>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingQrCodes>>,
          TError,
          Awaited<ReturnType<typeof getMarketingQrCodes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingQrCodesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingQrCodes>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodes>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Every flyer QR of the salon (always-ready, live campaigns, handed-out ended campaigns), minting missing codes
 */

export function useGetMarketingQrCodesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingQrCodes>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodes>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingQrCodesInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingQrCodesQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingQrCodes>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodes>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingQrCodesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingQrCodes>>> = ({ signal }) =>
    getMarketingQrCodes(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingQrCodes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingQrCodesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingQrCodes>>
>;
export type GetMarketingQrCodesQueryError = unknown;

export function useGetMarketingQrCodes<
  TData = Awaited<ReturnType<typeof getMarketingQrCodes>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodes>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingQrCodes>>,
          TError,
          Awaited<ReturnType<typeof getMarketingQrCodes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingQrCodes<
  TData = Awaited<ReturnType<typeof getMarketingQrCodes>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodes>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingQrCodes>>,
          TError,
          Awaited<ReturnType<typeof getMarketingQrCodes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingQrCodes<
  TData = Awaited<ReturnType<typeof getMarketingQrCodes>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodes>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Every flyer QR of the salon (always-ready, live campaigns, handed-out ended campaigns), minting missing codes
 */

export function useGetMarketingQrCodes<
  TData = Awaited<ReturnType<typeof getMarketingQrCodes>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodes>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingQrCodesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingQrCodesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingQrCodes>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodes>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingQrCodesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingQrCodes>>> = ({ signal }) =>
    getMarketingQrCodes(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingQrCodes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingQrCodesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingQrCodes>>
>;
export type GetMarketingQrCodesSuspenseQueryError = unknown;

export function useGetMarketingQrCodesSuspense<
  TData = Awaited<ReturnType<typeof getMarketingQrCodes>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodes>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingQrCodesSuspense<
  TData = Awaited<ReturnType<typeof getMarketingQrCodes>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodes>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingQrCodesSuspense<
  TData = Awaited<ReturnType<typeof getMarketingQrCodes>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodes>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Every flyer QR of the salon (always-ready, live campaigns, handed-out ended campaigns), minting missing codes
 */

export function useGetMarketingQrCodesSuspense<
  TData = Awaited<ReturnType<typeof getMarketingQrCodes>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodes>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingQrCodesSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary One destination's permanent QR (minted on first use; a campaign whose page is down only returns its existing code)
 */
export const getMarketingQrCodesFor = (
  params: GetMarketingQrCodesForParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingQrCodesFor200>({
    url: `/marketing/qr-codes/for`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingQrCodesForInfiniteQueryKey = (
  params?: GetMarketingQrCodesForParams
) => {
  return ['infinite', `/marketing/qr-codes/for`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingQrCodesForQueryKey = (params?: GetMarketingQrCodesForParams) => {
  return [`/marketing/qr-codes/for`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingQrCodesForInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingQrCodesFor>>>,
  TError = void,
>(
  params: GetMarketingQrCodesForParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodesFor>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingQrCodesForInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingQrCodesFor>>> = ({ signal }) =>
    getMarketingQrCodesFor(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingQrCodesFor>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingQrCodesForInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingQrCodesFor>>
>;
export type GetMarketingQrCodesForInfiniteQueryError = void;

export function useGetMarketingQrCodesForInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingQrCodesFor>>>,
  TError = void,
>(
  params: GetMarketingQrCodesForParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodesFor>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingQrCodesFor>>,
          TError,
          Awaited<ReturnType<typeof getMarketingQrCodesFor>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingQrCodesForInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingQrCodesFor>>>,
  TError = void,
>(
  params: GetMarketingQrCodesForParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodesFor>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingQrCodesFor>>,
          TError,
          Awaited<ReturnType<typeof getMarketingQrCodesFor>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingQrCodesForInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingQrCodesFor>>>,
  TError = void,
>(
  params: GetMarketingQrCodesForParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodesFor>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary One destination's permanent QR (minted on first use; a campaign whose page is down only returns its existing code)
 */

export function useGetMarketingQrCodesForInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingQrCodesFor>>>,
  TError = void,
>(
  params: GetMarketingQrCodesForParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodesFor>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingQrCodesForInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingQrCodesForQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingQrCodesFor>>,
  TError = void,
>(
  params: GetMarketingQrCodesForParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodesFor>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingQrCodesForQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingQrCodesFor>>> = ({ signal }) =>
    getMarketingQrCodesFor(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingQrCodesFor>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingQrCodesForQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingQrCodesFor>>
>;
export type GetMarketingQrCodesForQueryError = void;

export function useGetMarketingQrCodesFor<
  TData = Awaited<ReturnType<typeof getMarketingQrCodesFor>>,
  TError = void,
>(
  params: GetMarketingQrCodesForParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodesFor>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingQrCodesFor>>,
          TError,
          Awaited<ReturnType<typeof getMarketingQrCodesFor>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingQrCodesFor<
  TData = Awaited<ReturnType<typeof getMarketingQrCodesFor>>,
  TError = void,
>(
  params: GetMarketingQrCodesForParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodesFor>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingQrCodesFor>>,
          TError,
          Awaited<ReturnType<typeof getMarketingQrCodesFor>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingQrCodesFor<
  TData = Awaited<ReturnType<typeof getMarketingQrCodesFor>>,
  TError = void,
>(
  params: GetMarketingQrCodesForParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodesFor>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary One destination's permanent QR (minted on first use; a campaign whose page is down only returns its existing code)
 */

export function useGetMarketingQrCodesFor<
  TData = Awaited<ReturnType<typeof getMarketingQrCodesFor>>,
  TError = void,
>(
  params: GetMarketingQrCodesForParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodesFor>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingQrCodesForQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingQrCodesForSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingQrCodesFor>>,
  TError = void,
>(
  params: GetMarketingQrCodesForParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodesFor>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingQrCodesForQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingQrCodesFor>>> = ({ signal }) =>
    getMarketingQrCodesFor(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingQrCodesFor>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingQrCodesForSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingQrCodesFor>>
>;
export type GetMarketingQrCodesForSuspenseQueryError = void;

export function useGetMarketingQrCodesForSuspense<
  TData = Awaited<ReturnType<typeof getMarketingQrCodesFor>>,
  TError = void,
>(
  params: GetMarketingQrCodesForParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodesFor>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingQrCodesForSuspense<
  TData = Awaited<ReturnType<typeof getMarketingQrCodesFor>>,
  TError = void,
>(
  params: GetMarketingQrCodesForParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodesFor>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingQrCodesForSuspense<
  TData = Awaited<ReturnType<typeof getMarketingQrCodesFor>>,
  TError = void,
>(
  params: GetMarketingQrCodesForParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodesFor>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary One destination's permanent QR (minted on first use; a campaign whose page is down only returns its existing code)
 */

export function useGetMarketingQrCodesForSuspense<
  TData = Awaited<ReturnType<typeof getMarketingQrCodesFor>>,
  TError = void,
>(
  params: GetMarketingQrCodesForParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingQrCodesFor>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingQrCodesForSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Point a campaign QR somewhere else from the next scan on
 */
export const patchMarketingQrCodesIdTarget = (
  id: string,
  patchMarketingQrCodesIdTargetBody: PatchMarketingQrCodesIdTargetBody
) => {
  return customInstance<PatchMarketingQrCodesIdTarget200>({
    url: `/marketing/qr-codes/${id}/target`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchMarketingQrCodesIdTargetBody,
  });
};

export const getPatchMarketingQrCodesIdTargetMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMarketingQrCodesIdTarget>>,
    TError,
    { id: string; data: PatchMarketingQrCodesIdTargetBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMarketingQrCodesIdTarget>>,
  TError,
  { id: string; data: PatchMarketingQrCodesIdTargetBody },
  TContext
> => {
  const mutationKey = ['patchMarketingQrCodesIdTarget'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMarketingQrCodesIdTarget>>,
    { id: string; data: PatchMarketingQrCodesIdTargetBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return patchMarketingQrCodesIdTarget(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMarketingQrCodesIdTargetMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchMarketingQrCodesIdTarget>>
>;
export type PatchMarketingQrCodesIdTargetMutationBody = PatchMarketingQrCodesIdTargetBody;
export type PatchMarketingQrCodesIdTargetMutationError = void;

/**
 * @summary Point a campaign QR somewhere else from the next scan on
 */
export const usePatchMarketingQrCodesIdTarget = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchMarketingQrCodesIdTarget>>,
      TError,
      { id: string; data: PatchMarketingQrCodesIdTargetBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchMarketingQrCodesIdTarget>>,
  TError,
  { id: string; data: PatchMarketingQrCodesIdTargetBody },
  TContext
> => {
  const mutationOptions = getPatchMarketingQrCodesIdTargetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Stamp the first download / copy / print of a code (idempotent)
 */
export const postMarketingQrCodesIdHandedOut = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `/marketing/qr-codes/${id}/handed-out`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingQrCodesIdHandedOutMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingQrCodesIdHandedOut>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingQrCodesIdHandedOut>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postMarketingQrCodesIdHandedOut'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingQrCodesIdHandedOut>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postMarketingQrCodesIdHandedOut(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingQrCodesIdHandedOutMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingQrCodesIdHandedOut>>
>;

export type PostMarketingQrCodesIdHandedOutMutationError = void;

/**
 * @summary Stamp the first download / copy / print of a code (idempotent)
 */
export const usePostMarketingQrCodesIdHandedOut = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingQrCodesIdHandedOut>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingQrCodesIdHandedOut>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostMarketingQrCodesIdHandedOutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Text keywords with numbers for the range (people who texted, and what they did next) + totals + texting number
 */
export const getMarketingTextKeywords = (
  params?: GetMarketingTextKeywordsParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingTextKeywords200>({
    url: `/marketing/text-keywords`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingTextKeywordsInfiniteQueryKey = (
  params?: GetMarketingTextKeywordsParams
) => {
  return ['infinite', `/marketing/text-keywords`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingTextKeywordsQueryKey = (params?: GetMarketingTextKeywordsParams) => {
  return [`/marketing/text-keywords`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingTextKeywordsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingTextKeywords>>>,
  TError = unknown,
>(
  params?: GetMarketingTextKeywordsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywords>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingTextKeywordsInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingTextKeywords>>> = ({
    signal,
  }) => getMarketingTextKeywords(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingTextKeywords>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingTextKeywordsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingTextKeywords>>
>;
export type GetMarketingTextKeywordsInfiniteQueryError = unknown;

export function useGetMarketingTextKeywordsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingTextKeywords>>>,
  TError = unknown,
>(
  params: undefined | GetMarketingTextKeywordsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywords>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingTextKeywords>>,
          TError,
          Awaited<ReturnType<typeof getMarketingTextKeywords>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingTextKeywordsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingTextKeywords>>>,
  TError = unknown,
>(
  params?: GetMarketingTextKeywordsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywords>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingTextKeywords>>,
          TError,
          Awaited<ReturnType<typeof getMarketingTextKeywords>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingTextKeywordsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingTextKeywords>>>,
  TError = unknown,
>(
  params?: GetMarketingTextKeywordsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywords>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Text keywords with numbers for the range (people who texted, and what they did next) + totals + texting number
 */

export function useGetMarketingTextKeywordsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingTextKeywords>>>,
  TError = unknown,
>(
  params?: GetMarketingTextKeywordsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywords>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingTextKeywordsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingTextKeywordsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingTextKeywords>>,
  TError = unknown,
>(
  params?: GetMarketingTextKeywordsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywords>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingTextKeywordsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingTextKeywords>>> = ({
    signal,
  }) => getMarketingTextKeywords(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingTextKeywords>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingTextKeywordsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingTextKeywords>>
>;
export type GetMarketingTextKeywordsQueryError = unknown;

export function useGetMarketingTextKeywords<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywords>>,
  TError = unknown,
>(
  params: undefined | GetMarketingTextKeywordsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywords>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingTextKeywords>>,
          TError,
          Awaited<ReturnType<typeof getMarketingTextKeywords>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingTextKeywords<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywords>>,
  TError = unknown,
>(
  params?: GetMarketingTextKeywordsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywords>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingTextKeywords>>,
          TError,
          Awaited<ReturnType<typeof getMarketingTextKeywords>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingTextKeywords<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywords>>,
  TError = unknown,
>(
  params?: GetMarketingTextKeywordsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywords>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Text keywords with numbers for the range (people who texted, and what they did next) + totals + texting number
 */

export function useGetMarketingTextKeywords<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywords>>,
  TError = unknown,
>(
  params?: GetMarketingTextKeywordsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywords>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingTextKeywordsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingTextKeywordsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingTextKeywords>>,
  TError = unknown,
>(
  params?: GetMarketingTextKeywordsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywords>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingTextKeywordsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingTextKeywords>>> = ({
    signal,
  }) => getMarketingTextKeywords(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingTextKeywords>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingTextKeywordsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingTextKeywords>>
>;
export type GetMarketingTextKeywordsSuspenseQueryError = unknown;

export function useGetMarketingTextKeywordsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywords>>,
  TError = unknown,
>(
  params: undefined | GetMarketingTextKeywordsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywords>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingTextKeywordsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywords>>,
  TError = unknown,
>(
  params?: GetMarketingTextKeywordsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywords>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingTextKeywordsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywords>>,
  TError = unknown,
>(
  params?: GetMarketingTextKeywordsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywords>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Text keywords with numbers for the range (people who texted, and what they did next) + totals + texting number
 */

export function useGetMarketingTextKeywordsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywords>>,
  TError = unknown,
>(
  params?: GetMarketingTextKeywordsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywords>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingTextKeywordsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Add a keyword (on right away): the word and the one page it sends people to
 */
export const postMarketingTextKeywords = (
  saveTextKeywordBody: SaveTextKeywordBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingTextKeywords201>({
    url: `/marketing/text-keywords`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: saveTextKeywordBody,
    signal,
  });
};

export const getPostMarketingTextKeywordsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingTextKeywords>>,
    TError,
    { data: SaveTextKeywordBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingTextKeywords>>,
  TError,
  { data: SaveTextKeywordBody },
  TContext
> => {
  const mutationKey = ['postMarketingTextKeywords'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingTextKeywords>>,
    { data: SaveTextKeywordBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMarketingTextKeywords(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingTextKeywordsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingTextKeywords>>
>;
export type PostMarketingTextKeywordsMutationBody = SaveTextKeywordBody;
export type PostMarketingTextKeywordsMutationError = void;

/**
 * @summary Add a keyword (on right away): the word and the one page it sends people to
 */
export const usePostMarketingTextKeywords = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingTextKeywords>>,
      TError,
      { data: SaveTextKeywordBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingTextKeywords>>,
  TError,
  { data: SaveTextKeywordBody },
  TContext
> => {
  const mutationOptions = getPostMarketingTextKeywordsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Live check for the keyword sheet: free, taken by another keyword, reserved (STOP, HELP…) or invalid
 */
export const getMarketingTextKeywordsAvailability = (
  params: GetMarketingTextKeywordsAvailabilityParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingTextKeywordsAvailability200>({
    url: `/marketing/text-keywords/availability`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingTextKeywordsAvailabilityInfiniteQueryKey = (
  params?: GetMarketingTextKeywordsAvailabilityParams
) => {
  return [
    'infinite',
    `/marketing/text-keywords/availability`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMarketingTextKeywordsAvailabilityQueryKey = (
  params?: GetMarketingTextKeywordsAvailabilityParams
) => {
  return [`/marketing/text-keywords/availability`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingTextKeywordsAvailabilityInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>>,
  TError = unknown,
>(
  params: GetMarketingTextKeywordsAvailabilityParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingTextKeywordsAvailabilityInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>
  > = ({ signal }) => getMarketingTextKeywordsAvailability(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingTextKeywordsAvailabilityInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>
>;
export type GetMarketingTextKeywordsAvailabilityInfiniteQueryError = unknown;

export function useGetMarketingTextKeywordsAvailabilityInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>>,
  TError = unknown,
>(
  params: GetMarketingTextKeywordsAvailabilityParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
          TError,
          Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingTextKeywordsAvailabilityInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>>,
  TError = unknown,
>(
  params: GetMarketingTextKeywordsAvailabilityParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
          TError,
          Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingTextKeywordsAvailabilityInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>>,
  TError = unknown,
>(
  params: GetMarketingTextKeywordsAvailabilityParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Live check for the keyword sheet: free, taken by another keyword, reserved (STOP, HELP…) or invalid
 */

export function useGetMarketingTextKeywordsAvailabilityInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>>,
  TError = unknown,
>(
  params: GetMarketingTextKeywordsAvailabilityParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingTextKeywordsAvailabilityInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingTextKeywordsAvailabilityQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
  TError = unknown,
>(
  params: GetMarketingTextKeywordsAvailabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingTextKeywordsAvailabilityQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>
  > = ({ signal }) => getMarketingTextKeywordsAvailability(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingTextKeywordsAvailabilityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>
>;
export type GetMarketingTextKeywordsAvailabilityQueryError = unknown;

export function useGetMarketingTextKeywordsAvailability<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
  TError = unknown,
>(
  params: GetMarketingTextKeywordsAvailabilityParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
          TError,
          Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingTextKeywordsAvailability<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
  TError = unknown,
>(
  params: GetMarketingTextKeywordsAvailabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
          TError,
          Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingTextKeywordsAvailability<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
  TError = unknown,
>(
  params: GetMarketingTextKeywordsAvailabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Live check for the keyword sheet: free, taken by another keyword, reserved (STOP, HELP…) or invalid
 */

export function useGetMarketingTextKeywordsAvailability<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
  TError = unknown,
>(
  params: GetMarketingTextKeywordsAvailabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingTextKeywordsAvailabilityQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingTextKeywordsAvailabilitySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
  TError = unknown,
>(
  params: GetMarketingTextKeywordsAvailabilityParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingTextKeywordsAvailabilityQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>
  > = ({ signal }) => getMarketingTextKeywordsAvailability(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingTextKeywordsAvailabilitySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>
>;
export type GetMarketingTextKeywordsAvailabilitySuspenseQueryError = unknown;

export function useGetMarketingTextKeywordsAvailabilitySuspense<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
  TError = unknown,
>(
  params: GetMarketingTextKeywordsAvailabilityParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingTextKeywordsAvailabilitySuspense<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
  TError = unknown,
>(
  params: GetMarketingTextKeywordsAvailabilityParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingTextKeywordsAvailabilitySuspense<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
  TError = unknown,
>(
  params: GetMarketingTextKeywordsAvailabilityParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Live check for the keyword sheet: free, taken by another keyword, reserved (STOP, HELP…) or invalid
 */

export function useGetMarketingTextKeywordsAvailabilitySuspense<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
  TError = unknown,
>(
  params: GetMarketingTextKeywordsAvailabilityParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsAvailability>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingTextKeywordsAvailabilitySuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary One keyword: funnel for the range, people who texted (up to 200), video line and reply preview
 */
export const getMarketingTextKeywordsId = (
  id: string,
  params?: GetMarketingTextKeywordsIdParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingTextKeywordsId200>({
    url: `/marketing/text-keywords/${id}`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingTextKeywordsIdInfiniteQueryKey = (
  id?: string,
  params?: GetMarketingTextKeywordsIdParams
) => {
  return ['infinite', `/marketing/text-keywords/${id}`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingTextKeywordsIdQueryKey = (
  id?: string,
  params?: GetMarketingTextKeywordsIdParams
) => {
  return [`/marketing/text-keywords/${id}`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingTextKeywordsIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingTextKeywordsId>>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingTextKeywordsIdParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywordsId>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingTextKeywordsIdInfiniteQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingTextKeywordsId>>> = ({
    signal,
  }) => getMarketingTextKeywordsId(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingTextKeywordsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingTextKeywordsIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingTextKeywordsId>>
>;
export type GetMarketingTextKeywordsIdInfiniteQueryError = void;

export function useGetMarketingTextKeywordsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingTextKeywordsId>>>,
  TError = void,
>(
  id: string,
  params: undefined | GetMarketingTextKeywordsIdParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywordsId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingTextKeywordsId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingTextKeywordsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingTextKeywordsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingTextKeywordsId>>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingTextKeywordsIdParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywordsId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingTextKeywordsId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingTextKeywordsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingTextKeywordsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingTextKeywordsId>>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingTextKeywordsIdParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywordsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary One keyword: funnel for the range, people who texted (up to 200), video line and reply preview
 */

export function useGetMarketingTextKeywordsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingTextKeywordsId>>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingTextKeywordsIdParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywordsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingTextKeywordsIdInfiniteQueryOptions(id, params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingTextKeywordsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsId>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingTextKeywordsIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywordsId>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingTextKeywordsIdQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingTextKeywordsId>>> = ({
    signal,
  }) => getMarketingTextKeywordsId(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingTextKeywordsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingTextKeywordsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingTextKeywordsId>>
>;
export type GetMarketingTextKeywordsIdQueryError = void;

export function useGetMarketingTextKeywordsId<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsId>>,
  TError = void,
>(
  id: string,
  params: undefined | GetMarketingTextKeywordsIdParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywordsId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingTextKeywordsId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingTextKeywordsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingTextKeywordsId<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsId>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingTextKeywordsIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywordsId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingTextKeywordsId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingTextKeywordsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingTextKeywordsId<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsId>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingTextKeywordsIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywordsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary One keyword: funnel for the range, people who texted (up to 200), video line and reply preview
 */

export function useGetMarketingTextKeywordsId<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsId>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingTextKeywordsIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywordsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingTextKeywordsIdQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingTextKeywordsIdSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsId>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingTextKeywordsIdParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywordsId>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingTextKeywordsIdQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingTextKeywordsId>>> = ({
    signal,
  }) => getMarketingTextKeywordsId(id, params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingTextKeywordsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingTextKeywordsIdSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingTextKeywordsId>>
>;
export type GetMarketingTextKeywordsIdSuspenseQueryError = void;

export function useGetMarketingTextKeywordsIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsId>>,
  TError = void,
>(
  id: string,
  params: undefined | GetMarketingTextKeywordsIdParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywordsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingTextKeywordsIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsId>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingTextKeywordsIdParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywordsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingTextKeywordsIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsId>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingTextKeywordsIdParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywordsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary One keyword: funnel for the range, people who texted (up to 200), video line and reply preview
 */

export function useGetMarketingTextKeywordsIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsId>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingTextKeywordsIdParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingTextKeywordsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingTextKeywordsIdSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Edit the word and / or where it sends people (links already texted follow the new page)
 */
export const patchMarketingTextKeywordsId = (
  id: string,
  saveTextKeywordBody: SaveTextKeywordBody
) => {
  return customInstance<PatchMarketingTextKeywordsId200>({
    url: `/marketing/text-keywords/${id}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: saveTextKeywordBody,
  });
};

export const getPatchMarketingTextKeywordsIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMarketingTextKeywordsId>>,
    TError,
    { id: string; data: SaveTextKeywordBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMarketingTextKeywordsId>>,
  TError,
  { id: string; data: SaveTextKeywordBody },
  TContext
> => {
  const mutationKey = ['patchMarketingTextKeywordsId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMarketingTextKeywordsId>>,
    { id: string; data: SaveTextKeywordBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return patchMarketingTextKeywordsId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMarketingTextKeywordsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchMarketingTextKeywordsId>>
>;
export type PatchMarketingTextKeywordsIdMutationBody = SaveTextKeywordBody;
export type PatchMarketingTextKeywordsIdMutationError = void;

/**
 * @summary Edit the word and / or where it sends people (links already texted follow the new page)
 */
export const usePatchMarketingTextKeywordsId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchMarketingTextKeywordsId>>,
      TError,
      { id: string; data: SaveTextKeywordBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchMarketingTextKeywordsId>>,
  TError,
  { id: string; data: SaveTextKeywordBody },
  TContext
> => {
  const mutationOptions = getPatchMarketingTextKeywordsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete a keyword: the word is free again; links already texted keep opening a page
 */
export const deleteMarketingTextKeywordsId = (id: string) => {
  return customInstance<void>({ url: `/marketing/text-keywords/${id}`, method: 'DELETE' });
};

export const getDeleteMarketingTextKeywordsIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMarketingTextKeywordsId>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMarketingTextKeywordsId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteMarketingTextKeywordsId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMarketingTextKeywordsId>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteMarketingTextKeywordsId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMarketingTextKeywordsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMarketingTextKeywordsId>>
>;

export type DeleteMarketingTextKeywordsIdMutationError = void;

/**
 * @summary Delete a keyword: the word is free again; links already texted keep opening a page
 */
export const useDeleteMarketingTextKeywordsId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMarketingTextKeywordsId>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMarketingTextKeywordsId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteMarketingTextKeywordsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary People who texted the keyword in the range (newest 5,000), as CSV; salon admins and agency members
 */
export const getMarketingTextKeywordsIdPeopleCsv = (
  id: string,
  params?: GetMarketingTextKeywordsIdPeopleCsvParams,
  signal?: AbortSignal
) => {
  return customInstance<string>({
    url: `/marketing/text-keywords/${id}/people.csv`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingTextKeywordsIdPeopleCsvInfiniteQueryKey = (
  id?: string,
  params?: GetMarketingTextKeywordsIdPeopleCsvParams
) => {
  return [
    'infinite',
    `/marketing/text-keywords/${id}/people.csv`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMarketingTextKeywordsIdPeopleCsvQueryKey = (
  id?: string,
  params?: GetMarketingTextKeywordsIdPeopleCsvParams
) => {
  return [`/marketing/text-keywords/${id}/people.csv`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingTextKeywordsIdPeopleCsvInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingTextKeywordsIdPeopleCsvParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingTextKeywordsIdPeopleCsvInfiniteQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>> = ({
    signal,
  }) => getMarketingTextKeywordsIdPeopleCsv(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingTextKeywordsIdPeopleCsvInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>
>;
export type GetMarketingTextKeywordsIdPeopleCsvInfiniteQueryError = void;

export function useGetMarketingTextKeywordsIdPeopleCsvInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>>,
  TError = void,
>(
  id: string,
  params: undefined | GetMarketingTextKeywordsIdPeopleCsvParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
          TError,
          Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingTextKeywordsIdPeopleCsvInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingTextKeywordsIdPeopleCsvParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
          TError,
          Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingTextKeywordsIdPeopleCsvInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingTextKeywordsIdPeopleCsvParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary People who texted the keyword in the range (newest 5,000), as CSV; salon admins and agency members
 */

export function useGetMarketingTextKeywordsIdPeopleCsvInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingTextKeywordsIdPeopleCsvParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingTextKeywordsIdPeopleCsvInfiniteQueryOptions(
    id,
    params,
    options
  );

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingTextKeywordsIdPeopleCsvQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingTextKeywordsIdPeopleCsvParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingTextKeywordsIdPeopleCsvQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>> = ({
    signal,
  }) => getMarketingTextKeywordsIdPeopleCsv(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingTextKeywordsIdPeopleCsvQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>
>;
export type GetMarketingTextKeywordsIdPeopleCsvQueryError = void;

export function useGetMarketingTextKeywordsIdPeopleCsv<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
  TError = void,
>(
  id: string,
  params: undefined | GetMarketingTextKeywordsIdPeopleCsvParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
          TError,
          Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingTextKeywordsIdPeopleCsv<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingTextKeywordsIdPeopleCsvParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
          TError,
          Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingTextKeywordsIdPeopleCsv<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingTextKeywordsIdPeopleCsvParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary People who texted the keyword in the range (newest 5,000), as CSV; salon admins and agency members
 */

export function useGetMarketingTextKeywordsIdPeopleCsv<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingTextKeywordsIdPeopleCsvParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingTextKeywordsIdPeopleCsvQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingTextKeywordsIdPeopleCsvSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingTextKeywordsIdPeopleCsvParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingTextKeywordsIdPeopleCsvQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>> = ({
    signal,
  }) => getMarketingTextKeywordsIdPeopleCsv(id, params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingTextKeywordsIdPeopleCsvSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>
>;
export type GetMarketingTextKeywordsIdPeopleCsvSuspenseQueryError = void;

export function useGetMarketingTextKeywordsIdPeopleCsvSuspense<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
  TError = void,
>(
  id: string,
  params: undefined | GetMarketingTextKeywordsIdPeopleCsvParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingTextKeywordsIdPeopleCsvSuspense<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingTextKeywordsIdPeopleCsvParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingTextKeywordsIdPeopleCsvSuspense<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingTextKeywordsIdPeopleCsvParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary People who texted the keyword in the range (newest 5,000), as CSV; salon admins and agency members
 */

export function useGetMarketingTextKeywordsIdPeopleCsvSuspense<
  TData = Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingTextKeywordsIdPeopleCsvParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingTextKeywordsIdPeopleCsv>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingTextKeywordsIdPeopleCsvSuspenseQueryOptions(
    id,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Turn a keyword on or off (idempotent); off = its texts are normal Inbox texts, links keep opening
 */
export const postMarketingTextKeywordsIdStatus = (
  id: string,
  postMarketingTextKeywordsIdStatusBody: PostMarketingTextKeywordsIdStatusBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingTextKeywordsIdStatus200>({
    url: `/marketing/text-keywords/${id}/status`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingTextKeywordsIdStatusBody,
    signal,
  });
};

export const getPostMarketingTextKeywordsIdStatusMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingTextKeywordsIdStatus>>,
    TError,
    { id: string; data: PostMarketingTextKeywordsIdStatusBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingTextKeywordsIdStatus>>,
  TError,
  { id: string; data: PostMarketingTextKeywordsIdStatusBody },
  TContext
> => {
  const mutationKey = ['postMarketingTextKeywordsIdStatus'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingTextKeywordsIdStatus>>,
    { id: string; data: PostMarketingTextKeywordsIdStatusBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return postMarketingTextKeywordsIdStatus(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingTextKeywordsIdStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingTextKeywordsIdStatus>>
>;
export type PostMarketingTextKeywordsIdStatusMutationBody = PostMarketingTextKeywordsIdStatusBody;
export type PostMarketingTextKeywordsIdStatusMutationError = void;

/**
 * @summary Turn a keyword on or off (idempotent); off = its texts are normal Inbox texts, links keep opening
 */
export const usePostMarketingTextKeywordsIdStatus = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingTextKeywordsIdStatus>>,
      TError,
      { id: string; data: PostMarketingTextKeywordsIdStatusBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingTextKeywordsIdStatus>>,
  TError,
  { id: string; data: PostMarketingTextKeywordsIdStatusBody },
  TContext
> => {
  const mutationOptions = getPostMarketingTextKeywordsIdStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Surveys of this salon (newest edit first, deleted ones hidden) with texted / answered counts
 */
export const getMarketingSurveys = (signal?: AbortSignal) => {
  return customInstance<GetMarketingSurveys200>({
    url: `/marketing/surveys`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingSurveysInfiniteQueryKey = () => {
  return ['infinite', `/marketing/surveys`] as const;
};

export const getGetMarketingSurveysQueryKey = () => {
  return [`/marketing/surveys`] as const;
};

export const getGetMarketingSurveysInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveys>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingSurveys>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSurveysInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSurveys>>> = ({ signal }) =>
    getMarketingSurveys(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingSurveys>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSurveysInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSurveys>>
>;
export type GetMarketingSurveysInfiniteQueryError = void;

export function useGetMarketingSurveysInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveys>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingSurveys>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveys>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveys>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveys>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingSurveys>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveys>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveys>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveys>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingSurveys>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Surveys of this salon (newest edit first, deleted ones hidden) with texted / answered counts
 */

export function useGetMarketingSurveysInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveys>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingSurveys>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSurveysInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSurveysQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSurveys>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveys>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSurveysQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSurveys>>> = ({ signal }) =>
    getMarketingSurveys(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSurveys>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSurveysQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSurveys>>
>;
export type GetMarketingSurveysQueryError = void;

export function useGetMarketingSurveys<
  TData = Awaited<ReturnType<typeof getMarketingSurveys>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveys>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveys>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveys>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveys<
  TData = Awaited<ReturnType<typeof getMarketingSurveys>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveys>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveys>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveys>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveys<
  TData = Awaited<ReturnType<typeof getMarketingSurveys>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveys>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Surveys of this salon (newest edit first, deleted ones hidden) with texted / answered counts
 */

export function useGetMarketingSurveys<
  TData = Awaited<ReturnType<typeof getMarketingSurveys>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveys>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSurveysQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSurveysSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSurveys>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveys>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSurveysQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSurveys>>> = ({ signal }) =>
    getMarketingSurveys(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSurveys>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSurveysSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSurveys>>
>;
export type GetMarketingSurveysSuspenseQueryError = void;

export function useGetMarketingSurveysSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveys>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveys>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveys>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveys>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveys>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveys>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Surveys of this salon (newest edit first, deleted ones hidden) with texted / answered counts
 */

export function useGetMarketingSurveysSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveys>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveys>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSurveysSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Start a survey from a template (a DRAFT copy with fresh question ids)
 */
export const postMarketingSurveys = (createSurveyBody: CreateSurveyBody, signal?: AbortSignal) => {
  return customInstance<PostMarketingSurveys201>({
    url: `/marketing/surveys`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createSurveyBody,
    signal,
  });
};

export const getPostMarketingSurveysMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingSurveys>>,
    TError,
    { data: CreateSurveyBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingSurveys>>,
  TError,
  { data: CreateSurveyBody },
  TContext
> => {
  const mutationKey = ['postMarketingSurveys'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingSurveys>>,
    { data: CreateSurveyBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMarketingSurveys(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingSurveysMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingSurveys>>
>;
export type PostMarketingSurveysMutationBody = CreateSurveyBody;
export type PostMarketingSurveysMutationError = void;

/**
 * @summary Start a survey from a template (a DRAFT copy with fresh question ids)
 */
export const usePostMarketingSurveys = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingSurveys>>,
      TError,
      { data: CreateSurveyBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingSurveys>>,
  TError,
  { data: CreateSurveyBody },
  TContext
> => {
  const mutationOptions = getPostMarketingSurveysMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Starting points for a new survey (questions and answer labels)
 */
export const getMarketingSurveyTemplates = (signal?: AbortSignal) => {
  return customInstance<GetMarketingSurveyTemplates200>({
    url: `/marketing/survey-templates`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingSurveyTemplatesInfiniteQueryKey = () => {
  return ['infinite', `/marketing/survey-templates`] as const;
};

export const getGetMarketingSurveyTemplatesQueryKey = () => {
  return [`/marketing/survey-templates`] as const;
};

export const getGetMarketingSurveyTemplatesInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveyTemplates>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingSurveyTemplates>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSurveyTemplatesInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSurveyTemplates>>> = ({
    signal,
  }) => getMarketingSurveyTemplates(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingSurveyTemplates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSurveyTemplatesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSurveyTemplates>>
>;
export type GetMarketingSurveyTemplatesInfiniteQueryError = void;

export function useGetMarketingSurveyTemplatesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveyTemplates>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveyTemplates>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveyTemplates>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveyTemplates>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveyTemplatesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveyTemplates>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveyTemplates>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveyTemplates>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveyTemplates>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveyTemplatesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveyTemplates>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveyTemplates>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Starting points for a new survey (questions and answer labels)
 */

export function useGetMarketingSurveyTemplatesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveyTemplates>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveyTemplates>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSurveyTemplatesInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSurveyTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSurveyTemplates>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveyTemplates>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSurveyTemplatesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSurveyTemplates>>> = ({
    signal,
  }) => getMarketingSurveyTemplates(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSurveyTemplates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSurveyTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSurveyTemplates>>
>;
export type GetMarketingSurveyTemplatesQueryError = void;

export function useGetMarketingSurveyTemplates<
  TData = Awaited<ReturnType<typeof getMarketingSurveyTemplates>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveyTemplates>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveyTemplates>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveyTemplates>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveyTemplates<
  TData = Awaited<ReturnType<typeof getMarketingSurveyTemplates>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveyTemplates>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveyTemplates>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveyTemplates>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveyTemplates<
  TData = Awaited<ReturnType<typeof getMarketingSurveyTemplates>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveyTemplates>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Starting points for a new survey (questions and answer labels)
 */

export function useGetMarketingSurveyTemplates<
  TData = Awaited<ReturnType<typeof getMarketingSurveyTemplates>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveyTemplates>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSurveyTemplatesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSurveyTemplatesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSurveyTemplates>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveyTemplates>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSurveyTemplatesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSurveyTemplates>>> = ({
    signal,
  }) => getMarketingSurveyTemplates(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSurveyTemplates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSurveyTemplatesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSurveyTemplates>>
>;
export type GetMarketingSurveyTemplatesSuspenseQueryError = void;

export function useGetMarketingSurveyTemplatesSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveyTemplates>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveyTemplates>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveyTemplatesSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveyTemplates>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveyTemplates>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveyTemplatesSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveyTemplates>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveyTemplates>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Starting points for a new survey (questions and answer labels)
 */

export function useGetMarketingSurveyTemplatesSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveyTemplates>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveyTemplates>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSurveyTemplatesSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary One survey: wording, questions, status, lock and counts
 */
export const getMarketingSurveysId = (id: string, signal?: AbortSignal) => {
  return customInstance<GetMarketingSurveysId200>({
    url: `/marketing/surveys/${id}`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingSurveysIdInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/marketing/surveys/${id}`] as const;
};

export const getGetMarketingSurveysIdQueryKey = (id?: string) => {
  return [`/marketing/surveys/${id}`] as const;
};

export const getGetMarketingSurveysIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysId>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysId>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSurveysIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSurveysId>>> = ({ signal }) =>
    getMarketingSurveysId(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingSurveysId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSurveysIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSurveysId>>
>;
export type GetMarketingSurveysIdInfiniteQueryError = void;

export function useGetMarketingSurveysIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysId>>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveysId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveysId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysId>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveysId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveysId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysId>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary One survey: wording, questions, status, lock and counts
 */

export function useGetMarketingSurveysIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysId>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSurveysIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSurveysIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSurveysId>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysId>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSurveysIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSurveysId>>> = ({ signal }) =>
    getMarketingSurveysId(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSurveysId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSurveysIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSurveysId>>
>;
export type GetMarketingSurveysIdQueryError = void;

export function useGetMarketingSurveysId<
  TData = Awaited<ReturnType<typeof getMarketingSurveysId>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveysId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveysId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysId<
  TData = Awaited<ReturnType<typeof getMarketingSurveysId>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveysId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveysId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysId<
  TData = Awaited<ReturnType<typeof getMarketingSurveysId>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary One survey: wording, questions, status, lock and counts
 */

export function useGetMarketingSurveysId<
  TData = Awaited<ReturnType<typeof getMarketingSurveysId>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSurveysIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSurveysIdSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSurveysId>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysId>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSurveysIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSurveysId>>> = ({ signal }) =>
    getMarketingSurveysId(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSurveysId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSurveysIdSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSurveysId>>
>;
export type GetMarketingSurveysIdSuspenseQueryError = void;

export function useGetMarketingSurveysIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveysId>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveysId>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveysId>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary One survey: wording, questions, status, lock and counts
 */

export function useGetMarketingSurveysIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveysId>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSurveysIdSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Edit name / heading / intro / thank-you text (always) and questions (only before the first answer)
 */
export const patchMarketingSurveysId = (id: string, updateSurveyBody: UpdateSurveyBody) => {
  return customInstance<PatchMarketingSurveysId200>({
    url: `/marketing/surveys/${id}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateSurveyBody,
  });
};

export const getPatchMarketingSurveysIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMarketingSurveysId>>,
    TError,
    { id: string; data: UpdateSurveyBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMarketingSurveysId>>,
  TError,
  { id: string; data: UpdateSurveyBody },
  TContext
> => {
  const mutationKey = ['patchMarketingSurveysId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMarketingSurveysId>>,
    { id: string; data: UpdateSurveyBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return patchMarketingSurveysId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMarketingSurveysIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchMarketingSurveysId>>
>;
export type PatchMarketingSurveysIdMutationBody = UpdateSurveyBody;
export type PatchMarketingSurveysIdMutationError = void;

/**
 * @summary Edit name / heading / intro / thank-you text (always) and questions (only before the first answer)
 */
export const usePatchMarketingSurveysId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchMarketingSurveysId>>,
      TError,
      { id: string; data: UpdateSurveyBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchMarketingSurveysId>>,
  TError,
  { id: string; data: UpdateSurveyBody },
  TContext
> => {
  const mutationOptions = getPatchMarketingSurveysIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete the survey: hidden from the list and its links stop working; answers and sent texts are kept
 */
export const deleteMarketingSurveysId = (id: string) => {
  return customInstance<void>({ url: `/marketing/surveys/${id}`, method: 'DELETE' });
};

export const getDeleteMarketingSurveysIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMarketingSurveysId>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMarketingSurveysId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteMarketingSurveysId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMarketingSurveysId>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteMarketingSurveysId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMarketingSurveysIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMarketingSurveysId>>
>;

export type DeleteMarketingSurveysIdMutationError = void;

/**
 * @summary Delete the survey: hidden from the list and its links stop working; answers and sent texts are kept
 */
export const useDeleteMarketingSurveysId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMarketingSurveysId>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMarketingSurveysId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteMarketingSurveysIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Open the survey (from a draft or closed): it can be texted and its links take answers. Idempotent
 */
export const postMarketingSurveysIdOpen = (id: string, signal?: AbortSignal) => {
  return customInstance<PostMarketingSurveysIdOpen200>({
    url: `/marketing/surveys/${id}/open`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingSurveysIdOpenMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingSurveysIdOpen>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingSurveysIdOpen>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postMarketingSurveysIdOpen'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingSurveysIdOpen>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postMarketingSurveysIdOpen(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingSurveysIdOpenMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingSurveysIdOpen>>
>;

export type PostMarketingSurveysIdOpenMutationError = void;

/**
 * @summary Open the survey (from a draft or closed): it can be texted and its links take answers. Idempotent
 */
export const usePostMarketingSurveysIdOpen = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingSurveysIdOpen>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingSurveysIdOpen>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostMarketingSurveysIdOpenMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Close an open survey: links say it is closed, results stay. Idempotent
 */
export const postMarketingSurveysIdClose = (id: string, signal?: AbortSignal) => {
  return customInstance<PostMarketingSurveysIdClose200>({
    url: `/marketing/surveys/${id}/close`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingSurveysIdCloseMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingSurveysIdClose>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingSurveysIdClose>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postMarketingSurveysIdClose'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingSurveysIdClose>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postMarketingSurveysIdClose(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingSurveysIdCloseMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingSurveysIdClose>>
>;

export type PostMarketingSurveysIdCloseMutationError = void;

/**
 * @summary Close an open survey: links say it is closed, results stay. Idempotent
 */
export const usePostMarketingSurveysIdClose = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingSurveysIdClose>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingSurveysIdClose>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostMarketingSurveysIdCloseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Copy the survey as a new DRAFT named "… (copy)" with fresh question ids and no answers
 */
export const postMarketingSurveysIdDuplicate = (id: string, signal?: AbortSignal) => {
  return customInstance<PostMarketingSurveysIdDuplicate201>({
    url: `/marketing/surveys/${id}/duplicate`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingSurveysIdDuplicateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingSurveysIdDuplicate>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingSurveysIdDuplicate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postMarketingSurveysIdDuplicate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingSurveysIdDuplicate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postMarketingSurveysIdDuplicate(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingSurveysIdDuplicateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingSurveysIdDuplicate>>
>;

export type PostMarketingSurveysIdDuplicateMutationError = void;

/**
 * @summary Copy the survey as a new DRAFT named "… (copy)" with fresh question ids and no answers
 */
export const usePostMarketingSurveysIdDuplicate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingSurveysIdDuplicate>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingSurveysIdDuplicate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostMarketingSurveysIdDuplicateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary A survey's texts to clients (newest first, at most 10): texts sent and how many of those clients answered
 */
export const getMarketingSurveysIdTextSends = (id: string, signal?: AbortSignal) => {
  return customInstance<GetMarketingSurveysIdTextSends200>({
    url: `/marketing/surveys/${id}/text-sends`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingSurveysIdTextSendsInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/marketing/surveys/${id}/text-sends`] as const;
};

export const getGetMarketingSurveysIdTextSendsQueryKey = (id?: string) => {
  return [`/marketing/surveys/${id}/text-sends`] as const;
};

export const getGetMarketingSurveysIdTextSendsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSurveysIdTextSendsInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>> = ({
    signal,
  }) => getMarketingSurveysIdTextSends(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSurveysIdTextSendsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>
>;
export type GetMarketingSurveysIdTextSendsInfiniteQueryError = void;

export function useGetMarketingSurveysIdTextSendsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdTextSendsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdTextSendsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A survey's texts to clients (newest first, at most 10): texts sent and how many of those clients answered
 */

export function useGetMarketingSurveysIdTextSendsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSurveysIdTextSendsInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSurveysIdTextSendsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSurveysIdTextSendsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>> = ({
    signal,
  }) => getMarketingSurveysIdTextSends(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSurveysIdTextSendsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>
>;
export type GetMarketingSurveysIdTextSendsQueryError = void;

export function useGetMarketingSurveysIdTextSends<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdTextSends<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdTextSends<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A survey's texts to clients (newest first, at most 10): texts sent and how many of those clients answered
 */

export function useGetMarketingSurveysIdTextSends<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSurveysIdTextSendsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSurveysIdTextSendsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSurveysIdTextSendsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>> = ({
    signal,
  }) => getMarketingSurveysIdTextSends(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSurveysIdTextSendsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>
>;
export type GetMarketingSurveysIdTextSendsSuspenseQueryError = void;

export function useGetMarketingSurveysIdTextSendsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdTextSendsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdTextSendsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A survey's texts to clients (newest first, at most 10): texts sent and how many of those clients answered
 */

export function useGetMarketingSurveysIdTextSendsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdTextSends>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSurveysIdTextSendsSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary A survey's "Text it to your clients" panel: groups with counts and the default message
 */
export const getMarketingSurveysIdTextClients = (id: string, signal?: AbortSignal) => {
  return customInstance<GetMarketingSurveysIdTextClients200>({
    url: `/marketing/surveys/${id}/text-clients`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingSurveysIdTextClientsInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/marketing/surveys/${id}/text-clients`] as const;
};

export const getGetMarketingSurveysIdTextClientsQueryKey = (id?: string) => {
  return [`/marketing/surveys/${id}/text-clients`] as const;
};

export const getGetMarketingSurveysIdTextClientsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingSurveysIdTextClientsInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>> = ({
    signal,
  }) => getMarketingSurveysIdTextClients(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSurveysIdTextClientsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>
>;
export type GetMarketingSurveysIdTextClientsInfiniteQueryError = void;

export function useGetMarketingSurveysIdTextClientsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdTextClientsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdTextClientsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A survey's "Text it to your clients" panel: groups with counts and the default message
 */

export function useGetMarketingSurveysIdTextClientsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSurveysIdTextClientsInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSurveysIdTextClientsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSurveysIdTextClientsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>> = ({
    signal,
  }) => getMarketingSurveysIdTextClients(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSurveysIdTextClientsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>
>;
export type GetMarketingSurveysIdTextClientsQueryError = void;

export function useGetMarketingSurveysIdTextClients<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdTextClients<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdTextClients<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A survey's "Text it to your clients" panel: groups with counts and the default message
 */

export function useGetMarketingSurveysIdTextClients<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSurveysIdTextClientsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSurveysIdTextClientsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSurveysIdTextClientsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>> = ({
    signal,
  }) => getMarketingSurveysIdTextClients(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSurveysIdTextClientsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>
>;
export type GetMarketingSurveysIdTextClientsSuspenseQueryError = void;

export function useGetMarketingSurveysIdTextClientsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdTextClientsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdTextClientsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A survey's "Text it to your clients" panel: groups with counts and the default message
 */

export function useGetMarketingSurveysIdTextClientsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdTextClients>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSurveysIdTextClientsSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary A survey's results: sent / answered / response rate and each question's breakdown
 */
export const getMarketingSurveysIdResults = (id: string, signal?: AbortSignal) => {
  return customInstance<GetMarketingSurveysIdResults200>({
    url: `/marketing/surveys/${id}/results`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingSurveysIdResultsInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/marketing/surveys/${id}/results`] as const;
};

export const getGetMarketingSurveysIdResultsQueryKey = (id?: string) => {
  return [`/marketing/surveys/${id}/results`] as const;
};

export const getGetMarketingSurveysIdResultsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysIdResults>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSurveysIdResultsInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSurveysIdResults>>> = ({
    signal,
  }) => getMarketingSurveysIdResults(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSurveysIdResultsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSurveysIdResults>>
>;
export type GetMarketingSurveysIdResultsInfiniteQueryError = void;

export function useGetMarketingSurveysIdResultsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysIdResults>>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveysIdResults>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdResultsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysIdResults>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveysIdResults>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdResultsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysIdResults>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A survey's results: sent / answered / response rate and each question's breakdown
 */

export function useGetMarketingSurveysIdResultsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysIdResults>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSurveysIdResultsInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSurveysIdResultsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysIdResults>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSurveysIdResultsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSurveysIdResults>>> = ({
    signal,
  }) => getMarketingSurveysIdResults(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSurveysIdResultsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSurveysIdResults>>
>;
export type GetMarketingSurveysIdResultsQueryError = void;

export function useGetMarketingSurveysIdResults<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysIdResults>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveysIdResults>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdResults<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysIdResults>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveysIdResults>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdResults<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysIdResults>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A survey's results: sent / answered / response rate and each question's breakdown
 */

export function useGetMarketingSurveysIdResults<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysIdResults>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSurveysIdResultsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSurveysIdResultsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSurveysIdResultsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSurveysIdResults>>> = ({
    signal,
  }) => getMarketingSurveysIdResults(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSurveysIdResultsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSurveysIdResults>>
>;
export type GetMarketingSurveysIdResultsSuspenseQueryError = void;

export function useGetMarketingSurveysIdResultsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdResultsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdResultsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A survey's results: sent / answered / response rate and each question's breakdown
 */

export function useGetMarketingSurveysIdResultsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResults>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSurveysIdResultsSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary A survey's answers, one row per client: newest first, or low scores (≤ 2 stars) first with lowOnly
 */
export const getMarketingSurveysIdResponses = (
  id: string,
  params?: GetMarketingSurveysIdResponsesParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingSurveysIdResponses200>({
    url: `/marketing/surveys/${id}/responses`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingSurveysIdResponsesInfiniteQueryKey = (
  id?: string,
  params?: GetMarketingSurveysIdResponsesParams
) => {
  return ['infinite', `/marketing/surveys/${id}/responses`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingSurveysIdResponsesQueryKey = (
  id?: string,
  params?: GetMarketingSurveysIdResponsesParams
) => {
  return [`/marketing/surveys/${id}/responses`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingSurveysIdResponsesInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingSurveysIdResponsesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingSurveysIdResponsesInfiniteQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>> = ({
    signal,
  }) => getMarketingSurveysIdResponses(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSurveysIdResponsesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>
>;
export type GetMarketingSurveysIdResponsesInfiniteQueryError = void;

export function useGetMarketingSurveysIdResponsesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>>,
  TError = void,
>(
  id: string,
  params: undefined | GetMarketingSurveysIdResponsesParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdResponsesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingSurveysIdResponsesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdResponsesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingSurveysIdResponsesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A survey's answers, one row per client: newest first, or low scores (≤ 2 stars) first with lowOnly
 */

export function useGetMarketingSurveysIdResponsesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingSurveysIdResponsesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSurveysIdResponsesInfiniteQueryOptions(id, params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSurveysIdResponsesQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingSurveysIdResponsesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSurveysIdResponsesQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>> = ({
    signal,
  }) => getMarketingSurveysIdResponses(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSurveysIdResponsesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>
>;
export type GetMarketingSurveysIdResponsesQueryError = void;

export function useGetMarketingSurveysIdResponses<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
  TError = void,
>(
  id: string,
  params: undefined | GetMarketingSurveysIdResponsesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdResponses<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingSurveysIdResponsesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdResponses<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingSurveysIdResponsesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A survey's answers, one row per client: newest first, or low scores (≤ 2 stars) first with lowOnly
 */

export function useGetMarketingSurveysIdResponses<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingSurveysIdResponsesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSurveysIdResponsesQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSurveysIdResponsesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingSurveysIdResponsesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSurveysIdResponsesQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>> = ({
    signal,
  }) => getMarketingSurveysIdResponses(id, params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSurveysIdResponsesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>
>;
export type GetMarketingSurveysIdResponsesSuspenseQueryError = void;

export function useGetMarketingSurveysIdResponsesSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
  TError = void,
>(
  id: string,
  params: undefined | GetMarketingSurveysIdResponsesParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdResponsesSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingSurveysIdResponsesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdResponsesSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingSurveysIdResponsesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A survey's answers, one row per client: newest first, or low scores (≤ 2 stars) first with lowOnly
 */

export function useGetMarketingSurveysIdResponsesSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingSurveysIdResponsesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResponses>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSurveysIdResponsesSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Every answer of a survey as CSV (formula-neutralized); salon admins and agency members only
 */
export const getMarketingSurveysIdResponsesExport = (id: string, signal?: AbortSignal) => {
  return customInstance<string>({
    url: `/marketing/surveys/${id}/responses/export`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingSurveysIdResponsesExportInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/marketing/surveys/${id}/responses/export`] as const;
};

export const getGetMarketingSurveysIdResponsesExportQueryKey = (id?: string) => {
  return [`/marketing/surveys/${id}/responses/export`] as const;
};

export const getGetMarketingSurveysIdResponsesExportInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingSurveysIdResponsesExportInfiniteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>
  > = ({ signal }) => getMarketingSurveysIdResponsesExport(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSurveysIdResponsesExportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>
>;
export type GetMarketingSurveysIdResponsesExportInfiniteQueryError = void;

export function useGetMarketingSurveysIdResponsesExportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdResponsesExportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdResponsesExportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Every answer of a survey as CSV (formula-neutralized); salon admins and agency members only
 */

export function useGetMarketingSurveysIdResponsesExportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSurveysIdResponsesExportInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSurveysIdResponsesExportQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSurveysIdResponsesExportQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>
  > = ({ signal }) => getMarketingSurveysIdResponsesExport(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSurveysIdResponsesExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>
>;
export type GetMarketingSurveysIdResponsesExportQueryError = void;

export function useGetMarketingSurveysIdResponsesExport<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdResponsesExport<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdResponsesExport<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Every answer of a survey as CSV (formula-neutralized); salon admins and agency members only
 */

export function useGetMarketingSurveysIdResponsesExport<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSurveysIdResponsesExportQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSurveysIdResponsesExportSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSurveysIdResponsesExportQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>
  > = ({ signal }) => getMarketingSurveysIdResponsesExport(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSurveysIdResponsesExportSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>
>;
export type GetMarketingSurveysIdResponsesExportSuspenseQueryError = void;

export function useGetMarketingSurveysIdResponsesExportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdResponsesExportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSurveysIdResponsesExportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Every answer of a survey as CSV (formula-neutralized); salon admins and agency members only
 */

export function useGetMarketingSurveysIdResponsesExportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSurveysIdResponsesExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSurveysIdResponsesExportSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Other salons the caller may copy this salon's campaigns into (agency assignments or staff campaign-edit access)
 */
export const getMarketingCampaignCopyTargets = (signal?: AbortSignal) => {
  return customInstance<GetMarketingCampaignCopyTargets200>({
    url: `/marketing/campaign-copy-targets`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingCampaignCopyTargetsInfiniteQueryKey = () => {
  return ['infinite', `/marketing/campaign-copy-targets`] as const;
};

export const getGetMarketingCampaignCopyTargetsQueryKey = () => {
  return [`/marketing/campaign-copy-targets`] as const;
};

export const getGetMarketingCampaignCopyTargetsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignCopyTargetsInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>> = ({
    signal,
  }) => getMarketingCampaignCopyTargets(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignCopyTargetsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>
>;
export type GetMarketingCampaignCopyTargetsInfiniteQueryError = unknown;

export function useGetMarketingCampaignCopyTargetsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignCopyTargetsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignCopyTargetsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Other salons the caller may copy this salon's campaigns into (agency assignments or staff campaign-edit access)
 */

export function useGetMarketingCampaignCopyTargetsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignCopyTargetsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignCopyTargetsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignCopyTargetsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>> = ({
    signal,
  }) => getMarketingCampaignCopyTargets(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignCopyTargetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>
>;
export type GetMarketingCampaignCopyTargetsQueryError = unknown;

export function useGetMarketingCampaignCopyTargets<
  TData = Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignCopyTargets<
  TData = Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignCopyTargets<
  TData = Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Other salons the caller may copy this salon's campaigns into (agency assignments or staff campaign-edit access)
 */

export function useGetMarketingCampaignCopyTargets<
  TData = Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignCopyTargetsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignCopyTargetsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignCopyTargetsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>> = ({
    signal,
  }) => getMarketingCampaignCopyTargets(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignCopyTargetsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>
>;
export type GetMarketingCampaignCopyTargetsSuspenseQueryError = unknown;

export function useGetMarketingCampaignCopyTargetsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignCopyTargetsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignCopyTargetsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Other salons the caller may copy this salon's campaigns into (agency assignments or staff campaign-edit access)
 */

export function useGetMarketingCampaignCopyTargetsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignCopyTargets>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignCopyTargetsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Copy a campaign into other salons as drafts (403 when any target is not manageable; nothing is created then)
 */
export const postMarketingCampaignsIdCopyToSalons = (
  id: string,
  postMarketingCampaignsIdCopyToSalonsBody: PostMarketingCampaignsIdCopyToSalonsBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingCampaignsIdCopyToSalons201>({
    url: `/marketing/campaigns/${id}/copy-to-salons`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingCampaignsIdCopyToSalonsBody,
    signal,
  });
};

export const getPostMarketingCampaignsIdCopyToSalonsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingCampaignsIdCopyToSalons>>,
    TError,
    { id: string; data: PostMarketingCampaignsIdCopyToSalonsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingCampaignsIdCopyToSalons>>,
  TError,
  { id: string; data: PostMarketingCampaignsIdCopyToSalonsBody },
  TContext
> => {
  const mutationKey = ['postMarketingCampaignsIdCopyToSalons'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingCampaignsIdCopyToSalons>>,
    { id: string; data: PostMarketingCampaignsIdCopyToSalonsBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return postMarketingCampaignsIdCopyToSalons(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingCampaignsIdCopyToSalonsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingCampaignsIdCopyToSalons>>
>;
export type PostMarketingCampaignsIdCopyToSalonsMutationBody =
  PostMarketingCampaignsIdCopyToSalonsBody;
export type PostMarketingCampaignsIdCopyToSalonsMutationError = unknown;

/**
 * @summary Copy a campaign into other salons as drafts (403 when any target is not manageable; nothing is created then)
 */
export const usePostMarketingCampaignsIdCopyToSalons = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingCampaignsIdCopyToSalons>>,
      TError,
      { id: string; data: PostMarketingCampaignsIdCopyToSalonsBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingCampaignsIdCopyToSalons>>,
  TError,
  { id: string; data: PostMarketingCampaignsIdCopyToSalonsBody },
  TContext
> => {
  const mutationOptions = getPostMarketingCampaignsIdCopyToSalonsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary The campaign's automation journey (every step × channel; defaults with configured=false when unset) plus the campaign/salon facts the editor warns and previews with
 */
export const getMarketingCampaignsIdAutomation = (id: string, signal?: AbortSignal) => {
  return customInstance<GetMarketingCampaignsIdAutomation200>({
    url: `/marketing/campaigns/${id}/automation`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingCampaignsIdAutomationInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/marketing/campaigns/${id}/automation`] as const;
};

export const getGetMarketingCampaignsIdAutomationQueryKey = (id?: string) => {
  return [`/marketing/campaigns/${id}/automation`] as const;
};

export const getGetMarketingCampaignsIdAutomationInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCampaignsIdAutomationInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>> = ({
    signal,
  }) => getMarketingCampaignsIdAutomation(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdAutomationInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>
>;
export type GetMarketingCampaignsIdAutomationInfiniteQueryError = unknown;

export function useGetMarketingCampaignsIdAutomationInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdAutomationInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdAutomationInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The campaign's automation journey (every step × channel; defaults with configured=false when unset) plus the campaign/salon facts the editor warns and previews with
 */

export function useGetMarketingCampaignsIdAutomationInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdAutomationInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdAutomationQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdAutomationQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>> = ({
    signal,
  }) => getMarketingCampaignsIdAutomation(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdAutomationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>
>;
export type GetMarketingCampaignsIdAutomationQueryError = unknown;

export function useGetMarketingCampaignsIdAutomation<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdAutomation<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdAutomation<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The campaign's automation journey (every step × channel; defaults with configured=false when unset) plus the campaign/salon facts the editor warns and previews with
 */

export function useGetMarketingCampaignsIdAutomation<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdAutomationQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdAutomationSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdAutomationQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>> = ({
    signal,
  }) => getMarketingCampaignsIdAutomation(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdAutomationSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>
>;
export type GetMarketingCampaignsIdAutomationSuspenseQueryError = unknown;

export function useGetMarketingCampaignsIdAutomationSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdAutomationSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdAutomationSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The campaign's automation journey (every step × channel; defaults with configured=false when unset) plus the campaign/salon facts the editor warns and previews with
 */

export function useGetMarketingCampaignsIdAutomationSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAutomation>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdAutomationSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Save the campaign automation journey (edits overlay the stored journey; omitted fields keep their value). 400 when an enabled message cannot send as written (see the 400 reasons). 409 PENDING_CHANGE_REQUIRES_CONFIRM when a timing change or disabled step would touch queued sends without confirm; 409 AUTOMATION_CHANGED when another save landed first.
 */
export const putMarketingCampaignsIdAutomation = (
  id: string,
  putMarketingCampaignsIdAutomationBody: PutMarketingCampaignsIdAutomationBody
) => {
  return customInstance<PutMarketingCampaignsIdAutomation200>({
    url: `/marketing/campaigns/${id}/automation`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putMarketingCampaignsIdAutomationBody,
  });
};

export const getPutMarketingCampaignsIdAutomationMutationOptions = <
  TError = PutMarketingCampaignsIdAutomation400 | PutMarketingCampaignsIdAutomation409,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMarketingCampaignsIdAutomation>>,
    TError,
    { id: string; data: PutMarketingCampaignsIdAutomationBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMarketingCampaignsIdAutomation>>,
  TError,
  { id: string; data: PutMarketingCampaignsIdAutomationBody },
  TContext
> => {
  const mutationKey = ['putMarketingCampaignsIdAutomation'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMarketingCampaignsIdAutomation>>,
    { id: string; data: PutMarketingCampaignsIdAutomationBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return putMarketingCampaignsIdAutomation(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMarketingCampaignsIdAutomationMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMarketingCampaignsIdAutomation>>
>;
export type PutMarketingCampaignsIdAutomationMutationBody = PutMarketingCampaignsIdAutomationBody;
export type PutMarketingCampaignsIdAutomationMutationError =
  | PutMarketingCampaignsIdAutomation400
  | PutMarketingCampaignsIdAutomation409;

/**
 * @summary Save the campaign automation journey (edits overlay the stored journey; omitted fields keep their value). 400 when an enabled message cannot send as written (see the 400 reasons). 409 PENDING_CHANGE_REQUIRES_CONFIRM when a timing change or disabled step would touch queued sends without confirm; 409 AUTOMATION_CHANGED when another save landed first.
 */
export const usePutMarketingCampaignsIdAutomation = <
  TError = PutMarketingCampaignsIdAutomation400 | PutMarketingCampaignsIdAutomation409,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putMarketingCampaignsIdAutomation>>,
      TError,
      { id: string; data: PutMarketingCampaignsIdAutomationBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putMarketingCampaignsIdAutomation>>,
  TError,
  { id: string; data: PutMarketingCampaignsIdAutomationBody },
  TContext
> => {
  const mutationOptions = getPutMarketingCampaignsIdAutomationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Per step × channel send counts (sent / queued / failed / skipped) and top reasons — counts only
 */
export const getMarketingCampaignsIdAutomationActivity = (id: string, signal?: AbortSignal) => {
  return customInstance<GetMarketingCampaignsIdAutomationActivity200>({
    url: `/marketing/campaigns/${id}/automation/activity`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingCampaignsIdAutomationActivityInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/marketing/campaigns/${id}/automation/activity`] as const;
};

export const getGetMarketingCampaignsIdAutomationActivityQueryKey = (id?: string) => {
  return [`/marketing/campaigns/${id}/automation/activity`] as const;
};

export const getGetMarketingCampaignsIdAutomationActivityInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCampaignsIdAutomationActivityInfiniteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>
  > = ({ signal }) => getMarketingCampaignsIdAutomationActivity(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdAutomationActivityInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>
>;
export type GetMarketingCampaignsIdAutomationActivityInfiniteQueryError = unknown;

export function useGetMarketingCampaignsIdAutomationActivityInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdAutomationActivityInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdAutomationActivityInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Per step × channel send counts (sent / queued / failed / skipped) and top reasons — counts only
 */

export function useGetMarketingCampaignsIdAutomationActivityInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdAutomationActivityInfiniteQueryOptions(
    id,
    options
  );

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdAutomationActivityQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCampaignsIdAutomationActivityQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>
  > = ({ signal }) => getMarketingCampaignsIdAutomationActivity(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdAutomationActivityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>
>;
export type GetMarketingCampaignsIdAutomationActivityQueryError = unknown;

export function useGetMarketingCampaignsIdAutomationActivity<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdAutomationActivity<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdAutomationActivity<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Per step × channel send counts (sent / queued / failed / skipped) and top reasons — counts only
 */

export function useGetMarketingCampaignsIdAutomationActivity<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdAutomationActivityQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdAutomationActivitySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCampaignsIdAutomationActivityQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>
  > = ({ signal }) => getMarketingCampaignsIdAutomationActivity(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdAutomationActivitySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>
>;
export type GetMarketingCampaignsIdAutomationActivitySuspenseQueryError = unknown;

export function useGetMarketingCampaignsIdAutomationActivitySuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdAutomationActivitySuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdAutomationActivitySuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Per step × channel send counts (sent / queued / failed / skipped) and top reasons — counts only
 */

export function useGetMarketingCampaignsIdAutomationActivitySuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAutomationActivity>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdAutomationActivitySuspenseQueryOptions(
    id,
    options
  );

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary A voucher campaign's voucher setup, which fields are locked and how many vouchers were given
 */
export const getMarketingCampaignsIdVoucher = (id: string, signal?: AbortSignal) => {
  return customInstance<GetMarketingCampaignsIdVoucher200>({
    url: `/marketing/campaigns/${id}/voucher`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingCampaignsIdVoucherInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/marketing/campaigns/${id}/voucher`] as const;
};

export const getGetMarketingCampaignsIdVoucherQueryKey = (id?: string) => {
  return [`/marketing/campaigns/${id}/voucher`] as const;
};

export const getGetMarketingCampaignsIdVoucherInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdVoucherInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>> = ({
    signal,
  }) => getMarketingCampaignsIdVoucher(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdVoucherInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>
>;
export type GetMarketingCampaignsIdVoucherInfiniteQueryError = void;

export function useGetMarketingCampaignsIdVoucherInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A voucher campaign's voucher setup, which fields are locked and how many vouchers were given
 */

export function useGetMarketingCampaignsIdVoucherInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdVoucherInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdVoucherQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdVoucherQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>> = ({
    signal,
  }) => getMarketingCampaignsIdVoucher(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdVoucherQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>
>;
export type GetMarketingCampaignsIdVoucherQueryError = void;

export function useGetMarketingCampaignsIdVoucher<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucher<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucher<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A voucher campaign's voucher setup, which fields are locked and how many vouchers were given
 */

export function useGetMarketingCampaignsIdVoucher<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdVoucherQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdVoucherSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdVoucherQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>> = ({
    signal,
  }) => getMarketingCampaignsIdVoucher(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdVoucherSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>
>;
export type GetMarketingCampaignsIdVoucherSuspenseQueryError = void;

export function useGetMarketingCampaignsIdVoucherSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A voucher campaign's voucher setup, which fields are locked and how many vouchers were given
 */

export function useGetMarketingCampaignsIdVoucherSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucher>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdVoucherSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Save the whole voucher setup. After the first publish the offer is locked and the quantity limit may only go up
 */
export const putMarketingCampaignsIdVoucher = (
  id: string,
  putMarketingCampaignsIdVoucherBody: PutMarketingCampaignsIdVoucherBody
) => {
  return customInstance<PutMarketingCampaignsIdVoucher200>({
    url: `/marketing/campaigns/${id}/voucher`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putMarketingCampaignsIdVoucherBody,
  });
};

export const getPutMarketingCampaignsIdVoucherMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMarketingCampaignsIdVoucher>>,
    TError,
    { id: string; data: PutMarketingCampaignsIdVoucherBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMarketingCampaignsIdVoucher>>,
  TError,
  { id: string; data: PutMarketingCampaignsIdVoucherBody },
  TContext
> => {
  const mutationKey = ['putMarketingCampaignsIdVoucher'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMarketingCampaignsIdVoucher>>,
    { id: string; data: PutMarketingCampaignsIdVoucherBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return putMarketingCampaignsIdVoucher(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMarketingCampaignsIdVoucherMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMarketingCampaignsIdVoucher>>
>;
export type PutMarketingCampaignsIdVoucherMutationBody = PutMarketingCampaignsIdVoucherBody;
export type PutMarketingCampaignsIdVoucherMutationError = void;

/**
 * @summary Save the whole voucher setup. After the first publish the offer is locked and the quantity limit may only go up
 */
export const usePutMarketingCampaignsIdVoucher = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putMarketingCampaignsIdVoucher>>,
      TError,
      { id: string; data: PutMarketingCampaignsIdVoucherBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putMarketingCampaignsIdVoucher>>,
  TError,
  { id: string; data: PutMarketingCampaignsIdVoucherBody },
  TContext
> => {
  const mutationOptions = getPutMarketingCampaignsIdVoucherMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary A voucher's printed QR (link, display address, module path) and how printed vouchers are doing
 */
export const getMarketingCampaignsIdVoucherPrintKit = (id: string, signal?: AbortSignal) => {
  return customInstance<GetMarketingCampaignsIdVoucherPrintKit200>({
    url: `/marketing/campaigns/${id}/voucher/print-kit`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingCampaignsIdVoucherPrintKitInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/marketing/campaigns/${id}/voucher/print-kit`] as const;
};

export const getGetMarketingCampaignsIdVoucherPrintKitQueryKey = (id?: string) => {
  return [`/marketing/campaigns/${id}/voucher/print-kit`] as const;
};

export const getGetMarketingCampaignsIdVoucherPrintKitInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCampaignsIdVoucherPrintKitInfiniteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>
  > = ({ signal }) => getMarketingCampaignsIdVoucherPrintKit(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdVoucherPrintKitInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>
>;
export type GetMarketingCampaignsIdVoucherPrintKitInfiniteQueryError =
  void | VoucherPrintConflictError;

export function useGetMarketingCampaignsIdVoucherPrintKitInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherPrintKitInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherPrintKitInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A voucher's printed QR (link, display address, module path) and how printed vouchers are doing
 */

export function useGetMarketingCampaignsIdVoucherPrintKitInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdVoucherPrintKitInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdVoucherPrintKitQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdVoucherPrintKitQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>
  > = ({ signal }) => getMarketingCampaignsIdVoucherPrintKit(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdVoucherPrintKitQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>
>;
export type GetMarketingCampaignsIdVoucherPrintKitQueryError = void | VoucherPrintConflictError;

export function useGetMarketingCampaignsIdVoucherPrintKit<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherPrintKit<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherPrintKit<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A voucher's printed QR (link, display address, module path) and how printed vouchers are doing
 */

export function useGetMarketingCampaignsIdVoucherPrintKit<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdVoucherPrintKitQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdVoucherPrintKitSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdVoucherPrintKitQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>
  > = ({ signal }) => getMarketingCampaignsIdVoucherPrintKit(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdVoucherPrintKitSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>
>;
export type GetMarketingCampaignsIdVoucherPrintKitSuspenseQueryError =
  void | VoucherPrintConflictError;

export function useGetMarketingCampaignsIdVoucherPrintKitSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherPrintKitSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherPrintKitSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A voucher's printed QR (link, display address, module path) and how printed vouchers are doing
 */

export function useGetMarketingCampaignsIdVoucherPrintKitSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintKit>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdVoucherPrintKitSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Download the ready-to-print voucher sheet (US Letter, 3 per page, fronts then backs)
 */
export const getMarketingCampaignsIdVoucherPrintSheetPdf = (id: string, signal?: AbortSignal) => {
  return customInstance<Blob>({
    url: `/marketing/campaigns/${id}/voucher/print-sheet.pdf`,
    method: 'GET',
    responseType: 'blob',
    signal,
  });
};

export const getGetMarketingCampaignsIdVoucherPrintSheetPdfInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/marketing/campaigns/${id}/voucher/print-sheet.pdf`] as const;
};

export const getGetMarketingCampaignsIdVoucherPrintSheetPdfQueryKey = (id?: string) => {
  return [`/marketing/campaigns/${id}/voucher/print-sheet.pdf`] as const;
};

export const getGetMarketingCampaignsIdVoucherPrintSheetPdfInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCampaignsIdVoucherPrintSheetPdfInfiniteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>
  > = ({ signal }) => getMarketingCampaignsIdVoucherPrintSheetPdf(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdVoucherPrintSheetPdfInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>
>;
export type GetMarketingCampaignsIdVoucherPrintSheetPdfInfiniteQueryError =
  void | VoucherPrintConflictError;

export function useGetMarketingCampaignsIdVoucherPrintSheetPdfInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherPrintSheetPdfInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherPrintSheetPdfInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Download the ready-to-print voucher sheet (US Letter, 3 per page, fronts then backs)
 */

export function useGetMarketingCampaignsIdVoucherPrintSheetPdfInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdVoucherPrintSheetPdfInfiniteQueryOptions(
    id,
    options
  );

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdVoucherPrintSheetPdfQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCampaignsIdVoucherPrintSheetPdfQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>
  > = ({ signal }) => getMarketingCampaignsIdVoucherPrintSheetPdf(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdVoucherPrintSheetPdfQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>
>;
export type GetMarketingCampaignsIdVoucherPrintSheetPdfQueryError =
  void | VoucherPrintConflictError;

export function useGetMarketingCampaignsIdVoucherPrintSheetPdf<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherPrintSheetPdf<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherPrintSheetPdf<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Download the ready-to-print voucher sheet (US Letter, 3 per page, fronts then backs)
 */

export function useGetMarketingCampaignsIdVoucherPrintSheetPdf<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdVoucherPrintSheetPdfQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdVoucherPrintSheetPdfSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCampaignsIdVoucherPrintSheetPdfQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>
  > = ({ signal }) => getMarketingCampaignsIdVoucherPrintSheetPdf(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdVoucherPrintSheetPdfSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>
>;
export type GetMarketingCampaignsIdVoucherPrintSheetPdfSuspenseQueryError =
  void | VoucherPrintConflictError;

export function useGetMarketingCampaignsIdVoucherPrintSheetPdfSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherPrintSheetPdfSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherPrintSheetPdfSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Download the ready-to-print voucher sheet (US Letter, 3 per page, fronts then backs)
 */

export function useGetMarketingCampaignsIdVoucherPrintSheetPdfSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
  TError = void | VoucherPrintConflictError,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherPrintSheetPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdVoucherPrintSheetPdfSuspenseQueryOptions(
    id,
    options
  );

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary A voucher campaign's results: got, came in, new guests, by source, ad cost, money and the newest people
 */
export const getMarketingCampaignsIdVoucherResults = (
  id: string,
  params?: GetMarketingCampaignsIdVoucherResultsParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingCampaignsIdVoucherResults200>({
    url: `/marketing/campaigns/${id}/voucher/results`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingCampaignsIdVoucherResultsInfiniteQueryKey = (
  id?: string,
  params?: GetMarketingCampaignsIdVoucherResultsParams
) => {
  return [
    'infinite',
    `/marketing/campaigns/${id}/voucher/results`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMarketingCampaignsIdVoucherResultsQueryKey = (
  id?: string,
  params?: GetMarketingCampaignsIdVoucherResultsParams
) => {
  return [`/marketing/campaigns/${id}/voucher/results`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingCampaignsIdVoucherResultsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingCampaignsIdVoucherResultsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCampaignsIdVoucherResultsInfiniteQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>
  > = ({ signal }) => getMarketingCampaignsIdVoucherResults(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdVoucherResultsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>
>;
export type GetMarketingCampaignsIdVoucherResultsInfiniteQueryError = void;

export function useGetMarketingCampaignsIdVoucherResultsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>>,
  TError = void,
>(
  id: string,
  params: undefined | GetMarketingCampaignsIdVoucherResultsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherResultsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingCampaignsIdVoucherResultsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherResultsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingCampaignsIdVoucherResultsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A voucher campaign's results: got, came in, new guests, by source, ad cost, money and the newest people
 */

export function useGetMarketingCampaignsIdVoucherResultsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingCampaignsIdVoucherResultsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdVoucherResultsInfiniteQueryOptions(
    id,
    params,
    options
  );

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdVoucherResultsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingCampaignsIdVoucherResultsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCampaignsIdVoucherResultsQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>
  > = ({ signal }) => getMarketingCampaignsIdVoucherResults(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdVoucherResultsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>
>;
export type GetMarketingCampaignsIdVoucherResultsQueryError = void;

export function useGetMarketingCampaignsIdVoucherResults<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
  TError = void,
>(
  id: string,
  params: undefined | GetMarketingCampaignsIdVoucherResultsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherResults<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingCampaignsIdVoucherResultsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherResults<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingCampaignsIdVoucherResultsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A voucher campaign's results: got, came in, new guests, by source, ad cost, money and the newest people
 */

export function useGetMarketingCampaignsIdVoucherResults<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingCampaignsIdVoucherResultsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdVoucherResultsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdVoucherResultsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingCampaignsIdVoucherResultsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCampaignsIdVoucherResultsQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>
  > = ({ signal }) => getMarketingCampaignsIdVoucherResults(id, params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdVoucherResultsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>
>;
export type GetMarketingCampaignsIdVoucherResultsSuspenseQueryError = void;

export function useGetMarketingCampaignsIdVoucherResultsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
  TError = void,
>(
  id: string,
  params: undefined | GetMarketingCampaignsIdVoucherResultsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherResultsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingCampaignsIdVoucherResultsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherResultsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingCampaignsIdVoucherResultsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A voucher campaign's results: got, came in, new guests, by source, ad cost, money and the newest people
 */

export function useGetMarketingCampaignsIdVoucherResultsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingCampaignsIdVoucherResultsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherResults>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdVoucherResultsSuspenseQueryOptions(
    id,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary The salon's average ticket (null while none is set)
 */
export const getMarketingSettingsAverageTicket = (signal?: AbortSignal) => {
  return customInstance<GetMarketingSettingsAverageTicket200>({
    url: `/marketing/settings/average-ticket`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingSettingsAverageTicketInfiniteQueryKey = () => {
  return ['infinite', `/marketing/settings/average-ticket`] as const;
};

export const getGetMarketingSettingsAverageTicketQueryKey = () => {
  return [`/marketing/settings/average-ticket`] as const;
};

export const getGetMarketingSettingsAverageTicketInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSettingsAverageTicketInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>> = ({
    signal,
  }) => getMarketingSettingsAverageTicket(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSettingsAverageTicketInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>
>;
export type GetMarketingSettingsAverageTicketInfiniteQueryError = void;

export function useGetMarketingSettingsAverageTicketInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsAverageTicketInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsAverageTicketInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The salon's average ticket (null while none is set)
 */

export function useGetMarketingSettingsAverageTicketInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSettingsAverageTicketInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSettingsAverageTicketQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSettingsAverageTicketQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>> = ({
    signal,
  }) => getMarketingSettingsAverageTicket(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSettingsAverageTicketQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>
>;
export type GetMarketingSettingsAverageTicketQueryError = void;

export function useGetMarketingSettingsAverageTicket<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsAverageTicket<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsAverageTicket<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The salon's average ticket (null while none is set)
 */

export function useGetMarketingSettingsAverageTicket<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSettingsAverageTicketQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSettingsAverageTicketSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSettingsAverageTicketQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>> = ({
    signal,
  }) => getMarketingSettingsAverageTicket(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSettingsAverageTicketSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>
>;
export type GetMarketingSettingsAverageTicketSuspenseQueryError = void;

export function useGetMarketingSettingsAverageTicketSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsAverageTicketSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsAverageTicketSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The salon's average ticket (null while none is set)
 */

export function useGetMarketingSettingsAverageTicketSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAverageTicket>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSettingsAverageTicketSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Set the salon's average ticket ($1–$1,000, or null) for labeled voucher money estimates
 */
export const putMarketingSettingsAverageTicket = (
  putMarketingSettingsAverageTicketBody: PutMarketingSettingsAverageTicketBody
) => {
  return customInstance<PutMarketingSettingsAverageTicket200>({
    url: `/marketing/settings/average-ticket`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putMarketingSettingsAverageTicketBody,
  });
};

export const getPutMarketingSettingsAverageTicketMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMarketingSettingsAverageTicket>>,
    TError,
    { data: PutMarketingSettingsAverageTicketBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMarketingSettingsAverageTicket>>,
  TError,
  { data: PutMarketingSettingsAverageTicketBody },
  TContext
> => {
  const mutationKey = ['putMarketingSettingsAverageTicket'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMarketingSettingsAverageTicket>>,
    { data: PutMarketingSettingsAverageTicketBody }
  > = (props) => {
    const { data } = props ?? {};

    return putMarketingSettingsAverageTicket(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMarketingSettingsAverageTicketMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMarketingSettingsAverageTicket>>
>;
export type PutMarketingSettingsAverageTicketMutationBody = PutMarketingSettingsAverageTicketBody;
export type PutMarketingSettingsAverageTicketMutationError = void;

/**
 * @summary Set the salon's average ticket ($1–$1,000, or null) for labeled voucher money estimates
 */
export const usePutMarketingSettingsAverageTicket = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putMarketingSettingsAverageTicket>>,
      TError,
      { data: PutMarketingSettingsAverageTicketBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putMarketingSettingsAverageTicket>>,
  TError,
  { data: PutMarketingSettingsAverageTicketBody },
  TContext
> => {
  const mutationOptions = getPutMarketingSettingsAverageTicketMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary A voucher's "Text it to your clients" panel: groups with counts, default message, vouchers left, past sends
 */
export const getMarketingCampaignsIdVoucherTextClients = (id: string, signal?: AbortSignal) => {
  return customInstance<GetMarketingCampaignsIdVoucherTextClients200>({
    url: `/marketing/campaigns/${id}/voucher/text-clients`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingCampaignsIdVoucherTextClientsInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/marketing/campaigns/${id}/voucher/text-clients`] as const;
};

export const getGetMarketingCampaignsIdVoucherTextClientsQueryKey = (id?: string) => {
  return [`/marketing/campaigns/${id}/voucher/text-clients`] as const;
};

export const getGetMarketingCampaignsIdVoucherTextClientsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCampaignsIdVoucherTextClientsInfiniteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>
  > = ({ signal }) => getMarketingCampaignsIdVoucherTextClients(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdVoucherTextClientsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>
>;
export type GetMarketingCampaignsIdVoucherTextClientsInfiniteQueryError = void;

export function useGetMarketingCampaignsIdVoucherTextClientsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherTextClientsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherTextClientsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A voucher's "Text it to your clients" panel: groups with counts, default message, vouchers left, past sends
 */

export function useGetMarketingCampaignsIdVoucherTextClientsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdVoucherTextClientsInfiniteQueryOptions(
    id,
    options
  );

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdVoucherTextClientsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCampaignsIdVoucherTextClientsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>
  > = ({ signal }) => getMarketingCampaignsIdVoucherTextClients(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdVoucherTextClientsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>
>;
export type GetMarketingCampaignsIdVoucherTextClientsQueryError = void;

export function useGetMarketingCampaignsIdVoucherTextClients<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherTextClients<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherTextClients<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A voucher's "Text it to your clients" panel: groups with counts, default message, vouchers left, past sends
 */

export function useGetMarketingCampaignsIdVoucherTextClients<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdVoucherTextClientsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdVoucherTextClientsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCampaignsIdVoucherTextClientsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>
  > = ({ signal }) => getMarketingCampaignsIdVoucherTextClients(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdVoucherTextClientsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>
>;
export type GetMarketingCampaignsIdVoucherTextClientsSuspenseQueryError = void;

export function useGetMarketingCampaignsIdVoucherTextClientsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherTextClientsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdVoucherTextClientsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A voucher's "Text it to your clients" panel: groups with counts, default message, vouchers left, past sends
 */

export function useGetMarketingCampaignsIdVoucherTextClientsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdVoucherTextClients>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdVoucherTextClientsSuspenseQueryOptions(
    id,
    options
  );

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary A giveaway campaign's prizes, ticket rules and thank-you gift, which fields are locked and which prizes are drawn
 */
export const getMarketingCampaignsIdGiveaway = (id: string, signal?: AbortSignal) => {
  return customInstance<GetMarketingCampaignsIdGiveaway200>({
    url: `/marketing/campaigns/${id}/giveaway`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingCampaignsIdGiveawayInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/marketing/campaigns/${id}/giveaway`] as const;
};

export const getGetMarketingCampaignsIdGiveawayQueryKey = (id?: string) => {
  return [`/marketing/campaigns/${id}/giveaway`] as const;
};

export const getGetMarketingCampaignsIdGiveawayInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdGiveawayInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>> = ({
    signal,
  }) => getMarketingCampaignsIdGiveaway(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdGiveawayInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>
>;
export type GetMarketingCampaignsIdGiveawayInfiniteQueryError = void;

export function useGetMarketingCampaignsIdGiveawayInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdGiveawayInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdGiveawayInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A giveaway campaign's prizes, ticket rules and thank-you gift, which fields are locked and which prizes are drawn
 */

export function useGetMarketingCampaignsIdGiveawayInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdGiveawayInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdGiveawayQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdGiveawayQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>> = ({
    signal,
  }) => getMarketingCampaignsIdGiveaway(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdGiveawayQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>
>;
export type GetMarketingCampaignsIdGiveawayQueryError = void;

export function useGetMarketingCampaignsIdGiveaway<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdGiveaway<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdGiveaway<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A giveaway campaign's prizes, ticket rules and thank-you gift, which fields are locked and which prizes are drawn
 */

export function useGetMarketingCampaignsIdGiveaway<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdGiveawayQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdGiveawaySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdGiveawayQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>> = ({
    signal,
  }) => getMarketingCampaignsIdGiveaway(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdGiveawaySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>
>;
export type GetMarketingCampaignsIdGiveawaySuspenseQueryError = void;

export function useGetMarketingCampaignsIdGiveawaySuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdGiveawaySuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdGiveawaySuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A giveaway campaign's prizes, ticket rules and thank-you gift, which fields are locked and which prizes are drawn
 */

export function useGetMarketingCampaignsIdGiveawaySuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveaway>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdGiveawaySuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Save the whole giveaway setup. After the first publish prizes and ticket rules are locked and draw times may only move later
 */
export const putMarketingCampaignsIdGiveaway = (
  id: string,
  putMarketingCampaignsIdGiveawayBody: PutMarketingCampaignsIdGiveawayBody
) => {
  return customInstance<PutMarketingCampaignsIdGiveaway200>({
    url: `/marketing/campaigns/${id}/giveaway`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putMarketingCampaignsIdGiveawayBody,
  });
};

export const getPutMarketingCampaignsIdGiveawayMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMarketingCampaignsIdGiveaway>>,
    TError,
    { id: string; data: PutMarketingCampaignsIdGiveawayBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMarketingCampaignsIdGiveaway>>,
  TError,
  { id: string; data: PutMarketingCampaignsIdGiveawayBody },
  TContext
> => {
  const mutationKey = ['putMarketingCampaignsIdGiveaway'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMarketingCampaignsIdGiveaway>>,
    { id: string; data: PutMarketingCampaignsIdGiveawayBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return putMarketingCampaignsIdGiveaway(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMarketingCampaignsIdGiveawayMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMarketingCampaignsIdGiveaway>>
>;
export type PutMarketingCampaignsIdGiveawayMutationBody = PutMarketingCampaignsIdGiveawayBody;
export type PutMarketingCampaignsIdGiveawayMutationError = void;

/**
 * @summary Save the whole giveaway setup. After the first publish prizes and ticket rules are locked and draw times may only move later
 */
export const usePutMarketingCampaignsIdGiveaway = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putMarketingCampaignsIdGiveaway>>,
      TError,
      { id: string; data: PutMarketingCampaignsIdGiveawayBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putMarketingCampaignsIdGiveaway>>,
  TError,
  { id: string; data: PutMarketingCampaignsIdGiveawayBody },
  TContext
> => {
  const mutationOptions = getPutMarketingCampaignsIdGiveawayMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary The giveaway's thank-you gifts: who is in each group, what they'd get, who'd be skipped, and the send once made
 */
export const getMarketingCampaignsIdGiveawayThankYouGiftsPreview = (
  id: string,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingCampaignsIdGiveawayThankYouGiftsPreview200>({
    url: `/marketing/campaigns/${id}/giveaway/thank-you-gifts/preview`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingCampaignsIdGiveawayThankYouGiftsPreviewInfiniteQueryKey = (
  id?: string
) => {
  return ['infinite', `/marketing/campaigns/${id}/giveaway/thank-you-gifts/preview`] as const;
};

export const getGetMarketingCampaignsIdGiveawayThankYouGiftsPreviewQueryKey = (id?: string) => {
  return [`/marketing/campaigns/${id}/giveaway/thank-you-gifts/preview`] as const;
};

export const getGetMarketingCampaignsIdGiveawayThankYouGiftsPreviewInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>
  >,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetMarketingCampaignsIdGiveawayThankYouGiftsPreviewInfiniteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>
  > = ({ signal }) => getMarketingCampaignsIdGiveawayThankYouGiftsPreview(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdGiveawayThankYouGiftsPreviewInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>
>;
export type GetMarketingCampaignsIdGiveawayThankYouGiftsPreviewInfiniteQueryError = void;

export function useGetMarketingCampaignsIdGiveawayThankYouGiftsPreviewInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>
  >,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdGiveawayThankYouGiftsPreviewInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>
  >,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdGiveawayThankYouGiftsPreviewInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>
  >,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The giveaway's thank-you gifts: who is in each group, what they'd get, who'd be skipped, and the send once made
 */

export function useGetMarketingCampaignsIdGiveawayThankYouGiftsPreviewInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>
  >,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdGiveawayThankYouGiftsPreviewInfiniteQueryOptions(
    id,
    options
  );

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdGiveawayThankYouGiftsPreviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCampaignsIdGiveawayThankYouGiftsPreviewQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>
  > = ({ signal }) => getMarketingCampaignsIdGiveawayThankYouGiftsPreview(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdGiveawayThankYouGiftsPreviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>
>;
export type GetMarketingCampaignsIdGiveawayThankYouGiftsPreviewQueryError = void;

export function useGetMarketingCampaignsIdGiveawayThankYouGiftsPreview<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdGiveawayThankYouGiftsPreview<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdGiveawayThankYouGiftsPreview<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The giveaway's thank-you gifts: who is in each group, what they'd get, who'd be skipped, and the send once made
 */

export function useGetMarketingCampaignsIdGiveawayThankYouGiftsPreview<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdGiveawayThankYouGiftsPreviewQueryOptions(
    id,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdGiveawayThankYouGiftsPreviewSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCampaignsIdGiveawayThankYouGiftsPreviewQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>
  > = ({ signal }) => getMarketingCampaignsIdGiveawayThankYouGiftsPreview(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdGiveawayThankYouGiftsPreviewSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>
>;
export type GetMarketingCampaignsIdGiveawayThankYouGiftsPreviewSuspenseQueryError = void;

export function useGetMarketingCampaignsIdGiveawayThankYouGiftsPreviewSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdGiveawayThankYouGiftsPreviewSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdGiveawayThankYouGiftsPreviewSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The giveaway's thank-you gifts: who is in each group, what they'd get, who'd be skipped, and the send once made
 */

export function useGetMarketingCampaignsIdGiveawayThankYouGiftsPreviewSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayThankYouGiftsPreview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdGiveawayThankYouGiftsPreviewSuspenseQueryOptions(
    id,
    options
  );

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Send the giveaway's one thank-you text: the New Client Offer for entrants who never came, the chosen voucher for those who came. Winners are left out
 */
export const postMarketingCampaignsIdGiveawayThankYouGifts = (
  id: string,
  postMarketingCampaignsIdGiveawayThankYouGiftsBody?: PostMarketingCampaignsIdGiveawayThankYouGiftsBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingCampaignsIdGiveawayThankYouGifts200>({
    url: `/marketing/campaigns/${id}/giveaway/thank-you-gifts`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingCampaignsIdGiveawayThankYouGiftsBody,
    signal,
  });
};

export const getPostMarketingCampaignsIdGiveawayThankYouGiftsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingCampaignsIdGiveawayThankYouGifts>>,
    TError,
    { id: string; data: PostMarketingCampaignsIdGiveawayThankYouGiftsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingCampaignsIdGiveawayThankYouGifts>>,
  TError,
  { id: string; data: PostMarketingCampaignsIdGiveawayThankYouGiftsBody },
  TContext
> => {
  const mutationKey = ['postMarketingCampaignsIdGiveawayThankYouGifts'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingCampaignsIdGiveawayThankYouGifts>>,
    { id: string; data: PostMarketingCampaignsIdGiveawayThankYouGiftsBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return postMarketingCampaignsIdGiveawayThankYouGifts(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingCampaignsIdGiveawayThankYouGiftsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingCampaignsIdGiveawayThankYouGifts>>
>;
export type PostMarketingCampaignsIdGiveawayThankYouGiftsMutationBody =
  PostMarketingCampaignsIdGiveawayThankYouGiftsBody;
export type PostMarketingCampaignsIdGiveawayThankYouGiftsMutationError = void;

/**
 * @summary Send the giveaway's one thank-you text: the New Client Offer for entrants who never came, the chosen voucher for those who came. Winners are left out
 */
export const usePostMarketingCampaignsIdGiveawayThankYouGifts = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingCampaignsIdGiveawayThankYouGifts>>,
      TError,
      { id: string; data: PostMarketingCampaignsIdGiveawayThankYouGiftsBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingCampaignsIdGiveawayThankYouGifts>>,
  TError,
  { id: string; data: PostMarketingCampaignsIdGiveawayThankYouGiftsBody },
  TContext
> => {
  const mutationOptions = getPostMarketingCampaignsIdGiveawayThankYouGiftsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Draw the next winner of a prize: a random pick weighted by tickets, recorded (who was in, the number drawn, when, who pressed it). Gives the linked Hayven Prize card automatically
 */
export const postMarketingCampaignsIdGiveawayPrizesPrizeIdDraws = (
  id: string,
  prizeId: string,
  postMarketingCampaignsIdGiveawayPrizesPrizeIdDrawsBody: PostMarketingCampaignsIdGiveawayPrizesPrizeIdDrawsBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingCampaignsIdGiveawayPrizesPrizeIdDraws200>({
    url: `/marketing/campaigns/${id}/giveaway/prizes/${prizeId}/draws`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingCampaignsIdGiveawayPrizesPrizeIdDrawsBody,
    signal,
  });
};

export const getPostMarketingCampaignsIdGiveawayPrizesPrizeIdDrawsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingCampaignsIdGiveawayPrizesPrizeIdDraws>>,
    TError,
    { id: string; prizeId: string; data: PostMarketingCampaignsIdGiveawayPrizesPrizeIdDrawsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingCampaignsIdGiveawayPrizesPrizeIdDraws>>,
  TError,
  { id: string; prizeId: string; data: PostMarketingCampaignsIdGiveawayPrizesPrizeIdDrawsBody },
  TContext
> => {
  const mutationKey = ['postMarketingCampaignsIdGiveawayPrizesPrizeIdDraws'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingCampaignsIdGiveawayPrizesPrizeIdDraws>>,
    { id: string; prizeId: string; data: PostMarketingCampaignsIdGiveawayPrizesPrizeIdDrawsBody }
  > = (props) => {
    const { id, prizeId, data } = props ?? {};

    return postMarketingCampaignsIdGiveawayPrizesPrizeIdDraws(id, prizeId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingCampaignsIdGiveawayPrizesPrizeIdDrawsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingCampaignsIdGiveawayPrizesPrizeIdDraws>>
>;
export type PostMarketingCampaignsIdGiveawayPrizesPrizeIdDrawsMutationBody =
  PostMarketingCampaignsIdGiveawayPrizesPrizeIdDrawsBody;
export type PostMarketingCampaignsIdGiveawayPrizesPrizeIdDrawsMutationError = void;

/**
 * @summary Draw the next winner of a prize: a random pick weighted by tickets, recorded (who was in, the number drawn, when, who pressed it). Gives the linked Hayven Prize card automatically
 */
export const usePostMarketingCampaignsIdGiveawayPrizesPrizeIdDraws = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingCampaignsIdGiveawayPrizesPrizeIdDraws>>,
      TError,
      { id: string; prizeId: string; data: PostMarketingCampaignsIdGiveawayPrizesPrizeIdDrawsBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingCampaignsIdGiveawayPrizesPrizeIdDraws>>,
  TError,
  { id: string; prizeId: string; data: PostMarketingCampaignsIdGiveawayPrizesPrizeIdDrawsBody },
  TContext
> => {
  const mutationOptions =
    getPostMarketingCampaignsIdGiveawayPrizesPrizeIdDrawsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Void a draw (the reason is kept) so its slot can be drawn again. The voided winner stays out of later draws; a Prize card already given is not ended
 */
export const postMarketingCampaignsIdGiveawayDrawsDrawIdVoid = (
  id: string,
  drawId: string,
  postMarketingCampaignsIdGiveawayDrawsDrawIdVoidBody: PostMarketingCampaignsIdGiveawayDrawsDrawIdVoidBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingCampaignsIdGiveawayDrawsDrawIdVoid200>({
    url: `/marketing/campaigns/${id}/giveaway/draws/${drawId}/void`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingCampaignsIdGiveawayDrawsDrawIdVoidBody,
    signal,
  });
};

export const getPostMarketingCampaignsIdGiveawayDrawsDrawIdVoidMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingCampaignsIdGiveawayDrawsDrawIdVoid>>,
    TError,
    { id: string; drawId: string; data: PostMarketingCampaignsIdGiveawayDrawsDrawIdVoidBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingCampaignsIdGiveawayDrawsDrawIdVoid>>,
  TError,
  { id: string; drawId: string; data: PostMarketingCampaignsIdGiveawayDrawsDrawIdVoidBody },
  TContext
> => {
  const mutationKey = ['postMarketingCampaignsIdGiveawayDrawsDrawIdVoid'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingCampaignsIdGiveawayDrawsDrawIdVoid>>,
    { id: string; drawId: string; data: PostMarketingCampaignsIdGiveawayDrawsDrawIdVoidBody }
  > = (props) => {
    const { id, drawId, data } = props ?? {};

    return postMarketingCampaignsIdGiveawayDrawsDrawIdVoid(id, drawId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingCampaignsIdGiveawayDrawsDrawIdVoidMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingCampaignsIdGiveawayDrawsDrawIdVoid>>
>;
export type PostMarketingCampaignsIdGiveawayDrawsDrawIdVoidMutationBody =
  PostMarketingCampaignsIdGiveawayDrawsDrawIdVoidBody;
export type PostMarketingCampaignsIdGiveawayDrawsDrawIdVoidMutationError = void;

/**
 * @summary Void a draw (the reason is kept) so its slot can be drawn again. The voided winner stays out of later draws; a Prize card already given is not ended
 */
export const usePostMarketingCampaignsIdGiveawayDrawsDrawIdVoid = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingCampaignsIdGiveawayDrawsDrawIdVoid>>,
      TError,
      { id: string; drawId: string; data: PostMarketingCampaignsIdGiveawayDrawsDrawIdVoidBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingCampaignsIdGiveawayDrawsDrawIdVoid>>,
  TError,
  { id: string; drawId: string; data: PostMarketingCampaignsIdGiveawayDrawsDrawIdVoidBody },
  TContext
> => {
  const mutationOptions =
    getPostMarketingCampaignsIdGiveawayDrawsDrawIdVoidMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Retry giving a draw's linked Prize card (never gives a second one)
 */
export const postMarketingCampaignsIdGiveawayDrawsDrawIdAward = (
  id: string,
  drawId: string,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingCampaignsIdGiveawayDrawsDrawIdAward200>({
    url: `/marketing/campaigns/${id}/giveaway/draws/${drawId}/award`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingCampaignsIdGiveawayDrawsDrawIdAwardMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingCampaignsIdGiveawayDrawsDrawIdAward>>,
    TError,
    { id: string; drawId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingCampaignsIdGiveawayDrawsDrawIdAward>>,
  TError,
  { id: string; drawId: string },
  TContext
> => {
  const mutationKey = ['postMarketingCampaignsIdGiveawayDrawsDrawIdAward'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingCampaignsIdGiveawayDrawsDrawIdAward>>,
    { id: string; drawId: string }
  > = (props) => {
    const { id, drawId } = props ?? {};

    return postMarketingCampaignsIdGiveawayDrawsDrawIdAward(id, drawId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingCampaignsIdGiveawayDrawsDrawIdAwardMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingCampaignsIdGiveawayDrawsDrawIdAward>>
>;

export type PostMarketingCampaignsIdGiveawayDrawsDrawIdAwardMutationError = void;

/**
 * @summary Retry giving a draw's linked Prize card (never gives a second one)
 */
export const usePostMarketingCampaignsIdGiveawayDrawsDrawIdAward = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingCampaignsIdGiveawayDrawsDrawIdAward>>,
      TError,
      { id: string; drawId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingCampaignsIdGiveawayDrawsDrawIdAward>>,
  TError,
  { id: string; drawId: string },
  TContext
> => {
  const mutationOptions =
    getPostMarketingCampaignsIdGiveawayDrawsDrawIdAwardMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary What the filmed Live draw screen shows before "Draw now": brand, prize, people and tickets in, an idle reel, winners so far
 */
export const getMarketingCampaignsIdGiveawayLiveDraw = (
  id: string,
  params: GetMarketingCampaignsIdGiveawayLiveDrawParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingCampaignsIdGiveawayLiveDraw200>({
    url: `/marketing/campaigns/${id}/giveaway/live-draw`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingCampaignsIdGiveawayLiveDrawInfiniteQueryKey = (
  id?: string,
  params?: GetMarketingCampaignsIdGiveawayLiveDrawParams
) => {
  return [
    'infinite',
    `/marketing/campaigns/${id}/giveaway/live-draw`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMarketingCampaignsIdGiveawayLiveDrawQueryKey = (
  id?: string,
  params?: GetMarketingCampaignsIdGiveawayLiveDrawParams
) => {
  return [`/marketing/campaigns/${id}/giveaway/live-draw`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingCampaignsIdGiveawayLiveDrawInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>>,
  TError = void,
>(
  id: string,
  params: GetMarketingCampaignsIdGiveawayLiveDrawParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetMarketingCampaignsIdGiveawayLiveDrawInfiniteQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>
  > = ({ signal }) => getMarketingCampaignsIdGiveawayLiveDraw(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdGiveawayLiveDrawInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>
>;
export type GetMarketingCampaignsIdGiveawayLiveDrawInfiniteQueryError = void;

export function useGetMarketingCampaignsIdGiveawayLiveDrawInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>>,
  TError = void,
>(
  id: string,
  params: GetMarketingCampaignsIdGiveawayLiveDrawParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdGiveawayLiveDrawInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>>,
  TError = void,
>(
  id: string,
  params: GetMarketingCampaignsIdGiveawayLiveDrawParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdGiveawayLiveDrawInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>>,
  TError = void,
>(
  id: string,
  params: GetMarketingCampaignsIdGiveawayLiveDrawParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary What the filmed Live draw screen shows before "Draw now": brand, prize, people and tickets in, an idle reel, winners so far
 */

export function useGetMarketingCampaignsIdGiveawayLiveDrawInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>>,
  TError = void,
>(
  id: string,
  params: GetMarketingCampaignsIdGiveawayLiveDrawParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdGiveawayLiveDrawInfiniteQueryOptions(
    id,
    params,
    options
  );

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdGiveawayLiveDrawQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
  TError = void,
>(
  id: string,
  params: GetMarketingCampaignsIdGiveawayLiveDrawParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCampaignsIdGiveawayLiveDrawQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>
  > = ({ signal }) => getMarketingCampaignsIdGiveawayLiveDraw(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdGiveawayLiveDrawQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>
>;
export type GetMarketingCampaignsIdGiveawayLiveDrawQueryError = void;

export function useGetMarketingCampaignsIdGiveawayLiveDraw<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
  TError = void,
>(
  id: string,
  params: GetMarketingCampaignsIdGiveawayLiveDrawParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdGiveawayLiveDraw<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
  TError = void,
>(
  id: string,
  params: GetMarketingCampaignsIdGiveawayLiveDrawParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdGiveawayLiveDraw<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
  TError = void,
>(
  id: string,
  params: GetMarketingCampaignsIdGiveawayLiveDrawParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary What the filmed Live draw screen shows before "Draw now": brand, prize, people and tickets in, an idle reel, winners so far
 */

export function useGetMarketingCampaignsIdGiveawayLiveDraw<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
  TError = void,
>(
  id: string,
  params: GetMarketingCampaignsIdGiveawayLiveDrawParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdGiveawayLiveDrawQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdGiveawayLiveDrawSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
  TError = void,
>(
  id: string,
  params: GetMarketingCampaignsIdGiveawayLiveDrawParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCampaignsIdGiveawayLiveDrawQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>
  > = ({ signal }) => getMarketingCampaignsIdGiveawayLiveDraw(id, params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdGiveawayLiveDrawSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>
>;
export type GetMarketingCampaignsIdGiveawayLiveDrawSuspenseQueryError = void;

export function useGetMarketingCampaignsIdGiveawayLiveDrawSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
  TError = void,
>(
  id: string,
  params: GetMarketingCampaignsIdGiveawayLiveDrawParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdGiveawayLiveDrawSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
  TError = void,
>(
  id: string,
  params: GetMarketingCampaignsIdGiveawayLiveDrawParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdGiveawayLiveDrawSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
  TError = void,
>(
  id: string,
  params: GetMarketingCampaignsIdGiveawayLiveDrawParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary What the filmed Live draw screen shows before "Draw now": brand, prize, people and tickets in, an idle reel, winners so far
 */

export function useGetMarketingCampaignsIdGiveawayLiveDrawSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
  TError = void,
>(
  id: string,
  params: GetMarketingCampaignsIdGiveawayLiveDrawParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawayLiveDraw>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdGiveawayLiveDrawSuspenseQueryOptions(
    id,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Giveaway hub: entries, tickets, opening day, opening texts, prizes with their draws, thank-you gift groups
 */
export const getMarketingCampaignsIdGiveawaySummary = (id: string, signal?: AbortSignal) => {
  return customInstance<GetMarketingCampaignsIdGiveawaySummary200>({
    url: `/marketing/campaigns/${id}/giveaway/summary`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingCampaignsIdGiveawaySummaryInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/marketing/campaigns/${id}/giveaway/summary`] as const;
};

export const getGetMarketingCampaignsIdGiveawaySummaryQueryKey = (id?: string) => {
  return [`/marketing/campaigns/${id}/giveaway/summary`] as const;
};

export const getGetMarketingCampaignsIdGiveawaySummaryInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCampaignsIdGiveawaySummaryInfiniteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>
  > = ({ signal }) => getMarketingCampaignsIdGiveawaySummary(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdGiveawaySummaryInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>
>;
export type GetMarketingCampaignsIdGiveawaySummaryInfiniteQueryError = void;

export function useGetMarketingCampaignsIdGiveawaySummaryInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdGiveawaySummaryInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdGiveawaySummaryInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Giveaway hub: entries, tickets, opening day, opening texts, prizes with their draws, thank-you gift groups
 */

export function useGetMarketingCampaignsIdGiveawaySummaryInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdGiveawaySummaryInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdGiveawaySummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdGiveawaySummaryQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>
  > = ({ signal }) => getMarketingCampaignsIdGiveawaySummary(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdGiveawaySummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>
>;
export type GetMarketingCampaignsIdGiveawaySummaryQueryError = void;

export function useGetMarketingCampaignsIdGiveawaySummary<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdGiveawaySummary<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdGiveawaySummary<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Giveaway hub: entries, tickets, opening day, opening texts, prizes with their draws, thank-you gift groups
 */

export function useGetMarketingCampaignsIdGiveawaySummary<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdGiveawaySummaryQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdGiveawaySummarySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdGiveawaySummaryQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>
  > = ({ signal }) => getMarketingCampaignsIdGiveawaySummary(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdGiveawaySummarySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>
>;
export type GetMarketingCampaignsIdGiveawaySummarySuspenseQueryError = void;

export function useGetMarketingCampaignsIdGiveawaySummarySuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdGiveawaySummarySuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdGiveawaySummarySuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Giveaway hub: entries, tickets, opening day, opening texts, prizes with their draws, thank-you gift groups
 */

export function useGetMarketingCampaignsIdGiveawaySummarySuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdGiveawaySummary>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdGiveawaySummarySuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Landing editor payload (draft content, section summary, publish issues, salon facts)
 */
export const getMarketingCampaignsIdLanding = (id: string, signal?: AbortSignal) => {
  return customInstance<GetMarketingCampaignsIdLanding200>({
    url: `/marketing/campaigns/${id}/landing`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingCampaignsIdLandingInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/marketing/campaigns/${id}/landing`] as const;
};

export const getGetMarketingCampaignsIdLandingQueryKey = (id?: string) => {
  return [`/marketing/campaigns/${id}/landing`] as const;
};

export const getGetMarketingCampaignsIdLandingInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdLandingInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>> = ({
    signal,
  }) => getMarketingCampaignsIdLanding(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdLandingInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>
>;
export type GetMarketingCampaignsIdLandingInfiniteQueryError = void;

export function useGetMarketingCampaignsIdLandingInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdLandingInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdLandingInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Landing editor payload (draft content, section summary, publish issues, salon facts)
 */

export function useGetMarketingCampaignsIdLandingInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdLandingInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdLandingQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdLandingQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>> = ({
    signal,
  }) => getMarketingCampaignsIdLanding(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdLandingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>
>;
export type GetMarketingCampaignsIdLandingQueryError = void;

export function useGetMarketingCampaignsIdLanding<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdLanding<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdLanding<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Landing editor payload (draft content, section summary, publish issues, salon facts)
 */

export function useGetMarketingCampaignsIdLanding<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdLandingQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdLandingSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdLandingQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>> = ({
    signal,
  }) => getMarketingCampaignsIdLanding(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdLandingSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>
>;
export type GetMarketingCampaignsIdLandingSuspenseQueryError = void;

export function useGetMarketingCampaignsIdLandingSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdLandingSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdLandingSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Landing editor payload (draft content, section summary, publish issues, salon facts)
 */

export function useGetMarketingCampaignsIdLandingSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdLanding>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdLandingSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Autosave the landing draft; 409 DRAFT_CONFLICT (with the latest draft) when baseVersion is stale
 */
export const patchMarketingCampaignsIdLandingDraft = (
  id: string,
  patchMarketingCampaignsIdLandingDraftBody: PatchMarketingCampaignsIdLandingDraftBody
) => {
  return customInstance<PatchMarketingCampaignsIdLandingDraft200>({
    url: `/marketing/campaigns/${id}/landing/draft`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchMarketingCampaignsIdLandingDraftBody,
  });
};

export const getPatchMarketingCampaignsIdLandingDraftMutationOptions = <
  TError = PatchMarketingCampaignsIdLandingDraft400 | PatchMarketingCampaignsIdLandingDraft409,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMarketingCampaignsIdLandingDraft>>,
    TError,
    { id: string; data: PatchMarketingCampaignsIdLandingDraftBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMarketingCampaignsIdLandingDraft>>,
  TError,
  { id: string; data: PatchMarketingCampaignsIdLandingDraftBody },
  TContext
> => {
  const mutationKey = ['patchMarketingCampaignsIdLandingDraft'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMarketingCampaignsIdLandingDraft>>,
    { id: string; data: PatchMarketingCampaignsIdLandingDraftBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return patchMarketingCampaignsIdLandingDraft(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMarketingCampaignsIdLandingDraftMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchMarketingCampaignsIdLandingDraft>>
>;
export type PatchMarketingCampaignsIdLandingDraftMutationBody =
  PatchMarketingCampaignsIdLandingDraftBody;
export type PatchMarketingCampaignsIdLandingDraftMutationError =
  | PatchMarketingCampaignsIdLandingDraft400
  | PatchMarketingCampaignsIdLandingDraft409;

/**
 * @summary Autosave the landing draft; 409 DRAFT_CONFLICT (with the latest draft) when baseVersion is stale
 */
export const usePatchMarketingCampaignsIdLandingDraft = <
  TError = PatchMarketingCampaignsIdLandingDraft400 | PatchMarketingCampaignsIdLandingDraft409,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchMarketingCampaignsIdLandingDraft>>,
      TError,
      { id: string; data: PatchMarketingCampaignsIdLandingDraftBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchMarketingCampaignsIdLandingDraft>>,
  TError,
  { id: string; data: PatchMarketingCampaignsIdLandingDraftBody },
  TContext
> => {
  const mutationOptions = getPatchMarketingCampaignsIdLandingDraftMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Rewrite one landing copy field with AI — returns up to 3 alternative phrasings
 */
export const postMarketingCampaignsIdLandingRewrite = (
  id: string,
  postMarketingCampaignsIdLandingRewriteBody: PostMarketingCampaignsIdLandingRewriteBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingCampaignsIdLandingRewrite200>({
    url: `/marketing/campaigns/${id}/landing/rewrite`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingCampaignsIdLandingRewriteBody,
    signal,
  });
};

export const getPostMarketingCampaignsIdLandingRewriteMutationOptions = <
  TError = PostMarketingCampaignsIdLandingRewrite503,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingCampaignsIdLandingRewrite>>,
    TError,
    { id: string; data: PostMarketingCampaignsIdLandingRewriteBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingCampaignsIdLandingRewrite>>,
  TError,
  { id: string; data: PostMarketingCampaignsIdLandingRewriteBody },
  TContext
> => {
  const mutationKey = ['postMarketingCampaignsIdLandingRewrite'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingCampaignsIdLandingRewrite>>,
    { id: string; data: PostMarketingCampaignsIdLandingRewriteBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return postMarketingCampaignsIdLandingRewrite(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingCampaignsIdLandingRewriteMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingCampaignsIdLandingRewrite>>
>;
export type PostMarketingCampaignsIdLandingRewriteMutationBody =
  PostMarketingCampaignsIdLandingRewriteBody;
export type PostMarketingCampaignsIdLandingRewriteMutationError =
  PostMarketingCampaignsIdLandingRewrite503;

/**
 * @summary Rewrite one landing copy field with AI — returns up to 3 alternative phrasings
 */
export const usePostMarketingCampaignsIdLandingRewrite = <
  TError = PostMarketingCampaignsIdLandingRewrite503,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingCampaignsIdLandingRewrite>>,
      TError,
      { id: string; data: PostMarketingCampaignsIdLandingRewriteBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingCampaignsIdLandingRewrite>>,
  TError,
  { id: string; data: PostMarketingCampaignsIdLandingRewriteBody },
  TContext
> => {
  const mutationOptions = getPostMarketingCampaignsIdLandingRewriteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary AI reads the owner's flyer and/or text: `build` proposes headline, highlights, tidied text and form wording; `tidy` tidies a text (nothing on the page is saved)
 */
export const postMarketingCampaignsIdLandingAiBuild = (
  id: string,
  postMarketingCampaignsIdLandingAiBuildBody: PostMarketingCampaignsIdLandingAiBuildBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingCampaignsIdLandingAiBuild200>({
    url: `/marketing/campaigns/${id}/landing/ai-build`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingCampaignsIdLandingAiBuildBody,
    signal,
  });
};

export const getPostMarketingCampaignsIdLandingAiBuildMutationOptions = <
  TError =
    | PostMarketingCampaignsIdLandingAiBuild400
    | PostMarketingCampaignsIdLandingAiBuild404
    | PostMarketingCampaignsIdLandingAiBuild409
    | PostMarketingCampaignsIdLandingAiBuild429
    | PostMarketingCampaignsIdLandingAiBuild503,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingCampaignsIdLandingAiBuild>>,
    TError,
    { id: string; data: PostMarketingCampaignsIdLandingAiBuildBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingCampaignsIdLandingAiBuild>>,
  TError,
  { id: string; data: PostMarketingCampaignsIdLandingAiBuildBody },
  TContext
> => {
  const mutationKey = ['postMarketingCampaignsIdLandingAiBuild'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingCampaignsIdLandingAiBuild>>,
    { id: string; data: PostMarketingCampaignsIdLandingAiBuildBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return postMarketingCampaignsIdLandingAiBuild(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingCampaignsIdLandingAiBuildMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingCampaignsIdLandingAiBuild>>
>;
export type PostMarketingCampaignsIdLandingAiBuildMutationBody =
  PostMarketingCampaignsIdLandingAiBuildBody;
export type PostMarketingCampaignsIdLandingAiBuildMutationError =
  | PostMarketingCampaignsIdLandingAiBuild400
  | PostMarketingCampaignsIdLandingAiBuild404
  | PostMarketingCampaignsIdLandingAiBuild409
  | PostMarketingCampaignsIdLandingAiBuild429
  | PostMarketingCampaignsIdLandingAiBuild503;

/**
 * @summary AI reads the owner's flyer and/or text: `build` proposes headline, highlights, tidied text and form wording; `tidy` tidies a text (nothing on the page is saved)
 */
export const usePostMarketingCampaignsIdLandingAiBuild = <
  TError =
    | PostMarketingCampaignsIdLandingAiBuild400
    | PostMarketingCampaignsIdLandingAiBuild404
    | PostMarketingCampaignsIdLandingAiBuild409
    | PostMarketingCampaignsIdLandingAiBuild429
    | PostMarketingCampaignsIdLandingAiBuild503,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingCampaignsIdLandingAiBuild>>,
      TError,
      { id: string; data: PostMarketingCampaignsIdLandingAiBuildBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingCampaignsIdLandingAiBuild>>,
  TError,
  { id: string; data: PostMarketingCampaignsIdLandingAiBuildBody },
  TContext
> => {
  const mutationOptions = getPostMarketingCampaignsIdLandingAiBuildMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Lead header KPIs in people, over the same filters as the list
 */
export const getMarketingLeadsSummary = (
  params?: GetMarketingLeadsSummaryParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingLeadsSummary200>({
    url: `/marketing/leads/summary`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingLeadsSummaryInfiniteQueryKey = (
  params?: GetMarketingLeadsSummaryParams
) => {
  return ['infinite', `/marketing/leads/summary`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingLeadsSummaryQueryKey = (params?: GetMarketingLeadsSummaryParams) => {
  return [`/marketing/leads/summary`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingLeadsSummaryInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingLeadsSummary>>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsSummaryParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsSummary>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingLeadsSummaryInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingLeadsSummary>>> = ({
    signal,
  }) => getMarketingLeadsSummary(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingLeadsSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingLeadsSummaryInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingLeadsSummary>>
>;
export type GetMarketingLeadsSummaryInfiniteQueryError = unknown;

export function useGetMarketingLeadsSummaryInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingLeadsSummary>>>,
  TError = unknown,
>(
  params: undefined | GetMarketingLeadsSummaryParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsSummary>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingLeadsSummary>>,
          TError,
          Awaited<ReturnType<typeof getMarketingLeadsSummary>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsSummaryInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingLeadsSummary>>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsSummaryParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsSummary>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingLeadsSummary>>,
          TError,
          Awaited<ReturnType<typeof getMarketingLeadsSummary>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsSummaryInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingLeadsSummary>>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsSummaryParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsSummary>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Lead header KPIs in people, over the same filters as the list
 */

export function useGetMarketingLeadsSummaryInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingLeadsSummary>>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsSummaryParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsSummary>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingLeadsSummaryInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingLeadsSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingLeadsSummary>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsSummary>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingLeadsSummaryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingLeadsSummary>>> = ({
    signal,
  }) => getMarketingLeadsSummary(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingLeadsSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingLeadsSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingLeadsSummary>>
>;
export type GetMarketingLeadsSummaryQueryError = unknown;

export function useGetMarketingLeadsSummary<
  TData = Awaited<ReturnType<typeof getMarketingLeadsSummary>>,
  TError = unknown,
>(
  params: undefined | GetMarketingLeadsSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsSummary>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingLeadsSummary>>,
          TError,
          Awaited<ReturnType<typeof getMarketingLeadsSummary>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsSummary<
  TData = Awaited<ReturnType<typeof getMarketingLeadsSummary>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsSummary>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingLeadsSummary>>,
          TError,
          Awaited<ReturnType<typeof getMarketingLeadsSummary>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsSummary<
  TData = Awaited<ReturnType<typeof getMarketingLeadsSummary>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsSummary>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Lead header KPIs in people, over the same filters as the list
 */

export function useGetMarketingLeadsSummary<
  TData = Awaited<ReturnType<typeof getMarketingLeadsSummary>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsSummary>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingLeadsSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingLeadsSummarySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingLeadsSummary>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsSummaryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsSummary>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingLeadsSummaryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingLeadsSummary>>> = ({
    signal,
  }) => getMarketingLeadsSummary(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingLeadsSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingLeadsSummarySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingLeadsSummary>>
>;
export type GetMarketingLeadsSummarySuspenseQueryError = unknown;

export function useGetMarketingLeadsSummarySuspense<
  TData = Awaited<ReturnType<typeof getMarketingLeadsSummary>>,
  TError = unknown,
>(
  params: undefined | GetMarketingLeadsSummaryParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsSummary>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsSummarySuspense<
  TData = Awaited<ReturnType<typeof getMarketingLeadsSummary>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsSummaryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsSummary>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsSummarySuspense<
  TData = Awaited<ReturnType<typeof getMarketingLeadsSummary>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsSummaryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsSummary>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Lead header KPIs in people, over the same filters as the list
 */

export function useGetMarketingLeadsSummarySuspense<
  TData = Awaited<ReturnType<typeof getMarketingLeadsSummary>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsSummaryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsSummary>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingLeadsSummarySuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary How many people need a follow-up (the Leads nav badge; count only, unfiltered)
 */
export const getMarketingLeadsFollowUpCount = (signal?: AbortSignal) => {
  return customInstance<GetMarketingLeadsFollowUpCount200>({
    url: `/marketing/leads/follow-up-count`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingLeadsFollowUpCountInfiniteQueryKey = () => {
  return ['infinite', `/marketing/leads/follow-up-count`] as const;
};

export const getGetMarketingLeadsFollowUpCountQueryKey = () => {
  return [`/marketing/leads/follow-up-count`] as const;
};

export const getGetMarketingLeadsFollowUpCountInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingLeadsFollowUpCountInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>> = ({
    signal,
  }) => getMarketingLeadsFollowUpCount(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingLeadsFollowUpCountInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>
>;
export type GetMarketingLeadsFollowUpCountInfiniteQueryError = unknown;

export function useGetMarketingLeadsFollowUpCountInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
          TError,
          Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsFollowUpCountInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
          TError,
          Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsFollowUpCountInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary How many people need a follow-up (the Leads nav badge; count only, unfiltered)
 */

export function useGetMarketingLeadsFollowUpCountInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingLeadsFollowUpCountInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingLeadsFollowUpCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingLeadsFollowUpCountQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>> = ({
    signal,
  }) => getMarketingLeadsFollowUpCount(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingLeadsFollowUpCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>
>;
export type GetMarketingLeadsFollowUpCountQueryError = unknown;

export function useGetMarketingLeadsFollowUpCount<
  TData = Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
          TError,
          Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsFollowUpCount<
  TData = Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
          TError,
          Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsFollowUpCount<
  TData = Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary How many people need a follow-up (the Leads nav badge; count only, unfiltered)
 */

export function useGetMarketingLeadsFollowUpCount<
  TData = Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingLeadsFollowUpCountQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingLeadsFollowUpCountSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingLeadsFollowUpCountQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>> = ({
    signal,
  }) => getMarketingLeadsFollowUpCount(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingLeadsFollowUpCountSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>
>;
export type GetMarketingLeadsFollowUpCountSuspenseQueryError = unknown;

export function useGetMarketingLeadsFollowUpCountSuspense<
  TData = Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsFollowUpCountSuspense<
  TData = Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsFollowUpCountSuspense<
  TData = Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary How many people need a follow-up (the Leads nav badge; count only, unfiltered)
 */

export function useGetMarketingLeadsFollowUpCountSuspense<
  TData = Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingLeadsFollowUpCount>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingLeadsFollowUpCountSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Export the filtered leads as CSV (formula-neutralized); salon admins and agency members only
 */
export const getMarketingLeadsExport = (
  params?: GetMarketingLeadsExportParams,
  signal?: AbortSignal
) => {
  return customInstance<string>({ url: `/marketing/leads/export`, method: 'GET', params, signal });
};

export const getGetMarketingLeadsExportInfiniteQueryKey = (
  params?: GetMarketingLeadsExportParams
) => {
  return ['infinite', `/marketing/leads/export`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingLeadsExportQueryKey = (params?: GetMarketingLeadsExportParams) => {
  return [`/marketing/leads/export`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingLeadsExportInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingLeadsExport>>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsExportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsExport>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingLeadsExportInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingLeadsExport>>> = ({
    signal,
  }) => getMarketingLeadsExport(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingLeadsExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingLeadsExportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingLeadsExport>>
>;
export type GetMarketingLeadsExportInfiniteQueryError = unknown;

export function useGetMarketingLeadsExportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingLeadsExport>>>,
  TError = unknown,
>(
  params: undefined | GetMarketingLeadsExportParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsExport>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingLeadsExport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingLeadsExport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsExportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingLeadsExport>>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsExportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsExport>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingLeadsExport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingLeadsExport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsExportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingLeadsExport>>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsExportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsExport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Export the filtered leads as CSV (formula-neutralized); salon admins and agency members only
 */

export function useGetMarketingLeadsExportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingLeadsExport>>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsExportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsExport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingLeadsExportInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingLeadsExportQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingLeadsExport>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsExport>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingLeadsExportQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingLeadsExport>>> = ({
    signal,
  }) => getMarketingLeadsExport(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingLeadsExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingLeadsExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingLeadsExport>>
>;
export type GetMarketingLeadsExportQueryError = unknown;

export function useGetMarketingLeadsExport<
  TData = Awaited<ReturnType<typeof getMarketingLeadsExport>>,
  TError = unknown,
>(
  params: undefined | GetMarketingLeadsExportParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsExport>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingLeadsExport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingLeadsExport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsExport<
  TData = Awaited<ReturnType<typeof getMarketingLeadsExport>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsExport>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingLeadsExport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingLeadsExport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsExport<
  TData = Awaited<ReturnType<typeof getMarketingLeadsExport>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsExport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Export the filtered leads as CSV (formula-neutralized); salon admins and agency members only
 */

export function useGetMarketingLeadsExport<
  TData = Awaited<ReturnType<typeof getMarketingLeadsExport>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsExport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingLeadsExportQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingLeadsExportSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingLeadsExport>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsExportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsExport>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingLeadsExportQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingLeadsExport>>> = ({
    signal,
  }) => getMarketingLeadsExport(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingLeadsExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingLeadsExportSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingLeadsExport>>
>;
export type GetMarketingLeadsExportSuspenseQueryError = unknown;

export function useGetMarketingLeadsExportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingLeadsExport>>,
  TError = unknown,
>(
  params: undefined | GetMarketingLeadsExportParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsExport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsExportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingLeadsExport>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsExportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsExport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsExportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingLeadsExport>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsExportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsExport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Export the filtered leads as CSV (formula-neutralized); salon admins and agency members only
 */

export function useGetMarketingLeadsExportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingLeadsExport>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsExportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsExport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingLeadsExportSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List leads (one row per person, newest sign-up first, cursor paginated)
 */
export const getMarketingLeads = (params?: GetMarketingLeadsParams, signal?: AbortSignal) => {
  return customInstance<GetMarketingLeads200>({
    url: `/marketing/leads`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingLeadsInfiniteQueryKey = (params?: GetMarketingLeadsParams) => {
  return ['infinite', `/marketing/leads`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingLeadsQueryKey = (params?: GetMarketingLeadsParams) => {
  return [`/marketing/leads`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingLeadsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingLeads>>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingLeads>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingLeadsInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingLeads>>> = ({ signal }) =>
    getMarketingLeads(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingLeads>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingLeadsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingLeads>>
>;
export type GetMarketingLeadsInfiniteQueryError = unknown;

export function useGetMarketingLeadsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingLeads>>>,
  TError = unknown,
>(
  params: undefined | GetMarketingLeadsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingLeads>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingLeads>>,
          TError,
          Awaited<ReturnType<typeof getMarketingLeads>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingLeads>>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingLeads>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingLeads>>,
          TError,
          Awaited<ReturnType<typeof getMarketingLeads>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingLeads>>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingLeads>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List leads (one row per person, newest sign-up first, cursor paginated)
 */

export function useGetMarketingLeadsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingLeads>>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingLeads>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingLeadsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingLeadsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingLeads>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingLeads>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingLeadsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingLeads>>> = ({ signal }) =>
    getMarketingLeads(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingLeads>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingLeadsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingLeads>>
>;
export type GetMarketingLeadsQueryError = unknown;

export function useGetMarketingLeads<
  TData = Awaited<ReturnType<typeof getMarketingLeads>>,
  TError = unknown,
>(
  params: undefined | GetMarketingLeadsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingLeads>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingLeads>>,
          TError,
          Awaited<ReturnType<typeof getMarketingLeads>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeads<
  TData = Awaited<ReturnType<typeof getMarketingLeads>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingLeads>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingLeads>>,
          TError,
          Awaited<ReturnType<typeof getMarketingLeads>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeads<
  TData = Awaited<ReturnType<typeof getMarketingLeads>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingLeads>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List leads (one row per person, newest sign-up first, cursor paginated)
 */

export function useGetMarketingLeads<
  TData = Awaited<ReturnType<typeof getMarketingLeads>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingLeads>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingLeadsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingLeadsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingLeads>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingLeads>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingLeadsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingLeads>>> = ({ signal }) =>
    getMarketingLeads(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingLeads>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingLeadsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingLeads>>
>;
export type GetMarketingLeadsSuspenseQueryError = unknown;

export function useGetMarketingLeadsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingLeads>>,
  TError = unknown,
>(
  params: undefined | GetMarketingLeadsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingLeads>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingLeads>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingLeads>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingLeads>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingLeads>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List leads (one row per person, newest sign-up first, cursor paginated)
 */

export function useGetMarketingLeadsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingLeads>>,
  TError = unknown,
>(
  params?: GetMarketingLeadsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingLeads>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingLeadsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lead detail with verbatim consent evidence (drawer)
 */
export const getMarketingLeadsId = (id: string, signal?: AbortSignal) => {
  return customInstance<GetMarketingLeadsId200>({
    url: `/marketing/leads/${id}`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingLeadsIdInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/marketing/leads/${id}`] as const;
};

export const getGetMarketingLeadsIdQueryKey = (id?: string) => {
  return [`/marketing/leads/${id}`] as const;
};

export const getGetMarketingLeadsIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingLeadsId>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsId>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingLeadsIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingLeadsId>>> = ({ signal }) =>
    getMarketingLeadsId(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingLeadsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingLeadsIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingLeadsId>>
>;
export type GetMarketingLeadsIdInfiniteQueryError = unknown;

export function useGetMarketingLeadsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingLeadsId>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingLeadsId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingLeadsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingLeadsId>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingLeadsId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingLeadsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingLeadsId>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Lead detail with verbatim consent evidence (drawer)
 */

export function useGetMarketingLeadsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingLeadsId>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingLeadsIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingLeadsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingLeadsId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsId>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingLeadsIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingLeadsId>>> = ({ signal }) =>
    getMarketingLeadsId(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingLeadsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingLeadsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingLeadsId>>
>;
export type GetMarketingLeadsIdQueryError = unknown;

export function useGetMarketingLeadsId<
  TData = Awaited<ReturnType<typeof getMarketingLeadsId>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingLeadsId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingLeadsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsId<
  TData = Awaited<ReturnType<typeof getMarketingLeadsId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingLeadsId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingLeadsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsId<
  TData = Awaited<ReturnType<typeof getMarketingLeadsId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Lead detail with verbatim consent evidence (drawer)
 */

export function useGetMarketingLeadsId<
  TData = Awaited<ReturnType<typeof getMarketingLeadsId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingLeadsIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingLeadsIdSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingLeadsId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsId>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingLeadsIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingLeadsId>>> = ({ signal }) =>
    getMarketingLeadsId(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingLeadsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingLeadsIdSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingLeadsId>>
>;
export type GetMarketingLeadsIdSuspenseQueryError = unknown;

export function useGetMarketingLeadsIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingLeadsId>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingLeadsId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingLeadsIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingLeadsId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Lead detail with verbatim consent evidence (drawer)
 */

export function useGetMarketingLeadsIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingLeadsId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingLeadsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingLeadsIdSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Per-campaign funnel rows + org totals (bookings made in range)
 */
export const getMarketingAnalyticsCampaigns = (
  params?: GetMarketingAnalyticsCampaignsParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingAnalyticsCampaigns200>({
    url: `/marketing/analytics/campaigns`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingAnalyticsCampaignsInfiniteQueryKey = (
  params?: GetMarketingAnalyticsCampaignsParams
) => {
  return ['infinite', `/marketing/analytics/campaigns`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingAnalyticsCampaignsQueryKey = (
  params?: GetMarketingAnalyticsCampaignsParams
) => {
  return [`/marketing/analytics/campaigns`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingAnalyticsCampaignsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsCampaignsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingAnalyticsCampaignsInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>> = ({
    signal,
  }) => getMarketingAnalyticsCampaigns(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingAnalyticsCampaignsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>
>;
export type GetMarketingAnalyticsCampaignsInfiniteQueryError = unknown;

export function useGetMarketingAnalyticsCampaignsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>>,
  TError = unknown,
>(
  params: undefined | GetMarketingAnalyticsCampaignsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
          TError,
          Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsCampaignsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsCampaignsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
          TError,
          Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsCampaignsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsCampaignsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Per-campaign funnel rows + org totals (bookings made in range)
 */

export function useGetMarketingAnalyticsCampaignsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsCampaignsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingAnalyticsCampaignsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingAnalyticsCampaignsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsCampaignsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingAnalyticsCampaignsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>> = ({
    signal,
  }) => getMarketingAnalyticsCampaigns(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingAnalyticsCampaignsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>
>;
export type GetMarketingAnalyticsCampaignsQueryError = unknown;

export function useGetMarketingAnalyticsCampaigns<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
  TError = unknown,
>(
  params: undefined | GetMarketingAnalyticsCampaignsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
          TError,
          Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsCampaigns<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsCampaignsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
          TError,
          Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsCampaigns<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsCampaignsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Per-campaign funnel rows + org totals (bookings made in range)
 */

export function useGetMarketingAnalyticsCampaigns<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsCampaignsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingAnalyticsCampaignsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingAnalyticsCampaignsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsCampaignsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingAnalyticsCampaignsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>> = ({
    signal,
  }) => getMarketingAnalyticsCampaigns(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingAnalyticsCampaignsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>
>;
export type GetMarketingAnalyticsCampaignsSuspenseQueryError = unknown;

export function useGetMarketingAnalyticsCampaignsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
  TError = unknown,
>(
  params: undefined | GetMarketingAnalyticsCampaignsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsCampaignsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsCampaignsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsCampaignsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsCampaignsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Per-campaign funnel rows + org totals (bookings made in range)
 */

export function useGetMarketingAnalyticsCampaignsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsCampaignsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaigns>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingAnalyticsCampaignsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary All campaigns as CSV for the range (the comparison table + a Total row; formula-neutralized, no PII)
 */
export const getMarketingAnalyticsCampaignsExport = (
  params?: GetMarketingAnalyticsCampaignsExportParams,
  signal?: AbortSignal
) => {
  return customInstance<string>({
    url: `/marketing/analytics/campaigns/export`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingAnalyticsCampaignsExportInfiniteQueryKey = (
  params?: GetMarketingAnalyticsCampaignsExportParams
) => {
  return [
    'infinite',
    `/marketing/analytics/campaigns/export`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMarketingAnalyticsCampaignsExportQueryKey = (
  params?: GetMarketingAnalyticsCampaignsExportParams
) => {
  return [`/marketing/analytics/campaigns/export`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingAnalyticsCampaignsExportInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsCampaignsExportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingAnalyticsCampaignsExportInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>
  > = ({ signal }) => getMarketingAnalyticsCampaignsExport(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingAnalyticsCampaignsExportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>
>;
export type GetMarketingAnalyticsCampaignsExportInfiniteQueryError = unknown;

export function useGetMarketingAnalyticsCampaignsExportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>>,
  TError = unknown,
>(
  params: undefined | GetMarketingAnalyticsCampaignsExportParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsCampaignsExportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsCampaignsExportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsCampaignsExportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsCampaignsExportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary All campaigns as CSV for the range (the comparison table + a Total row; formula-neutralized, no PII)
 */

export function useGetMarketingAnalyticsCampaignsExportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsCampaignsExportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingAnalyticsCampaignsExportInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingAnalyticsCampaignsExportQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsCampaignsExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingAnalyticsCampaignsExportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>
  > = ({ signal }) => getMarketingAnalyticsCampaignsExport(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingAnalyticsCampaignsExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>
>;
export type GetMarketingAnalyticsCampaignsExportQueryError = unknown;

export function useGetMarketingAnalyticsCampaignsExport<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
  TError = unknown,
>(
  params: undefined | GetMarketingAnalyticsCampaignsExportParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsCampaignsExport<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsCampaignsExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsCampaignsExport<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsCampaignsExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary All campaigns as CSV for the range (the comparison table + a Total row; formula-neutralized, no PII)
 */

export function useGetMarketingAnalyticsCampaignsExport<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsCampaignsExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingAnalyticsCampaignsExportQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingAnalyticsCampaignsExportSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsCampaignsExportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingAnalyticsCampaignsExportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>
  > = ({ signal }) => getMarketingAnalyticsCampaignsExport(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingAnalyticsCampaignsExportSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>
>;
export type GetMarketingAnalyticsCampaignsExportSuspenseQueryError = unknown;

export function useGetMarketingAnalyticsCampaignsExportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
  TError = unknown,
>(
  params: undefined | GetMarketingAnalyticsCampaignsExportParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsCampaignsExportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsCampaignsExportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsCampaignsExportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsCampaignsExportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary All campaigns as CSV for the range (the comparison table + a Total row; formula-neutralized, no PII)
 */

export function useGetMarketingAnalyticsCampaignsExportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsCampaignsExportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingAnalyticsCampaignsExportSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Bio Page Insights: visitors, sources, button clicks, bookings, sign-ups and journeys in range
 */
export const getMarketingAnalyticsBio = (
  params?: GetMarketingAnalyticsBioParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingAnalyticsBio200>({
    url: `/marketing/analytics/bio`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingAnalyticsBioInfiniteQueryKey = (
  params?: GetMarketingAnalyticsBioParams
) => {
  return ['infinite', `/marketing/analytics/bio`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingAnalyticsBioQueryKey = (params?: GetMarketingAnalyticsBioParams) => {
  return [`/marketing/analytics/bio`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingAnalyticsBioInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingAnalyticsBio>>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsBioParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingAnalyticsBio>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingAnalyticsBioInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingAnalyticsBio>>> = ({
    signal,
  }) => getMarketingAnalyticsBio(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingAnalyticsBio>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingAnalyticsBioInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingAnalyticsBio>>
>;
export type GetMarketingAnalyticsBioInfiniteQueryError = unknown;

export function useGetMarketingAnalyticsBioInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingAnalyticsBio>>>,
  TError = unknown,
>(
  params: undefined | GetMarketingAnalyticsBioParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingAnalyticsBio>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingAnalyticsBio>>,
          TError,
          Awaited<ReturnType<typeof getMarketingAnalyticsBio>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsBioInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingAnalyticsBio>>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsBioParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingAnalyticsBio>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingAnalyticsBio>>,
          TError,
          Awaited<ReturnType<typeof getMarketingAnalyticsBio>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsBioInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingAnalyticsBio>>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsBioParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingAnalyticsBio>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Bio Page Insights: visitors, sources, button clicks, bookings, sign-ups and journeys in range
 */

export function useGetMarketingAnalyticsBioInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingAnalyticsBio>>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsBioParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingAnalyticsBio>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingAnalyticsBioInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingAnalyticsBioQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsBio>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsBioParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingAnalyticsBio>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingAnalyticsBioQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingAnalyticsBio>>> = ({
    signal,
  }) => getMarketingAnalyticsBio(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingAnalyticsBio>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingAnalyticsBioQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingAnalyticsBio>>
>;
export type GetMarketingAnalyticsBioQueryError = unknown;

export function useGetMarketingAnalyticsBio<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsBio>>,
  TError = unknown,
>(
  params: undefined | GetMarketingAnalyticsBioParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingAnalyticsBio>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingAnalyticsBio>>,
          TError,
          Awaited<ReturnType<typeof getMarketingAnalyticsBio>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsBio<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsBio>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsBioParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingAnalyticsBio>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingAnalyticsBio>>,
          TError,
          Awaited<ReturnType<typeof getMarketingAnalyticsBio>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsBio<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsBio>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsBioParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingAnalyticsBio>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Bio Page Insights: visitors, sources, button clicks, bookings, sign-ups and journeys in range
 */

export function useGetMarketingAnalyticsBio<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsBio>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsBioParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingAnalyticsBio>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingAnalyticsBioQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingAnalyticsBioSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsBio>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsBioParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingAnalyticsBio>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingAnalyticsBioQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingAnalyticsBio>>> = ({
    signal,
  }) => getMarketingAnalyticsBio(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingAnalyticsBio>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingAnalyticsBioSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingAnalyticsBio>>
>;
export type GetMarketingAnalyticsBioSuspenseQueryError = unknown;

export function useGetMarketingAnalyticsBioSuspense<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsBio>>,
  TError = unknown,
>(
  params: undefined | GetMarketingAnalyticsBioParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingAnalyticsBio>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsBioSuspense<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsBio>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsBioParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingAnalyticsBio>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsBioSuspense<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsBio>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsBioParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingAnalyticsBio>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Bio Page Insights: visitors, sources, button clicks, bookings, sign-ups and journeys in range
 */

export function useGetMarketingAnalyticsBioSuspense<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsBio>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsBioParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingAnalyticsBio>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingAnalyticsBioSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Bio Page Insights as CSV for the range (summary, sources, buttons; formula-neutralized, no PII)
 */
export const getMarketingAnalyticsBioExport = (
  params?: GetMarketingAnalyticsBioExportParams,
  signal?: AbortSignal
) => {
  return customInstance<string>({
    url: `/marketing/analytics/bio/export`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingAnalyticsBioExportInfiniteQueryKey = (
  params?: GetMarketingAnalyticsBioExportParams
) => {
  return ['infinite', `/marketing/analytics/bio/export`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingAnalyticsBioExportQueryKey = (
  params?: GetMarketingAnalyticsBioExportParams
) => {
  return [`/marketing/analytics/bio/export`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingAnalyticsBioExportInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsBioExportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingAnalyticsBioExportInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>> = ({
    signal,
  }) => getMarketingAnalyticsBioExport(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingAnalyticsBioExportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>
>;
export type GetMarketingAnalyticsBioExportInfiniteQueryError = unknown;

export function useGetMarketingAnalyticsBioExportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>>,
  TError = unknown,
>(
  params: undefined | GetMarketingAnalyticsBioExportParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsBioExportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsBioExportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsBioExportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsBioExportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Bio Page Insights as CSV for the range (summary, sources, buttons; formula-neutralized, no PII)
 */

export function useGetMarketingAnalyticsBioExportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsBioExportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingAnalyticsBioExportInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingAnalyticsBioExportQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsBioExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingAnalyticsBioExportQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>> = ({
    signal,
  }) => getMarketingAnalyticsBioExport(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingAnalyticsBioExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>
>;
export type GetMarketingAnalyticsBioExportQueryError = unknown;

export function useGetMarketingAnalyticsBioExport<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
  TError = unknown,
>(
  params: undefined | GetMarketingAnalyticsBioExportParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsBioExport<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsBioExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsBioExport<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsBioExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Bio Page Insights as CSV for the range (summary, sources, buttons; formula-neutralized, no PII)
 */

export function useGetMarketingAnalyticsBioExport<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsBioExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingAnalyticsBioExportQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingAnalyticsBioExportSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsBioExportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingAnalyticsBioExportQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>> = ({
    signal,
  }) => getMarketingAnalyticsBioExport(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingAnalyticsBioExportSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>
>;
export type GetMarketingAnalyticsBioExportSuspenseQueryError = unknown;

export function useGetMarketingAnalyticsBioExportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
  TError = unknown,
>(
  params: undefined | GetMarketingAnalyticsBioExportParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsBioExportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsBioExportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsBioExportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsBioExportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Bio Page Insights as CSV for the range (summary, sources, buttons; formula-neutralized, no PII)
 */

export function useGetMarketingAnalyticsBioExportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
  TError = unknown,
>(
  params?: GetMarketingAnalyticsBioExportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsBioExport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingAnalyticsBioExportSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Single-campaign report: people who signed up in the range + what they did within 30 days
 */
export const getMarketingAnalyticsCampaignsIdReport = (
  id: string,
  params?: GetMarketingAnalyticsCampaignsIdReportParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingAnalyticsCampaignsIdReport200>({
    url: `/marketing/analytics/campaigns/${id}/report`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingAnalyticsCampaignsIdReportInfiniteQueryKey = (
  id?: string,
  params?: GetMarketingAnalyticsCampaignsIdReportParams
) => {
  return [
    'infinite',
    `/marketing/analytics/campaigns/${id}/report`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMarketingAnalyticsCampaignsIdReportQueryKey = (
  id?: string,
  params?: GetMarketingAnalyticsCampaignsIdReportParams
) => {
  return [`/marketing/analytics/campaigns/${id}/report`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingAnalyticsCampaignsIdReportInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>>,
  TError = unknown,
>(
  id: string,
  params?: GetMarketingAnalyticsCampaignsIdReportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingAnalyticsCampaignsIdReportInfiniteQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>
  > = ({ signal }) => getMarketingAnalyticsCampaignsIdReport(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingAnalyticsCampaignsIdReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>
>;
export type GetMarketingAnalyticsCampaignsIdReportInfiniteQueryError = unknown;

export function useGetMarketingAnalyticsCampaignsIdReportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>>,
  TError = unknown,
>(
  id: string,
  params: undefined | GetMarketingAnalyticsCampaignsIdReportParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsCampaignsIdReportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>>,
  TError = unknown,
>(
  id: string,
  params?: GetMarketingAnalyticsCampaignsIdReportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsCampaignsIdReportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>>,
  TError = unknown,
>(
  id: string,
  params?: GetMarketingAnalyticsCampaignsIdReportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Single-campaign report: people who signed up in the range + what they did within 30 days
 */

export function useGetMarketingAnalyticsCampaignsIdReportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>>,
  TError = unknown,
>(
  id: string,
  params?: GetMarketingAnalyticsCampaignsIdReportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingAnalyticsCampaignsIdReportInfiniteQueryOptions(
    id,
    params,
    options
  );

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingAnalyticsCampaignsIdReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
  TError = unknown,
>(
  id: string,
  params?: GetMarketingAnalyticsCampaignsIdReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingAnalyticsCampaignsIdReportQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>
  > = ({ signal }) => getMarketingAnalyticsCampaignsIdReport(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingAnalyticsCampaignsIdReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>
>;
export type GetMarketingAnalyticsCampaignsIdReportQueryError = unknown;

export function useGetMarketingAnalyticsCampaignsIdReport<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
  TError = unknown,
>(
  id: string,
  params: undefined | GetMarketingAnalyticsCampaignsIdReportParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsCampaignsIdReport<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
  TError = unknown,
>(
  id: string,
  params?: GetMarketingAnalyticsCampaignsIdReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsCampaignsIdReport<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
  TError = unknown,
>(
  id: string,
  params?: GetMarketingAnalyticsCampaignsIdReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Single-campaign report: people who signed up in the range + what they did within 30 days
 */

export function useGetMarketingAnalyticsCampaignsIdReport<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
  TError = unknown,
>(
  id: string,
  params?: GetMarketingAnalyticsCampaignsIdReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingAnalyticsCampaignsIdReportQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingAnalyticsCampaignsIdReportSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
  TError = unknown,
>(
  id: string,
  params?: GetMarketingAnalyticsCampaignsIdReportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingAnalyticsCampaignsIdReportQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>
  > = ({ signal }) => getMarketingAnalyticsCampaignsIdReport(id, params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingAnalyticsCampaignsIdReportSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>
>;
export type GetMarketingAnalyticsCampaignsIdReportSuspenseQueryError = unknown;

export function useGetMarketingAnalyticsCampaignsIdReportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
  TError = unknown,
>(
  id: string,
  params: undefined | GetMarketingAnalyticsCampaignsIdReportParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsCampaignsIdReportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
  TError = unknown,
>(
  id: string,
  params?: GetMarketingAnalyticsCampaignsIdReportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingAnalyticsCampaignsIdReportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
  TError = unknown,
>(
  id: string,
  params?: GetMarketingAnalyticsCampaignsIdReportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Single-campaign report: people who signed up in the range + what they did within 30 days
 */

export function useGetMarketingAnalyticsCampaignsIdReportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
  TError = unknown,
>(
  id: string,
  params?: GetMarketingAnalyticsCampaignsIdReportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingAnalyticsCampaignsIdReport>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingAnalyticsCampaignsIdReportSuspenseQueryOptions(
    id,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Sends history (non-draft batches, newest first), paged, optionally Texts or Emails only
 */
export const getMarketingBulkSms = (params?: GetMarketingBulkSmsParams, signal?: AbortSignal) => {
  return customInstance<GetMarketingBulkSms200>({
    url: `/marketing/bulk-sms`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingBulkSmsInfiniteQueryKey = (params?: GetMarketingBulkSmsParams) => {
  return ['infinite', `/marketing/bulk-sms`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingBulkSmsQueryKey = (params?: GetMarketingBulkSmsParams) => {
  return [`/marketing/bulk-sms`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingBulkSmsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkSms>>>,
  TError = void,
>(
  params?: GetMarketingBulkSmsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSms>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingBulkSmsInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingBulkSms>>> = ({ signal }) =>
    getMarketingBulkSms(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingBulkSms>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingBulkSmsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingBulkSms>>
>;
export type GetMarketingBulkSmsInfiniteQueryError = void;

export function useGetMarketingBulkSmsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkSms>>>,
  TError = void,
>(
  params: undefined | GetMarketingBulkSmsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSms>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingBulkSms>>,
          TError,
          Awaited<ReturnType<typeof getMarketingBulkSms>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkSmsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkSms>>>,
  TError = void,
>(
  params?: GetMarketingBulkSmsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSms>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingBulkSms>>,
          TError,
          Awaited<ReturnType<typeof getMarketingBulkSms>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkSmsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkSms>>>,
  TError = void,
>(
  params?: GetMarketingBulkSmsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSms>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Sends history (non-draft batches, newest first), paged, optionally Texts or Emails only
 */

export function useGetMarketingBulkSmsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkSms>>>,
  TError = void,
>(
  params?: GetMarketingBulkSmsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSms>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingBulkSmsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingBulkSmsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingBulkSms>>,
  TError = void,
>(
  params?: GetMarketingBulkSmsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSms>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingBulkSmsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingBulkSms>>> = ({ signal }) =>
    getMarketingBulkSms(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingBulkSms>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingBulkSmsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingBulkSms>>
>;
export type GetMarketingBulkSmsQueryError = void;

export function useGetMarketingBulkSms<
  TData = Awaited<ReturnType<typeof getMarketingBulkSms>>,
  TError = void,
>(
  params: undefined | GetMarketingBulkSmsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSms>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingBulkSms>>,
          TError,
          Awaited<ReturnType<typeof getMarketingBulkSms>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkSms<
  TData = Awaited<ReturnType<typeof getMarketingBulkSms>>,
  TError = void,
>(
  params?: GetMarketingBulkSmsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSms>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingBulkSms>>,
          TError,
          Awaited<ReturnType<typeof getMarketingBulkSms>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkSms<
  TData = Awaited<ReturnType<typeof getMarketingBulkSms>>,
  TError = void,
>(
  params?: GetMarketingBulkSmsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSms>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Sends history (non-draft batches, newest first), paged, optionally Texts or Emails only
 */

export function useGetMarketingBulkSms<
  TData = Awaited<ReturnType<typeof getMarketingBulkSms>>,
  TError = void,
>(
  params?: GetMarketingBulkSmsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSms>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingBulkSmsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingBulkSmsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingBulkSms>>,
  TError = void,
>(
  params?: GetMarketingBulkSmsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSms>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingBulkSmsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingBulkSms>>> = ({ signal }) =>
    getMarketingBulkSms(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingBulkSms>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingBulkSmsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingBulkSms>>
>;
export type GetMarketingBulkSmsSuspenseQueryError = void;

export function useGetMarketingBulkSmsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingBulkSms>>,
  TError = void,
>(
  params: undefined | GetMarketingBulkSmsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSms>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkSmsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingBulkSms>>,
  TError = void,
>(
  params?: GetMarketingBulkSmsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSms>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkSmsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingBulkSms>>,
  TError = void,
>(
  params?: GetMarketingBulkSmsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSms>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Sends history (non-draft batches, newest first), paged, optionally Texts or Emails only
 */

export function useGetMarketingBulkSmsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingBulkSms>>,
  TError = void,
>(
  params?: GetMarketingBulkSmsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSms>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingBulkSmsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a bulk Text (default) or Email draft from a Leads selection, a Clients-page view / ticked rows, or a sent email's group (Text only)
 */
export const postMarketingBulkSms = (
  postMarketingBulkSmsBody: PostMarketingBulkSmsBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingBulkSms201>({
    url: `/marketing/bulk-sms`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingBulkSmsBody,
    signal,
  });
};

export const getPostMarketingBulkSmsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingBulkSms>>,
    TError,
    { data: PostMarketingBulkSmsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingBulkSms>>,
  TError,
  { data: PostMarketingBulkSmsBody },
  TContext
> => {
  const mutationKey = ['postMarketingBulkSms'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingBulkSms>>,
    { data: PostMarketingBulkSmsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMarketingBulkSms(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingBulkSmsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingBulkSms>>
>;
export type PostMarketingBulkSmsMutationBody = PostMarketingBulkSmsBody;
export type PostMarketingBulkSmsMutationError = void;

/**
 * @summary Create a bulk Text (default) or Email draft from a Leads selection, a Clients-page view / ticked rows, or a sent email's group (Text only)
 */
export const usePostMarketingBulkSms = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingBulkSms>>,
      TError,
      { data: PostMarketingBulkSmsBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingBulkSms>>,
  TError,
  { data: PostMarketingBulkSmsBody },
  TContext
> => {
  const mutationOptions = getPostMarketingBulkSmsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Bulk send detail (draft: exclusions, gates + sending plan live; sent: progress incl. daily-wave state)
 */
export const getMarketingBulkSmsId = (id: string, signal?: AbortSignal) => {
  return customInstance<GetMarketingBulkSmsId200>({
    url: `/marketing/bulk-sms/${id}`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingBulkSmsIdInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/marketing/bulk-sms/${id}`] as const;
};

export const getGetMarketingBulkSmsIdQueryKey = (id?: string) => {
  return [`/marketing/bulk-sms/${id}`] as const;
};

export const getGetMarketingBulkSmsIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkSmsId>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSmsId>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingBulkSmsIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingBulkSmsId>>> = ({ signal }) =>
    getMarketingBulkSmsId(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingBulkSmsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingBulkSmsIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingBulkSmsId>>
>;
export type GetMarketingBulkSmsIdInfiniteQueryError = unknown;

export function useGetMarketingBulkSmsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkSmsId>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSmsId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingBulkSmsId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingBulkSmsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkSmsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkSmsId>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSmsId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingBulkSmsId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingBulkSmsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkSmsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkSmsId>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSmsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Bulk send detail (draft: exclusions, gates + sending plan live; sent: progress incl. daily-wave state)
 */

export function useGetMarketingBulkSmsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkSmsId>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSmsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingBulkSmsIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingBulkSmsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingBulkSmsId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSmsId>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingBulkSmsIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingBulkSmsId>>> = ({ signal }) =>
    getMarketingBulkSmsId(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingBulkSmsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingBulkSmsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingBulkSmsId>>
>;
export type GetMarketingBulkSmsIdQueryError = unknown;

export function useGetMarketingBulkSmsId<
  TData = Awaited<ReturnType<typeof getMarketingBulkSmsId>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSmsId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingBulkSmsId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingBulkSmsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkSmsId<
  TData = Awaited<ReturnType<typeof getMarketingBulkSmsId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSmsId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingBulkSmsId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingBulkSmsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkSmsId<
  TData = Awaited<ReturnType<typeof getMarketingBulkSmsId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSmsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Bulk send detail (draft: exclusions, gates + sending plan live; sent: progress incl. daily-wave state)
 */

export function useGetMarketingBulkSmsId<
  TData = Awaited<ReturnType<typeof getMarketingBulkSmsId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSmsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingBulkSmsIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingBulkSmsIdSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingBulkSmsId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSmsId>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingBulkSmsIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingBulkSmsId>>> = ({ signal }) =>
    getMarketingBulkSmsId(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingBulkSmsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingBulkSmsIdSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingBulkSmsId>>
>;
export type GetMarketingBulkSmsIdSuspenseQueryError = unknown;

export function useGetMarketingBulkSmsIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingBulkSmsId>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSmsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkSmsIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingBulkSmsId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSmsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkSmsIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingBulkSmsId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSmsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Bulk send detail (draft: exclusions, gates + sending plan live; sent: progress incl. daily-wave state)
 */

export function useGetMarketingBulkSmsIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingBulkSmsId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSmsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingBulkSmsIdSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Save the message body (DRAFT, or PAUSED before a resume) — returns the length + cost line only
 */
export const patchMarketingBulkSmsId = (
  id: string,
  patchMarketingBulkSmsIdBody: PatchMarketingBulkSmsIdBody
) => {
  return customInstance<PatchMarketingBulkSmsId200>({
    url: `/marketing/bulk-sms/${id}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchMarketingBulkSmsIdBody,
  });
};

export const getPatchMarketingBulkSmsIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMarketingBulkSmsId>>,
    TError,
    { id: string; data: PatchMarketingBulkSmsIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMarketingBulkSmsId>>,
  TError,
  { id: string; data: PatchMarketingBulkSmsIdBody },
  TContext
> => {
  const mutationKey = ['patchMarketingBulkSmsId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMarketingBulkSmsId>>,
    { id: string; data: PatchMarketingBulkSmsIdBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return patchMarketingBulkSmsId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMarketingBulkSmsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchMarketingBulkSmsId>>
>;
export type PatchMarketingBulkSmsIdMutationBody = PatchMarketingBulkSmsIdBody;
export type PatchMarketingBulkSmsIdMutationError = void;

/**
 * @summary Save the message body (DRAFT, or PAUSED before a resume) — returns the length + cost line only
 */
export const usePatchMarketingBulkSmsId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchMarketingBulkSmsId>>,
      TError,
      { id: string; data: PatchMarketingBulkSmsIdBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchMarketingBulkSmsId>>,
  TError,
  { id: string; data: PatchMarketingBulkSmsIdBody },
  TContext
> => {
  const mutationOptions = getPatchMarketingBulkSmsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Discard a draft bulk send (DRAFT only)
 */
export const deleteMarketingBulkSmsId = (id: string) => {
  return customInstance<DeleteMarketingBulkSmsId200>({
    url: `/marketing/bulk-sms/${id}`,
    method: 'DELETE',
  });
};

export const getDeleteMarketingBulkSmsIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMarketingBulkSmsId>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMarketingBulkSmsId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteMarketingBulkSmsId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMarketingBulkSmsId>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteMarketingBulkSmsId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMarketingBulkSmsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMarketingBulkSmsId>>
>;

export type DeleteMarketingBulkSmsIdMutationError = void;

/**
 * @summary Discard a draft bulk send (DRAFT only)
 */
export const useDeleteMarketingBulkSmsId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMarketingBulkSmsId>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMarketingBulkSmsId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteMarketingBulkSmsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary A draft's texts against this month's plan: texts left, extra texts, their cost and whether the spending cap allows it
 */
export const getMarketingBulkSmsIdPlanQuote = (id: string, signal?: AbortSignal) => {
  return customInstance<GetMarketingBulkSmsIdPlanQuote200>({
    url: `/marketing/bulk-sms/${id}/plan-quote`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingBulkSmsIdPlanQuoteInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/marketing/bulk-sms/${id}/plan-quote`] as const;
};

export const getGetMarketingBulkSmsIdPlanQuoteQueryKey = (id?: string) => {
  return [`/marketing/bulk-sms/${id}/plan-quote`] as const;
};

export const getGetMarketingBulkSmsIdPlanQuoteInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingBulkSmsIdPlanQuoteInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>> = ({
    signal,
  }) => getMarketingBulkSmsIdPlanQuote(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingBulkSmsIdPlanQuoteInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>
>;
export type GetMarketingBulkSmsIdPlanQuoteInfiniteQueryError = void;

export function useGetMarketingBulkSmsIdPlanQuoteInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
          TError,
          Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkSmsIdPlanQuoteInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
          TError,
          Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkSmsIdPlanQuoteInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A draft's texts against this month's plan: texts left, extra texts, their cost and whether the spending cap allows it
 */

export function useGetMarketingBulkSmsIdPlanQuoteInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingBulkSmsIdPlanQuoteInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingBulkSmsIdPlanQuoteQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingBulkSmsIdPlanQuoteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>> = ({
    signal,
  }) => getMarketingBulkSmsIdPlanQuote(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingBulkSmsIdPlanQuoteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>
>;
export type GetMarketingBulkSmsIdPlanQuoteQueryError = void;

export function useGetMarketingBulkSmsIdPlanQuote<
  TData = Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
          TError,
          Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkSmsIdPlanQuote<
  TData = Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
          TError,
          Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkSmsIdPlanQuote<
  TData = Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A draft's texts against this month's plan: texts left, extra texts, their cost and whether the spending cap allows it
 */

export function useGetMarketingBulkSmsIdPlanQuote<
  TData = Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingBulkSmsIdPlanQuoteQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingBulkSmsIdPlanQuoteSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingBulkSmsIdPlanQuoteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>> = ({
    signal,
  }) => getMarketingBulkSmsIdPlanQuote(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingBulkSmsIdPlanQuoteSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>
>;
export type GetMarketingBulkSmsIdPlanQuoteSuspenseQueryError = void;

export function useGetMarketingBulkSmsIdPlanQuoteSuspense<
  TData = Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkSmsIdPlanQuoteSuspense<
  TData = Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkSmsIdPlanQuoteSuspense<
  TData = Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A draft's texts against this month's plan: texts left, extra texts, their cost and whether the spending cap allows it
 */

export function useGetMarketingBulkSmsIdPlanQuoteSuspense<
  TData = Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkSmsIdPlanQuote>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingBulkSmsIdPlanQuoteSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Send a draft (fail-closed gate + plan re-check, then the first daily wave is queued — now or at the next sending-hours opening; an email may pick `sendAt`)
 */
export const postMarketingBulkSmsIdSend = (
  id: string,
  postMarketingBulkSmsIdSendBody?: PostMarketingBulkSmsIdSendBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingBulkSmsIdSend200>({
    url: `/marketing/bulk-sms/${id}/send`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingBulkSmsIdSendBody,
    signal,
  });
};

export const getPostMarketingBulkSmsIdSendMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingBulkSmsIdSend>>,
    TError,
    { id: string; data: PostMarketingBulkSmsIdSendBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingBulkSmsIdSend>>,
  TError,
  { id: string; data: PostMarketingBulkSmsIdSendBody },
  TContext
> => {
  const mutationKey = ['postMarketingBulkSmsIdSend'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingBulkSmsIdSend>>,
    { id: string; data: PostMarketingBulkSmsIdSendBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return postMarketingBulkSmsIdSend(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingBulkSmsIdSendMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingBulkSmsIdSend>>
>;
export type PostMarketingBulkSmsIdSendMutationBody = PostMarketingBulkSmsIdSendBody;
export type PostMarketingBulkSmsIdSendMutationError = void;

/**
 * @summary Send a draft (fail-closed gate + plan re-check, then the first daily wave is queued — now or at the next sending-hours opening; an email may pick `sendAt`)
 */
export const usePostMarketingBulkSmsIdSend = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingBulkSmsIdSend>>,
      TError,
      { id: string; data: PostMarketingBulkSmsIdSendBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingBulkSmsIdSend>>,
  TError,
  { id: string; data: PostMarketingBulkSmsIdSendBody },
  TContext
> => {
  const mutationOptions = getPostMarketingBulkSmsIdSendMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Pause a queued / sending / held bulk SMS (stops within one text; Resume continues it)
 */
export const postMarketingBulkSmsIdPause = (id: string, signal?: AbortSignal) => {
  return customInstance<PostMarketingBulkSmsIdPause200>({
    url: `/marketing/bulk-sms/${id}/pause`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingBulkSmsIdPauseMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingBulkSmsIdPause>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingBulkSmsIdPause>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postMarketingBulkSmsIdPause'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingBulkSmsIdPause>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postMarketingBulkSmsIdPause(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingBulkSmsIdPauseMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingBulkSmsIdPause>>
>;

export type PostMarketingBulkSmsIdPauseMutationError = void;

/**
 * @summary Pause a queued / sending / held bulk SMS (stops within one text; Resume continues it)
 */
export const usePostMarketingBulkSmsIdPause = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingBulkSmsIdPause>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingBulkSmsIdPause>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostMarketingBulkSmsIdPauseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Resume a paused bulk SMS (gates re-checked live; starts now or at the next sending-hours opening)
 */
export const postMarketingBulkSmsIdResume = (id: string, signal?: AbortSignal) => {
  return customInstance<PostMarketingBulkSmsIdResume200>({
    url: `/marketing/bulk-sms/${id}/resume`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingBulkSmsIdResumeMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingBulkSmsIdResume>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingBulkSmsIdResume>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postMarketingBulkSmsIdResume'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingBulkSmsIdResume>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postMarketingBulkSmsIdResume(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingBulkSmsIdResumeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingBulkSmsIdResume>>
>;

export type PostMarketingBulkSmsIdResumeMutationError = void;

/**
 * @summary Resume a paused bulk SMS (gates re-checked live; starts now or at the next sending-hours opening)
 */
export const usePostMarketingBulkSmsIdResume = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingBulkSmsIdResume>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingBulkSmsIdResume>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostMarketingBulkSmsIdResumeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Cancel a queued / sending / held / paused bulk SMS
 */
export const postMarketingBulkSmsIdCancel = (id: string, signal?: AbortSignal) => {
  return customInstance<PostMarketingBulkSmsIdCancel200>({
    url: `/marketing/bulk-sms/${id}/cancel`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingBulkSmsIdCancelMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingBulkSmsIdCancel>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingBulkSmsIdCancel>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postMarketingBulkSmsIdCancel'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingBulkSmsIdCancel>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postMarketingBulkSmsIdCancel(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingBulkSmsIdCancelMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingBulkSmsIdCancel>>
>;

export type PostMarketingBulkSmsIdCancelMutationError = void;

/**
 * @summary Cancel a queued / sending / held / paused bulk SMS
 */
export const usePostMarketingBulkSmsIdCancel = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingBulkSmsIdCancel>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingBulkSmsIdCancel>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostMarketingBulkSmsIdCancelMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Upload the email's photo (re-encoded as a JPEG ≤ 1200 px wide; replaces the current one)
 */
export const postMarketingBulkEmailIdPhoto = (
  id: string,
  postMarketingBulkEmailIdPhotoBody: PostMarketingBulkEmailIdPhotoBody,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(`image`, postMarketingBulkEmailIdPhotoBody.image);

  return customInstance<PostMarketingBulkEmailIdPhoto200>({
    url: `/marketing/bulk-email/${id}/photo`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getPostMarketingBulkEmailIdPhotoMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingBulkEmailIdPhoto>>,
    TError,
    { id: string; data: PostMarketingBulkEmailIdPhotoBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingBulkEmailIdPhoto>>,
  TError,
  { id: string; data: PostMarketingBulkEmailIdPhotoBody },
  TContext
> => {
  const mutationKey = ['postMarketingBulkEmailIdPhoto'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingBulkEmailIdPhoto>>,
    { id: string; data: PostMarketingBulkEmailIdPhotoBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return postMarketingBulkEmailIdPhoto(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingBulkEmailIdPhotoMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingBulkEmailIdPhoto>>
>;
export type PostMarketingBulkEmailIdPhotoMutationBody = PostMarketingBulkEmailIdPhotoBody;
export type PostMarketingBulkEmailIdPhotoMutationError = void;

/**
 * @summary Upload the email's photo (re-encoded as a JPEG ≤ 1200 px wide; replaces the current one)
 */
export const usePostMarketingBulkEmailIdPhoto = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingBulkEmailIdPhoto>>,
      TError,
      { id: string; data: PostMarketingBulkEmailIdPhotoBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingBulkEmailIdPhoto>>,
  TError,
  { id: string; data: PostMarketingBulkEmailIdPhotoBody },
  TContext
> => {
  const mutationOptions = getPostMarketingBulkEmailIdPhotoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Remove the email's photo
 */
export const deleteMarketingBulkEmailIdPhoto = (id: string) => {
  return customInstance<DeleteMarketingBulkEmailIdPhoto200>({
    url: `/marketing/bulk-email/${id}/photo`,
    method: 'DELETE',
  });
};

export const getDeleteMarketingBulkEmailIdPhotoMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMarketingBulkEmailIdPhoto>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMarketingBulkEmailIdPhoto>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteMarketingBulkEmailIdPhoto'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMarketingBulkEmailIdPhoto>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteMarketingBulkEmailIdPhoto(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMarketingBulkEmailIdPhotoMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMarketingBulkEmailIdPhoto>>
>;

export type DeleteMarketingBulkEmailIdPhotoMutationError = void;

/**
 * @summary Remove the email's photo
 */
export const useDeleteMarketingBulkEmailIdPhoto = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMarketingBulkEmailIdPhoto>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMarketingBulkEmailIdPhoto>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteMarketingBulkEmailIdPhotoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Draft the subject + body with AI from the current draft and an optional hint (returned, not saved)
 */
export const postMarketingBulkEmailIdWriteWithAi = (
  id: string,
  postMarketingBulkEmailIdWriteWithAiBody?: PostMarketingBulkEmailIdWriteWithAiBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingBulkEmailIdWriteWithAi200>({
    url: `/marketing/bulk-email/${id}/write-with-ai`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingBulkEmailIdWriteWithAiBody,
    signal,
  });
};

export const getPostMarketingBulkEmailIdWriteWithAiMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingBulkEmailIdWriteWithAi>>,
    TError,
    { id: string; data: PostMarketingBulkEmailIdWriteWithAiBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingBulkEmailIdWriteWithAi>>,
  TError,
  { id: string; data: PostMarketingBulkEmailIdWriteWithAiBody },
  TContext
> => {
  const mutationKey = ['postMarketingBulkEmailIdWriteWithAi'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingBulkEmailIdWriteWithAi>>,
    { id: string; data: PostMarketingBulkEmailIdWriteWithAiBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return postMarketingBulkEmailIdWriteWithAi(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingBulkEmailIdWriteWithAiMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingBulkEmailIdWriteWithAi>>
>;
export type PostMarketingBulkEmailIdWriteWithAiMutationBody =
  PostMarketingBulkEmailIdWriteWithAiBody;
export type PostMarketingBulkEmailIdWriteWithAiMutationError = void;

/**
 * @summary Draft the subject + body with AI from the current draft and an optional hint (returned, not saved)
 */
export const usePostMarketingBulkEmailIdWriteWithAi = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingBulkEmailIdWriteWithAi>>,
      TError,
      { id: string; data: PostMarketingBulkEmailIdWriteWithAiBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingBulkEmailIdWriteWithAi>>,
  TError,
  { id: string; data: PostMarketingBulkEmailIdWriteWithAiBody },
  TContext
> => {
  const mutationOptions = getPostMarketingBulkEmailIdWriteWithAiMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Send the email as clients will see it to the signed-in person's own address ([Test], not counted)
 */
export const postMarketingBulkEmailIdTest = (id: string, signal?: AbortSignal) => {
  return customInstance<PostMarketingBulkEmailIdTest200>({
    url: `/marketing/bulk-email/${id}/test`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingBulkEmailIdTestMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingBulkEmailIdTest>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingBulkEmailIdTest>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postMarketingBulkEmailIdTest'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingBulkEmailIdTest>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postMarketingBulkEmailIdTest(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingBulkEmailIdTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingBulkEmailIdTest>>
>;

export type PostMarketingBulkEmailIdTestMutationError = void;

/**
 * @summary Send the email as clients will see it to the signed-in person's own address ([Test], not counted)
 */
export const usePostMarketingBulkEmailIdTest = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingBulkEmailIdTest>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingBulkEmailIdTest>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostMarketingBulkEmailIdTestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Save the email subject / body / button (DRAFT, or PAUSED before a resume) — returns content, rail and checklist
 */
export const patchMarketingBulkEmailId = (
  id: string,
  patchMarketingBulkEmailIdBody: PatchMarketingBulkEmailIdBody
) => {
  return customInstance<PatchMarketingBulkEmailId200>({
    url: `/marketing/bulk-email/${id}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchMarketingBulkEmailIdBody,
  });
};

export const getPatchMarketingBulkEmailIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMarketingBulkEmailId>>,
    TError,
    { id: string; data: PatchMarketingBulkEmailIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMarketingBulkEmailId>>,
  TError,
  { id: string; data: PatchMarketingBulkEmailIdBody },
  TContext
> => {
  const mutationKey = ['patchMarketingBulkEmailId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMarketingBulkEmailId>>,
    { id: string; data: PatchMarketingBulkEmailIdBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return patchMarketingBulkEmailId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMarketingBulkEmailIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchMarketingBulkEmailId>>
>;
export type PatchMarketingBulkEmailIdMutationBody = PatchMarketingBulkEmailIdBody;
export type PatchMarketingBulkEmailIdMutationError = void;

/**
 * @summary Save the email subject / body / button (DRAFT, or PAUSED before a resume) — returns content, rail and checklist
 */
export const usePatchMarketingBulkEmailId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchMarketingBulkEmailId>>,
      TError,
      { id: string; data: PatchMarketingBulkEmailIdBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchMarketingBulkEmailId>>,
  TError,
  { id: string; data: PatchMarketingBulkEmailIdBody },
  TContext
> => {
  const mutationOptions = getPatchMarketingBulkEmailIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Who an email is for, left out (by reason), didn't arrive or didn't click — names only, 50 a page
 */
export const getMarketingBulkEmailIdRecipients = (
  id: string,
  params: GetMarketingBulkEmailIdRecipientsParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingBulkEmailIdRecipients200>({
    url: `/marketing/bulk-email/${id}/recipients`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingBulkEmailIdRecipientsInfiniteQueryKey = (
  id?: string,
  params?: GetMarketingBulkEmailIdRecipientsParams
) => {
  return [
    'infinite',
    `/marketing/bulk-email/${id}/recipients`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMarketingBulkEmailIdRecipientsQueryKey = (
  id?: string,
  params?: GetMarketingBulkEmailIdRecipientsParams
) => {
  return [`/marketing/bulk-email/${id}/recipients`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingBulkEmailIdRecipientsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>>,
  TError = void,
>(
  id: string,
  params: GetMarketingBulkEmailIdRecipientsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingBulkEmailIdRecipientsInfiniteQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>> = ({
    signal,
  }) => getMarketingBulkEmailIdRecipients(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingBulkEmailIdRecipientsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>
>;
export type GetMarketingBulkEmailIdRecipientsInfiniteQueryError = void;

export function useGetMarketingBulkEmailIdRecipientsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>>,
  TError = void,
>(
  id: string,
  params: GetMarketingBulkEmailIdRecipientsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
          TError,
          Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkEmailIdRecipientsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>>,
  TError = void,
>(
  id: string,
  params: GetMarketingBulkEmailIdRecipientsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
          TError,
          Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkEmailIdRecipientsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>>,
  TError = void,
>(
  id: string,
  params: GetMarketingBulkEmailIdRecipientsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Who an email is for, left out (by reason), didn't arrive or didn't click — names only, 50 a page
 */

export function useGetMarketingBulkEmailIdRecipientsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>>,
  TError = void,
>(
  id: string,
  params: GetMarketingBulkEmailIdRecipientsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingBulkEmailIdRecipientsInfiniteQueryOptions(
    id,
    params,
    options
  );

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingBulkEmailIdRecipientsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
  TError = void,
>(
  id: string,
  params: GetMarketingBulkEmailIdRecipientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingBulkEmailIdRecipientsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>> = ({
    signal,
  }) => getMarketingBulkEmailIdRecipients(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingBulkEmailIdRecipientsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>
>;
export type GetMarketingBulkEmailIdRecipientsQueryError = void;

export function useGetMarketingBulkEmailIdRecipients<
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
  TError = void,
>(
  id: string,
  params: GetMarketingBulkEmailIdRecipientsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
          TError,
          Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkEmailIdRecipients<
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
  TError = void,
>(
  id: string,
  params: GetMarketingBulkEmailIdRecipientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
          TError,
          Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkEmailIdRecipients<
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
  TError = void,
>(
  id: string,
  params: GetMarketingBulkEmailIdRecipientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Who an email is for, left out (by reason), didn't arrive or didn't click — names only, 50 a page
 */

export function useGetMarketingBulkEmailIdRecipients<
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
  TError = void,
>(
  id: string,
  params: GetMarketingBulkEmailIdRecipientsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingBulkEmailIdRecipientsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingBulkEmailIdRecipientsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
  TError = void,
>(
  id: string,
  params: GetMarketingBulkEmailIdRecipientsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingBulkEmailIdRecipientsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>> = ({
    signal,
  }) => getMarketingBulkEmailIdRecipients(id, params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingBulkEmailIdRecipientsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>
>;
export type GetMarketingBulkEmailIdRecipientsSuspenseQueryError = void;

export function useGetMarketingBulkEmailIdRecipientsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
  TError = void,
>(
  id: string,
  params: GetMarketingBulkEmailIdRecipientsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkEmailIdRecipientsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
  TError = void,
>(
  id: string,
  params: GetMarketingBulkEmailIdRecipientsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkEmailIdRecipientsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
  TError = void,
>(
  id: string,
  params: GetMarketingBulkEmailIdRecipientsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Who an email is for, left out (by reason), didn't arrive or didn't click — names only, 50 a page
 */

export function useGetMarketingBulkEmailIdRecipientsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
  TError = void,
>(
  id: string,
  params: GetMarketingBulkEmailIdRecipientsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdRecipients>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingBulkEmailIdRecipientsSuspenseQueryOptions(
    id,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Who booked from this email (within 7 days of clicking), in click order — 50 a page
 */
export const getMarketingBulkEmailIdBookings = (
  id: string,
  params?: GetMarketingBulkEmailIdBookingsParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingBulkEmailIdBookings200>({
    url: `/marketing/bulk-email/${id}/bookings`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingBulkEmailIdBookingsInfiniteQueryKey = (
  id?: string,
  params?: GetMarketingBulkEmailIdBookingsParams
) => {
  return ['infinite', `/marketing/bulk-email/${id}/bookings`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingBulkEmailIdBookingsQueryKey = (
  id?: string,
  params?: GetMarketingBulkEmailIdBookingsParams
) => {
  return [`/marketing/bulk-email/${id}/bookings`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingBulkEmailIdBookingsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingBulkEmailIdBookingsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingBulkEmailIdBookingsInfiniteQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>> = ({
    signal,
  }) => getMarketingBulkEmailIdBookings(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingBulkEmailIdBookingsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>
>;
export type GetMarketingBulkEmailIdBookingsInfiniteQueryError = void;

export function useGetMarketingBulkEmailIdBookingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>>,
  TError = void,
>(
  id: string,
  params: undefined | GetMarketingBulkEmailIdBookingsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
          TError,
          Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkEmailIdBookingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingBulkEmailIdBookingsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
          TError,
          Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkEmailIdBookingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingBulkEmailIdBookingsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Who booked from this email (within 7 days of clicking), in click order — 50 a page
 */

export function useGetMarketingBulkEmailIdBookingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingBulkEmailIdBookingsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingBulkEmailIdBookingsInfiniteQueryOptions(id, params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingBulkEmailIdBookingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingBulkEmailIdBookingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingBulkEmailIdBookingsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>> = ({
    signal,
  }) => getMarketingBulkEmailIdBookings(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingBulkEmailIdBookingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>
>;
export type GetMarketingBulkEmailIdBookingsQueryError = void;

export function useGetMarketingBulkEmailIdBookings<
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
  TError = void,
>(
  id: string,
  params: undefined | GetMarketingBulkEmailIdBookingsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
          TError,
          Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkEmailIdBookings<
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingBulkEmailIdBookingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
          TError,
          Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkEmailIdBookings<
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingBulkEmailIdBookingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Who booked from this email (within 7 days of clicking), in click order — 50 a page
 */

export function useGetMarketingBulkEmailIdBookings<
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingBulkEmailIdBookingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingBulkEmailIdBookingsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingBulkEmailIdBookingsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingBulkEmailIdBookingsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingBulkEmailIdBookingsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>> = ({
    signal,
  }) => getMarketingBulkEmailIdBookings(id, params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingBulkEmailIdBookingsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>
>;
export type GetMarketingBulkEmailIdBookingsSuspenseQueryError = void;

export function useGetMarketingBulkEmailIdBookingsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
  TError = void,
>(
  id: string,
  params: undefined | GetMarketingBulkEmailIdBookingsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkEmailIdBookingsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingBulkEmailIdBookingsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkEmailIdBookingsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingBulkEmailIdBookingsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Who booked from this email (within 7 days of clicking), in click order — 50 a page
 */

export function useGetMarketingBulkEmailIdBookingsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingBulkEmailIdBookingsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdBookings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingBulkEmailIdBookingsSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Download who booked from this email as CSV (names and salon-time dates only)
 */
export const getMarketingBulkEmailIdBookingsCsv = (id: string, signal?: AbortSignal) => {
  return customInstance<string>({
    url: `/marketing/bulk-email/${id}/bookings.csv`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingBulkEmailIdBookingsCsvInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/marketing/bulk-email/${id}/bookings.csv`] as const;
};

export const getGetMarketingBulkEmailIdBookingsCsvQueryKey = (id?: string) => {
  return [`/marketing/bulk-email/${id}/bookings.csv`] as const;
};

export const getGetMarketingBulkEmailIdBookingsCsvInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingBulkEmailIdBookingsCsvInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>> = ({
    signal,
  }) => getMarketingBulkEmailIdBookingsCsv(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingBulkEmailIdBookingsCsvInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>
>;
export type GetMarketingBulkEmailIdBookingsCsvInfiniteQueryError = void;

export function useGetMarketingBulkEmailIdBookingsCsvInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
          TError,
          Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkEmailIdBookingsCsvInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
          TError,
          Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkEmailIdBookingsCsvInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Download who booked from this email as CSV (names and salon-time dates only)
 */

export function useGetMarketingBulkEmailIdBookingsCsvInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingBulkEmailIdBookingsCsvInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingBulkEmailIdBookingsCsvQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingBulkEmailIdBookingsCsvQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>> = ({
    signal,
  }) => getMarketingBulkEmailIdBookingsCsv(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingBulkEmailIdBookingsCsvQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>
>;
export type GetMarketingBulkEmailIdBookingsCsvQueryError = void;

export function useGetMarketingBulkEmailIdBookingsCsv<
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
          TError,
          Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkEmailIdBookingsCsv<
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
          TError,
          Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkEmailIdBookingsCsv<
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Download who booked from this email as CSV (names and salon-time dates only)
 */

export function useGetMarketingBulkEmailIdBookingsCsv<
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingBulkEmailIdBookingsCsvQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingBulkEmailIdBookingsCsvSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingBulkEmailIdBookingsCsvQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>> = ({
    signal,
  }) => getMarketingBulkEmailIdBookingsCsv(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingBulkEmailIdBookingsCsvSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>
>;
export type GetMarketingBulkEmailIdBookingsCsvSuspenseQueryError = void;

export function useGetMarketingBulkEmailIdBookingsCsvSuspense<
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkEmailIdBookingsCsvSuspense<
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingBulkEmailIdBookingsCsvSuspense<
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Download who booked from this email as CSV (names and salon-time dates only)
 */

export function useGetMarketingBulkEmailIdBookingsCsvSuspense<
  TData = Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingBulkEmailIdBookingsCsv>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingBulkEmailIdBookingsCsvSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Switch a draft between Text and Email (same people; returns the full detail)
 */
export const patchMarketingBulkSmsIdChannel = (
  id: string,
  patchMarketingBulkSmsIdChannelBody: PatchMarketingBulkSmsIdChannelBody
) => {
  return customInstance<PatchMarketingBulkSmsIdChannel200>({
    url: `/marketing/bulk-sms/${id}/channel`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchMarketingBulkSmsIdChannelBody,
  });
};

export const getPatchMarketingBulkSmsIdChannelMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMarketingBulkSmsIdChannel>>,
    TError,
    { id: string; data: PatchMarketingBulkSmsIdChannelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMarketingBulkSmsIdChannel>>,
  TError,
  { id: string; data: PatchMarketingBulkSmsIdChannelBody },
  TContext
> => {
  const mutationKey = ['patchMarketingBulkSmsIdChannel'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMarketingBulkSmsIdChannel>>,
    { id: string; data: PatchMarketingBulkSmsIdChannelBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return patchMarketingBulkSmsIdChannel(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMarketingBulkSmsIdChannelMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchMarketingBulkSmsIdChannel>>
>;
export type PatchMarketingBulkSmsIdChannelMutationBody = PatchMarketingBulkSmsIdChannelBody;
export type PatchMarketingBulkSmsIdChannelMutationError = void;

/**
 * @summary Switch a draft between Text and Email (same people; returns the full detail)
 */
export const usePatchMarketingBulkSmsIdChannel = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchMarketingBulkSmsIdChannel>>,
      TError,
      { id: string; data: PatchMarketingBulkSmsIdChannelBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchMarketingBulkSmsIdChannel>>,
  TError,
  { id: string; data: PatchMarketingBulkSmsIdChannelBody },
  TContext
> => {
  const mutationOptions = getPatchMarketingBulkSmsIdChannelMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Live compliance status: 10DLC messaging state, quiet hours, STOP/HELP, CAN-SPAM readiness
 */
export const getMarketingSettingsCompliance = (signal?: AbortSignal) => {
  return customInstance<GetMarketingSettingsCompliance200>({
    url: `/marketing/settings/compliance`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingSettingsComplianceInfiniteQueryKey = () => {
  return ['infinite', `/marketing/settings/compliance`] as const;
};

export const getGetMarketingSettingsComplianceQueryKey = () => {
  return [`/marketing/settings/compliance`] as const;
};

export const getGetMarketingSettingsComplianceInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsCompliance>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSettingsComplianceInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSettingsCompliance>>> = ({
    signal,
  }) => getMarketingSettingsCompliance(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSettingsComplianceInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSettingsCompliance>>
>;
export type GetMarketingSettingsComplianceInfiniteQueryError = unknown;

export function useGetMarketingSettingsComplianceInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsCompliance>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsCompliance>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsComplianceInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsCompliance>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsCompliance>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsComplianceInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsCompliance>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Live compliance status: 10DLC messaging state, quiet hours, STOP/HELP, CAN-SPAM readiness
 */

export function useGetMarketingSettingsComplianceInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsCompliance>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSettingsComplianceInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSettingsComplianceQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsCompliance>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSettingsComplianceQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSettingsCompliance>>> = ({
    signal,
  }) => getMarketingSettingsCompliance(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSettingsComplianceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSettingsCompliance>>
>;
export type GetMarketingSettingsComplianceQueryError = unknown;

export function useGetMarketingSettingsCompliance<
  TData = Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsCompliance>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsCompliance>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsCompliance<
  TData = Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsCompliance>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsCompliance>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsCompliance<
  TData = Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsCompliance>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Live compliance status: 10DLC messaging state, quiet hours, STOP/HELP, CAN-SPAM readiness
 */

export function useGetMarketingSettingsCompliance<
  TData = Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsCompliance>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSettingsComplianceQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSettingsComplianceSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSettingsComplianceQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSettingsCompliance>>> = ({
    signal,
  }) => getMarketingSettingsCompliance(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSettingsComplianceSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSettingsCompliance>>
>;
export type GetMarketingSettingsComplianceSuspenseQueryError = unknown;

export function useGetMarketingSettingsComplianceSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsComplianceSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsComplianceSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Live compliance status: 10DLC messaging state, quiet hours, STOP/HELP, CAN-SPAM readiness
 */

export function useGetMarketingSettingsComplianceSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsCompliance>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSettingsComplianceSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Narrow the salon quiet-hours window (start 6–8 PM, end 8–10 AM); can only tighten the default
 */
export const putMarketingSettingsQuietHours = (
  putMarketingSettingsQuietHoursBody: PutMarketingSettingsQuietHoursBody
) => {
  return customInstance<PutMarketingSettingsQuietHours200>({
    url: `/marketing/settings/quiet-hours`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putMarketingSettingsQuietHoursBody,
  });
};

export const getPutMarketingSettingsQuietHoursMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMarketingSettingsQuietHours>>,
    TError,
    { data: PutMarketingSettingsQuietHoursBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMarketingSettingsQuietHours>>,
  TError,
  { data: PutMarketingSettingsQuietHoursBody },
  TContext
> => {
  const mutationKey = ['putMarketingSettingsQuietHours'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMarketingSettingsQuietHours>>,
    { data: PutMarketingSettingsQuietHoursBody }
  > = (props) => {
    const { data } = props ?? {};

    return putMarketingSettingsQuietHours(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMarketingSettingsQuietHoursMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMarketingSettingsQuietHours>>
>;
export type PutMarketingSettingsQuietHoursMutationBody = PutMarketingSettingsQuietHoursBody;
export type PutMarketingSettingsQuietHoursMutationError = void;

/**
 * @summary Narrow the salon quiet-hours window (start 6–8 PM, end 8–10 AM); can only tighten the default
 */
export const usePutMarketingSettingsQuietHours = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putMarketingSettingsQuietHours>>,
      TError,
      { data: PutMarketingSettingsQuietHoursBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putMarketingSettingsQuietHours>>,
  TError,
  { data: PutMarketingSettingsQuietHoursBody },
  TContext
> => {
  const mutationOptions = getPutMarketingSettingsQuietHoursMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Set the salon's daily marketing text budget ($5–$500); agency admins only (the agency pays for SMS)
 */
export const putMarketingSettingsBulkSmsBudget = (
  putMarketingSettingsBulkSmsBudgetBody: PutMarketingSettingsBulkSmsBudgetBody
) => {
  return customInstance<PutMarketingSettingsBulkSmsBudget200>({
    url: `/marketing/settings/bulk-sms-budget`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putMarketingSettingsBulkSmsBudgetBody,
  });
};

export const getPutMarketingSettingsBulkSmsBudgetMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMarketingSettingsBulkSmsBudget>>,
    TError,
    { data: PutMarketingSettingsBulkSmsBudgetBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMarketingSettingsBulkSmsBudget>>,
  TError,
  { data: PutMarketingSettingsBulkSmsBudgetBody },
  TContext
> => {
  const mutationKey = ['putMarketingSettingsBulkSmsBudget'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMarketingSettingsBulkSmsBudget>>,
    { data: PutMarketingSettingsBulkSmsBudgetBody }
  > = (props) => {
    const { data } = props ?? {};

    return putMarketingSettingsBulkSmsBudget(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMarketingSettingsBulkSmsBudgetMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMarketingSettingsBulkSmsBudget>>
>;
export type PutMarketingSettingsBulkSmsBudgetMutationBody = PutMarketingSettingsBulkSmsBudgetBody;
export type PutMarketingSettingsBulkSmsBudgetMutationError = void;

/**
 * @summary Set the salon's daily marketing text budget ($5–$500); agency admins only (the agency pays for SMS)
 */
export const usePutMarketingSettingsBulkSmsBudget = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putMarketingSettingsBulkSmsBudget>>,
      TError,
      { data: PutMarketingSettingsBulkSmsBudgetBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putMarketingSettingsBulkSmsBudget>>,
  TError,
  { data: PutMarketingSettingsBulkSmsBudgetBody },
  TContext
> => {
  const mutationOptions = getPutMarketingSettingsBulkSmsBudgetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Re-sync 10DLC status from Twilio then return the fresh compliance status (rate-limited 5/min/org)
 */
export const postMarketingSettingsMessagingSync = (signal?: AbortSignal) => {
  return customInstance<PostMarketingSettingsMessagingSync200>({
    url: `/marketing/settings/messaging/sync`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingSettingsMessagingSyncMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingSettingsMessagingSync>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingSettingsMessagingSync>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postMarketingSettingsMessagingSync'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingSettingsMessagingSync>>,
    void
  > = () => {
    return postMarketingSettingsMessagingSync();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingSettingsMessagingSyncMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingSettingsMessagingSync>>
>;

export type PostMarketingSettingsMessagingSyncMutationError = void;

/**
 * @summary Re-sync 10DLC status from Twilio then return the fresh compliance status (rate-limited 5/min/org)
 */
export const usePostMarketingSettingsMessagingSync = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingSettingsMessagingSync>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingSettingsMessagingSync>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getPostMarketingSettingsMessagingSyncMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Legal pages status + effective/override/default blanks for Terms and Privacy
 */
export const getMarketingSettingsLegalPages = (signal?: AbortSignal) => {
  return customInstance<GetMarketingSettingsLegalPages200>({
    url: `/marketing/settings/legal-pages`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingSettingsLegalPagesInfiniteQueryKey = () => {
  return ['infinite', `/marketing/settings/legal-pages`] as const;
};

export const getGetMarketingSettingsLegalPagesQueryKey = () => {
  return [`/marketing/settings/legal-pages`] as const;
};

export const getGetMarketingSettingsLegalPagesInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSettingsLegalPagesInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>> = ({
    signal,
  }) => getMarketingSettingsLegalPages(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSettingsLegalPagesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>
>;
export type GetMarketingSettingsLegalPagesInfiniteQueryError = unknown;

export function useGetMarketingSettingsLegalPagesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsLegalPagesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsLegalPagesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Legal pages status + effective/override/default blanks for Terms and Privacy
 */

export function useGetMarketingSettingsLegalPagesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSettingsLegalPagesInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSettingsLegalPagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSettingsLegalPagesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>> = ({
    signal,
  }) => getMarketingSettingsLegalPages(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSettingsLegalPagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>
>;
export type GetMarketingSettingsLegalPagesQueryError = unknown;

export function useGetMarketingSettingsLegalPages<
  TData = Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsLegalPages<
  TData = Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsLegalPages<
  TData = Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Legal pages status + effective/override/default blanks for Terms and Privacy
 */

export function useGetMarketingSettingsLegalPages<
  TData = Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSettingsLegalPagesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSettingsLegalPagesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSettingsLegalPagesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>> = ({
    signal,
  }) => getMarketingSettingsLegalPages(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSettingsLegalPagesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>
>;
export type GetMarketingSettingsLegalPagesSuspenseQueryError = unknown;

export function useGetMarketingSettingsLegalPagesSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsLegalPagesSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsLegalPagesSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Legal pages status + effective/override/default blanks for Terms and Privacy
 */

export function useGetMarketingSettingsLegalPagesSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsLegalPages>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSettingsLegalPagesSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update the editable legal-page blanks (null = use Business Details); agency members only
 */
export const putMarketingSettingsLegalPages = (
  putMarketingSettingsLegalPagesBody: PutMarketingSettingsLegalPagesBody
) => {
  return customInstance<PutMarketingSettingsLegalPages200>({
    url: `/marketing/settings/legal-pages`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putMarketingSettingsLegalPagesBody,
  });
};

export const getPutMarketingSettingsLegalPagesMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMarketingSettingsLegalPages>>,
    TError,
    { data: PutMarketingSettingsLegalPagesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMarketingSettingsLegalPages>>,
  TError,
  { data: PutMarketingSettingsLegalPagesBody },
  TContext
> => {
  const mutationKey = ['putMarketingSettingsLegalPages'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMarketingSettingsLegalPages>>,
    { data: PutMarketingSettingsLegalPagesBody }
  > = (props) => {
    const { data } = props ?? {};

    return putMarketingSettingsLegalPages(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMarketingSettingsLegalPagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMarketingSettingsLegalPages>>
>;
export type PutMarketingSettingsLegalPagesMutationBody = PutMarketingSettingsLegalPagesBody;
export type PutMarketingSettingsLegalPagesMutationError = void;

/**
 * @summary Update the editable legal-page blanks (null = use Business Details); agency members only
 */
export const usePutMarketingSettingsLegalPages = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putMarketingSettingsLegalPages>>,
      TError,
      { data: PutMarketingSettingsLegalPagesBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putMarketingSettingsLegalPages>>,
  TError,
  { data: PutMarketingSettingsLegalPagesBody },
  TContext
> => {
  const mutationOptions = getPutMarketingSettingsLegalPagesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Active consent copy version + full version history with per-version submission counts
 */
export const getMarketingSettingsConsentCopy = (signal?: AbortSignal) => {
  return customInstance<GetMarketingSettingsConsentCopy200>({
    url: `/marketing/settings/consent-copy`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingSettingsConsentCopyInfiniteQueryKey = () => {
  return ['infinite', `/marketing/settings/consent-copy`] as const;
};

export const getGetMarketingSettingsConsentCopyQueryKey = () => {
  return [`/marketing/settings/consent-copy`] as const;
};

export const getGetMarketingSettingsConsentCopyInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSettingsConsentCopyInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>> = ({
    signal,
  }) => getMarketingSettingsConsentCopy(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSettingsConsentCopyInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>
>;
export type GetMarketingSettingsConsentCopyInfiniteQueryError = unknown;

export function useGetMarketingSettingsConsentCopyInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsConsentCopyInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsConsentCopyInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Active consent copy version + full version history with per-version submission counts
 */

export function useGetMarketingSettingsConsentCopyInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSettingsConsentCopyInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSettingsConsentCopyQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSettingsConsentCopyQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>> = ({
    signal,
  }) => getMarketingSettingsConsentCopy(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSettingsConsentCopyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>
>;
export type GetMarketingSettingsConsentCopyQueryError = unknown;

export function useGetMarketingSettingsConsentCopy<
  TData = Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsConsentCopy<
  TData = Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsConsentCopy<
  TData = Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Active consent copy version + full version history with per-version submission counts
 */

export function useGetMarketingSettingsConsentCopy<
  TData = Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSettingsConsentCopyQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSettingsConsentCopySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSettingsConsentCopyQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>> = ({
    signal,
  }) => getMarketingSettingsConsentCopy(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSettingsConsentCopySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>
>;
export type GetMarketingSettingsConsentCopySuspenseQueryError = unknown;

export function useGetMarketingSettingsConsentCopySuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsConsentCopySuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsConsentCopySuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Active consent copy version + full version history with per-version submission counts
 */

export function useGetMarketingSettingsConsentCopySuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsConsentCopy>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSettingsConsentCopySuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Save a new active consent copy version (applies to future submissions only); agency members only
 */
export const postMarketingSettingsConsentCopyVersions = (
  postMarketingSettingsConsentCopyVersionsBody: PostMarketingSettingsConsentCopyVersionsBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingSettingsConsentCopyVersions200>({
    url: `/marketing/settings/consent-copy/versions`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingSettingsConsentCopyVersionsBody,
    signal,
  });
};

export const getPostMarketingSettingsConsentCopyVersionsMutationOptions = <
  TError = void | PostMarketingSettingsConsentCopyVersions422,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingSettingsConsentCopyVersions>>,
    TError,
    { data: PostMarketingSettingsConsentCopyVersionsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingSettingsConsentCopyVersions>>,
  TError,
  { data: PostMarketingSettingsConsentCopyVersionsBody },
  TContext
> => {
  const mutationKey = ['postMarketingSettingsConsentCopyVersions'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingSettingsConsentCopyVersions>>,
    { data: PostMarketingSettingsConsentCopyVersionsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMarketingSettingsConsentCopyVersions(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingSettingsConsentCopyVersionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingSettingsConsentCopyVersions>>
>;
export type PostMarketingSettingsConsentCopyVersionsMutationBody =
  PostMarketingSettingsConsentCopyVersionsBody;
export type PostMarketingSettingsConsentCopyVersionsMutationError =
  void | PostMarketingSettingsConsentCopyVersions422;

/**
 * @summary Save a new active consent copy version (applies to future submissions only); agency members only
 */
export const usePostMarketingSettingsConsentCopyVersions = <
  TError = void | PostMarketingSettingsConsentCopyVersions422,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingSettingsConsentCopyVersions>>,
      TError,
      { data: PostMarketingSettingsConsentCopyVersionsBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingSettingsConsentCopyVersions>>,
  TError,
  { data: PostMarketingSettingsConsentCopyVersionsBody },
  TContext
> => {
  const mutationOptions = getPostMarketingSettingsConsentCopyVersionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Per-campaign landing-page search visibility (newest first, non-archived)
 */
export const getMarketingSettingsVisibility = (signal?: AbortSignal) => {
  return customInstance<GetMarketingSettingsVisibility200>({
    url: `/marketing/settings/visibility`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingSettingsVisibilityInfiniteQueryKey = () => {
  return ['infinite', `/marketing/settings/visibility`] as const;
};

export const getGetMarketingSettingsVisibilityQueryKey = () => {
  return [`/marketing/settings/visibility`] as const;
};

export const getGetMarketingSettingsVisibilityInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsVisibility>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSettingsVisibilityInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSettingsVisibility>>> = ({
    signal,
  }) => getMarketingSettingsVisibility(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSettingsVisibilityInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSettingsVisibility>>
>;
export type GetMarketingSettingsVisibilityInfiniteQueryError = unknown;

export function useGetMarketingSettingsVisibilityInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsVisibility>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsVisibility>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsVisibilityInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsVisibility>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsVisibility>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsVisibilityInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsVisibility>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Per-campaign landing-page search visibility (newest first, non-archived)
 */

export function useGetMarketingSettingsVisibilityInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsVisibility>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSettingsVisibilityInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSettingsVisibilityQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsVisibility>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSettingsVisibilityQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSettingsVisibility>>> = ({
    signal,
  }) => getMarketingSettingsVisibility(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSettingsVisibilityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSettingsVisibility>>
>;
export type GetMarketingSettingsVisibilityQueryError = unknown;

export function useGetMarketingSettingsVisibility<
  TData = Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsVisibility>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsVisibility>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsVisibility<
  TData = Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsVisibility>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsVisibility>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsVisibility<
  TData = Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsVisibility>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Per-campaign landing-page search visibility (newest first, non-archived)
 */

export function useGetMarketingSettingsVisibility<
  TData = Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsVisibility>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSettingsVisibilityQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSettingsVisibilitySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSettingsVisibilityQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSettingsVisibility>>> = ({
    signal,
  }) => getMarketingSettingsVisibility(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSettingsVisibilitySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSettingsVisibility>>
>;
export type GetMarketingSettingsVisibilitySuspenseQueryError = unknown;

export function useGetMarketingSettingsVisibilitySuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsVisibilitySuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsVisibilitySuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Per-campaign landing-page search visibility (newest first, non-archived)
 */

export function useGetMarketingSettingsVisibilitySuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsVisibility>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSettingsVisibilitySuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Set a campaign landing page's search visibility (agency members only)
 */
export const patchMarketingCampaignsCampaignIdLandingVisibility = (
  campaignId: string,
  patchMarketingCampaignsCampaignIdLandingVisibilityBody: PatchMarketingCampaignsCampaignIdLandingVisibilityBody
) => {
  return customInstance<PatchMarketingCampaignsCampaignIdLandingVisibility200>({
    url: `/marketing/campaigns/${campaignId}/landing/visibility`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchMarketingCampaignsCampaignIdLandingVisibilityBody,
  });
};

export const getPatchMarketingCampaignsCampaignIdLandingVisibilityMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMarketingCampaignsCampaignIdLandingVisibility>>,
    TError,
    { campaignId: string; data: PatchMarketingCampaignsCampaignIdLandingVisibilityBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMarketingCampaignsCampaignIdLandingVisibility>>,
  TError,
  { campaignId: string; data: PatchMarketingCampaignsCampaignIdLandingVisibilityBody },
  TContext
> => {
  const mutationKey = ['patchMarketingCampaignsCampaignIdLandingVisibility'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMarketingCampaignsCampaignIdLandingVisibility>>,
    { campaignId: string; data: PatchMarketingCampaignsCampaignIdLandingVisibilityBody }
  > = (props) => {
    const { campaignId, data } = props ?? {};

    return patchMarketingCampaignsCampaignIdLandingVisibility(campaignId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMarketingCampaignsCampaignIdLandingVisibilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchMarketingCampaignsCampaignIdLandingVisibility>>
>;
export type PatchMarketingCampaignsCampaignIdLandingVisibilityMutationBody =
  PatchMarketingCampaignsCampaignIdLandingVisibilityBody;
export type PatchMarketingCampaignsCampaignIdLandingVisibilityMutationError = void;

/**
 * @summary Set a campaign landing page's search visibility (agency members only)
 */
export const usePatchMarketingCampaignsCampaignIdLandingVisibility = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchMarketingCampaignsCampaignIdLandingVisibility>>,
      TError,
      { campaignId: string; data: PatchMarketingCampaignsCampaignIdLandingVisibilityBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchMarketingCampaignsCampaignIdLandingVisibility>>,
  TError,
  { campaignId: string; data: PatchMarketingCampaignsCampaignIdLandingVisibilityBody },
  TContext
> => {
  const mutationOptions =
    getPatchMarketingCampaignsCampaignIdLandingVisibilityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Connected Google reviews source + which sources are usable (200 even when none is)
 */
export const getMarketingGoogleReviewsSource = (signal?: AbortSignal) => {
  return customInstance<GetMarketingGoogleReviewsSource200>({
    url: `/marketing/google-reviews/source`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingGoogleReviewsSourceInfiniteQueryKey = () => {
  return ['infinite', `/marketing/google-reviews/source`] as const;
};

export const getGetMarketingGoogleReviewsSourceQueryKey = () => {
  return [`/marketing/google-reviews/source`] as const;
};

export const getGetMarketingGoogleReviewsSourceInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleReviewsSourceInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>> = ({
    signal,
  }) => getMarketingGoogleReviewsSource(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleReviewsSourceInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>
>;
export type GetMarketingGoogleReviewsSourceInfiniteQueryError = unknown;

export function useGetMarketingGoogleReviewsSourceInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleReviewsSourceInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleReviewsSourceInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Connected Google reviews source + which sources are usable (200 even when none is)
 */

export function useGetMarketingGoogleReviewsSourceInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleReviewsSourceInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleReviewsSourceQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleReviewsSourceQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>> = ({
    signal,
  }) => getMarketingGoogleReviewsSource(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleReviewsSourceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>
>;
export type GetMarketingGoogleReviewsSourceQueryError = unknown;

export function useGetMarketingGoogleReviewsSource<
  TData = Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleReviewsSource<
  TData = Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleReviewsSource<
  TData = Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Connected Google reviews source + which sources are usable (200 even when none is)
 */

export function useGetMarketingGoogleReviewsSource<
  TData = Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleReviewsSourceQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleReviewsSourceSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleReviewsSourceQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>> = ({
    signal,
  }) => getMarketingGoogleReviewsSource(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleReviewsSourceSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>
>;
export type GetMarketingGoogleReviewsSourceSuspenseQueryError = unknown;

export function useGetMarketingGoogleReviewsSourceSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleReviewsSourceSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleReviewsSourceSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Connected Google reviews source + which sources are usable (200 even when none is)
 */

export function useGetMarketingGoogleReviewsSourceSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleReviewsSource>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleReviewsSourceSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Connect / change the salon's Google listing: a listing of its Google account or Places (fetches the first snapshot)
 */
export const putMarketingGoogleReviewsSource = (
  putMarketingGoogleReviewsSourceBody: PutMarketingGoogleReviewsSourceBody
) => {
  return customInstance<PutMarketingGoogleReviewsSource200>({
    url: `/marketing/google-reviews/source`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putMarketingGoogleReviewsSourceBody,
  });
};

export const getPutMarketingGoogleReviewsSourceMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMarketingGoogleReviewsSource>>,
    TError,
    { data: PutMarketingGoogleReviewsSourceBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMarketingGoogleReviewsSource>>,
  TError,
  { data: PutMarketingGoogleReviewsSourceBody },
  TContext
> => {
  const mutationKey = ['putMarketingGoogleReviewsSource'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMarketingGoogleReviewsSource>>,
    { data: PutMarketingGoogleReviewsSourceBody }
  > = (props) => {
    const { data } = props ?? {};

    return putMarketingGoogleReviewsSource(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMarketingGoogleReviewsSourceMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMarketingGoogleReviewsSource>>
>;
export type PutMarketingGoogleReviewsSourceMutationBody = PutMarketingGoogleReviewsSourceBody;
export type PutMarketingGoogleReviewsSourceMutationError = void;

/**
 * @summary Connect / change the salon's Google listing: a listing of its Google account or Places (fetches the first snapshot)
 */
export const usePutMarketingGoogleReviewsSource = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putMarketingGoogleReviewsSource>>,
      TError,
      { data: PutMarketingGoogleReviewsSourceBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putMarketingGoogleReviewsSource>>,
  TError,
  { data: PutMarketingGoogleReviewsSourceBody },
  TContext
> => {
  const mutationOptions = getPutMarketingGoogleReviewsSourceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Disconnect the salon's Google listing (imported quotes already in content remain)
 */
export const deleteMarketingGoogleReviewsSource = () => {
  return customInstance<void>({ url: `/marketing/google-reviews/source`, method: 'DELETE' });
};

export const getDeleteMarketingGoogleReviewsSourceMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMarketingGoogleReviewsSource>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMarketingGoogleReviewsSource>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['deleteMarketingGoogleReviewsSource'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMarketingGoogleReviewsSource>>,
    void
  > = () => {
    return deleteMarketingGoogleReviewsSource();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMarketingGoogleReviewsSourceMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMarketingGoogleReviewsSource>>
>;

export type DeleteMarketingGoogleReviewsSourceMutationError = void;

/**
 * @summary Disconnect the salon's Google listing (imported quotes already in content remain)
 */
export const useDeleteMarketingGoogleReviewsSource = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMarketingGoogleReviewsSource>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMarketingGoogleReviewsSource>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getDeleteMarketingGoogleReviewsSourceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Free-text search for the salon's Google listing (≤5 candidates)
 */
export const postMarketingGoogleReviewsSearch = (
  postMarketingGoogleReviewsSearchBody: PostMarketingGoogleReviewsSearchBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingGoogleReviewsSearch200>({
    url: `/marketing/google-reviews/search`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingGoogleReviewsSearchBody,
    signal,
  });
};

export const getPostMarketingGoogleReviewsSearchMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingGoogleReviewsSearch>>,
    TError,
    { data: PostMarketingGoogleReviewsSearchBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingGoogleReviewsSearch>>,
  TError,
  { data: PostMarketingGoogleReviewsSearchBody },
  TContext
> => {
  const mutationKey = ['postMarketingGoogleReviewsSearch'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingGoogleReviewsSearch>>,
    { data: PostMarketingGoogleReviewsSearchBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMarketingGoogleReviewsSearch(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingGoogleReviewsSearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingGoogleReviewsSearch>>
>;
export type PostMarketingGoogleReviewsSearchMutationBody = PostMarketingGoogleReviewsSearchBody;
export type PostMarketingGoogleReviewsSearchMutationError = void;

/**
 * @summary Free-text search for the salon's Google listing (≤5 candidates)
 */
export const usePostMarketingGoogleReviewsSearch = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingGoogleReviewsSearch>>,
      TError,
      { data: PostMarketingGoogleReviewsSearchBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingGoogleReviewsSearch>>,
  TError,
  { data: PostMarketingGoogleReviewsSearchBody },
  TContext
> => {
  const mutationOptions = getPostMarketingGoogleReviewsSearchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Manually refresh the snapshot (Places: once per salon-local day; GBP: a small daily quota)
 */
export const postMarketingGoogleReviewsSourceRefresh = (signal?: AbortSignal) => {
  return customInstance<PostMarketingGoogleReviewsSourceRefresh200>({
    url: `/marketing/google-reviews/source/refresh`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingGoogleReviewsSourceRefreshMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingGoogleReviewsSourceRefresh>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingGoogleReviewsSourceRefresh>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postMarketingGoogleReviewsSourceRefresh'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingGoogleReviewsSourceRefresh>>,
    void
  > = () => {
    return postMarketingGoogleReviewsSourceRefresh();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingGoogleReviewsSourceRefreshMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingGoogleReviewsSourceRefresh>>
>;

export type PostMarketingGoogleReviewsSourceRefreshMutationError = void;

/**
 * @summary Manually refresh the snapshot (Places: once per salon-local day; GBP: a small daily quota)
 */
export const usePostMarketingGoogleReviewsSourceRefresh = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingGoogleReviewsSourceRefresh>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingGoogleReviewsSourceRefresh>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getPostMarketingGoogleReviewsSourceRefreshMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary This salon's Google Business Profile connection
 */
export const getMarketingGoogleBusinessConnection = (signal?: AbortSignal) => {
  return customInstance<GetMarketingGoogleBusinessConnection200>({
    url: `/marketing/google-business/connection`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingGoogleBusinessConnectionInfiniteQueryKey = () => {
  return ['infinite', `/marketing/google-business/connection`] as const;
};

export const getGetMarketingGoogleBusinessConnectionQueryKey = () => {
  return [`/marketing/google-business/connection`] as const;
};

export const getGetMarketingGoogleBusinessConnectionInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingGoogleBusinessConnectionInfiniteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>
  > = ({ signal }) => getMarketingGoogleBusinessConnection(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleBusinessConnectionInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>
>;
export type GetMarketingGoogleBusinessConnectionInfiniteQueryError = void;

export function useGetMarketingGoogleBusinessConnectionInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleBusinessConnectionInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleBusinessConnectionInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary This salon's Google Business Profile connection
 */

export function useGetMarketingGoogleBusinessConnectionInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleBusinessConnectionInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleBusinessConnectionQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleBusinessConnectionQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>
  > = ({ signal }) => getMarketingGoogleBusinessConnection(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleBusinessConnectionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>
>;
export type GetMarketingGoogleBusinessConnectionQueryError = void;

export function useGetMarketingGoogleBusinessConnection<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleBusinessConnection<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleBusinessConnection<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary This salon's Google Business Profile connection
 */

export function useGetMarketingGoogleBusinessConnection<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleBusinessConnectionQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleBusinessConnectionSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleBusinessConnectionQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>
  > = ({ signal }) => getMarketingGoogleBusinessConnection(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleBusinessConnectionSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>
>;
export type GetMarketingGoogleBusinessConnectionSuspenseQueryError = void;

export function useGetMarketingGoogleBusinessConnectionSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleBusinessConnectionSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleBusinessConnectionSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary This salon's Google Business Profile connection
 */

export function useGetMarketingGoogleBusinessConnectionSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessConnection>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleBusinessConnectionSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Disconnect Google from this salon (also removes its Google Business reviews source)
 */
export const deleteMarketingGoogleBusinessConnection = () => {
  return customInstance<void>({ url: `/marketing/google-business/connection`, method: 'DELETE' });
};

export const getDeleteMarketingGoogleBusinessConnectionMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMarketingGoogleBusinessConnection>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMarketingGoogleBusinessConnection>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['deleteMarketingGoogleBusinessConnection'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMarketingGoogleBusinessConnection>>,
    void
  > = () => {
    return deleteMarketingGoogleBusinessConnection();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMarketingGoogleBusinessConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMarketingGoogleBusinessConnection>>
>;

export type DeleteMarketingGoogleBusinessConnectionMutationError = void;

/**
 * @summary Disconnect Google from this salon (also removes its Google Business reviews source)
 */
export const useDeleteMarketingGoogleBusinessConnection = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMarketingGoogleBusinessConnection>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMarketingGoogleBusinessConnection>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getDeleteMarketingGoogleBusinessConnectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Start connecting a Google account to this salon (returns Google consent URL)
 */
export const postMarketingGoogleBusinessOauthStart = (
  params?: PostMarketingGoogleBusinessOauthStartParams,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingGoogleBusinessOauthStart200>({
    url: `/marketing/google-business/oauth/start`,
    method: 'POST',
    params,
    signal,
  });
};

export const getPostMarketingGoogleBusinessOauthStartMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingGoogleBusinessOauthStart>>,
    TError,
    { params?: PostMarketingGoogleBusinessOauthStartParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingGoogleBusinessOauthStart>>,
  TError,
  { params?: PostMarketingGoogleBusinessOauthStartParams },
  TContext
> => {
  const mutationKey = ['postMarketingGoogleBusinessOauthStart'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingGoogleBusinessOauthStart>>,
    { params?: PostMarketingGoogleBusinessOauthStartParams }
  > = (props) => {
    const { params } = props ?? {};

    return postMarketingGoogleBusinessOauthStart(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingGoogleBusinessOauthStartMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingGoogleBusinessOauthStart>>
>;

export type PostMarketingGoogleBusinessOauthStartMutationError = void;

/**
 * @summary Start connecting a Google account to this salon (returns Google consent URL)
 */
export const usePostMarketingGoogleBusinessOauthStart = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingGoogleBusinessOauthStart>>,
      TError,
      { params?: PostMarketingGoogleBusinessOauthStartParams },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingGoogleBusinessOauthStart>>,
  TError,
  { params?: PostMarketingGoogleBusinessOauthStartParams },
  TContext
> => {
  const mutationOptions = getPostMarketingGoogleBusinessOauthStartMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Finish connecting a Google account to the salon that started the sign-in
 */
export const postMarketingGoogleBusinessOauthComplete = (
  postMarketingGoogleBusinessOauthCompleteBody: PostMarketingGoogleBusinessOauthCompleteBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingGoogleBusinessOauthComplete200>({
    url: `/marketing/google-business/oauth/complete`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingGoogleBusinessOauthCompleteBody,
    signal,
  });
};

export const getPostMarketingGoogleBusinessOauthCompleteMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingGoogleBusinessOauthComplete>>,
    TError,
    { data: PostMarketingGoogleBusinessOauthCompleteBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingGoogleBusinessOauthComplete>>,
  TError,
  { data: PostMarketingGoogleBusinessOauthCompleteBody },
  TContext
> => {
  const mutationKey = ['postMarketingGoogleBusinessOauthComplete'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingGoogleBusinessOauthComplete>>,
    { data: PostMarketingGoogleBusinessOauthCompleteBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMarketingGoogleBusinessOauthComplete(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingGoogleBusinessOauthCompleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingGoogleBusinessOauthComplete>>
>;
export type PostMarketingGoogleBusinessOauthCompleteMutationBody =
  PostMarketingGoogleBusinessOauthCompleteBody;
export type PostMarketingGoogleBusinessOauthCompleteMutationError = void;

/**
 * @summary Finish connecting a Google account to the salon that started the sign-in
 */
export const usePostMarketingGoogleBusinessOauthComplete = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingGoogleBusinessOauthComplete>>,
      TError,
      { data: PostMarketingGoogleBusinessOauthCompleteBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingGoogleBusinessOauthComplete>>,
  TError,
  { data: PostMarketingGoogleBusinessOauthCompleteBody },
  TContext
> => {
  const mutationOptions = getPostMarketingGoogleBusinessOauthCompleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Search the listings of this salon's connected Google account (≤50 rows)
 */
export const getMarketingGoogleBusinessLocations = (
  params?: GetMarketingGoogleBusinessLocationsParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingGoogleBusinessLocations200>({
    url: `/marketing/google-business/locations`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingGoogleBusinessLocationsInfiniteQueryKey = (
  params?: GetMarketingGoogleBusinessLocationsParams
) => {
  return ['infinite', `/marketing/google-business/locations`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingGoogleBusinessLocationsQueryKey = (
  params?: GetMarketingGoogleBusinessLocationsParams
) => {
  return [`/marketing/google-business/locations`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingGoogleBusinessLocationsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>>,
  TError = void,
>(
  params?: GetMarketingGoogleBusinessLocationsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingGoogleBusinessLocationsInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>> = ({
    signal,
  }) => getMarketingGoogleBusinessLocations(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleBusinessLocationsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>
>;
export type GetMarketingGoogleBusinessLocationsInfiniteQueryError = void;

export function useGetMarketingGoogleBusinessLocationsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>>,
  TError = void,
>(
  params: undefined | GetMarketingGoogleBusinessLocationsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleBusinessLocationsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>>,
  TError = void,
>(
  params?: GetMarketingGoogleBusinessLocationsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleBusinessLocationsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>>,
  TError = void,
>(
  params?: GetMarketingGoogleBusinessLocationsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search the listings of this salon's connected Google account (≤50 rows)
 */

export function useGetMarketingGoogleBusinessLocationsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>>,
  TError = void,
>(
  params?: GetMarketingGoogleBusinessLocationsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleBusinessLocationsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleBusinessLocationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
  TError = void,
>(
  params?: GetMarketingGoogleBusinessLocationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleBusinessLocationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>> = ({
    signal,
  }) => getMarketingGoogleBusinessLocations(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleBusinessLocationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>
>;
export type GetMarketingGoogleBusinessLocationsQueryError = void;

export function useGetMarketingGoogleBusinessLocations<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
  TError = void,
>(
  params: undefined | GetMarketingGoogleBusinessLocationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleBusinessLocations<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
  TError = void,
>(
  params?: GetMarketingGoogleBusinessLocationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleBusinessLocations<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
  TError = void,
>(
  params?: GetMarketingGoogleBusinessLocationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search the listings of this salon's connected Google account (≤50 rows)
 */

export function useGetMarketingGoogleBusinessLocations<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
  TError = void,
>(
  params?: GetMarketingGoogleBusinessLocationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleBusinessLocationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleBusinessLocationsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
  TError = void,
>(
  params?: GetMarketingGoogleBusinessLocationsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleBusinessLocationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>> = ({
    signal,
  }) => getMarketingGoogleBusinessLocations(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleBusinessLocationsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>
>;
export type GetMarketingGoogleBusinessLocationsSuspenseQueryError = void;

export function useGetMarketingGoogleBusinessLocationsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
  TError = void,
>(
  params: undefined | GetMarketingGoogleBusinessLocationsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleBusinessLocationsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
  TError = void,
>(
  params?: GetMarketingGoogleBusinessLocationsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleBusinessLocationsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
  TError = void,
>(
  params?: GetMarketingGoogleBusinessLocationsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search the listings of this salon's connected Google account (≤50 rows)
 */

export function useGetMarketingGoogleBusinessLocationsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
  TError = void,
>(
  params?: GetMarketingGoogleBusinessLocationsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleBusinessLocationsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Up to 3 listings of this salon's Google account matching its phone / address
 */
export const getMarketingGoogleBusinessSuggestions = (signal?: AbortSignal) => {
  return customInstance<GetMarketingGoogleBusinessSuggestions200>({
    url: `/marketing/google-business/suggestions`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingGoogleBusinessSuggestionsInfiniteQueryKey = () => {
  return ['infinite', `/marketing/google-business/suggestions`] as const;
};

export const getGetMarketingGoogleBusinessSuggestionsQueryKey = () => {
  return [`/marketing/google-business/suggestions`] as const;
};

export const getGetMarketingGoogleBusinessSuggestionsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingGoogleBusinessSuggestionsInfiniteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>
  > = ({ signal }) => getMarketingGoogleBusinessSuggestions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleBusinessSuggestionsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>
>;
export type GetMarketingGoogleBusinessSuggestionsInfiniteQueryError = void;

export function useGetMarketingGoogleBusinessSuggestionsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleBusinessSuggestionsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleBusinessSuggestionsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Up to 3 listings of this salon's Google account matching its phone / address
 */

export function useGetMarketingGoogleBusinessSuggestionsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleBusinessSuggestionsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleBusinessSuggestionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleBusinessSuggestionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>
  > = ({ signal }) => getMarketingGoogleBusinessSuggestions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleBusinessSuggestionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>
>;
export type GetMarketingGoogleBusinessSuggestionsQueryError = void;

export function useGetMarketingGoogleBusinessSuggestions<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleBusinessSuggestions<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleBusinessSuggestions<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Up to 3 listings of this salon's Google account matching its phone / address
 */

export function useGetMarketingGoogleBusinessSuggestions<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleBusinessSuggestionsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleBusinessSuggestionsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingGoogleBusinessSuggestionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>
  > = ({ signal }) => getMarketingGoogleBusinessSuggestions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleBusinessSuggestionsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>
>;
export type GetMarketingGoogleBusinessSuggestionsSuspenseQueryError = void;

export function useGetMarketingGoogleBusinessSuggestionsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleBusinessSuggestionsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleBusinessSuggestionsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Up to 3 listings of this salon's Google account matching its phone / address
 */

export function useGetMarketingGoogleBusinessSuggestionsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessSuggestions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleBusinessSuggestionsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Live rating + review count of one listing, for the link confirm step
 */
export const getMarketingGoogleBusinessLocationsLocationIdPreview = (
  locationId: string,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingGoogleBusinessLocationsLocationIdPreview200>({
    url: `/marketing/google-business/locations/${locationId}/preview`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingGoogleBusinessLocationsLocationIdPreviewInfiniteQueryKey = (
  locationId?: string
) => {
  return ['infinite', `/marketing/google-business/locations/${locationId}/preview`] as const;
};

export const getGetMarketingGoogleBusinessLocationsLocationIdPreviewQueryKey = (
  locationId?: string
) => {
  return [`/marketing/google-business/locations/${locationId}/preview`] as const;
};

export const getGetMarketingGoogleBusinessLocationsLocationIdPreviewInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>
  >,
  TError = void,
>(
  locationId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetMarketingGoogleBusinessLocationsLocationIdPreviewInfiniteQueryKey(locationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>
  > = ({ signal }) => getMarketingGoogleBusinessLocationsLocationIdPreview(locationId, signal);

  return { queryKey, queryFn, enabled: !!locationId, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleBusinessLocationsLocationIdPreviewInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>
>;
export type GetMarketingGoogleBusinessLocationsLocationIdPreviewInfiniteQueryError = void;

export function useGetMarketingGoogleBusinessLocationsLocationIdPreviewInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>
  >,
  TError = void,
>(
  locationId: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleBusinessLocationsLocationIdPreviewInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>
  >,
  TError = void,
>(
  locationId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleBusinessLocationsLocationIdPreviewInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>
  >,
  TError = void,
>(
  locationId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Live rating + review count of one listing, for the link confirm step
 */

export function useGetMarketingGoogleBusinessLocationsLocationIdPreviewInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>
  >,
  TError = void,
>(
  locationId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleBusinessLocationsLocationIdPreviewInfiniteQueryOptions(
    locationId,
    options
  );

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleBusinessLocationsLocationIdPreviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
  TError = void,
>(
  locationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetMarketingGoogleBusinessLocationsLocationIdPreviewQueryKey(locationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>
  > = ({ signal }) => getMarketingGoogleBusinessLocationsLocationIdPreview(locationId, signal);

  return { queryKey, queryFn, enabled: !!locationId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleBusinessLocationsLocationIdPreviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>
>;
export type GetMarketingGoogleBusinessLocationsLocationIdPreviewQueryError = void;

export function useGetMarketingGoogleBusinessLocationsLocationIdPreview<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
  TError = void,
>(
  locationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleBusinessLocationsLocationIdPreview<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
  TError = void,
>(
  locationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
          TError,
          Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleBusinessLocationsLocationIdPreview<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
  TError = void,
>(
  locationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Live rating + review count of one listing, for the link confirm step
 */

export function useGetMarketingGoogleBusinessLocationsLocationIdPreview<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
  TError = void,
>(
  locationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleBusinessLocationsLocationIdPreviewQueryOptions(
    locationId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingGoogleBusinessLocationsLocationIdPreviewSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
  TError = void,
>(
  locationId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetMarketingGoogleBusinessLocationsLocationIdPreviewQueryKey(locationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>
  > = ({ signal }) => getMarketingGoogleBusinessLocationsLocationIdPreview(locationId, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingGoogleBusinessLocationsLocationIdPreviewSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>
>;
export type GetMarketingGoogleBusinessLocationsLocationIdPreviewSuspenseQueryError = void;

export function useGetMarketingGoogleBusinessLocationsLocationIdPreviewSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
  TError = void,
>(
  locationId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleBusinessLocationsLocationIdPreviewSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
  TError = void,
>(
  locationId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingGoogleBusinessLocationsLocationIdPreviewSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
  TError = void,
>(
  locationId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Live rating + review count of one listing, for the link confirm step
 */

export function useGetMarketingGoogleBusinessLocationsLocationIdPreviewSuspense<
  TData = Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
  TError = void,
>(
  locationId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingGoogleBusinessLocationsLocationIdPreview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingGoogleBusinessLocationsLocationIdPreviewSuspenseQueryOptions(
    locationId,
    options
  );

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Queue a refresh of this salon's Google listing directory (1 per 5 minutes per Google account)
 */
export const postMarketingGoogleBusinessLocationsRefresh = (signal?: AbortSignal) => {
  return customInstance<PostMarketingGoogleBusinessLocationsRefresh202>({
    url: `/marketing/google-business/locations/refresh`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingGoogleBusinessLocationsRefreshMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingGoogleBusinessLocationsRefresh>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingGoogleBusinessLocationsRefresh>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postMarketingGoogleBusinessLocationsRefresh'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingGoogleBusinessLocationsRefresh>>,
    void
  > = () => {
    return postMarketingGoogleBusinessLocationsRefresh();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingGoogleBusinessLocationsRefreshMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingGoogleBusinessLocationsRefresh>>
>;

export type PostMarketingGoogleBusinessLocationsRefreshMutationError = void;

/**
 * @summary Queue a refresh of this salon's Google listing directory (1 per 5 minutes per Google account)
 */
export const usePostMarketingGoogleBusinessLocationsRefresh = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingGoogleBusinessLocationsRefresh>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingGoogleBusinessLocationsRefresh>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getPostMarketingGoogleBusinessLocationsRefreshMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Reviews waiting for a reply (with AI drafts) or every review already replied on Google (database only)
 */
export const getMarketingReviewsReplies = (
  params?: GetMarketingReviewsRepliesParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingReviewsReplies200>({
    url: `/marketing/reviews/replies`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingReviewsRepliesInfiniteQueryKey = (
  params?: GetMarketingReviewsRepliesParams
) => {
  return ['infinite', `/marketing/reviews/replies`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingReviewsRepliesQueryKey = (
  params?: GetMarketingReviewsRepliesParams
) => {
  return [`/marketing/reviews/replies`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingReviewsRepliesInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsReplies>>>,
  TError = void,
>(
  params?: GetMarketingReviewsRepliesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsReplies>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingReviewsRepliesInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsReplies>>> = ({
    signal,
  }) => getMarketingReviewsReplies(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsReplies>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsRepliesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsReplies>>
>;
export type GetMarketingReviewsRepliesInfiniteQueryError = void;

export function useGetMarketingReviewsRepliesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsReplies>>>,
  TError = void,
>(
  params: undefined | GetMarketingReviewsRepliesParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsReplies>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsReplies>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsReplies>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsRepliesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsReplies>>>,
  TError = void,
>(
  params?: GetMarketingReviewsRepliesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsReplies>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsReplies>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsReplies>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsRepliesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsReplies>>>,
  TError = void,
>(
  params?: GetMarketingReviewsRepliesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsReplies>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Reviews waiting for a reply (with AI drafts) or every review already replied on Google (database only)
 */

export function useGetMarketingReviewsRepliesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsReplies>>>,
  TError = void,
>(
  params?: GetMarketingReviewsRepliesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsReplies>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsRepliesInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingReviewsRepliesQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplies>>,
  TError = void,
>(
  params?: GetMarketingReviewsRepliesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsReplies>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingReviewsRepliesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsReplies>>> = ({
    signal,
  }) => getMarketingReviewsReplies(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsReplies>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsRepliesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsReplies>>
>;
export type GetMarketingReviewsRepliesQueryError = void;

export function useGetMarketingReviewsReplies<
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplies>>,
  TError = void,
>(
  params: undefined | GetMarketingReviewsRepliesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsReplies>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsReplies>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsReplies>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsReplies<
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplies>>,
  TError = void,
>(
  params?: GetMarketingReviewsRepliesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsReplies>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsReplies>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsReplies>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsReplies<
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplies>>,
  TError = void,
>(
  params?: GetMarketingReviewsRepliesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsReplies>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Reviews waiting for a reply (with AI drafts) or every review already replied on Google (database only)
 */

export function useGetMarketingReviewsReplies<
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplies>>,
  TError = void,
>(
  params?: GetMarketingReviewsRepliesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsReplies>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsRepliesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingReviewsRepliesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplies>>,
  TError = void,
>(
  params?: GetMarketingReviewsRepliesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsReplies>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingReviewsRepliesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsReplies>>> = ({
    signal,
  }) => getMarketingReviewsReplies(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsReplies>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsRepliesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsReplies>>
>;
export type GetMarketingReviewsRepliesSuspenseQueryError = void;

export function useGetMarketingReviewsRepliesSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplies>>,
  TError = void,
>(
  params: undefined | GetMarketingReviewsRepliesParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsReplies>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsRepliesSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplies>>,
  TError = void,
>(
  params?: GetMarketingReviewsRepliesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsReplies>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsRepliesSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplies>>,
  TError = void,
>(
  params?: GetMarketingReviewsRepliesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsReplies>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Reviews waiting for a reply (with AI drafts) or every review already replied on Google (database only)
 */

export function useGetMarketingReviewsRepliesSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplies>>,
  TError = void,
>(
  params?: GetMarketingReviewsRepliesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsReplies>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsRepliesSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Check Google for new reviews and replies now (read only; once per salon per 5 minutes)
 */
export const postMarketingReviewsRepliesSync = (signal?: AbortSignal) => {
  return customInstance<PostMarketingReviewsRepliesSync200>({
    url: `/marketing/reviews/replies/sync`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingReviewsRepliesSyncMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingReviewsRepliesSync>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingReviewsRepliesSync>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postMarketingReviewsRepliesSync'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingReviewsRepliesSync>>,
    void
  > = () => {
    return postMarketingReviewsRepliesSync();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingReviewsRepliesSyncMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingReviewsRepliesSync>>
>;

export type PostMarketingReviewsRepliesSyncMutationError = void;

/**
 * @summary Check Google for new reviews and replies now (read only; once per salon per 5 minutes)
 */
export const usePostMarketingReviewsRepliesSync = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingReviewsRepliesSync>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingReviewsRepliesSync>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getPostMarketingReviewsRepliesSyncMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Post the reply (as edited by the owner) on Google — queued; status POSTING until Google answers
 */
export const postMarketingReviewsRepliesReviewIdPost = (
  reviewId: string,
  postMarketingReviewsRepliesReviewIdPostBody: PostMarketingReviewsRepliesReviewIdPostBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingReviewsRepliesReviewIdPost202>({
    url: `/marketing/reviews/replies/${reviewId}/post`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingReviewsRepliesReviewIdPostBody,
    signal,
  });
};

export const getPostMarketingReviewsRepliesReviewIdPostMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingReviewsRepliesReviewIdPost>>,
    TError,
    { reviewId: string; data: PostMarketingReviewsRepliesReviewIdPostBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingReviewsRepliesReviewIdPost>>,
  TError,
  { reviewId: string; data: PostMarketingReviewsRepliesReviewIdPostBody },
  TContext
> => {
  const mutationKey = ['postMarketingReviewsRepliesReviewIdPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingReviewsRepliesReviewIdPost>>,
    { reviewId: string; data: PostMarketingReviewsRepliesReviewIdPostBody }
  > = (props) => {
    const { reviewId, data } = props ?? {};

    return postMarketingReviewsRepliesReviewIdPost(reviewId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingReviewsRepliesReviewIdPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingReviewsRepliesReviewIdPost>>
>;
export type PostMarketingReviewsRepliesReviewIdPostMutationBody =
  PostMarketingReviewsRepliesReviewIdPostBody;
export type PostMarketingReviewsRepliesReviewIdPostMutationError = void;

/**
 * @summary Post the reply (as edited by the owner) on Google — queued; status POSTING until Google answers
 */
export const usePostMarketingReviewsRepliesReviewIdPost = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingReviewsRepliesReviewIdPost>>,
      TError,
      { reviewId: string; data: PostMarketingReviewsRepliesReviewIdPostBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingReviewsRepliesReviewIdPost>>,
  TError,
  { reviewId: string; data: PostMarketingReviewsRepliesReviewIdPostBody },
  TContext
> => {
  const mutationOptions = getPostMarketingReviewsRepliesReviewIdPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Write a new AI draft for the review (optionally steered by a hint)
 */
export const postMarketingReviewsRepliesReviewIdRewrite = (
  reviewId: string,
  postMarketingReviewsRepliesReviewIdRewriteBody: PostMarketingReviewsRepliesReviewIdRewriteBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingReviewsRepliesReviewIdRewrite200>({
    url: `/marketing/reviews/replies/${reviewId}/rewrite`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingReviewsRepliesReviewIdRewriteBody,
    signal,
  });
};

export const getPostMarketingReviewsRepliesReviewIdRewriteMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingReviewsRepliesReviewIdRewrite>>,
    TError,
    { reviewId: string; data: PostMarketingReviewsRepliesReviewIdRewriteBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingReviewsRepliesReviewIdRewrite>>,
  TError,
  { reviewId: string; data: PostMarketingReviewsRepliesReviewIdRewriteBody },
  TContext
> => {
  const mutationKey = ['postMarketingReviewsRepliesReviewIdRewrite'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingReviewsRepliesReviewIdRewrite>>,
    { reviewId: string; data: PostMarketingReviewsRepliesReviewIdRewriteBody }
  > = (props) => {
    const { reviewId, data } = props ?? {};

    return postMarketingReviewsRepliesReviewIdRewrite(reviewId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingReviewsRepliesReviewIdRewriteMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingReviewsRepliesReviewIdRewrite>>
>;
export type PostMarketingReviewsRepliesReviewIdRewriteMutationBody =
  PostMarketingReviewsRepliesReviewIdRewriteBody;
export type PostMarketingReviewsRepliesReviewIdRewriteMutationError = void;

/**
 * @summary Write a new AI draft for the review (optionally steered by a hint)
 */
export const usePostMarketingReviewsRepliesReviewIdRewrite = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingReviewsRepliesReviewIdRewrite>>,
      TError,
      { reviewId: string; data: PostMarketingReviewsRepliesReviewIdRewriteBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingReviewsRepliesReviewIdRewrite>>,
  TError,
  { reviewId: string; data: PostMarketingReviewsRepliesReviewIdRewriteBody },
  TContext
> => {
  const mutationOptions = getPostMarketingReviewsRepliesReviewIdRewriteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Skip replying to this review (it leaves the queue)
 */
export const postMarketingReviewsRepliesReviewIdSkip = (reviewId: string, signal?: AbortSignal) => {
  return customInstance<PostMarketingReviewsRepliesReviewIdSkip200>({
    url: `/marketing/reviews/replies/${reviewId}/skip`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingReviewsRepliesReviewIdSkipMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingReviewsRepliesReviewIdSkip>>,
    TError,
    { reviewId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingReviewsRepliesReviewIdSkip>>,
  TError,
  { reviewId: string },
  TContext
> => {
  const mutationKey = ['postMarketingReviewsRepliesReviewIdSkip'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingReviewsRepliesReviewIdSkip>>,
    { reviewId: string }
  > = (props) => {
    const { reviewId } = props ?? {};

    return postMarketingReviewsRepliesReviewIdSkip(reviewId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingReviewsRepliesReviewIdSkipMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingReviewsRepliesReviewIdSkip>>
>;

export type PostMarketingReviewsRepliesReviewIdSkipMutationError = void;

/**
 * @summary Skip replying to this review (it leaves the queue)
 */
export const usePostMarketingReviewsRepliesReviewIdSkip = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingReviewsRepliesReviewIdSkip>>,
      TError,
      { reviewId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingReviewsRepliesReviewIdSkip>>,
  TError,
  { reviewId: string },
  TContext
> => {
  const mutationOptions = getPostMarketingReviewsRepliesReviewIdSkipMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Auto-reply, reply voice, signature and monthly review goal
 */
export const getMarketingReviewsReplySettings = (signal?: AbortSignal) => {
  return customInstance<GetMarketingReviewsReplySettings200>({
    url: `/marketing/reviews/reply-settings`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingReviewsReplySettingsInfiniteQueryKey = () => {
  return ['infinite', `/marketing/reviews/reply-settings`] as const;
};

export const getGetMarketingReviewsReplySettingsQueryKey = () => {
  return [`/marketing/reviews/reply-settings`] as const;
};

export const getGetMarketingReviewsReplySettingsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingReviewsReplySettingsInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>> = ({
    signal,
  }) => getMarketingReviewsReplySettings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsReplySettingsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>
>;
export type GetMarketingReviewsReplySettingsInfiniteQueryError = void;

export function useGetMarketingReviewsReplySettingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsReplySettingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsReplySettingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Auto-reply, reply voice, signature and monthly review goal
 */

export function useGetMarketingReviewsReplySettingsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsReplySettingsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingReviewsReplySettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingReviewsReplySettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>> = ({
    signal,
  }) => getMarketingReviewsReplySettings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsReplySettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>
>;
export type GetMarketingReviewsReplySettingsQueryError = void;

export function useGetMarketingReviewsReplySettings<
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsReplySettings<
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsReplySettings<
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Auto-reply, reply voice, signature and monthly review goal
 */

export function useGetMarketingReviewsReplySettings<
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsReplySettingsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingReviewsReplySettingsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingReviewsReplySettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>> = ({
    signal,
  }) => getMarketingReviewsReplySettings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsReplySettingsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>
>;
export type GetMarketingReviewsReplySettingsSuspenseQueryError = void;

export function useGetMarketingReviewsReplySettingsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsReplySettingsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsReplySettingsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Auto-reply, reply voice, signature and monthly review goal
 */

export function useGetMarketingReviewsReplySettingsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsReplySettings>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsReplySettingsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update reply settings (covering more stars schedules waiting drafts: 1 h for 4–5★, 3 h for 1–3★)
 */
export const patchMarketingReviewsReplySettings = (
  patchMarketingReviewsReplySettingsBody: PatchMarketingReviewsReplySettingsBody
) => {
  return customInstance<PatchMarketingReviewsReplySettings200>({
    url: `/marketing/reviews/reply-settings`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchMarketingReviewsReplySettingsBody,
  });
};

export const getPatchMarketingReviewsReplySettingsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMarketingReviewsReplySettings>>,
    TError,
    { data: PatchMarketingReviewsReplySettingsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMarketingReviewsReplySettings>>,
  TError,
  { data: PatchMarketingReviewsReplySettingsBody },
  TContext
> => {
  const mutationKey = ['patchMarketingReviewsReplySettings'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMarketingReviewsReplySettings>>,
    { data: PatchMarketingReviewsReplySettingsBody }
  > = (props) => {
    const { data } = props ?? {};

    return patchMarketingReviewsReplySettings(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMarketingReviewsReplySettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchMarketingReviewsReplySettings>>
>;
export type PatchMarketingReviewsReplySettingsMutationBody = PatchMarketingReviewsReplySettingsBody;
export type PatchMarketingReviewsReplySettingsMutationError = void;

/**
 * @summary Update reply settings (covering more stars schedules waiting drafts: 1 h for 4–5★, 3 h for 1–3★)
 */
export const usePatchMarketingReviewsReplySettings = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchMarketingReviewsReplySettings>>,
      TError,
      { data: PatchMarketingReviewsReplySettingsBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchMarketingReviewsReplySettings>>,
  TError,
  { data: PatchMarketingReviewsReplySettingsBody },
  TContext
> => {
  const mutationOptions = getPatchMarketingReviewsReplySettingsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary This month: new reviews vs goal, replied count, average reply time
 */
export const getMarketingReviewsReplyStats = (signal?: AbortSignal) => {
  return customInstance<GetMarketingReviewsReplyStats200>({
    url: `/marketing/reviews/reply-stats`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingReviewsReplyStatsInfiniteQueryKey = () => {
  return ['infinite', `/marketing/reviews/reply-stats`] as const;
};

export const getGetMarketingReviewsReplyStatsQueryKey = () => {
  return [`/marketing/reviews/reply-stats`] as const;
};

export const getGetMarketingReviewsReplyStatsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingReviewsReplyStatsInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>> = ({
    signal,
  }) => getMarketingReviewsReplyStats(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsReplyStatsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>
>;
export type GetMarketingReviewsReplyStatsInfiniteQueryError = void;

export function useGetMarketingReviewsReplyStatsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsReplyStatsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsReplyStatsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary This month: new reviews vs goal, replied count, average reply time
 */

export function useGetMarketingReviewsReplyStatsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsReplyStatsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingReviewsReplyStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingReviewsReplyStatsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>> = ({
    signal,
  }) => getMarketingReviewsReplyStats(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsReplyStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>
>;
export type GetMarketingReviewsReplyStatsQueryError = void;

export function useGetMarketingReviewsReplyStats<
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsReplyStats<
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsReplyStats<
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary This month: new reviews vs goal, replied count, average reply time
 */

export function useGetMarketingReviewsReplyStats<
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsReplyStatsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingReviewsReplyStatsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingReviewsReplyStatsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>> = ({
    signal,
  }) => getMarketingReviewsReplyStats(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsReplyStatsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>
>;
export type GetMarketingReviewsReplyStatsSuspenseQueryError = void;

export function useGetMarketingReviewsReplyStatsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsReplyStatsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsReplyStatsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary This month: new reviews vs goal, replied count, average reply time
 */

export function useGetMarketingReviewsReplyStatsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsReplyStats>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsReplyStatsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Ad-tracking status (masked Meta Pixel + derived badge + serverConfigured); token never returned
 */
export const getMarketingSettingsAdTracking = (signal?: AbortSignal) => {
  return customInstance<GetMarketingSettingsAdTracking200>({
    url: `/marketing/settings/ad-tracking`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingSettingsAdTrackingInfiniteQueryKey = () => {
  return ['infinite', `/marketing/settings/ad-tracking`] as const;
};

export const getGetMarketingSettingsAdTrackingQueryKey = () => {
  return [`/marketing/settings/ad-tracking`] as const;
};

export const getGetMarketingSettingsAdTrackingInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSettingsAdTrackingInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>> = ({
    signal,
  }) => getMarketingSettingsAdTracking(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSettingsAdTrackingInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>
>;
export type GetMarketingSettingsAdTrackingInfiniteQueryError = unknown;

export function useGetMarketingSettingsAdTrackingInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsAdTrackingInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsAdTrackingInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Ad-tracking status (masked Meta Pixel + derived badge + serverConfigured); token never returned
 */

export function useGetMarketingSettingsAdTrackingInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSettingsAdTrackingInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSettingsAdTrackingQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSettingsAdTrackingQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>> = ({
    signal,
  }) => getMarketingSettingsAdTracking(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSettingsAdTrackingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>
>;
export type GetMarketingSettingsAdTrackingQueryError = unknown;

export function useGetMarketingSettingsAdTracking<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsAdTracking<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsAdTracking<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Ad-tracking status (masked Meta Pixel + derived badge + serverConfigured); token never returned
 */

export function useGetMarketingSettingsAdTracking<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSettingsAdTrackingQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSettingsAdTrackingSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSettingsAdTrackingQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>> = ({
    signal,
  }) => getMarketingSettingsAdTracking(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSettingsAdTrackingSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>
>;
export type GetMarketingSettingsAdTrackingSuspenseQueryError = unknown;

export function useGetMarketingSettingsAdTrackingSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsAdTrackingSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsAdTrackingSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Ad-tracking status (masked Meta Pixel + derived badge + serverConfigured); token never returned
 */

export function useGetMarketingSettingsAdTrackingSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTracking>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSettingsAdTrackingSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Connect / update the salon Meta Pixel (validates against Graph, stores the token encrypted)
 */
export const putMarketingSettingsAdTrackingMetaPixel = (
  putMarketingSettingsAdTrackingMetaPixelBody: PutMarketingSettingsAdTrackingMetaPixelBody
) => {
  return customInstance<PutMarketingSettingsAdTrackingMetaPixel200>({
    url: `/marketing/settings/ad-tracking/meta-pixel`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putMarketingSettingsAdTrackingMetaPixelBody,
  });
};

export const getPutMarketingSettingsAdTrackingMetaPixelMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMarketingSettingsAdTrackingMetaPixel>>,
    TError,
    { data: PutMarketingSettingsAdTrackingMetaPixelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMarketingSettingsAdTrackingMetaPixel>>,
  TError,
  { data: PutMarketingSettingsAdTrackingMetaPixelBody },
  TContext
> => {
  const mutationKey = ['putMarketingSettingsAdTrackingMetaPixel'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMarketingSettingsAdTrackingMetaPixel>>,
    { data: PutMarketingSettingsAdTrackingMetaPixelBody }
  > = (props) => {
    const { data } = props ?? {};

    return putMarketingSettingsAdTrackingMetaPixel(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMarketingSettingsAdTrackingMetaPixelMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMarketingSettingsAdTrackingMetaPixel>>
>;
export type PutMarketingSettingsAdTrackingMetaPixelMutationBody =
  PutMarketingSettingsAdTrackingMetaPixelBody;
export type PutMarketingSettingsAdTrackingMetaPixelMutationError = void;

/**
 * @summary Connect / update the salon Meta Pixel (validates against Graph, stores the token encrypted)
 */
export const usePutMarketingSettingsAdTrackingMetaPixel = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putMarketingSettingsAdTrackingMetaPixel>>,
      TError,
      { data: PutMarketingSettingsAdTrackingMetaPixelBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putMarketingSettingsAdTrackingMetaPixel>>,
  TError,
  { data: PutMarketingSettingsAdTrackingMetaPixelBody },
  TContext
> => {
  const mutationOptions = getPutMarketingSettingsAdTrackingMetaPixelMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Disconnect the salon Meta Pixel (deletes credentials; the conversion-event log is kept)
 */
export const deleteMarketingSettingsAdTrackingMetaPixel = () => {
  return customInstance<void>({
    url: `/marketing/settings/ad-tracking/meta-pixel`,
    method: 'DELETE',
  });
};

export const getDeleteMarketingSettingsAdTrackingMetaPixelMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMarketingSettingsAdTrackingMetaPixel>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMarketingSettingsAdTrackingMetaPixel>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['deleteMarketingSettingsAdTrackingMetaPixel'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMarketingSettingsAdTrackingMetaPixel>>,
    void
  > = () => {
    return deleteMarketingSettingsAdTrackingMetaPixel();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMarketingSettingsAdTrackingMetaPixelMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMarketingSettingsAdTrackingMetaPixel>>
>;

export type DeleteMarketingSettingsAdTrackingMetaPixelMutationError = void;

/**
 * @summary Disconnect the salon Meta Pixel (deletes credentials; the conversion-event log is kept)
 */
export const useDeleteMarketingSettingsAdTrackingMetaPixel = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMarketingSettingsAdTrackingMetaPixel>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMarketingSettingsAdTrackingMetaPixel>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getDeleteMarketingSettingsAdTrackingMetaPixelMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Turn test mode off: clear the Test events code (no Pixel ID or token needed)
 */
export const deleteMarketingSettingsAdTrackingMetaPixelTestEventCode = () => {
  return customInstance<DeleteMarketingSettingsAdTrackingMetaPixelTestEventCode200>({
    url: `/marketing/settings/ad-tracking/meta-pixel/test-event-code`,
    method: 'DELETE',
  });
};

export const getDeleteMarketingSettingsAdTrackingMetaPixelTestEventCodeMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMarketingSettingsAdTrackingMetaPixelTestEventCode>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMarketingSettingsAdTrackingMetaPixelTestEventCode>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['deleteMarketingSettingsAdTrackingMetaPixelTestEventCode'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMarketingSettingsAdTrackingMetaPixelTestEventCode>>,
    void
  > = () => {
    return deleteMarketingSettingsAdTrackingMetaPixelTestEventCode();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMarketingSettingsAdTrackingMetaPixelTestEventCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMarketingSettingsAdTrackingMetaPixelTestEventCode>>
>;

export type DeleteMarketingSettingsAdTrackingMetaPixelTestEventCodeMutationError = void;

/**
 * @summary Turn test mode off: clear the Test events code (no Pixel ID or token needed)
 */
export const useDeleteMarketingSettingsAdTrackingMetaPixelTestEventCode = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMarketingSettingsAdTrackingMetaPixelTestEventCode>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMarketingSettingsAdTrackingMetaPixelTestEventCode>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getDeleteMarketingSettingsAdTrackingMetaPixelTestEventCodeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Send one test Lead to Events Manager › Test events (rate-limited 5/min/org)
 */
export const postMarketingSettingsAdTrackingMetaPixelTestEvent = (signal?: AbortSignal) => {
  return customInstance<PostMarketingSettingsAdTrackingMetaPixelTestEvent200>({
    url: `/marketing/settings/ad-tracking/meta-pixel/test-event`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingSettingsAdTrackingMetaPixelTestEventMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingSettingsAdTrackingMetaPixelTestEvent>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingSettingsAdTrackingMetaPixelTestEvent>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postMarketingSettingsAdTrackingMetaPixelTestEvent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingSettingsAdTrackingMetaPixelTestEvent>>,
    void
  > = () => {
    return postMarketingSettingsAdTrackingMetaPixelTestEvent();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingSettingsAdTrackingMetaPixelTestEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingSettingsAdTrackingMetaPixelTestEvent>>
>;

export type PostMarketingSettingsAdTrackingMetaPixelTestEventMutationError = void;

/**
 * @summary Send one test Lead to Events Manager › Test events (rate-limited 5/min/org)
 */
export const usePostMarketingSettingsAdTrackingMetaPixelTestEvent = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingSettingsAdTrackingMetaPixelTestEvent>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingSettingsAdTrackingMetaPixelTestEvent>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getPostMarketingSettingsAdTrackingMetaPixelTestEventMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary The salon's Meta ad account link (choices + suggestion for agency members only)
 */
export const getMarketingSettingsAdTrackingMetaAds = (signal?: AbortSignal) => {
  return customInstance<GetMarketingSettingsAdTrackingMetaAds200>({
    url: `/marketing/settings/ad-tracking/meta-ads`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingSettingsAdTrackingMetaAdsInfiniteQueryKey = () => {
  return ['infinite', `/marketing/settings/ad-tracking/meta-ads`] as const;
};

export const getGetMarketingSettingsAdTrackingMetaAdsQueryKey = () => {
  return [`/marketing/settings/ad-tracking/meta-ads`] as const;
};

export const getGetMarketingSettingsAdTrackingMetaAdsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingSettingsAdTrackingMetaAdsInfiniteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>
  > = ({ signal }) => getMarketingSettingsAdTrackingMetaAds(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSettingsAdTrackingMetaAdsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>
>;
export type GetMarketingSettingsAdTrackingMetaAdsInfiniteQueryError = unknown;

export function useGetMarketingSettingsAdTrackingMetaAdsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsAdTrackingMetaAdsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsAdTrackingMetaAdsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The salon's Meta ad account link (choices + suggestion for agency members only)
 */

export function useGetMarketingSettingsAdTrackingMetaAdsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSettingsAdTrackingMetaAdsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSettingsAdTrackingMetaAdsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSettingsAdTrackingMetaAdsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>
  > = ({ signal }) => getMarketingSettingsAdTrackingMetaAds(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSettingsAdTrackingMetaAdsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>
>;
export type GetMarketingSettingsAdTrackingMetaAdsQueryError = unknown;

export function useGetMarketingSettingsAdTrackingMetaAds<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsAdTrackingMetaAds<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsAdTrackingMetaAds<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The salon's Meta ad account link (choices + suggestion for agency members only)
 */

export function useGetMarketingSettingsAdTrackingMetaAds<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSettingsAdTrackingMetaAdsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSettingsAdTrackingMetaAdsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSettingsAdTrackingMetaAdsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>
  > = ({ signal }) => getMarketingSettingsAdTrackingMetaAds(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSettingsAdTrackingMetaAdsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>
>;
export type GetMarketingSettingsAdTrackingMetaAdsSuspenseQueryError = unknown;

export function useGetMarketingSettingsAdTrackingMetaAdsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsAdTrackingMetaAdsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsAdTrackingMetaAdsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The salon's Meta ad account link (choices + suggestion for agency members only)
 */

export function useGetMarketingSettingsAdTrackingMetaAdsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingMetaAds>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSettingsAdTrackingMetaAdsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Link this salon to its Meta ad account (agency members); queues a lifetime backfill
 */
export const putMarketingSettingsAdTrackingMetaAdsLink = (
  putMarketingSettingsAdTrackingMetaAdsLinkBody: PutMarketingSettingsAdTrackingMetaAdsLinkBody
) => {
  return customInstance<PutMarketingSettingsAdTrackingMetaAdsLink200>({
    url: `/marketing/settings/ad-tracking/meta-ads/link`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putMarketingSettingsAdTrackingMetaAdsLinkBody,
  });
};

export const getPutMarketingSettingsAdTrackingMetaAdsLinkMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMarketingSettingsAdTrackingMetaAdsLink>>,
    TError,
    { data: PutMarketingSettingsAdTrackingMetaAdsLinkBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMarketingSettingsAdTrackingMetaAdsLink>>,
  TError,
  { data: PutMarketingSettingsAdTrackingMetaAdsLinkBody },
  TContext
> => {
  const mutationKey = ['putMarketingSettingsAdTrackingMetaAdsLink'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMarketingSettingsAdTrackingMetaAdsLink>>,
    { data: PutMarketingSettingsAdTrackingMetaAdsLinkBody }
  > = (props) => {
    const { data } = props ?? {};

    return putMarketingSettingsAdTrackingMetaAdsLink(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMarketingSettingsAdTrackingMetaAdsLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMarketingSettingsAdTrackingMetaAdsLink>>
>;
export type PutMarketingSettingsAdTrackingMetaAdsLinkMutationBody =
  PutMarketingSettingsAdTrackingMetaAdsLinkBody;
export type PutMarketingSettingsAdTrackingMetaAdsLinkMutationError = void;

/**
 * @summary Link this salon to its Meta ad account (agency members); queues a lifetime backfill
 */
export const usePutMarketingSettingsAdTrackingMetaAdsLink = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putMarketingSettingsAdTrackingMetaAdsLink>>,
      TError,
      { data: PutMarketingSettingsAdTrackingMetaAdsLinkBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putMarketingSettingsAdTrackingMetaAdsLink>>,
  TError,
  { data: PutMarketingSettingsAdTrackingMetaAdsLinkBody },
  TContext
> => {
  const mutationOptions = getPutMarketingSettingsAdTrackingMetaAdsLinkMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Unlink this salon from its Meta ad account (agency members; imported spend stays)
 */
export const deleteMarketingSettingsAdTrackingMetaAdsLink = () => {
  return customInstance<void>({
    url: `/marketing/settings/ad-tracking/meta-ads/link`,
    method: 'DELETE',
  });
};

export const getDeleteMarketingSettingsAdTrackingMetaAdsLinkMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMarketingSettingsAdTrackingMetaAdsLink>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMarketingSettingsAdTrackingMetaAdsLink>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['deleteMarketingSettingsAdTrackingMetaAdsLink'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMarketingSettingsAdTrackingMetaAdsLink>>,
    void
  > = () => {
    return deleteMarketingSettingsAdTrackingMetaAdsLink();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMarketingSettingsAdTrackingMetaAdsLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMarketingSettingsAdTrackingMetaAdsLink>>
>;

export type DeleteMarketingSettingsAdTrackingMetaAdsLinkMutationError = void;

/**
 * @summary Unlink this salon from its Meta ad account (agency members; imported spend stays)
 */
export const useDeleteMarketingSettingsAdTrackingMetaAdsLink = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMarketingSettingsAdTrackingMetaAdsLink>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMarketingSettingsAdTrackingMetaAdsLink>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getDeleteMarketingSettingsAdTrackingMetaAdsLinkMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Which Meta campaigns pay for this campaign (auto page match + corrections) and the imported total
 */
export const getMarketingCampaignsIdMetaAds = (id: string, signal?: AbortSignal) => {
  return customInstance<GetMarketingCampaignsIdMetaAds200>({
    url: `/marketing/campaigns/${id}/meta-ads`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingCampaignsIdMetaAdsInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/marketing/campaigns/${id}/meta-ads`] as const;
};

export const getGetMarketingCampaignsIdMetaAdsQueryKey = (id?: string) => {
  return [`/marketing/campaigns/${id}/meta-ads`] as const;
};

export const getGetMarketingCampaignsIdMetaAdsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdMetaAdsInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>> = ({
    signal,
  }) => getMarketingCampaignsIdMetaAds(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdMetaAdsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>
>;
export type GetMarketingCampaignsIdMetaAdsInfiniteQueryError = void;

export function useGetMarketingCampaignsIdMetaAdsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdMetaAdsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdMetaAdsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Which Meta campaigns pay for this campaign (auto page match + corrections) and the imported total
 */

export function useGetMarketingCampaignsIdMetaAdsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdMetaAdsInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdMetaAdsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdMetaAdsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>> = ({
    signal,
  }) => getMarketingCampaignsIdMetaAds(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdMetaAdsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>
>;
export type GetMarketingCampaignsIdMetaAdsQueryError = void;

export function useGetMarketingCampaignsIdMetaAds<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdMetaAds<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdMetaAds<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Which Meta campaigns pay for this campaign (auto page match + corrections) and the imported total
 */

export function useGetMarketingCampaignsIdMetaAds<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdMetaAdsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdMetaAdsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdMetaAdsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>> = ({
    signal,
  }) => getMarketingCampaignsIdMetaAds(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdMetaAdsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>
>;
export type GetMarketingCampaignsIdMetaAdsSuspenseQueryError = void;

export function useGetMarketingCampaignsIdMetaAdsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdMetaAdsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdMetaAdsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Which Meta campaigns pay for this campaign (auto page match + corrections) and the imported total
 */

export function useGetMarketingCampaignsIdMetaAdsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdMetaAds>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdMetaAdsSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Include / exclude a Meta campaign for this campaign (null = automatic); re-sums imported spend
 */
export const putMarketingCampaignsIdMetaAdsOverrides = (
  id: string,
  putMarketingCampaignsIdMetaAdsOverridesBody: PutMarketingCampaignsIdMetaAdsOverridesBody
) => {
  return customInstance<PutMarketingCampaignsIdMetaAdsOverrides200>({
    url: `/marketing/campaigns/${id}/meta-ads/overrides`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putMarketingCampaignsIdMetaAdsOverridesBody,
  });
};

export const getPutMarketingCampaignsIdMetaAdsOverridesMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMarketingCampaignsIdMetaAdsOverrides>>,
    TError,
    { id: string; data: PutMarketingCampaignsIdMetaAdsOverridesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMarketingCampaignsIdMetaAdsOverrides>>,
  TError,
  { id: string; data: PutMarketingCampaignsIdMetaAdsOverridesBody },
  TContext
> => {
  const mutationKey = ['putMarketingCampaignsIdMetaAdsOverrides'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMarketingCampaignsIdMetaAdsOverrides>>,
    { id: string; data: PutMarketingCampaignsIdMetaAdsOverridesBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return putMarketingCampaignsIdMetaAdsOverrides(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMarketingCampaignsIdMetaAdsOverridesMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMarketingCampaignsIdMetaAdsOverrides>>
>;
export type PutMarketingCampaignsIdMetaAdsOverridesMutationBody =
  PutMarketingCampaignsIdMetaAdsOverridesBody;
export type PutMarketingCampaignsIdMetaAdsOverridesMutationError = void;

/**
 * @summary Include / exclude a Meta campaign for this campaign (null = automatic); re-sums imported spend
 */
export const usePutMarketingCampaignsIdMetaAdsOverrides = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putMarketingCampaignsIdMetaAdsOverrides>>,
      TError,
      { id: string; data: PutMarketingCampaignsIdMetaAdsOverridesBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putMarketingCampaignsIdMetaAdsOverrides>>,
  TError,
  { id: string; data: PutMarketingCampaignsIdMetaAdsOverridesBody },
  TContext
> => {
  const mutationOptions = getPutMarketingCampaignsIdMetaAdsOverridesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Meta needs attention: Pixel failing / silent, Page or Instagram needs reconnecting (Marketing banner)
 */
export const getMarketingMetaAttention = (signal?: AbortSignal) => {
  return customInstance<GetMarketingMetaAttention200>({
    url: `/marketing/meta-attention`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingMetaAttentionInfiniteQueryKey = () => {
  return ['infinite', `/marketing/meta-attention`] as const;
};

export const getGetMarketingMetaAttentionQueryKey = () => {
  return [`/marketing/meta-attention`] as const;
};

export const getGetMarketingMetaAttentionInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingMetaAttention>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingMetaAttention>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingMetaAttentionInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingMetaAttention>>> = ({
    signal,
  }) => getMarketingMetaAttention(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingMetaAttention>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingMetaAttentionInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingMetaAttention>>
>;
export type GetMarketingMetaAttentionInfiniteQueryError = unknown;

export function useGetMarketingMetaAttentionInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingMetaAttention>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingMetaAttention>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingMetaAttention>>,
          TError,
          Awaited<ReturnType<typeof getMarketingMetaAttention>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingMetaAttentionInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingMetaAttention>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingMetaAttention>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingMetaAttention>>,
          TError,
          Awaited<ReturnType<typeof getMarketingMetaAttention>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingMetaAttentionInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingMetaAttention>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingMetaAttention>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Meta needs attention: Pixel failing / silent, Page or Instagram needs reconnecting (Marketing banner)
 */

export function useGetMarketingMetaAttentionInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingMetaAttention>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingMetaAttention>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingMetaAttentionInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingMetaAttentionQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingMetaAttention>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingMetaAttention>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingMetaAttentionQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingMetaAttention>>> = ({
    signal,
  }) => getMarketingMetaAttention(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingMetaAttention>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingMetaAttentionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingMetaAttention>>
>;
export type GetMarketingMetaAttentionQueryError = unknown;

export function useGetMarketingMetaAttention<
  TData = Awaited<ReturnType<typeof getMarketingMetaAttention>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingMetaAttention>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingMetaAttention>>,
          TError,
          Awaited<ReturnType<typeof getMarketingMetaAttention>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingMetaAttention<
  TData = Awaited<ReturnType<typeof getMarketingMetaAttention>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingMetaAttention>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingMetaAttention>>,
          TError,
          Awaited<ReturnType<typeof getMarketingMetaAttention>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingMetaAttention<
  TData = Awaited<ReturnType<typeof getMarketingMetaAttention>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingMetaAttention>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Meta needs attention: Pixel failing / silent, Page or Instagram needs reconnecting (Marketing banner)
 */

export function useGetMarketingMetaAttention<
  TData = Awaited<ReturnType<typeof getMarketingMetaAttention>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingMetaAttention>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingMetaAttentionQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingMetaAttentionSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingMetaAttention>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingMetaAttention>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingMetaAttentionQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingMetaAttention>>> = ({
    signal,
  }) => getMarketingMetaAttention(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingMetaAttention>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingMetaAttentionSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingMetaAttention>>
>;
export type GetMarketingMetaAttentionSuspenseQueryError = unknown;

export function useGetMarketingMetaAttentionSuspense<
  TData = Awaited<ReturnType<typeof getMarketingMetaAttention>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingMetaAttention>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingMetaAttentionSuspense<
  TData = Awaited<ReturnType<typeof getMarketingMetaAttention>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingMetaAttention>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingMetaAttentionSuspense<
  TData = Awaited<ReturnType<typeof getMarketingMetaAttention>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingMetaAttention>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Meta needs attention: Pixel failing / silent, Page or Instagram needs reconnecting (Marketing banner)
 */

export function useGetMarketingMetaAttentionSuspense<
  TData = Awaited<ReturnType<typeof getMarketingMetaAttention>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingMetaAttention>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingMetaAttentionSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Ad-tracking events table: beacon counts (browser) + Conversions API delivery log (server), last 7/30 days
 */
export const getMarketingSettingsAdTrackingEvents = (
  params?: GetMarketingSettingsAdTrackingEventsParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingSettingsAdTrackingEvents200>({
    url: `/marketing/settings/ad-tracking/events`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingSettingsAdTrackingEventsInfiniteQueryKey = (
  params?: GetMarketingSettingsAdTrackingEventsParams
) => {
  return [
    'infinite',
    `/marketing/settings/ad-tracking/events`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMarketingSettingsAdTrackingEventsQueryKey = (
  params?: GetMarketingSettingsAdTrackingEventsParams
) => {
  return [`/marketing/settings/ad-tracking/events`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingSettingsAdTrackingEventsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>>,
  TError = void,
>(
  params?: GetMarketingSettingsAdTrackingEventsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingSettingsAdTrackingEventsInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>
  > = ({ signal }) => getMarketingSettingsAdTrackingEvents(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSettingsAdTrackingEventsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>
>;
export type GetMarketingSettingsAdTrackingEventsInfiniteQueryError = void;

export function useGetMarketingSettingsAdTrackingEventsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>>,
  TError = void,
>(
  params: undefined | GetMarketingSettingsAdTrackingEventsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsAdTrackingEventsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>>,
  TError = void,
>(
  params?: GetMarketingSettingsAdTrackingEventsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsAdTrackingEventsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>>,
  TError = void,
>(
  params?: GetMarketingSettingsAdTrackingEventsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Ad-tracking events table: beacon counts (browser) + Conversions API delivery log (server), last 7/30 days
 */

export function useGetMarketingSettingsAdTrackingEventsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>>,
  TError = void,
>(
  params?: GetMarketingSettingsAdTrackingEventsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSettingsAdTrackingEventsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSettingsAdTrackingEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
  TError = void,
>(
  params?: GetMarketingSettingsAdTrackingEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingSettingsAdTrackingEventsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>
  > = ({ signal }) => getMarketingSettingsAdTrackingEvents(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSettingsAdTrackingEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>
>;
export type GetMarketingSettingsAdTrackingEventsQueryError = void;

export function useGetMarketingSettingsAdTrackingEvents<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
  TError = void,
>(
  params: undefined | GetMarketingSettingsAdTrackingEventsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsAdTrackingEvents<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
  TError = void,
>(
  params?: GetMarketingSettingsAdTrackingEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsAdTrackingEvents<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
  TError = void,
>(
  params?: GetMarketingSettingsAdTrackingEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Ad-tracking events table: beacon counts (browser) + Conversions API delivery log (server), last 7/30 days
 */

export function useGetMarketingSettingsAdTrackingEvents<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
  TError = void,
>(
  params?: GetMarketingSettingsAdTrackingEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSettingsAdTrackingEventsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSettingsAdTrackingEventsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
  TError = void,
>(
  params?: GetMarketingSettingsAdTrackingEventsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingSettingsAdTrackingEventsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>
  > = ({ signal }) => getMarketingSettingsAdTrackingEvents(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSettingsAdTrackingEventsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>
>;
export type GetMarketingSettingsAdTrackingEventsSuspenseQueryError = void;

export function useGetMarketingSettingsAdTrackingEventsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
  TError = void,
>(
  params: undefined | GetMarketingSettingsAdTrackingEventsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsAdTrackingEventsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
  TError = void,
>(
  params?: GetMarketingSettingsAdTrackingEventsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSettingsAdTrackingEventsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
  TError = void,
>(
  params?: GetMarketingSettingsAdTrackingEventsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Ad-tracking events table: beacon counts (browser) + Conversions API delivery log (server), last 7/30 days
 */

export function useGetMarketingSettingsAdTrackingEventsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
  TError = void,
>(
  params?: GetMarketingSettingsAdTrackingEventsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSettingsAdTrackingEvents>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSettingsAdTrackingEventsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Hub Ad tracking card: pixel connected + lifetime Lead / Schedule / Purchase sent counts
 */
export const getMarketingCampaignsIdAdTracking = (id: string, signal?: AbortSignal) => {
  return customInstance<GetMarketingCampaignsIdAdTracking200>({
    url: `/marketing/campaigns/${id}/ad-tracking`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingCampaignsIdAdTrackingInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/marketing/campaigns/${id}/ad-tracking`] as const;
};

export const getGetMarketingCampaignsIdAdTrackingQueryKey = (id?: string) => {
  return [`/marketing/campaigns/${id}/ad-tracking`] as const;
};

export const getGetMarketingCampaignsIdAdTrackingInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCampaignsIdAdTrackingInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>> = ({
    signal,
  }) => getMarketingCampaignsIdAdTracking(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdAdTrackingInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>
>;
export type GetMarketingCampaignsIdAdTrackingInfiniteQueryError = void;

export function useGetMarketingCampaignsIdAdTrackingInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdAdTrackingInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdAdTrackingInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Hub Ad tracking card: pixel connected + lifetime Lead / Schedule / Purchase sent counts
 */

export function useGetMarketingCampaignsIdAdTrackingInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdAdTrackingInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdAdTrackingQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdAdTrackingQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>> = ({
    signal,
  }) => getMarketingCampaignsIdAdTracking(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdAdTrackingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>
>;
export type GetMarketingCampaignsIdAdTrackingQueryError = void;

export function useGetMarketingCampaignsIdAdTracking<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdAdTracking<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdAdTracking<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Hub Ad tracking card: pixel connected + lifetime Lead / Schedule / Purchase sent counts
 */

export function useGetMarketingCampaignsIdAdTracking<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdAdTrackingQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdAdTrackingSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdAdTrackingQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>> = ({
    signal,
  }) => getMarketingCampaignsIdAdTracking(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdAdTrackingSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>
>;
export type GetMarketingCampaignsIdAdTrackingSuspenseQueryError = void;

export function useGetMarketingCampaignsIdAdTrackingSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdAdTrackingSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdAdTrackingSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Hub Ad tracking card: pixel connected + lifetime Lead / Schedule / Purchase sent counts
 */

export function useGetMarketingCampaignsIdAdTrackingSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAdTracking>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdAdTrackingSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Ad-spend ledger for a campaign + lifetime ROAS inputs
 */
export const getMarketingCampaignsIdAdSpend = (id: string, signal?: AbortSignal) => {
  return customInstance<GetMarketingCampaignsIdAdSpend200>({
    url: `/marketing/campaigns/${id}/ad-spend`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingCampaignsIdAdSpendInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/marketing/campaigns/${id}/ad-spend`] as const;
};

export const getGetMarketingCampaignsIdAdSpendQueryKey = (id?: string) => {
  return [`/marketing/campaigns/${id}/ad-spend`] as const;
};

export const getGetMarketingCampaignsIdAdSpendInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdAdSpendInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>> = ({
    signal,
  }) => getMarketingCampaignsIdAdSpend(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdAdSpendInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>
>;
export type GetMarketingCampaignsIdAdSpendInfiniteQueryError = void;

export function useGetMarketingCampaignsIdAdSpendInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdAdSpendInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdAdSpendInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Ad-spend ledger for a campaign + lifetime ROAS inputs
 */

export function useGetMarketingCampaignsIdAdSpendInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdAdSpendInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdAdSpendQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdAdSpendQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>> = ({
    signal,
  }) => getMarketingCampaignsIdAdSpend(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdAdSpendQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>
>;
export type GetMarketingCampaignsIdAdSpendQueryError = void;

export function useGetMarketingCampaignsIdAdSpend<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdAdSpend<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdAdSpend<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Ad-spend ledger for a campaign + lifetime ROAS inputs
 */

export function useGetMarketingCampaignsIdAdSpend<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdAdSpendQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCampaignsIdAdSpendSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCampaignsIdAdSpendQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>> = ({
    signal,
  }) => getMarketingCampaignsIdAdSpend(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCampaignsIdAdSpendSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>
>;
export type GetMarketingCampaignsIdAdSpendSuspenseQueryError = void;

export function useGetMarketingCampaignsIdAdSpendSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdAdSpendSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCampaignsIdAdSpendSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Ad-spend ledger for a campaign + lifetime ROAS inputs
 */

export function useGetMarketingCampaignsIdAdSpendSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCampaignsIdAdSpend>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCampaignsIdAdSpendSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Add a dated ad-spend entry (409 AD_SPEND_PERIOD_OVERLAP when the period overlaps another)
 */
export const postMarketingCampaignsIdAdSpend = (
  id: string,
  postMarketingCampaignsIdAdSpendBody: PostMarketingCampaignsIdAdSpendBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingCampaignsIdAdSpend201>({
    url: `/marketing/campaigns/${id}/ad-spend`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingCampaignsIdAdSpendBody,
    signal,
  });
};

export const getPostMarketingCampaignsIdAdSpendMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingCampaignsIdAdSpend>>,
    TError,
    { id: string; data: PostMarketingCampaignsIdAdSpendBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingCampaignsIdAdSpend>>,
  TError,
  { id: string; data: PostMarketingCampaignsIdAdSpendBody },
  TContext
> => {
  const mutationKey = ['postMarketingCampaignsIdAdSpend'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingCampaignsIdAdSpend>>,
    { id: string; data: PostMarketingCampaignsIdAdSpendBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return postMarketingCampaignsIdAdSpend(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingCampaignsIdAdSpendMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingCampaignsIdAdSpend>>
>;
export type PostMarketingCampaignsIdAdSpendMutationBody = PostMarketingCampaignsIdAdSpendBody;
export type PostMarketingCampaignsIdAdSpendMutationError = void;

/**
 * @summary Add a dated ad-spend entry (409 AD_SPEND_PERIOD_OVERLAP when the period overlaps another)
 */
export const usePostMarketingCampaignsIdAdSpend = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingCampaignsIdAdSpend>>,
      TError,
      { id: string; data: PostMarketingCampaignsIdAdSpendBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingCampaignsIdAdSpend>>,
  TError,
  { id: string; data: PostMarketingCampaignsIdAdSpendBody },
  TContext
> => {
  const mutationOptions = getPostMarketingCampaignsIdAdSpendMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Edit an ad-spend entry (period / amount / note)
 */
export const patchMarketingCampaignsIdAdSpendEntryId = (
  id: string,
  entryId: string,
  patchMarketingCampaignsIdAdSpendEntryIdBody: PatchMarketingCampaignsIdAdSpendEntryIdBody
) => {
  return customInstance<PatchMarketingCampaignsIdAdSpendEntryId200>({
    url: `/marketing/campaigns/${id}/ad-spend/${entryId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchMarketingCampaignsIdAdSpendEntryIdBody,
  });
};

export const getPatchMarketingCampaignsIdAdSpendEntryIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMarketingCampaignsIdAdSpendEntryId>>,
    TError,
    { id: string; entryId: string; data: PatchMarketingCampaignsIdAdSpendEntryIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMarketingCampaignsIdAdSpendEntryId>>,
  TError,
  { id: string; entryId: string; data: PatchMarketingCampaignsIdAdSpendEntryIdBody },
  TContext
> => {
  const mutationKey = ['patchMarketingCampaignsIdAdSpendEntryId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMarketingCampaignsIdAdSpendEntryId>>,
    { id: string; entryId: string; data: PatchMarketingCampaignsIdAdSpendEntryIdBody }
  > = (props) => {
    const { id, entryId, data } = props ?? {};

    return patchMarketingCampaignsIdAdSpendEntryId(id, entryId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMarketingCampaignsIdAdSpendEntryIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchMarketingCampaignsIdAdSpendEntryId>>
>;
export type PatchMarketingCampaignsIdAdSpendEntryIdMutationBody =
  PatchMarketingCampaignsIdAdSpendEntryIdBody;
export type PatchMarketingCampaignsIdAdSpendEntryIdMutationError = void;

/**
 * @summary Edit an ad-spend entry (period / amount / note)
 */
export const usePatchMarketingCampaignsIdAdSpendEntryId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchMarketingCampaignsIdAdSpendEntryId>>,
      TError,
      { id: string; entryId: string; data: PatchMarketingCampaignsIdAdSpendEntryIdBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchMarketingCampaignsIdAdSpendEntryId>>,
  TError,
  { id: string; entryId: string; data: PatchMarketingCampaignsIdAdSpendEntryIdBody },
  TContext
> => {
  const mutationOptions = getPatchMarketingCampaignsIdAdSpendEntryIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete an ad-spend entry
 */
export const deleteMarketingCampaignsIdAdSpendEntryId = (id: string, entryId: string) => {
  return customInstance<void>({
    url: `/marketing/campaigns/${id}/ad-spend/${entryId}`,
    method: 'DELETE',
  });
};

export const getDeleteMarketingCampaignsIdAdSpendEntryIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMarketingCampaignsIdAdSpendEntryId>>,
    TError,
    { id: string; entryId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMarketingCampaignsIdAdSpendEntryId>>,
  TError,
  { id: string; entryId: string },
  TContext
> => {
  const mutationKey = ['deleteMarketingCampaignsIdAdSpendEntryId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMarketingCampaignsIdAdSpendEntryId>>,
    { id: string; entryId: string }
  > = (props) => {
    const { id, entryId } = props ?? {};

    return deleteMarketingCampaignsIdAdSpendEntryId(id, entryId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMarketingCampaignsIdAdSpendEntryIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMarketingCampaignsIdAdSpendEntryId>>
>;

export type DeleteMarketingCampaignsIdAdSpendEntryIdMutationError = void;

/**
 * @summary Delete an ad-spend entry
 */
export const useDeleteMarketingCampaignsIdAdSpendEntryId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMarketingCampaignsIdAdSpendEntryId>>,
      TError,
      { id: string; entryId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMarketingCampaignsIdAdSpendEntryId>>,
  TError,
  { id: string; entryId: string },
  TContext
> => {
  const mutationOptions = getDeleteMarketingCampaignsIdAdSpendEntryIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Facebook & Instagram connection status for Comment → DM (tokens never returned)
 */
export const getMarketingMetaSocialConnection = (signal?: AbortSignal) => {
  return customInstance<GetMarketingMetaSocialConnection200>({
    url: `/marketing/meta-social/connection`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingMetaSocialConnectionInfiniteQueryKey = () => {
  return ['infinite', `/marketing/meta-social/connection`] as const;
};

export const getGetMarketingMetaSocialConnectionQueryKey = () => {
  return [`/marketing/meta-social/connection`] as const;
};

export const getGetMarketingMetaSocialConnectionInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingMetaSocialConnectionInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>> = ({
    signal,
  }) => getMarketingMetaSocialConnection(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingMetaSocialConnectionInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>
>;
export type GetMarketingMetaSocialConnectionInfiniteQueryError = unknown;

export function useGetMarketingMetaSocialConnectionInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
          TError,
          Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingMetaSocialConnectionInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
          TError,
          Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingMetaSocialConnectionInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Facebook & Instagram connection status for Comment → DM (tokens never returned)
 */

export function useGetMarketingMetaSocialConnectionInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingMetaSocialConnectionInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingMetaSocialConnectionQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingMetaSocialConnectionQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>> = ({
    signal,
  }) => getMarketingMetaSocialConnection(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingMetaSocialConnectionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>
>;
export type GetMarketingMetaSocialConnectionQueryError = unknown;

export function useGetMarketingMetaSocialConnection<
  TData = Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
          TError,
          Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingMetaSocialConnection<
  TData = Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
          TError,
          Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingMetaSocialConnection<
  TData = Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Facebook & Instagram connection status for Comment → DM (tokens never returned)
 */

export function useGetMarketingMetaSocialConnection<
  TData = Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingMetaSocialConnectionQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingMetaSocialConnectionSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingMetaSocialConnectionQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>> = ({
    signal,
  }) => getMarketingMetaSocialConnection(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingMetaSocialConnectionSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>
>;
export type GetMarketingMetaSocialConnectionSuspenseQueryError = unknown;

export function useGetMarketingMetaSocialConnectionSuspense<
  TData = Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingMetaSocialConnectionSuspense<
  TData = Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingMetaSocialConnectionSuspense<
  TData = Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Facebook & Instagram connection status for Comment → DM (tokens never returned)
 */

export function useGetMarketingMetaSocialConnectionSuspense<
  TData = Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingMetaSocialConnection>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingMetaSocialConnectionSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Disconnect the Page (deletes the token, pauses active automations; idempotent)
 */
export const deleteMarketingMetaSocialConnection = () => {
  return customInstance<void>({ url: `/marketing/meta-social/connection`, method: 'DELETE' });
};

export const getDeleteMarketingMetaSocialConnectionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMarketingMetaSocialConnection>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMarketingMetaSocialConnection>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['deleteMarketingMetaSocialConnection'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMarketingMetaSocialConnection>>,
    void
  > = () => {
    return deleteMarketingMetaSocialConnection();
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMarketingMetaSocialConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMarketingMetaSocialConnection>>
>;

export type DeleteMarketingMetaSocialConnectionMutationError = unknown;

/**
 * @summary Disconnect the Page (deletes the token, pauses active automations; idempotent)
 */
export const useDeleteMarketingMetaSocialConnection = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMarketingMetaSocialConnection>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMarketingMetaSocialConnection>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getDeleteMarketingMetaSocialConnectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Start connecting a Facebook Page (returns the Facebook Login URL)
 */
export const postMarketingMetaSocialOauthStart = (signal?: AbortSignal) => {
  return customInstance<PostMarketingMetaSocialOauthStart200>({
    url: `/marketing/meta-social/oauth/start`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingMetaSocialOauthStartMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingMetaSocialOauthStart>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingMetaSocialOauthStart>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postMarketingMetaSocialOauthStart'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingMetaSocialOauthStart>>,
    void
  > = () => {
    return postMarketingMetaSocialOauthStart();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingMetaSocialOauthStartMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingMetaSocialOauthStart>>
>;

export type PostMarketingMetaSocialOauthStartMutationError = void;

/**
 * @summary Start connecting a Facebook Page (returns the Facebook Login URL)
 */
export const usePostMarketingMetaSocialOauthStart = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingMetaSocialOauthStart>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingMetaSocialOauthStart>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getPostMarketingMetaSocialOauthStartMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Finish the Facebook Login round-trip and list the Pages the user can connect
 */
export const postMarketingMetaSocialOauthComplete = (
  postMarketingMetaSocialOauthCompleteBody: PostMarketingMetaSocialOauthCompleteBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingMetaSocialOauthComplete200>({
    url: `/marketing/meta-social/oauth/complete`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingMetaSocialOauthCompleteBody,
    signal,
  });
};

export const getPostMarketingMetaSocialOauthCompleteMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingMetaSocialOauthComplete>>,
    TError,
    { data: PostMarketingMetaSocialOauthCompleteBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingMetaSocialOauthComplete>>,
  TError,
  { data: PostMarketingMetaSocialOauthCompleteBody },
  TContext
> => {
  const mutationKey = ['postMarketingMetaSocialOauthComplete'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingMetaSocialOauthComplete>>,
    { data: PostMarketingMetaSocialOauthCompleteBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMarketingMetaSocialOauthComplete(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingMetaSocialOauthCompleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingMetaSocialOauthComplete>>
>;
export type PostMarketingMetaSocialOauthCompleteMutationBody =
  PostMarketingMetaSocialOauthCompleteBody;
export type PostMarketingMetaSocialOauthCompleteMutationError = void;

/**
 * @summary Finish the Facebook Login round-trip and list the Pages the user can connect
 */
export const usePostMarketingMetaSocialOauthComplete = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingMetaSocialOauthComplete>>,
      TError,
      { data: PostMarketingMetaSocialOauthCompleteBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingMetaSocialOauthComplete>>,
  TError,
  { data: PostMarketingMetaSocialOauthCompleteBody },
  TContext
> => {
  const mutationOptions = getPostMarketingMetaSocialOauthCompleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Connect the chosen Page (+ its Instagram account) to this salon and subscribe webhooks
 */
export const postMarketingMetaSocialConnect = (
  postMarketingMetaSocialConnectBody: PostMarketingMetaSocialConnectBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingMetaSocialConnect200>({
    url: `/marketing/meta-social/connect`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingMetaSocialConnectBody,
    signal,
  });
};

export const getPostMarketingMetaSocialConnectMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingMetaSocialConnect>>,
    TError,
    { data: PostMarketingMetaSocialConnectBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingMetaSocialConnect>>,
  TError,
  { data: PostMarketingMetaSocialConnectBody },
  TContext
> => {
  const mutationKey = ['postMarketingMetaSocialConnect'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingMetaSocialConnect>>,
    { data: PostMarketingMetaSocialConnectBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMarketingMetaSocialConnect(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingMetaSocialConnectMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingMetaSocialConnect>>
>;
export type PostMarketingMetaSocialConnectMutationBody = PostMarketingMetaSocialConnectBody;
export type PostMarketingMetaSocialConnectMutationError = void;

/**
 * @summary Connect the chosen Page (+ its Instagram account) to this salon and subscribe webhooks
 */
export const usePostMarketingMetaSocialConnect = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingMetaSocialConnect>>,
      TError,
      { data: PostMarketingMetaSocialConnectBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingMetaSocialConnect>>,
  TError,
  { data: PostMarketingMetaSocialConnectBody },
  TContext
> => {
  const mutationOptions = getPostMarketingMetaSocialConnectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Comment → DM automations (not archived) with their results for the period, salon totals and the setup
 */
export const getMarketingCommentAutomations = (
  params?: GetMarketingCommentAutomationsParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingCommentAutomations200>({
    url: `/marketing/comment-automations`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingCommentAutomationsInfiniteQueryKey = (
  params?: GetMarketingCommentAutomationsParams
) => {
  return ['infinite', `/marketing/comment-automations`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingCommentAutomationsQueryKey = (
  params?: GetMarketingCommentAutomationsParams
) => {
  return [`/marketing/comment-automations`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingCommentAutomationsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentAutomations>>>,
  TError = unknown,
>(
  params?: GetMarketingCommentAutomationsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCommentAutomationsInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCommentAutomations>>> = ({
    signal,
  }) => getMarketingCommentAutomations(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCommentAutomationsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCommentAutomations>>
>;
export type GetMarketingCommentAutomationsInfiniteQueryError = unknown;

export function useGetMarketingCommentAutomationsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentAutomations>>>,
  TError = unknown,
>(
  params: undefined | GetMarketingCommentAutomationsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCommentAutomations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentAutomations>>>,
  TError = unknown,
>(
  params?: GetMarketingCommentAutomationsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCommentAutomations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentAutomations>>>,
  TError = unknown,
>(
  params?: GetMarketingCommentAutomationsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Comment → DM automations (not archived) with their results for the period, salon totals and the setup
 */

export function useGetMarketingCommentAutomationsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentAutomations>>>,
  TError = unknown,
>(
  params?: GetMarketingCommentAutomationsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCommentAutomationsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCommentAutomationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
  TError = unknown,
>(
  params?: GetMarketingCommentAutomationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCommentAutomations>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCommentAutomationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCommentAutomations>>> = ({
    signal,
  }) => getMarketingCommentAutomations(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCommentAutomationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCommentAutomations>>
>;
export type GetMarketingCommentAutomationsQueryError = unknown;

export function useGetMarketingCommentAutomations<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
  TError = unknown,
>(
  params: undefined | GetMarketingCommentAutomationsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCommentAutomations>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCommentAutomations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomations<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
  TError = unknown,
>(
  params?: GetMarketingCommentAutomationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCommentAutomations>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCommentAutomations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomations<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
  TError = unknown,
>(
  params?: GetMarketingCommentAutomationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCommentAutomations>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Comment → DM automations (not archived) with their results for the period, salon totals and the setup
 */

export function useGetMarketingCommentAutomations<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
  TError = unknown,
>(
  params?: GetMarketingCommentAutomationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCommentAutomations>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCommentAutomationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCommentAutomationsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
  TError = unknown,
>(
  params?: GetMarketingCommentAutomationsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCommentAutomationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCommentAutomations>>> = ({
    signal,
  }) => getMarketingCommentAutomations(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCommentAutomationsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCommentAutomations>>
>;
export type GetMarketingCommentAutomationsSuspenseQueryError = unknown;

export function useGetMarketingCommentAutomationsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
  TError = unknown,
>(
  params: undefined | GetMarketingCommentAutomationsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
  TError = unknown,
>(
  params?: GetMarketingCommentAutomationsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
  TError = unknown,
>(
  params?: GetMarketingCommentAutomationsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Comment → DM automations (not archived) with their results for the period, salon totals and the setup
 */

export function useGetMarketingCommentAutomationsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
  TError = unknown,
>(
  params?: GetMarketingCommentAutomationsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCommentAutomationsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a Comment → DM automation (post metadata is read from Meta; keywords normalized)
 */
export const postMarketingCommentAutomations = (
  postMarketingCommentAutomationsBody: PostMarketingCommentAutomationsBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingCommentAutomations201>({
    url: `/marketing/comment-automations`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingCommentAutomationsBody,
    signal,
  });
};

export const getPostMarketingCommentAutomationsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingCommentAutomations>>,
    TError,
    { data: PostMarketingCommentAutomationsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingCommentAutomations>>,
  TError,
  { data: PostMarketingCommentAutomationsBody },
  TContext
> => {
  const mutationKey = ['postMarketingCommentAutomations'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingCommentAutomations>>,
    { data: PostMarketingCommentAutomationsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMarketingCommentAutomations(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingCommentAutomationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingCommentAutomations>>
>;
export type PostMarketingCommentAutomationsMutationBody = PostMarketingCommentAutomationsBody;
export type PostMarketingCommentAutomationsMutationError = void;

/**
 * @summary Create a Comment → DM automation (post metadata is read from Meta; keywords normalized)
 */
export const usePostMarketingCommentAutomations = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingCommentAutomations>>,
      TError,
      { data: PostMarketingCommentAutomationsBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingCommentAutomations>>,
  TError,
  { data: PostMarketingCommentAutomationsBody },
  TContext
> => {
  const mutationOptions = getPostMarketingCommentAutomationsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Salon pages a DM button can open (New Client Offer, Bio Page, Book online): pickable, open today, fallback
 */
export const getMarketingCommentAutomationsSalonPages = (signal?: AbortSignal) => {
  return customInstance<GetMarketingCommentAutomationsSalonPages200>({
    url: `/marketing/comment-automations/salon-pages`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingCommentAutomationsSalonPagesInfiniteQueryKey = () => {
  return ['infinite', `/marketing/comment-automations/salon-pages`] as const;
};

export const getGetMarketingCommentAutomationsSalonPagesQueryKey = () => {
  return [`/marketing/comment-automations/salon-pages`] as const;
};

export const getGetMarketingCommentAutomationsSalonPagesInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCommentAutomationsSalonPagesInfiniteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>
  > = ({ signal }) => getMarketingCommentAutomationsSalonPages(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCommentAutomationsSalonPagesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>
>;
export type GetMarketingCommentAutomationsSalonPagesInfiniteQueryError = unknown;

export function useGetMarketingCommentAutomationsSalonPagesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsSalonPagesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsSalonPagesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Salon pages a DM button can open (New Client Offer, Bio Page, Book online): pickable, open today, fallback
 */

export function useGetMarketingCommentAutomationsSalonPagesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCommentAutomationsSalonPagesInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCommentAutomationsSalonPagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCommentAutomationsSalonPagesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>
  > = ({ signal }) => getMarketingCommentAutomationsSalonPages(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCommentAutomationsSalonPagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>
>;
export type GetMarketingCommentAutomationsSalonPagesQueryError = unknown;

export function useGetMarketingCommentAutomationsSalonPages<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsSalonPages<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsSalonPages<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Salon pages a DM button can open (New Client Offer, Bio Page, Book online): pickable, open today, fallback
 */

export function useGetMarketingCommentAutomationsSalonPages<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCommentAutomationsSalonPagesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCommentAutomationsSalonPagesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCommentAutomationsSalonPagesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>
  > = ({ signal }) => getMarketingCommentAutomationsSalonPages(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCommentAutomationsSalonPagesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>
>;
export type GetMarketingCommentAutomationsSalonPagesSuspenseQueryError = unknown;

export function useGetMarketingCommentAutomationsSalonPagesSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsSalonPagesSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsSalonPagesSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Salon pages a DM button can open (New Client Offer, Bio Page, Book online): pickable, open today, fallback
 */

export function useGetMarketingCommentAutomationsSalonPagesSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsSalonPages>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCommentAutomationsSalonPagesSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Recent Facebook Page posts / Instagram media for the post picker (25 per page, cached 60 s)
 */
export const getMarketingCommentAutomationsPosts = (
  params: GetMarketingCommentAutomationsPostsParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingCommentAutomationsPosts200>({
    url: `/marketing/comment-automations/posts`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingCommentAutomationsPostsInfiniteQueryKey = (
  params?: GetMarketingCommentAutomationsPostsParams
) => {
  return ['infinite', `/marketing/comment-automations/posts`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingCommentAutomationsPostsQueryKey = (
  params?: GetMarketingCommentAutomationsPostsParams
) => {
  return [`/marketing/comment-automations/posts`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingCommentAutomationsPostsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>>,
  TError = void,
>(
  params: GetMarketingCommentAutomationsPostsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCommentAutomationsPostsInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>> = ({
    signal,
  }) => getMarketingCommentAutomationsPosts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCommentAutomationsPostsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>
>;
export type GetMarketingCommentAutomationsPostsInfiniteQueryError = void;

export function useGetMarketingCommentAutomationsPostsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>>,
  TError = void,
>(
  params: GetMarketingCommentAutomationsPostsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsPostsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>>,
  TError = void,
>(
  params: GetMarketingCommentAutomationsPostsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsPostsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>>,
  TError = void,
>(
  params: GetMarketingCommentAutomationsPostsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recent Facebook Page posts / Instagram media for the post picker (25 per page, cached 60 s)
 */

export function useGetMarketingCommentAutomationsPostsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>>,
  TError = void,
>(
  params: GetMarketingCommentAutomationsPostsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCommentAutomationsPostsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCommentAutomationsPostsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
  TError = void,
>(
  params: GetMarketingCommentAutomationsPostsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCommentAutomationsPostsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>> = ({
    signal,
  }) => getMarketingCommentAutomationsPosts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCommentAutomationsPostsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>
>;
export type GetMarketingCommentAutomationsPostsQueryError = void;

export function useGetMarketingCommentAutomationsPosts<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
  TError = void,
>(
  params: GetMarketingCommentAutomationsPostsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsPosts<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
  TError = void,
>(
  params: GetMarketingCommentAutomationsPostsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsPosts<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
  TError = void,
>(
  params: GetMarketingCommentAutomationsPostsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recent Facebook Page posts / Instagram media for the post picker (25 per page, cached 60 s)
 */

export function useGetMarketingCommentAutomationsPosts<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
  TError = void,
>(
  params: GetMarketingCommentAutomationsPostsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCommentAutomationsPostsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCommentAutomationsPostsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
  TError = void,
>(
  params: GetMarketingCommentAutomationsPostsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCommentAutomationsPostsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>> = ({
    signal,
  }) => getMarketingCommentAutomationsPosts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCommentAutomationsPostsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>
>;
export type GetMarketingCommentAutomationsPostsSuspenseQueryError = void;

export function useGetMarketingCommentAutomationsPostsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
  TError = void,
>(
  params: GetMarketingCommentAutomationsPostsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsPostsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
  TError = void,
>(
  params: GetMarketingCommentAutomationsPostsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsPostsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
  TError = void,
>(
  params: GetMarketingCommentAutomationsPostsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recent Facebook Page posts / Instagram media for the post picker (25 per page, cached 60 s)
 */

export function useGetMarketingCommentAutomationsPostsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
  TError = void,
>(
  params: GetMarketingCommentAutomationsPostsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsPosts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCommentAutomationsPostsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary One automation for the editor (refreshes the post preview from Meta, best-effort)
 */
export const getMarketingCommentAutomationsId = (id: string, signal?: AbortSignal) => {
  return customInstance<GetMarketingCommentAutomationsId200>({
    url: `/marketing/comment-automations/${id}`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingCommentAutomationsIdInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/marketing/comment-automations/${id}`] as const;
};

export const getGetMarketingCommentAutomationsIdQueryKey = (id?: string) => {
  return [`/marketing/comment-automations/${id}`] as const;
};

export const getGetMarketingCommentAutomationsIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCommentAutomationsIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>> = ({
    signal,
  }) => getMarketingCommentAutomationsId(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCommentAutomationsIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>
>;
export type GetMarketingCommentAutomationsIdInfiniteQueryError = void;

export function useGetMarketingCommentAutomationsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary One automation for the editor (refreshes the post preview from Meta, best-effort)
 */

export function useGetMarketingCommentAutomationsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCommentAutomationsIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCommentAutomationsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCommentAutomationsIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>> = ({
    signal,
  }) => getMarketingCommentAutomationsId(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCommentAutomationsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>
>;
export type GetMarketingCommentAutomationsIdQueryError = void;

export function useGetMarketingCommentAutomationsId<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsId<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsId<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary One automation for the editor (refreshes the post preview from Meta, best-effort)
 */

export function useGetMarketingCommentAutomationsId<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCommentAutomationsIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCommentAutomationsIdSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCommentAutomationsIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>> = ({
    signal,
  }) => getMarketingCommentAutomationsId(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCommentAutomationsIdSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>
>;
export type GetMarketingCommentAutomationsIdSuspenseQueryError = void;

export function useGetMarketingCommentAutomationsIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary One automation for the editor (refreshes the post preview from Meta, best-effort)
 */

export function useGetMarketingCommentAutomationsIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCommentAutomationsIdSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Replace an automation’s editable fields (status changes use pause / resume / archive)
 */
export const patchMarketingCommentAutomationsId = (
  id: string,
  patchMarketingCommentAutomationsIdBody: PatchMarketingCommentAutomationsIdBody
) => {
  return customInstance<PatchMarketingCommentAutomationsId200>({
    url: `/marketing/comment-automations/${id}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchMarketingCommentAutomationsIdBody,
  });
};

export const getPatchMarketingCommentAutomationsIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMarketingCommentAutomationsId>>,
    TError,
    { id: string; data: PatchMarketingCommentAutomationsIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMarketingCommentAutomationsId>>,
  TError,
  { id: string; data: PatchMarketingCommentAutomationsIdBody },
  TContext
> => {
  const mutationKey = ['patchMarketingCommentAutomationsId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMarketingCommentAutomationsId>>,
    { id: string; data: PatchMarketingCommentAutomationsIdBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return patchMarketingCommentAutomationsId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMarketingCommentAutomationsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchMarketingCommentAutomationsId>>
>;
export type PatchMarketingCommentAutomationsIdMutationBody = PatchMarketingCommentAutomationsIdBody;
export type PatchMarketingCommentAutomationsIdMutationError = void;

/**
 * @summary Replace an automation’s editable fields (status changes use pause / resume / archive)
 */
export const usePatchMarketingCommentAutomationsId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchMarketingCommentAutomationsId>>,
      TError,
      { id: string; data: PatchMarketingCommentAutomationsIdBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchMarketingCommentAutomationsId>>,
  TError,
  { id: string; data: PatchMarketingCommentAutomationsIdBody },
  TContext
> => {
  const mutationOptions = getPatchMarketingCommentAutomationsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Pause an automation (idempotent; queued comments are skipped as AUTOMATION_PAUSED)
 */
export const postMarketingCommentAutomationsIdPause = (id: string, signal?: AbortSignal) => {
  return customInstance<PostMarketingCommentAutomationsIdPause200>({
    url: `/marketing/comment-automations/${id}/pause`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingCommentAutomationsIdPauseMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingCommentAutomationsIdPause>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingCommentAutomationsIdPause>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postMarketingCommentAutomationsIdPause'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingCommentAutomationsIdPause>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postMarketingCommentAutomationsIdPause(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingCommentAutomationsIdPauseMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingCommentAutomationsIdPause>>
>;

export type PostMarketingCommentAutomationsIdPauseMutationError = void;

/**
 * @summary Pause an automation (idempotent; queued comments are skipped as AUTOMATION_PAUSED)
 */
export const usePostMarketingCommentAutomationsIdPause = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingCommentAutomationsIdPause>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingCommentAutomationsIdPause>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostMarketingCommentAutomationsIdPauseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Resume (activate) an automation (idempotent)
 */
export const postMarketingCommentAutomationsIdResume = (id: string, signal?: AbortSignal) => {
  return customInstance<PostMarketingCommentAutomationsIdResume200>({
    url: `/marketing/comment-automations/${id}/resume`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingCommentAutomationsIdResumeMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingCommentAutomationsIdResume>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingCommentAutomationsIdResume>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postMarketingCommentAutomationsIdResume'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingCommentAutomationsIdResume>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postMarketingCommentAutomationsIdResume(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingCommentAutomationsIdResumeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingCommentAutomationsIdResume>>
>;

export type PostMarketingCommentAutomationsIdResumeMutationError = void;

/**
 * @summary Resume (activate) an automation (idempotent)
 */
export const usePostMarketingCommentAutomationsIdResume = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingCommentAutomationsIdResume>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingCommentAutomationsIdResume>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostMarketingCommentAutomationsIdResumeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete an automation (removed if it never handled a comment, archived with its history otherwise)
 */
export const postMarketingCommentAutomationsIdArchive = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `/marketing/comment-automations/${id}/archive`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingCommentAutomationsIdArchiveMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingCommentAutomationsIdArchive>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingCommentAutomationsIdArchive>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postMarketingCommentAutomationsIdArchive'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingCommentAutomationsIdArchive>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postMarketingCommentAutomationsIdArchive(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingCommentAutomationsIdArchiveMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingCommentAutomationsIdArchive>>
>;

export type PostMarketingCommentAutomationsIdArchiveMutationError = void;

/**
 * @summary Delete an automation (removed if it never handled a comment, archived with its history otherwise)
 */
export const usePostMarketingCommentAutomationsIdArchive = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingCommentAutomationsIdArchive>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingCommentAutomationsIdArchive>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostMarketingCommentAutomationsIdArchiveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Matched comments, their outcome and the person each brought, newest first (cursor pagination; view=new; period)
 */
export const getMarketingCommentAutomationsIdActivity = (
  id: string,
  params?: GetMarketingCommentAutomationsIdActivityParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingCommentAutomationsIdActivity200>({
    url: `/marketing/comment-automations/${id}/activity`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingCommentAutomationsIdActivityInfiniteQueryKey = (
  id?: string,
  params?: GetMarketingCommentAutomationsIdActivityParams
) => {
  return [
    'infinite',
    `/marketing/comment-automations/${id}/activity`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMarketingCommentAutomationsIdActivityQueryKey = (
  id?: string,
  params?: GetMarketingCommentAutomationsIdActivityParams
) => {
  return [`/marketing/comment-automations/${id}/activity`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingCommentAutomationsIdActivityInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingCommentAutomationsIdActivityParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetMarketingCommentAutomationsIdActivityInfiniteQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>
  > = ({ signal }) => getMarketingCommentAutomationsIdActivity(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCommentAutomationsIdActivityInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>
>;
export type GetMarketingCommentAutomationsIdActivityInfiniteQueryError = void;

export function useGetMarketingCommentAutomationsIdActivityInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>>,
  TError = void,
>(
  id: string,
  params: undefined | GetMarketingCommentAutomationsIdActivityParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsIdActivityInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingCommentAutomationsIdActivityParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsIdActivityInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingCommentAutomationsIdActivityParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Matched comments, their outcome and the person each brought, newest first (cursor pagination; view=new; period)
 */

export function useGetMarketingCommentAutomationsIdActivityInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingCommentAutomationsIdActivityParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCommentAutomationsIdActivityInfiniteQueryOptions(
    id,
    params,
    options
  );

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCommentAutomationsIdActivityQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingCommentAutomationsIdActivityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCommentAutomationsIdActivityQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>
  > = ({ signal }) => getMarketingCommentAutomationsIdActivity(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCommentAutomationsIdActivityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>
>;
export type GetMarketingCommentAutomationsIdActivityQueryError = void;

export function useGetMarketingCommentAutomationsIdActivity<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
  TError = void,
>(
  id: string,
  params: undefined | GetMarketingCommentAutomationsIdActivityParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsIdActivity<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingCommentAutomationsIdActivityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsIdActivity<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingCommentAutomationsIdActivityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Matched comments, their outcome and the person each brought, newest first (cursor pagination; view=new; period)
 */

export function useGetMarketingCommentAutomationsIdActivity<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingCommentAutomationsIdActivityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCommentAutomationsIdActivityQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCommentAutomationsIdActivitySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingCommentAutomationsIdActivityParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingCommentAutomationsIdActivityQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>
  > = ({ signal }) => getMarketingCommentAutomationsIdActivity(id, params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCommentAutomationsIdActivitySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>
>;
export type GetMarketingCommentAutomationsIdActivitySuspenseQueryError = void;

export function useGetMarketingCommentAutomationsIdActivitySuspense<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
  TError = void,
>(
  id: string,
  params: undefined | GetMarketingCommentAutomationsIdActivityParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsIdActivitySuspense<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingCommentAutomationsIdActivityParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentAutomationsIdActivitySuspense<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingCommentAutomationsIdActivityParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Matched comments, their outcome and the person each brought, newest first (cursor pagination; view=new; period)
 */

export function useGetMarketingCommentAutomationsIdActivitySuspense<
  TData = Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
  TError = void,
>(
  id: string,
  params?: GetMarketingCommentAutomationsIdActivityParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentAutomationsIdActivity>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCommentAutomationsIdActivitySuspenseQueryOptions(
    id,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary The owner's monthly social media report (Comment → DM + Text Keywords), as the shared page shows it
 */
export const getMarketingSocialReport = (
  params?: GetMarketingSocialReportParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingSocialReport200>({
    url: `/marketing/social-report`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingSocialReportInfiniteQueryKey = (
  params?: GetMarketingSocialReportParams
) => {
  return ['infinite', `/marketing/social-report`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingSocialReportQueryKey = (params?: GetMarketingSocialReportParams) => {
  return [`/marketing/social-report`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingSocialReportInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSocialReport>>>,
  TError = void,
>(
  params?: GetMarketingSocialReportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingSocialReport>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSocialReportInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSocialReport>>> = ({
    signal,
  }) => getMarketingSocialReport(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingSocialReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSocialReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSocialReport>>
>;
export type GetMarketingSocialReportInfiniteQueryError = void;

export function useGetMarketingSocialReportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSocialReport>>>,
  TError = void,
>(
  params: undefined | GetMarketingSocialReportParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingSocialReport>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSocialReport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSocialReport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSocialReportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSocialReport>>>,
  TError = void,
>(
  params?: GetMarketingSocialReportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingSocialReport>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSocialReport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSocialReport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSocialReportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSocialReport>>>,
  TError = void,
>(
  params?: GetMarketingSocialReportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingSocialReport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The owner's monthly social media report (Comment → DM + Text Keywords), as the shared page shows it
 */

export function useGetMarketingSocialReportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSocialReport>>>,
  TError = void,
>(
  params?: GetMarketingSocialReportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingSocialReport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSocialReportInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSocialReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSocialReport>>,
  TError = void,
>(
  params?: GetMarketingSocialReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSocialReport>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSocialReportQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSocialReport>>> = ({
    signal,
  }) => getMarketingSocialReport(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSocialReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSocialReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSocialReport>>
>;
export type GetMarketingSocialReportQueryError = void;

export function useGetMarketingSocialReport<
  TData = Awaited<ReturnType<typeof getMarketingSocialReport>>,
  TError = void,
>(
  params: undefined | GetMarketingSocialReportParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSocialReport>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSocialReport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSocialReport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSocialReport<
  TData = Awaited<ReturnType<typeof getMarketingSocialReport>>,
  TError = void,
>(
  params?: GetMarketingSocialReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSocialReport>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSocialReport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSocialReport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSocialReport<
  TData = Awaited<ReturnType<typeof getMarketingSocialReport>>,
  TError = void,
>(
  params?: GetMarketingSocialReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSocialReport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The owner's monthly social media report (Comment → DM + Text Keywords), as the shared page shows it
 */

export function useGetMarketingSocialReport<
  TData = Awaited<ReturnType<typeof getMarketingSocialReport>>,
  TError = void,
>(
  params?: GetMarketingSocialReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSocialReport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSocialReportQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSocialReportSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSocialReport>>,
  TError = void,
>(
  params?: GetMarketingSocialReportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingSocialReport>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSocialReportQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSocialReport>>> = ({
    signal,
  }) => getMarketingSocialReport(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSocialReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSocialReportSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSocialReport>>
>;
export type GetMarketingSocialReportSuspenseQueryError = void;

export function useGetMarketingSocialReportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSocialReport>>,
  TError = void,
>(
  params: undefined | GetMarketingSocialReportParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingSocialReport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSocialReportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSocialReport>>,
  TError = void,
>(
  params?: GetMarketingSocialReportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingSocialReport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSocialReportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSocialReport>>,
  TError = void,
>(
  params?: GetMarketingSocialReportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingSocialReport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The owner's monthly social media report (Comment → DM + Text Keywords), as the shared page shows it
 */

export function useGetMarketingSocialReportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSocialReport>>,
  TError = void,
>(
  params?: GetMarketingSocialReportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingSocialReport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSocialReportSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Download the owner's monthly social media report (one-page PDF)
 */
export const getMarketingSocialReportPdf = (
  params?: GetMarketingSocialReportPdfParams,
  signal?: AbortSignal
) => {
  return customInstance<Blob>({
    url: `/marketing/social-report/pdf`,
    method: 'GET',
    params,
    responseType: 'blob',
    signal,
  });
};

export const getGetMarketingSocialReportPdfInfiniteQueryKey = (
  params?: GetMarketingSocialReportPdfParams
) => {
  return ['infinite', `/marketing/social-report/pdf`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingSocialReportPdfQueryKey = (
  params?: GetMarketingSocialReportPdfParams
) => {
  return [`/marketing/social-report/pdf`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingSocialReportPdfInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSocialReportPdf>>>,
  TError = void,
>(
  params?: GetMarketingSocialReportPdfParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSocialReportPdfInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSocialReportPdf>>> = ({
    signal,
  }) => getMarketingSocialReportPdf(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSocialReportPdfInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSocialReportPdf>>
>;
export type GetMarketingSocialReportPdfInfiniteQueryError = void;

export function useGetMarketingSocialReportPdfInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSocialReportPdf>>>,
  TError = void,
>(
  params: undefined | GetMarketingSocialReportPdfParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSocialReportPdf>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSocialReportPdfInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSocialReportPdf>>>,
  TError = void,
>(
  params?: GetMarketingSocialReportPdfParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSocialReportPdf>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSocialReportPdfInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSocialReportPdf>>>,
  TError = void,
>(
  params?: GetMarketingSocialReportPdfParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Download the owner's monthly social media report (one-page PDF)
 */

export function useGetMarketingSocialReportPdfInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSocialReportPdf>>>,
  TError = void,
>(
  params?: GetMarketingSocialReportPdfParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSocialReportPdfInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSocialReportPdfQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
  TError = void,
>(
  params?: GetMarketingSocialReportPdfParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSocialReportPdf>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSocialReportPdfQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSocialReportPdf>>> = ({
    signal,
  }) => getMarketingSocialReportPdf(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSocialReportPdfQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSocialReportPdf>>
>;
export type GetMarketingSocialReportPdfQueryError = void;

export function useGetMarketingSocialReportPdf<
  TData = Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
  TError = void,
>(
  params: undefined | GetMarketingSocialReportPdfParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSocialReportPdf>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSocialReportPdf>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSocialReportPdf<
  TData = Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
  TError = void,
>(
  params?: GetMarketingSocialReportPdfParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSocialReportPdf>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSocialReportPdf>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSocialReportPdf<
  TData = Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
  TError = void,
>(
  params?: GetMarketingSocialReportPdfParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSocialReportPdf>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Download the owner's monthly social media report (one-page PDF)
 */

export function useGetMarketingSocialReportPdf<
  TData = Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
  TError = void,
>(
  params?: GetMarketingSocialReportPdfParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSocialReportPdf>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSocialReportPdfQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSocialReportPdfSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
  TError = void,
>(
  params?: GetMarketingSocialReportPdfParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSocialReportPdfQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSocialReportPdf>>> = ({
    signal,
  }) => getMarketingSocialReportPdf(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSocialReportPdfSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSocialReportPdf>>
>;
export type GetMarketingSocialReportPdfSuspenseQueryError = void;

export function useGetMarketingSocialReportPdfSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
  TError = void,
>(
  params: undefined | GetMarketingSocialReportPdfParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSocialReportPdfSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
  TError = void,
>(
  params?: GetMarketingSocialReportPdfParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSocialReportPdfSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
  TError = void,
>(
  params?: GetMarketingSocialReportPdfParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Download the owner's monthly social media report (one-page PDF)
 */

export function useGetMarketingSocialReportPdfSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
  TError = void,
>(
  params?: GetMarketingSocialReportPdfParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSocialReportPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSocialReportPdfSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary The salon's report link for the owner (null until it is first copied)
 */
export const getMarketingSocialReportShare = (signal?: AbortSignal) => {
  return customInstance<GetMarketingSocialReportShare200>({
    url: `/marketing/social-report/share`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingSocialReportShareInfiniteQueryKey = () => {
  return ['infinite', `/marketing/social-report/share`] as const;
};

export const getGetMarketingSocialReportShareQueryKey = () => {
  return [`/marketing/social-report/share`] as const;
};

export const getGetMarketingSocialReportShareInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSocialReportShare>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSocialReportShareInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSocialReportShare>>> = ({
    signal,
  }) => getMarketingSocialReportShare(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSocialReportShareInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSocialReportShare>>
>;
export type GetMarketingSocialReportShareInfiniteQueryError = unknown;

export function useGetMarketingSocialReportShareInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSocialReportShare>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSocialReportShare>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSocialReportShareInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSocialReportShare>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSocialReportShare>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSocialReportShareInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSocialReportShare>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The salon's report link for the owner (null until it is first copied)
 */

export function useGetMarketingSocialReportShareInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingSocialReportShare>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSocialReportShareInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSocialReportShareQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingSocialReportShare>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSocialReportShareQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSocialReportShare>>> = ({
    signal,
  }) => getMarketingSocialReportShare(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSocialReportShareQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSocialReportShare>>
>;
export type GetMarketingSocialReportShareQueryError = unknown;

export function useGetMarketingSocialReportShare<
  TData = Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSocialReportShare>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSocialReportShare>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSocialReportShare<
  TData = Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSocialReportShare>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
          TError,
          Awaited<ReturnType<typeof getMarketingSocialReportShare>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSocialReportShare<
  TData = Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSocialReportShare>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The salon's report link for the owner (null until it is first copied)
 */

export function useGetMarketingSocialReportShare<
  TData = Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingSocialReportShare>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSocialReportShareQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingSocialReportShareSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingSocialReportShareQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingSocialReportShare>>> = ({
    signal,
  }) => getMarketingSocialReportShare(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingSocialReportShareSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingSocialReportShare>>
>;
export type GetMarketingSocialReportShareSuspenseQueryError = unknown;

export function useGetMarketingSocialReportShareSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSocialReportShareSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingSocialReportShareSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The salon's report link for the owner (null until it is first copied)
 */

export function useGetMarketingSocialReportShareSuspense<
  TData = Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingSocialReportShare>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingSocialReportShareSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary The salon's report link for the owner, created on first use
 */
export const postMarketingSocialReportShare = (signal?: AbortSignal) => {
  return customInstance<PostMarketingSocialReportShare200>({
    url: `/marketing/social-report/share`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingSocialReportShareMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingSocialReportShare>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingSocialReportShare>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postMarketingSocialReportShare'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingSocialReportShare>>,
    void
  > = () => {
    return postMarketingSocialReportShare();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingSocialReportShareMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingSocialReportShare>>
>;

export type PostMarketingSocialReportShareMutationError = unknown;

/**
 * @summary The salon's report link for the owner, created on first use
 */
export const usePostMarketingSocialReportShare = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingSocialReportShare>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingSocialReportShare>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getPostMarketingSocialReportShareMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Replace the report link: the old link stops working at once
 */
export const postMarketingSocialReportShareReset = (signal?: AbortSignal) => {
  return customInstance<PostMarketingSocialReportShareReset200>({
    url: `/marketing/social-report/share/reset`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingSocialReportShareResetMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingSocialReportShareReset>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingSocialReportShareReset>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postMarketingSocialReportShareReset'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingSocialReportShareReset>>,
    void
  > = () => {
    return postMarketingSocialReportShareReset();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingSocialReportShareResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingSocialReportShareReset>>
>;

export type PostMarketingSocialReportShareResetMutationError = unknown;

/**
 * @summary Replace the report link: the old link stops working at once
 */
export const usePostMarketingSocialReportShareReset = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingSocialReportShareReset>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingSocialReportShareReset>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getPostMarketingSocialReportShareResetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary The owner's monthly marketing report as the shared page shows it, plus the team's ready-to-send check; ad money only for admins and agency members
 */
export const getMarketingOwnerReport = (
  params?: GetMarketingOwnerReportParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingOwnerReport200>({
    url: `/marketing/owner-report`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingOwnerReportInfiniteQueryKey = (
  params?: GetMarketingOwnerReportParams
) => {
  return ['infinite', `/marketing/owner-report`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingOwnerReportQueryKey = (params?: GetMarketingOwnerReportParams) => {
  return [`/marketing/owner-report`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingOwnerReportInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingOwnerReport>>>,
  TError = void,
>(
  params?: GetMarketingOwnerReportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingOwnerReport>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingOwnerReportInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingOwnerReport>>> = ({
    signal,
  }) => getMarketingOwnerReport(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingOwnerReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingOwnerReportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingOwnerReport>>
>;
export type GetMarketingOwnerReportInfiniteQueryError = void;

export function useGetMarketingOwnerReportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingOwnerReport>>>,
  TError = void,
>(
  params: undefined | GetMarketingOwnerReportParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingOwnerReport>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingOwnerReport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingOwnerReport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingOwnerReportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingOwnerReport>>>,
  TError = void,
>(
  params?: GetMarketingOwnerReportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingOwnerReport>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingOwnerReport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingOwnerReport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingOwnerReportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingOwnerReport>>>,
  TError = void,
>(
  params?: GetMarketingOwnerReportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingOwnerReport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The owner's monthly marketing report as the shared page shows it, plus the team's ready-to-send check; ad money only for admins and agency members
 */

export function useGetMarketingOwnerReportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingOwnerReport>>>,
  TError = void,
>(
  params?: GetMarketingOwnerReportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingOwnerReport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingOwnerReportInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingOwnerReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingOwnerReport>>,
  TError = void,
>(
  params?: GetMarketingOwnerReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingOwnerReport>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingOwnerReportQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingOwnerReport>>> = ({
    signal,
  }) => getMarketingOwnerReport(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingOwnerReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingOwnerReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingOwnerReport>>
>;
export type GetMarketingOwnerReportQueryError = void;

export function useGetMarketingOwnerReport<
  TData = Awaited<ReturnType<typeof getMarketingOwnerReport>>,
  TError = void,
>(
  params: undefined | GetMarketingOwnerReportParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingOwnerReport>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingOwnerReport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingOwnerReport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingOwnerReport<
  TData = Awaited<ReturnType<typeof getMarketingOwnerReport>>,
  TError = void,
>(
  params?: GetMarketingOwnerReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingOwnerReport>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingOwnerReport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingOwnerReport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingOwnerReport<
  TData = Awaited<ReturnType<typeof getMarketingOwnerReport>>,
  TError = void,
>(
  params?: GetMarketingOwnerReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingOwnerReport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The owner's monthly marketing report as the shared page shows it, plus the team's ready-to-send check; ad money only for admins and agency members
 */

export function useGetMarketingOwnerReport<
  TData = Awaited<ReturnType<typeof getMarketingOwnerReport>>,
  TError = void,
>(
  params?: GetMarketingOwnerReportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingOwnerReport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingOwnerReportQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingOwnerReportSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingOwnerReport>>,
  TError = void,
>(
  params?: GetMarketingOwnerReportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingOwnerReport>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingOwnerReportQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingOwnerReport>>> = ({
    signal,
  }) => getMarketingOwnerReport(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingOwnerReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingOwnerReportSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingOwnerReport>>
>;
export type GetMarketingOwnerReportSuspenseQueryError = void;

export function useGetMarketingOwnerReportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingOwnerReport>>,
  TError = void,
>(
  params: undefined | GetMarketingOwnerReportParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingOwnerReport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingOwnerReportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingOwnerReport>>,
  TError = void,
>(
  params?: GetMarketingOwnerReportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingOwnerReport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingOwnerReportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingOwnerReport>>,
  TError = void,
>(
  params?: GetMarketingOwnerReportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingOwnerReport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The owner's monthly marketing report as the shared page shows it, plus the team's ready-to-send check; ad money only for admins and agency members
 */

export function useGetMarketingOwnerReportSuspense<
  TData = Awaited<ReturnType<typeof getMarketingOwnerReport>>,
  TError = void,
>(
  params?: GetMarketingOwnerReportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingOwnerReport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingOwnerReportSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Save any of the team's inputs for one month of the owner report (plan, note, ask, typed numbers); blank clears one
 */
export const putMarketingOwnerReportNotesMonth = (
  month: string,
  putMarketingOwnerReportNotesMonthBody: PutMarketingOwnerReportNotesMonthBody
) => {
  return customInstance<PutMarketingOwnerReportNotesMonth200>({
    url: `/marketing/owner-report/notes/${month}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putMarketingOwnerReportNotesMonthBody,
  });
};

export const getPutMarketingOwnerReportNotesMonthMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMarketingOwnerReportNotesMonth>>,
    TError,
    { month: string; data: PutMarketingOwnerReportNotesMonthBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMarketingOwnerReportNotesMonth>>,
  TError,
  { month: string; data: PutMarketingOwnerReportNotesMonthBody },
  TContext
> => {
  const mutationKey = ['putMarketingOwnerReportNotesMonth'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMarketingOwnerReportNotesMonth>>,
    { month: string; data: PutMarketingOwnerReportNotesMonthBody }
  > = (props) => {
    const { month, data } = props ?? {};

    return putMarketingOwnerReportNotesMonth(month, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMarketingOwnerReportNotesMonthMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMarketingOwnerReportNotesMonth>>
>;
export type PutMarketingOwnerReportNotesMonthMutationBody = PutMarketingOwnerReportNotesMonthBody;
export type PutMarketingOwnerReportNotesMonthMutationError = void;

/**
 * @summary Save any of the team's inputs for one month of the owner report (plan, note, ask, typed numbers); blank clears one
 */
export const usePutMarketingOwnerReportNotesMonth = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putMarketingOwnerReportNotesMonth>>,
      TError,
      { month: string; data: PutMarketingOwnerReportNotesMonthBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putMarketingOwnerReportNotesMonth>>,
  TError,
  { month: string; data: PutMarketingOwnerReportNotesMonthBody },
  TContext
> => {
  const mutationOptions = getPutMarketingOwnerReportNotesMonthMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary The salon's owner report link (null until it is first copied)
 */
export const getMarketingOwnerReportShare = (signal?: AbortSignal) => {
  return customInstance<GetMarketingOwnerReportShare200>({
    url: `/marketing/owner-report/share`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingOwnerReportShareInfiniteQueryKey = () => {
  return ['infinite', `/marketing/owner-report/share`] as const;
};

export const getGetMarketingOwnerReportShareQueryKey = () => {
  return [`/marketing/owner-report/share`] as const;
};

export const getGetMarketingOwnerReportShareInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingOwnerReportShare>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingOwnerReportShare>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingOwnerReportShareInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingOwnerReportShare>>> = ({
    signal,
  }) => getMarketingOwnerReportShare(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingOwnerReportShare>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingOwnerReportShareInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingOwnerReportShare>>
>;
export type GetMarketingOwnerReportShareInfiniteQueryError = unknown;

export function useGetMarketingOwnerReportShareInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingOwnerReportShare>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingOwnerReportShare>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingOwnerReportShare>>,
          TError,
          Awaited<ReturnType<typeof getMarketingOwnerReportShare>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingOwnerReportShareInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingOwnerReportShare>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingOwnerReportShare>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingOwnerReportShare>>,
          TError,
          Awaited<ReturnType<typeof getMarketingOwnerReportShare>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingOwnerReportShareInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingOwnerReportShare>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingOwnerReportShare>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The salon's owner report link (null until it is first copied)
 */

export function useGetMarketingOwnerReportShareInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingOwnerReportShare>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingOwnerReportShare>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingOwnerReportShareInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingOwnerReportShareQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingOwnerReportShare>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingOwnerReportShare>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingOwnerReportShareQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingOwnerReportShare>>> = ({
    signal,
  }) => getMarketingOwnerReportShare(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingOwnerReportShare>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingOwnerReportShareQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingOwnerReportShare>>
>;
export type GetMarketingOwnerReportShareQueryError = unknown;

export function useGetMarketingOwnerReportShare<
  TData = Awaited<ReturnType<typeof getMarketingOwnerReportShare>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingOwnerReportShare>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingOwnerReportShare>>,
          TError,
          Awaited<ReturnType<typeof getMarketingOwnerReportShare>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingOwnerReportShare<
  TData = Awaited<ReturnType<typeof getMarketingOwnerReportShare>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingOwnerReportShare>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingOwnerReportShare>>,
          TError,
          Awaited<ReturnType<typeof getMarketingOwnerReportShare>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingOwnerReportShare<
  TData = Awaited<ReturnType<typeof getMarketingOwnerReportShare>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingOwnerReportShare>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The salon's owner report link (null until it is first copied)
 */

export function useGetMarketingOwnerReportShare<
  TData = Awaited<ReturnType<typeof getMarketingOwnerReportShare>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingOwnerReportShare>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingOwnerReportShareQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingOwnerReportShareSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingOwnerReportShare>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingOwnerReportShare>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingOwnerReportShareQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingOwnerReportShare>>> = ({
    signal,
  }) => getMarketingOwnerReportShare(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingOwnerReportShare>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingOwnerReportShareSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingOwnerReportShare>>
>;
export type GetMarketingOwnerReportShareSuspenseQueryError = unknown;

export function useGetMarketingOwnerReportShareSuspense<
  TData = Awaited<ReturnType<typeof getMarketingOwnerReportShare>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingOwnerReportShare>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingOwnerReportShareSuspense<
  TData = Awaited<ReturnType<typeof getMarketingOwnerReportShare>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingOwnerReportShare>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingOwnerReportShareSuspense<
  TData = Awaited<ReturnType<typeof getMarketingOwnerReportShare>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingOwnerReportShare>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The salon's owner report link (null until it is first copied)
 */

export function useGetMarketingOwnerReportShareSuspense<
  TData = Awaited<ReturnType<typeof getMarketingOwnerReportShare>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingOwnerReportShare>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingOwnerReportShareSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary The salon's owner report link, created on first use
 */
export const postMarketingOwnerReportShare = (signal?: AbortSignal) => {
  return customInstance<PostMarketingOwnerReportShare200>({
    url: `/marketing/owner-report/share`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingOwnerReportShareMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingOwnerReportShare>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingOwnerReportShare>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postMarketingOwnerReportShare'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingOwnerReportShare>>,
    void
  > = () => {
    return postMarketingOwnerReportShare();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingOwnerReportShareMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingOwnerReportShare>>
>;

export type PostMarketingOwnerReportShareMutationError = unknown;

/**
 * @summary The salon's owner report link, created on first use
 */
export const usePostMarketingOwnerReportShare = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingOwnerReportShare>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingOwnerReportShare>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getPostMarketingOwnerReportShareMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Replace the owner report link: the old link stops working at once
 */
export const postMarketingOwnerReportShareReset = (signal?: AbortSignal) => {
  return customInstance<PostMarketingOwnerReportShareReset200>({
    url: `/marketing/owner-report/share/reset`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingOwnerReportShareResetMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingOwnerReportShareReset>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingOwnerReportShareReset>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postMarketingOwnerReportShareReset'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingOwnerReportShareReset>>,
    void
  > = () => {
    return postMarketingOwnerReportShareReset();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingOwnerReportShareResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingOwnerReportShareReset>>
>;

export type PostMarketingOwnerReportShareResetMutationError = unknown;

/**
 * @summary Replace the owner report link: the old link stops working at once
 */
export const usePostMarketingOwnerReportShareReset = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingOwnerReportShareReset>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingOwnerReportShareReset>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getPostMarketingOwnerReportShareResetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary The salon’s Comment → DM automatic reply, its suggested prefill, per-platform state and automatic-row counts
 */
export const getMarketingCommentDmAutoReply = (signal?: AbortSignal) => {
  return customInstance<GetMarketingCommentDmAutoReply200>({
    url: `/marketing/comment-dm/auto-reply`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingCommentDmAutoReplyInfiniteQueryKey = () => {
  return ['infinite', `/marketing/comment-dm/auto-reply`] as const;
};

export const getGetMarketingCommentDmAutoReplyQueryKey = () => {
  return [`/marketing/comment-dm/auto-reply`] as const;
};

export const getGetMarketingCommentDmAutoReplyInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCommentDmAutoReplyInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>> = ({
    signal,
  }) => getMarketingCommentDmAutoReply(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCommentDmAutoReplyInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>
>;
export type GetMarketingCommentDmAutoReplyInfiniteQueryError = unknown;

export function useGetMarketingCommentDmAutoReplyInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentDmAutoReplyInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentDmAutoReplyInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The salon’s Comment → DM automatic reply, its suggested prefill, per-platform state and automatic-row counts
 */

export function useGetMarketingCommentDmAutoReplyInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCommentDmAutoReplyInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCommentDmAutoReplyQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCommentDmAutoReplyQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>> = ({
    signal,
  }) => getMarketingCommentDmAutoReply(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCommentDmAutoReplyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>
>;
export type GetMarketingCommentDmAutoReplyQueryError = unknown;

export function useGetMarketingCommentDmAutoReply<
  TData = Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentDmAutoReply<
  TData = Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
          TError,
          Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentDmAutoReply<
  TData = Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The salon’s Comment → DM automatic reply, its suggested prefill, per-platform state and automatic-row counts
 */

export function useGetMarketingCommentDmAutoReply<
  TData = Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCommentDmAutoReplyQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingCommentDmAutoReplySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingCommentDmAutoReplyQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>> = ({
    signal,
  }) => getMarketingCommentDmAutoReply(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingCommentDmAutoReplySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>
>;
export type GetMarketingCommentDmAutoReplySuspenseQueryError = unknown;

export function useGetMarketingCommentDmAutoReplySuspense<
  TData = Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentDmAutoReplySuspense<
  TData = Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingCommentDmAutoReplySuspense<
  TData = Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The salon’s Comment → DM automatic reply, its suggested prefill, per-platform state and automatic-row counts
 */

export function useGetMarketingCommentDmAutoReplySuspense<
  TData = Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingCommentDmAutoReply>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingCommentDmAutoReplySuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Save the automatic reply (whole form, optimistic baseVersion); re-copies it into every following automatic row
 */
export const putMarketingCommentDmAutoReply = (
  putMarketingCommentDmAutoReplyBody: PutMarketingCommentDmAutoReplyBody
) => {
  return customInstance<PutMarketingCommentDmAutoReply200>({
    url: `/marketing/comment-dm/auto-reply`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putMarketingCommentDmAutoReplyBody,
  });
};

export const getPutMarketingCommentDmAutoReplyMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMarketingCommentDmAutoReply>>,
    TError,
    { data: PutMarketingCommentDmAutoReplyBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMarketingCommentDmAutoReply>>,
  TError,
  { data: PutMarketingCommentDmAutoReplyBody },
  TContext
> => {
  const mutationKey = ['putMarketingCommentDmAutoReply'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMarketingCommentDmAutoReply>>,
    { data: PutMarketingCommentDmAutoReplyBody }
  > = (props) => {
    const { data } = props ?? {};

    return putMarketingCommentDmAutoReply(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMarketingCommentDmAutoReplyMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMarketingCommentDmAutoReply>>
>;
export type PutMarketingCommentDmAutoReplyMutationBody = PutMarketingCommentDmAutoReplyBody;
export type PutMarketingCommentDmAutoReplyMutationError = void;

/**
 * @summary Save the automatic reply (whole form, optimistic baseVersion); re-copies it into every following automatic row
 */
export const usePutMarketingCommentDmAutoReply = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putMarketingCommentDmAutoReply>>,
      TError,
      { data: PutMarketingCommentDmAutoReplyBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putMarketingCommentDmAutoReply>>,
  TError,
  { data: PutMarketingCommentDmAutoReplyBody },
  TContext
> => {
  const mutationOptions = getPutMarketingCommentDmAutoReplyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Reviews KPIs: Google rating, new reviews, requests sent/skipped/tapped/reviewed over 30 or 90 days
 */
export const getMarketingReviewsSummary = (
  params?: GetMarketingReviewsSummaryParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingReviewsSummary200>({
    url: `/marketing/reviews/summary`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingReviewsSummaryInfiniteQueryKey = (
  params?: GetMarketingReviewsSummaryParams
) => {
  return ['infinite', `/marketing/reviews/summary`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingReviewsSummaryQueryKey = (
  params?: GetMarketingReviewsSummaryParams
) => {
  return [`/marketing/reviews/summary`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingReviewsSummaryInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsSummary>>>,
  TError = void,
>(
  params?: GetMarketingReviewsSummaryParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsSummary>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingReviewsSummaryInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsSummary>>> = ({
    signal,
  }) => getMarketingReviewsSummary(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsSummaryInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsSummary>>
>;
export type GetMarketingReviewsSummaryInfiniteQueryError = void;

export function useGetMarketingReviewsSummaryInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsSummary>>>,
  TError = void,
>(
  params: undefined | GetMarketingReviewsSummaryParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsSummary>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsSummary>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsSummary>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsSummaryInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsSummary>>>,
  TError = void,
>(
  params?: GetMarketingReviewsSummaryParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsSummary>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsSummary>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsSummary>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsSummaryInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsSummary>>>,
  TError = void,
>(
  params?: GetMarketingReviewsSummaryParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsSummary>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Reviews KPIs: Google rating, new reviews, requests sent/skipped/tapped/reviewed over 30 or 90 days
 */

export function useGetMarketingReviewsSummaryInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsSummary>>>,
  TError = void,
>(
  params?: GetMarketingReviewsSummaryParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsSummary>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsSummaryInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingReviewsSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingReviewsSummary>>,
  TError = void,
>(
  params?: GetMarketingReviewsSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsSummary>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingReviewsSummaryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsSummary>>> = ({
    signal,
  }) => getMarketingReviewsSummary(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsSummary>>
>;
export type GetMarketingReviewsSummaryQueryError = void;

export function useGetMarketingReviewsSummary<
  TData = Awaited<ReturnType<typeof getMarketingReviewsSummary>>,
  TError = void,
>(
  params: undefined | GetMarketingReviewsSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsSummary>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsSummary>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsSummary>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsSummary<
  TData = Awaited<ReturnType<typeof getMarketingReviewsSummary>>,
  TError = void,
>(
  params?: GetMarketingReviewsSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsSummary>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsSummary>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsSummary>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsSummary<
  TData = Awaited<ReturnType<typeof getMarketingReviewsSummary>>,
  TError = void,
>(
  params?: GetMarketingReviewsSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsSummary>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Reviews KPIs: Google rating, new reviews, requests sent/skipped/tapped/reviewed over 30 or 90 days
 */

export function useGetMarketingReviewsSummary<
  TData = Awaited<ReturnType<typeof getMarketingReviewsSummary>>,
  TError = void,
>(
  params?: GetMarketingReviewsSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsSummary>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingReviewsSummarySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingReviewsSummary>>,
  TError = void,
>(
  params?: GetMarketingReviewsSummaryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsSummary>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingReviewsSummaryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsSummary>>> = ({
    signal,
  }) => getMarketingReviewsSummary(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsSummarySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsSummary>>
>;
export type GetMarketingReviewsSummarySuspenseQueryError = void;

export function useGetMarketingReviewsSummarySuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsSummary>>,
  TError = void,
>(
  params: undefined | GetMarketingReviewsSummaryParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsSummary>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsSummarySuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsSummary>>,
  TError = void,
>(
  params?: GetMarketingReviewsSummaryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsSummary>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsSummarySuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsSummary>>,
  TError = void,
>(
  params?: GetMarketingReviewsSummaryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsSummary>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Reviews KPIs: Google rating, new reviews, requests sent/skipped/tapped/reviewed over 30 or 90 days
 */

export function useGetMarketingReviewsSummarySuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsSummary>>,
  TError = void,
>(
  params?: GetMarketingReviewsSummaryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsSummary>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsSummarySuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Open "Needs attention" items (≤3★ Google reviews + client replies, last 14 days) and the nav badge counts
 */
export const getMarketingReviewsAttention = (signal?: AbortSignal) => {
  return customInstance<GetMarketingReviewsAttention200>({
    url: `/marketing/reviews/attention`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingReviewsAttentionInfiniteQueryKey = () => {
  return ['infinite', `/marketing/reviews/attention`] as const;
};

export const getGetMarketingReviewsAttentionQueryKey = () => {
  return [`/marketing/reviews/attention`] as const;
};

export const getGetMarketingReviewsAttentionInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsAttention>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsAttention>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingReviewsAttentionInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsAttention>>> = ({
    signal,
  }) => getMarketingReviewsAttention(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsAttention>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsAttentionInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsAttention>>
>;
export type GetMarketingReviewsAttentionInfiniteQueryError = void;

export function useGetMarketingReviewsAttentionInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsAttention>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsAttention>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsAttention>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsAttention>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsAttentionInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsAttention>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsAttention>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsAttention>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsAttention>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsAttentionInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsAttention>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsAttention>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Open "Needs attention" items (≤3★ Google reviews + client replies, last 14 days) and the nav badge counts
 */

export function useGetMarketingReviewsAttentionInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsAttention>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsAttention>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsAttentionInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingReviewsAttentionQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingReviewsAttention>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsAttention>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingReviewsAttentionQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsAttention>>> = ({
    signal,
  }) => getMarketingReviewsAttention(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsAttention>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsAttentionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsAttention>>
>;
export type GetMarketingReviewsAttentionQueryError = void;

export function useGetMarketingReviewsAttention<
  TData = Awaited<ReturnType<typeof getMarketingReviewsAttention>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsAttention>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsAttention>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsAttention>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsAttention<
  TData = Awaited<ReturnType<typeof getMarketingReviewsAttention>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsAttention>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsAttention>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsAttention>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsAttention<
  TData = Awaited<ReturnType<typeof getMarketingReviewsAttention>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsAttention>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Open "Needs attention" items (≤3★ Google reviews + client replies, last 14 days) and the nav badge counts
 */

export function useGetMarketingReviewsAttention<
  TData = Awaited<ReturnType<typeof getMarketingReviewsAttention>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsAttention>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsAttentionQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingReviewsAttentionSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingReviewsAttention>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsAttention>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingReviewsAttentionQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsAttention>>> = ({
    signal,
  }) => getMarketingReviewsAttention(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsAttention>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsAttentionSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsAttention>>
>;
export type GetMarketingReviewsAttentionSuspenseQueryError = void;

export function useGetMarketingReviewsAttentionSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsAttention>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsAttention>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsAttentionSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsAttention>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsAttention>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsAttentionSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsAttention>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsAttention>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Open "Needs attention" items (≤3★ Google reviews + client replies, last 14 days) and the nav badge counts
 */

export function useGetMarketingReviewsAttentionSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsAttention>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsAttention>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsAttentionSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary The "Needs attention" count and the nav badge count, without the items
 */
export const getMarketingReviewsAttentionCount = (signal?: AbortSignal) => {
  return customInstance<GetMarketingReviewsAttentionCount200>({
    url: `/marketing/reviews/attention/count`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingReviewsAttentionCountInfiniteQueryKey = () => {
  return ['infinite', `/marketing/reviews/attention/count`] as const;
};

export const getGetMarketingReviewsAttentionCountQueryKey = () => {
  return [`/marketing/reviews/attention/count`] as const;
};

export const getGetMarketingReviewsAttentionCountInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingReviewsAttentionCountInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>> = ({
    signal,
  }) => getMarketingReviewsAttentionCount(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsAttentionCountInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>
>;
export type GetMarketingReviewsAttentionCountInfiniteQueryError = void;

export function useGetMarketingReviewsAttentionCountInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsAttentionCountInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsAttentionCountInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The "Needs attention" count and the nav badge count, without the items
 */

export function useGetMarketingReviewsAttentionCountInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsAttentionCountInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingReviewsAttentionCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingReviewsAttentionCountQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>> = ({
    signal,
  }) => getMarketingReviewsAttentionCount(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsAttentionCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>
>;
export type GetMarketingReviewsAttentionCountQueryError = void;

export function useGetMarketingReviewsAttentionCount<
  TData = Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsAttentionCount<
  TData = Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsAttentionCount<
  TData = Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The "Needs attention" count and the nav badge count, without the items
 */

export function useGetMarketingReviewsAttentionCount<
  TData = Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsAttentionCountQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingReviewsAttentionCountSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingReviewsAttentionCountQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>> = ({
    signal,
  }) => getMarketingReviewsAttentionCount(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsAttentionCountSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>
>;
export type GetMarketingReviewsAttentionCountSuspenseQueryError = void;

export function useGetMarketingReviewsAttentionCountSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsAttentionCountSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsAttentionCountSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The "Needs attention" count and the nav badge count, without the items
 */

export function useGetMarketingReviewsAttentionCountSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsAttentionCount>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsAttentionCountSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Mark an attention item handled (idempotent); returns the remaining open count
 */
export const postMarketingReviewsAttentionKindIdResolve = (
  kind: 'review' | 'reply',
  id: string,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingReviewsAttentionKindIdResolve200>({
    url: `/marketing/reviews/attention/${kind}/${id}/resolve`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingReviewsAttentionKindIdResolveMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingReviewsAttentionKindIdResolve>>,
    TError,
    { kind: 'review' | 'reply'; id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingReviewsAttentionKindIdResolve>>,
  TError,
  { kind: 'review' | 'reply'; id: string },
  TContext
> => {
  const mutationKey = ['postMarketingReviewsAttentionKindIdResolve'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingReviewsAttentionKindIdResolve>>,
    { kind: 'review' | 'reply'; id: string }
  > = (props) => {
    const { kind, id } = props ?? {};

    return postMarketingReviewsAttentionKindIdResolve(kind, id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingReviewsAttentionKindIdResolveMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingReviewsAttentionKindIdResolve>>
>;

export type PostMarketingReviewsAttentionKindIdResolveMutationError = void;

/**
 * @summary Mark an attention item handled (idempotent); returns the remaining open count
 */
export const usePostMarketingReviewsAttentionKindIdResolve = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingReviewsAttentionKindIdResolve>>,
      TError,
      { kind: 'review' | 'reply'; id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingReviewsAttentionKindIdResolve>>,
  TError,
  { kind: 'review' | 'reply'; id: string },
  TContext
> => {
  const mutationOptions = getPostMarketingReviewsAttentionKindIdResolveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Per technician: requests sent, taps, matched Google reviews, average stars, named in reviews
 */
export const getMarketingReviewsTechnicians = (
  params?: GetMarketingReviewsTechniciansParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingReviewsTechnicians200>({
    url: `/marketing/reviews/technicians`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingReviewsTechniciansInfiniteQueryKey = (
  params?: GetMarketingReviewsTechniciansParams
) => {
  return ['infinite', `/marketing/reviews/technicians`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingReviewsTechniciansQueryKey = (
  params?: GetMarketingReviewsTechniciansParams
) => {
  return [`/marketing/reviews/technicians`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingReviewsTechniciansInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>>,
  TError = void,
>(
  params?: GetMarketingReviewsTechniciansParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingReviewsTechniciansInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>> = ({
    signal,
  }) => getMarketingReviewsTechnicians(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsTechniciansInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>
>;
export type GetMarketingReviewsTechniciansInfiniteQueryError = void;

export function useGetMarketingReviewsTechniciansInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>>,
  TError = void,
>(
  params: undefined | GetMarketingReviewsTechniciansParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsTechniciansInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>>,
  TError = void,
>(
  params?: GetMarketingReviewsTechniciansParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsTechniciansInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>>,
  TError = void,
>(
  params?: GetMarketingReviewsTechniciansParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Per technician: requests sent, taps, matched Google reviews, average stars, named in reviews
 */

export function useGetMarketingReviewsTechniciansInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>>,
  TError = void,
>(
  params?: GetMarketingReviewsTechniciansParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsTechniciansInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingReviewsTechniciansQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
  TError = void,
>(
  params?: GetMarketingReviewsTechniciansParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingReviewsTechniciansQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>> = ({
    signal,
  }) => getMarketingReviewsTechnicians(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsTechniciansQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>
>;
export type GetMarketingReviewsTechniciansQueryError = void;

export function useGetMarketingReviewsTechnicians<
  TData = Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
  TError = void,
>(
  params: undefined | GetMarketingReviewsTechniciansParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsTechnicians<
  TData = Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
  TError = void,
>(
  params?: GetMarketingReviewsTechniciansParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsTechnicians<
  TData = Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
  TError = void,
>(
  params?: GetMarketingReviewsTechniciansParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Per technician: requests sent, taps, matched Google reviews, average stars, named in reviews
 */

export function useGetMarketingReviewsTechnicians<
  TData = Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
  TError = void,
>(
  params?: GetMarketingReviewsTechniciansParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsTechniciansQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingReviewsTechniciansSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
  TError = void,
>(
  params?: GetMarketingReviewsTechniciansParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingReviewsTechniciansQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>> = ({
    signal,
  }) => getMarketingReviewsTechnicians(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsTechniciansSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>
>;
export type GetMarketingReviewsTechniciansSuspenseQueryError = void;

export function useGetMarketingReviewsTechniciansSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
  TError = void,
>(
  params: undefined | GetMarketingReviewsTechniciansParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsTechniciansSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
  TError = void,
>(
  params?: GetMarketingReviewsTechniciansParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsTechniciansSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
  TError = void,
>(
  params?: GetMarketingReviewsTechniciansParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Per technician: requests sent, taps, matched Google reviews, average stars, named in reviews
 */

export function useGetMarketingReviewsTechniciansSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
  TError = void,
>(
  params?: GetMarketingReviewsTechniciansParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsTechnicians>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsTechniciansSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Recent review requests, newest first (25 per page, cursor paginated)
 */
export const getMarketingReviewsRequests = (
  params?: GetMarketingReviewsRequestsParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingReviewsRequests200>({
    url: `/marketing/reviews/requests`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingReviewsRequestsInfiniteQueryKey = (
  params?: GetMarketingReviewsRequestsParams
) => {
  return ['infinite', `/marketing/reviews/requests`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingReviewsRequestsQueryKey = (
  params?: GetMarketingReviewsRequestsParams
) => {
  return [`/marketing/reviews/requests`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingReviewsRequestsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsRequests>>>,
  TError = void,
>(
  params?: GetMarketingReviewsRequestsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingReviewsRequestsInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsRequests>>> = ({
    signal,
  }) => getMarketingReviewsRequests(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsRequestsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsRequests>>
>;
export type GetMarketingReviewsRequestsInfiniteQueryError = void;

export function useGetMarketingReviewsRequestsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsRequests>>>,
  TError = void,
>(
  params: undefined | GetMarketingReviewsRequestsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsRequests>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsRequestsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsRequests>>>,
  TError = void,
>(
  params?: GetMarketingReviewsRequestsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsRequests>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsRequestsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsRequests>>>,
  TError = void,
>(
  params?: GetMarketingReviewsRequestsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recent review requests, newest first (25 per page, cursor paginated)
 */

export function useGetMarketingReviewsRequestsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsRequests>>>,
  TError = void,
>(
  params?: GetMarketingReviewsRequestsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsRequestsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingReviewsRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
  TError = void,
>(
  params?: GetMarketingReviewsRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsRequests>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingReviewsRequestsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsRequests>>> = ({
    signal,
  }) => getMarketingReviewsRequests(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsRequests>>
>;
export type GetMarketingReviewsRequestsQueryError = void;

export function useGetMarketingReviewsRequests<
  TData = Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
  TError = void,
>(
  params: undefined | GetMarketingReviewsRequestsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsRequests>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsRequests>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsRequests<
  TData = Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
  TError = void,
>(
  params?: GetMarketingReviewsRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsRequests>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsRequests>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsRequests<
  TData = Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
  TError = void,
>(
  params?: GetMarketingReviewsRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsRequests>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recent review requests, newest first (25 per page, cursor paginated)
 */

export function useGetMarketingReviewsRequests<
  TData = Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
  TError = void,
>(
  params?: GetMarketingReviewsRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsRequests>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsRequestsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingReviewsRequestsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
  TError = void,
>(
  params?: GetMarketingReviewsRequestsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingReviewsRequestsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsRequests>>> = ({
    signal,
  }) => getMarketingReviewsRequests(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsRequestsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsRequests>>
>;
export type GetMarketingReviewsRequestsSuspenseQueryError = void;

export function useGetMarketingReviewsRequestsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
  TError = void,
>(
  params: undefined | GetMarketingReviewsRequestsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsRequestsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
  TError = void,
>(
  params?: GetMarketingReviewsRequestsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsRequestsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
  TError = void,
>(
  params?: GetMarketingReviewsRequestsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recent review requests, newest first (25 per page, cursor paginated)
 */

export function useGetMarketingReviewsRequestsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
  TError = void,
>(
  params?: GetMarketingReviewsRequestsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingReviewsRequests>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsRequestsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @deprecated
 * @summary Deprecated (use /marketing/qr-codes/for?kind=GOOGLE_REVIEW): front-desk Google review QR (permanent scan link, PNG data URL + printable SVG card)
 */
export const getMarketingReviewsQr = (
  params?: GetMarketingReviewsQrParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingReviewsQr200>({
    url: `/marketing/reviews/qr`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingReviewsQrInfiniteQueryKey = (params?: GetMarketingReviewsQrParams) => {
  return ['infinite', `/marketing/reviews/qr`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingReviewsQrQueryKey = (params?: GetMarketingReviewsQrParams) => {
  return [`/marketing/reviews/qr`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingReviewsQrInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsQr>>>,
  TError = void,
>(
  params?: GetMarketingReviewsQrParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsQr>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingReviewsQrInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsQr>>> = ({ signal }) =>
    getMarketingReviewsQr(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsQr>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsQrInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsQr>>
>;
export type GetMarketingReviewsQrInfiniteQueryError = void;

export function useGetMarketingReviewsQrInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsQr>>>,
  TError = void,
>(
  params: undefined | GetMarketingReviewsQrParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsQr>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsQr>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsQr>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsQrInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsQr>>>,
  TError = void,
>(
  params?: GetMarketingReviewsQrParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsQr>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsQr>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsQr>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsQrInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsQr>>>,
  TError = void,
>(
  params?: GetMarketingReviewsQrParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsQr>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @deprecated
 * @summary Deprecated (use /marketing/qr-codes/for?kind=GOOGLE_REVIEW): front-desk Google review QR (permanent scan link, PNG data URL + printable SVG card)
 */

export function useGetMarketingReviewsQrInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingReviewsQr>>>,
  TError = void,
>(
  params?: GetMarketingReviewsQrParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsQr>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsQrInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingReviewsQrQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingReviewsQr>>,
  TError = void,
>(
  params?: GetMarketingReviewsQrParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsQr>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingReviewsQrQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsQr>>> = ({ signal }) =>
    getMarketingReviewsQr(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsQr>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsQrQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsQr>>
>;
export type GetMarketingReviewsQrQueryError = void;

export function useGetMarketingReviewsQr<
  TData = Awaited<ReturnType<typeof getMarketingReviewsQr>>,
  TError = void,
>(
  params: undefined | GetMarketingReviewsQrParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsQr>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsQr>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsQr>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsQr<
  TData = Awaited<ReturnType<typeof getMarketingReviewsQr>>,
  TError = void,
>(
  params?: GetMarketingReviewsQrParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsQr>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingReviewsQr>>,
          TError,
          Awaited<ReturnType<typeof getMarketingReviewsQr>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsQr<
  TData = Awaited<ReturnType<typeof getMarketingReviewsQr>>,
  TError = void,
>(
  params?: GetMarketingReviewsQrParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsQr>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @deprecated
 * @summary Deprecated (use /marketing/qr-codes/for?kind=GOOGLE_REVIEW): front-desk Google review QR (permanent scan link, PNG data URL + printable SVG card)
 */

export function useGetMarketingReviewsQr<
  TData = Awaited<ReturnType<typeof getMarketingReviewsQr>>,
  TError = void,
>(
  params?: GetMarketingReviewsQrParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsQr>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsQrQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingReviewsQrSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingReviewsQr>>,
  TError = void,
>(
  params?: GetMarketingReviewsQrParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsQr>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingReviewsQrQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingReviewsQr>>> = ({ signal }) =>
    getMarketingReviewsQr(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingReviewsQr>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingReviewsQrSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingReviewsQr>>
>;
export type GetMarketingReviewsQrSuspenseQueryError = void;

export function useGetMarketingReviewsQrSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsQr>>,
  TError = void,
>(
  params: undefined | GetMarketingReviewsQrParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsQr>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsQrSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsQr>>,
  TError = void,
>(
  params?: GetMarketingReviewsQrParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsQr>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingReviewsQrSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsQr>>,
  TError = void,
>(
  params?: GetMarketingReviewsQrParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsQr>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @deprecated
 * @summary Deprecated (use /marketing/qr-codes/for?kind=GOOGLE_REVIEW): front-desk Google review QR (permanent scan link, PNG data URL + printable SVG card)
 */

export function useGetMarketingReviewsQrSuspense<
  TData = Awaited<ReturnType<typeof getMarketingReviewsQr>>,
  TError = void,
>(
  params?: GetMarketingReviewsQrParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingReviewsQr>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingReviewsQrSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Email salon admins about new Google reviews of 3 stars or lower
 */
export const putMarketingReviewsSettings = (
  putMarketingReviewsSettingsBody: PutMarketingReviewsSettingsBody
) => {
  return customInstance<PutMarketingReviewsSettings200>({
    url: `/marketing/reviews/settings`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putMarketingReviewsSettingsBody,
  });
};

export const getPutMarketingReviewsSettingsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMarketingReviewsSettings>>,
    TError,
    { data: PutMarketingReviewsSettingsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMarketingReviewsSettings>>,
  TError,
  { data: PutMarketingReviewsSettingsBody },
  TContext
> => {
  const mutationKey = ['putMarketingReviewsSettings'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMarketingReviewsSettings>>,
    { data: PutMarketingReviewsSettingsBody }
  > = (props) => {
    const { data } = props ?? {};

    return putMarketingReviewsSettings(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMarketingReviewsSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMarketingReviewsSettings>>
>;
export type PutMarketingReviewsSettingsMutationBody = PutMarketingReviewsSettingsBody;
export type PutMarketingReviewsSettingsMutationError = void;

/**
 * @summary Email salon admins about new Google reviews of 3 stars or lower
 */
export const usePutMarketingReviewsSettings = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putMarketingReviewsSettings>>,
      TError,
      { data: PutMarketingReviewsSettingsBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putMarketingReviewsSettings>>,
  TError,
  { data: PutMarketingReviewsSettingsBody },
  TContext
> => {
  const mutationOptions = getPutMarketingReviewsSettingsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary The salon's New Client Offer (null until created) with its journey messages, plus go-live readiness
 */
export const getMarketingNewClientOffer = (signal?: AbortSignal) => {
  return customInstance<GetMarketingNewClientOffer200>({
    url: `/marketing/new-client-offer`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingNewClientOfferInfiniteQueryKey = () => {
  return ['infinite', `/marketing/new-client-offer`] as const;
};

export const getGetMarketingNewClientOfferQueryKey = () => {
  return [`/marketing/new-client-offer`] as const;
};

export const getGetMarketingNewClientOfferInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOffer>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOffer>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingNewClientOfferInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingNewClientOffer>>> = ({
    signal,
  }) => getMarketingNewClientOffer(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingNewClientOffer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingNewClientOfferInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingNewClientOffer>>
>;
export type GetMarketingNewClientOfferInfiniteQueryError = unknown;

export function useGetMarketingNewClientOfferInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOffer>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOffer>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingNewClientOffer>>,
          TError,
          Awaited<ReturnType<typeof getMarketingNewClientOffer>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOffer>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOffer>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingNewClientOffer>>,
          TError,
          Awaited<ReturnType<typeof getMarketingNewClientOffer>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOffer>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOffer>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The salon's New Client Offer (null until created) with its journey messages, plus go-live readiness
 */

export function useGetMarketingNewClientOfferInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOffer>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOffer>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingNewClientOfferInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingNewClientOfferQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingNewClientOffer>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOffer>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingNewClientOfferQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingNewClientOffer>>> = ({
    signal,
  }) => getMarketingNewClientOffer(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingNewClientOffer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingNewClientOfferQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingNewClientOffer>>
>;
export type GetMarketingNewClientOfferQueryError = unknown;

export function useGetMarketingNewClientOffer<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOffer>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOffer>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingNewClientOffer>>,
          TError,
          Awaited<ReturnType<typeof getMarketingNewClientOffer>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOffer<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOffer>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOffer>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingNewClientOffer>>,
          TError,
          Awaited<ReturnType<typeof getMarketingNewClientOffer>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOffer<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOffer>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOffer>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The salon's New Client Offer (null until created) with its journey messages, plus go-live readiness
 */

export function useGetMarketingNewClientOffer<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOffer>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOffer>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingNewClientOfferQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingNewClientOfferSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingNewClientOffer>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOffer>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingNewClientOfferQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingNewClientOffer>>> = ({
    signal,
  }) => getMarketingNewClientOffer(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingNewClientOffer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingNewClientOfferSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingNewClientOffer>>
>;
export type GetMarketingNewClientOfferSuspenseQueryError = unknown;

export function useGetMarketingNewClientOfferSuspense<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOffer>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOffer>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferSuspense<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOffer>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOffer>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferSuspense<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOffer>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOffer>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The salon's New Client Offer (null until created) with its journey messages, plus go-live readiness
 */

export function useGetMarketingNewClientOfferSuspense<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOffer>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOffer>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingNewClientOfferSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create the salon offer as a DRAFT with defaults (15% off, 14 days, default copy and journey)
 */
export const postMarketingNewClientOffer = (signal?: AbortSignal) => {
  return customInstance<PostMarketingNewClientOffer201>({
    url: `/marketing/new-client-offer`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingNewClientOfferMutationOptions = <
  TError = PostMarketingNewClientOffer409,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingNewClientOffer>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingNewClientOffer>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postMarketingNewClientOffer'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingNewClientOffer>>,
    void
  > = () => {
    return postMarketingNewClientOffer();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingNewClientOfferMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingNewClientOffer>>
>;

export type PostMarketingNewClientOfferMutationError = PostMarketingNewClientOffer409;

/**
 * @summary Create the salon offer as a DRAFT with defaults (15% off, 14 days, default copy and journey)
 */
export const usePostMarketingNewClientOffer = <
  TError = PostMarketingNewClientOffer409,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingNewClientOffer>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingNewClientOffer>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getPostMarketingNewClientOfferMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Save the offer settings (whole form). The discount needs exactly one of percentOff / amountOffCents matching discountType (400 otherwise). 409 OFFER_CHANGED when baseVersion is stale.
 */
export const patchMarketingNewClientOffer = (
  patchMarketingNewClientOfferBody: PatchMarketingNewClientOfferBody
) => {
  return customInstance<PatchMarketingNewClientOffer200>({
    url: `/marketing/new-client-offer`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchMarketingNewClientOfferBody,
  });
};

export const getPatchMarketingNewClientOfferMutationOptions = <
  TError = PatchMarketingNewClientOffer400 | void | PatchMarketingNewClientOffer409,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMarketingNewClientOffer>>,
    TError,
    { data: PatchMarketingNewClientOfferBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMarketingNewClientOffer>>,
  TError,
  { data: PatchMarketingNewClientOfferBody },
  TContext
> => {
  const mutationKey = ['patchMarketingNewClientOffer'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMarketingNewClientOffer>>,
    { data: PatchMarketingNewClientOfferBody }
  > = (props) => {
    const { data } = props ?? {};

    return patchMarketingNewClientOffer(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMarketingNewClientOfferMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchMarketingNewClientOffer>>
>;
export type PatchMarketingNewClientOfferMutationBody = PatchMarketingNewClientOfferBody;
export type PatchMarketingNewClientOfferMutationError =
  | PatchMarketingNewClientOffer400
  | void
  | PatchMarketingNewClientOffer409;

/**
 * @summary Save the offer settings (whole form). The discount needs exactly one of percentOff / amountOffCents matching discountType (400 otherwise). 409 OFFER_CHANGED when baseVersion is stale.
 */
export const usePatchMarketingNewClientOffer = <
  TError = PatchMarketingNewClientOffer400 | void | PatchMarketingNewClientOffer409,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchMarketingNewClientOffer>>,
      TError,
      { data: PatchMarketingNewClientOfferBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchMarketingNewClientOffer>>,
  TError,
  { data: PatchMarketingNewClientOfferBody },
  TContext
> => {
  const mutationOptions = getPatchMarketingNewClientOfferMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Save journey steps (listed steps replace their row; omitted steps keep theirs). 400 UNKNOWN_VARIABLE when an enabled step uses a token the offer journey cannot fill; 409 OFFER_CHANGED on a stale baseVersion.
 */
export const putMarketingNewClientOfferMessages = (
  putMarketingNewClientOfferMessagesBody: PutMarketingNewClientOfferMessagesBody
) => {
  return customInstance<PutMarketingNewClientOfferMessages200>({
    url: `/marketing/new-client-offer/messages`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putMarketingNewClientOfferMessagesBody,
  });
};

export const getPutMarketingNewClientOfferMessagesMutationOptions = <
  TError = PutMarketingNewClientOfferMessages400 | void | PutMarketingNewClientOfferMessages409,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMarketingNewClientOfferMessages>>,
    TError,
    { data: PutMarketingNewClientOfferMessagesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMarketingNewClientOfferMessages>>,
  TError,
  { data: PutMarketingNewClientOfferMessagesBody },
  TContext
> => {
  const mutationKey = ['putMarketingNewClientOfferMessages'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMarketingNewClientOfferMessages>>,
    { data: PutMarketingNewClientOfferMessagesBody }
  > = (props) => {
    const { data } = props ?? {};

    return putMarketingNewClientOfferMessages(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMarketingNewClientOfferMessagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMarketingNewClientOfferMessages>>
>;
export type PutMarketingNewClientOfferMessagesMutationBody = PutMarketingNewClientOfferMessagesBody;
export type PutMarketingNewClientOfferMessagesMutationError =
  | PutMarketingNewClientOfferMessages400
  | void
  | PutMarketingNewClientOfferMessages409;

/**
 * @summary Save journey steps (listed steps replace their row; omitted steps keep theirs). 400 UNKNOWN_VARIABLE when an enabled step uses a token the offer journey cannot fill; 409 OFFER_CHANGED on a stale baseVersion.
 */
export const usePutMarketingNewClientOfferMessages = <
  TError = PutMarketingNewClientOfferMessages400 | void | PutMarketingNewClientOfferMessages409,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putMarketingNewClientOfferMessages>>,
      TError,
      { data: PutMarketingNewClientOfferMessagesBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putMarketingNewClientOfferMessages>>,
  TError,
  { data: PutMarketingNewClientOfferMessagesBody },
  TContext
> => {
  const mutationOptions = getPutMarketingNewClientOfferMessagesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary DRAFT / PAUSED → LIVE (idempotent). 400 SUBDOMAIN_REQUIRED until the salon has a web address; 409 SMS_NOT_READY with no texting number while guests can sign up online (resume too); 409 TERMS_NOT_REVIEWED on the first go live without termsReviewed: true.
 */
export const postMarketingNewClientOfferGoLive = (
  postMarketingNewClientOfferGoLiveBody?: PostMarketingNewClientOfferGoLiveBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingNewClientOfferGoLive200>({
    url: `/marketing/new-client-offer/go-live`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingNewClientOfferGoLiveBody,
    signal,
  });
};

export const getPostMarketingNewClientOfferGoLiveMutationOptions = <
  TError = PostMarketingNewClientOfferGoLive400 | void | PostMarketingNewClientOfferGoLive409,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingNewClientOfferGoLive>>,
    TError,
    { data: PostMarketingNewClientOfferGoLiveBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingNewClientOfferGoLive>>,
  TError,
  { data: PostMarketingNewClientOfferGoLiveBody },
  TContext
> => {
  const mutationKey = ['postMarketingNewClientOfferGoLive'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingNewClientOfferGoLive>>,
    { data: PostMarketingNewClientOfferGoLiveBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMarketingNewClientOfferGoLive(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingNewClientOfferGoLiveMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingNewClientOfferGoLive>>
>;
export type PostMarketingNewClientOfferGoLiveMutationBody = PostMarketingNewClientOfferGoLiveBody;
export type PostMarketingNewClientOfferGoLiveMutationError =
  | PostMarketingNewClientOfferGoLive400
  | void
  | PostMarketingNewClientOfferGoLive409;

/**
 * @summary DRAFT / PAUSED → LIVE (idempotent). 400 SUBDOMAIN_REQUIRED until the salon has a web address; 409 SMS_NOT_READY with no texting number while guests can sign up online (resume too); 409 TERMS_NOT_REVIEWED on the first go live without termsReviewed: true.
 */
export const usePostMarketingNewClientOfferGoLive = <
  TError = PostMarketingNewClientOfferGoLive400 | void | PostMarketingNewClientOfferGoLive409,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingNewClientOfferGoLive>>,
      TError,
      { data: PostMarketingNewClientOfferGoLiveBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingNewClientOfferGoLive>>,
  TError,
  { data: PostMarketingNewClientOfferGoLiveBody },
  TContext
> => {
  const mutationOptions = getPostMarketingNewClientOfferGoLiveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary LIVE → PAUSED (idempotent). Public surfaces stop showing the offer; issued passes stay valid.
 */
export const postMarketingNewClientOfferPause = (signal?: AbortSignal) => {
  return customInstance<PostMarketingNewClientOfferPause200>({
    url: `/marketing/new-client-offer/pause`,
    method: 'POST',
    signal,
  });
};

export const getPostMarketingNewClientOfferPauseMutationOptions = <
  TError = void | PostMarketingNewClientOfferPause409,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingNewClientOfferPause>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingNewClientOfferPause>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postMarketingNewClientOfferPause'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingNewClientOfferPause>>,
    void
  > = () => {
    return postMarketingNewClientOfferPause();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingNewClientOfferPauseMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingNewClientOfferPause>>
>;

export type PostMarketingNewClientOfferPauseMutationError =
  void | PostMarketingNewClientOfferPause409;

/**
 * @summary LIVE → PAUSED (idempotent). Public surfaces stop showing the offer; issued passes stay valid.
 */
export const usePostMarketingNewClientOfferPause = <
  TError = void | PostMarketingNewClientOfferPause409,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingNewClientOfferPause>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingNewClientOfferPause>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getPostMarketingNewClientOfferPauseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary The offer ad page (`/new-client`): link, status (mirrors the offer), the offer version and the Customize fields
 */
export const getMarketingNewClientOfferPage = (signal?: AbortSignal) => {
  return customInstance<GetMarketingNewClientOfferPage200>({
    url: `/marketing/new-client-offer/page`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingNewClientOfferPageInfiniteQueryKey = () => {
  return ['infinite', `/marketing/new-client-offer/page`] as const;
};

export const getGetMarketingNewClientOfferPageQueryKey = () => {
  return [`/marketing/new-client-offer/page`] as const;
};

export const getGetMarketingNewClientOfferPageInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingNewClientOfferPageInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>> = ({
    signal,
  }) => getMarketingNewClientOfferPage(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingNewClientOfferPageInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>
>;
export type GetMarketingNewClientOfferPageInfiniteQueryError = void;

export function useGetMarketingNewClientOfferPageInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
          TError,
          Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferPageInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
          TError,
          Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferPageInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The offer ad page (`/new-client`): link, status (mirrors the offer), the offer version and the Customize fields
 */

export function useGetMarketingNewClientOfferPageInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingNewClientOfferPageInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingNewClientOfferPageQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingNewClientOfferPageQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>> = ({
    signal,
  }) => getMarketingNewClientOfferPage(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingNewClientOfferPageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>
>;
export type GetMarketingNewClientOfferPageQueryError = void;

export function useGetMarketingNewClientOfferPage<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
          TError,
          Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferPage<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
          TError,
          Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferPage<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The offer ad page (`/new-client`): link, status (mirrors the offer), the offer version and the Customize fields
 */

export function useGetMarketingNewClientOfferPage<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingNewClientOfferPageQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingNewClientOfferPageSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingNewClientOfferPageQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>> = ({
    signal,
  }) => getMarketingNewClientOfferPage(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingNewClientOfferPageSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>
>;
export type GetMarketingNewClientOfferPageSuspenseQueryError = void;

export function useGetMarketingNewClientOfferPageSuspense<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferPageSuspense<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferPageSuspense<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The offer ad page (`/new-client`): link, status (mirrors the offer), the offer version and the Customize fields
 */

export function useGetMarketingNewClientOfferPageSuspense<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferPage>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingNewClientOfferPageSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Save the offer ad page Customize fields (whole set; poster.imageUrl "" = no photo, ctaLabel "" = the offer-derived label). Changes are live at once. 409 OFFER_CHANGED when baseVersion (the offer version) is stale.
 */
export const putMarketingNewClientOfferPage = (
  putMarketingNewClientOfferPageBody: PutMarketingNewClientOfferPageBody
) => {
  return customInstance<PutMarketingNewClientOfferPage200>({
    url: `/marketing/new-client-offer/page`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: putMarketingNewClientOfferPageBody,
  });
};

export const getPutMarketingNewClientOfferPageMutationOptions = <
  TError = PutMarketingNewClientOfferPage400 | void | PutMarketingNewClientOfferPage409,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putMarketingNewClientOfferPage>>,
    TError,
    { data: PutMarketingNewClientOfferPageBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putMarketingNewClientOfferPage>>,
  TError,
  { data: PutMarketingNewClientOfferPageBody },
  TContext
> => {
  const mutationKey = ['putMarketingNewClientOfferPage'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putMarketingNewClientOfferPage>>,
    { data: PutMarketingNewClientOfferPageBody }
  > = (props) => {
    const { data } = props ?? {};

    return putMarketingNewClientOfferPage(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutMarketingNewClientOfferPageMutationResult = NonNullable<
  Awaited<ReturnType<typeof putMarketingNewClientOfferPage>>
>;
export type PutMarketingNewClientOfferPageMutationBody = PutMarketingNewClientOfferPageBody;
export type PutMarketingNewClientOfferPageMutationError =
  | PutMarketingNewClientOfferPage400
  | void
  | PutMarketingNewClientOfferPage409;

/**
 * @summary Save the offer ad page Customize fields (whole set; poster.imageUrl "" = no photo, ctaLabel "" = the offer-derived label). Changes are live at once. 409 OFFER_CHANGED when baseVersion (the offer version) is stale.
 */
export const usePutMarketingNewClientOfferPage = <
  TError = PutMarketingNewClientOfferPage400 | void | PutMarketingNewClientOfferPage409,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putMarketingNewClientOfferPage>>,
      TError,
      { data: PutMarketingNewClientOfferPageBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putMarketingNewClientOfferPage>>,
  TError,
  { data: PutMarketingNewClientOfferPageBody },
  TContext
> => {
  const mutationOptions = getPutMarketingNewClientOfferPageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @deprecated
 * @summary Deprecated (use /marketing/qr-codes/for?kind=NEW_CLIENT_OFFER): PNG of the permanent New Client Offer QR
 */
export const getMarketingNewClientOfferShareQrPng = (
  params?: GetMarketingNewClientOfferShareQrPngParams,
  signal?: AbortSignal
) => {
  return customInstance<Blob>({
    url: `/marketing/new-client-offer/share-qr.png`,
    method: 'GET',
    params,
    responseType: 'blob',
    signal,
  });
};

export const getGetMarketingNewClientOfferShareQrPngInfiniteQueryKey = (
  params?: GetMarketingNewClientOfferShareQrPngParams
) => {
  return [
    'infinite',
    `/marketing/new-client-offer/share-qr.png`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMarketingNewClientOfferShareQrPngQueryKey = (
  params?: GetMarketingNewClientOfferShareQrPngParams
) => {
  return [`/marketing/new-client-offer/share-qr.png`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingNewClientOfferShareQrPngInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>>,
  TError = void,
>(
  params?: GetMarketingNewClientOfferShareQrPngParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingNewClientOfferShareQrPngInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>
  > = ({ signal }) => getMarketingNewClientOfferShareQrPng(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingNewClientOfferShareQrPngInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>
>;
export type GetMarketingNewClientOfferShareQrPngInfiniteQueryError = void;

export function useGetMarketingNewClientOfferShareQrPngInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>>,
  TError = void,
>(
  params: undefined | GetMarketingNewClientOfferShareQrPngParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
          TError,
          Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferShareQrPngInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>>,
  TError = void,
>(
  params?: GetMarketingNewClientOfferShareQrPngParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
          TError,
          Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferShareQrPngInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>>,
  TError = void,
>(
  params?: GetMarketingNewClientOfferShareQrPngParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @deprecated
 * @summary Deprecated (use /marketing/qr-codes/for?kind=NEW_CLIENT_OFFER): PNG of the permanent New Client Offer QR
 */

export function useGetMarketingNewClientOfferShareQrPngInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>>,
  TError = void,
>(
  params?: GetMarketingNewClientOfferShareQrPngParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingNewClientOfferShareQrPngInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingNewClientOfferShareQrPngQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
  TError = void,
>(
  params?: GetMarketingNewClientOfferShareQrPngParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingNewClientOfferShareQrPngQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>
  > = ({ signal }) => getMarketingNewClientOfferShareQrPng(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingNewClientOfferShareQrPngQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>
>;
export type GetMarketingNewClientOfferShareQrPngQueryError = void;

export function useGetMarketingNewClientOfferShareQrPng<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
  TError = void,
>(
  params: undefined | GetMarketingNewClientOfferShareQrPngParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
          TError,
          Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferShareQrPng<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
  TError = void,
>(
  params?: GetMarketingNewClientOfferShareQrPngParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
          TError,
          Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferShareQrPng<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
  TError = void,
>(
  params?: GetMarketingNewClientOfferShareQrPngParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @deprecated
 * @summary Deprecated (use /marketing/qr-codes/for?kind=NEW_CLIENT_OFFER): PNG of the permanent New Client Offer QR
 */

export function useGetMarketingNewClientOfferShareQrPng<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
  TError = void,
>(
  params?: GetMarketingNewClientOfferShareQrPngParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingNewClientOfferShareQrPngQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingNewClientOfferShareQrPngSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
  TError = void,
>(
  params?: GetMarketingNewClientOfferShareQrPngParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingNewClientOfferShareQrPngQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>
  > = ({ signal }) => getMarketingNewClientOfferShareQrPng(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingNewClientOfferShareQrPngSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>
>;
export type GetMarketingNewClientOfferShareQrPngSuspenseQueryError = void;

export function useGetMarketingNewClientOfferShareQrPngSuspense<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
  TError = void,
>(
  params: undefined | GetMarketingNewClientOfferShareQrPngParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferShareQrPngSuspense<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
  TError = void,
>(
  params?: GetMarketingNewClientOfferShareQrPngParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferShareQrPngSuspense<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
  TError = void,
>(
  params?: GetMarketingNewClientOfferShareQrPngParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @deprecated
 * @summary Deprecated (use /marketing/qr-codes/for?kind=NEW_CLIENT_OFFER): PNG of the permanent New Client Offer QR
 */

export function useGetMarketingNewClientOfferShareQrPngSuspense<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
  TError = void,
>(
  params?: GetMarketingNewClientOfferShareQrPngParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferShareQrPng>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingNewClientOfferShareQrPngSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Funnel (signed up → booked → came in) for guests who signed up in the range, sources, cost per new client from ad spend, and who needs a nudge now
 */
export const getMarketingNewClientOfferOverview = (
  params?: GetMarketingNewClientOfferOverviewParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingNewClientOfferOverview200>({
    url: `/marketing/new-client-offer/overview`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingNewClientOfferOverviewInfiniteQueryKey = (
  params?: GetMarketingNewClientOfferOverviewParams
) => {
  return ['infinite', `/marketing/new-client-offer/overview`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingNewClientOfferOverviewQueryKey = (
  params?: GetMarketingNewClientOfferOverviewParams
) => {
  return [`/marketing/new-client-offer/overview`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingNewClientOfferOverviewInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>>,
  TError = unknown,
>(
  params?: GetMarketingNewClientOfferOverviewParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingNewClientOfferOverviewInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>> = ({
    signal,
  }) => getMarketingNewClientOfferOverview(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingNewClientOfferOverviewInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>
>;
export type GetMarketingNewClientOfferOverviewInfiniteQueryError = unknown;

export function useGetMarketingNewClientOfferOverviewInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>>,
  TError = unknown,
>(
  params: undefined | GetMarketingNewClientOfferOverviewParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
          TError,
          Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferOverviewInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>>,
  TError = unknown,
>(
  params?: GetMarketingNewClientOfferOverviewParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
          TError,
          Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferOverviewInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>>,
  TError = unknown,
>(
  params?: GetMarketingNewClientOfferOverviewParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Funnel (signed up → booked → came in) for guests who signed up in the range, sources, cost per new client from ad spend, and who needs a nudge now
 */

export function useGetMarketingNewClientOfferOverviewInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>>,
  TError = unknown,
>(
  params?: GetMarketingNewClientOfferOverviewParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingNewClientOfferOverviewInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingNewClientOfferOverviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
  TError = unknown,
>(
  params?: GetMarketingNewClientOfferOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingNewClientOfferOverviewQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>> = ({
    signal,
  }) => getMarketingNewClientOfferOverview(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingNewClientOfferOverviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>
>;
export type GetMarketingNewClientOfferOverviewQueryError = unknown;

export function useGetMarketingNewClientOfferOverview<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
  TError = unknown,
>(
  params: undefined | GetMarketingNewClientOfferOverviewParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
          TError,
          Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferOverview<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
  TError = unknown,
>(
  params?: GetMarketingNewClientOfferOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
          TError,
          Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferOverview<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
  TError = unknown,
>(
  params?: GetMarketingNewClientOfferOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Funnel (signed up → booked → came in) for guests who signed up in the range, sources, cost per new client from ad spend, and who needs a nudge now
 */

export function useGetMarketingNewClientOfferOverview<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
  TError = unknown,
>(
  params?: GetMarketingNewClientOfferOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingNewClientOfferOverviewQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingNewClientOfferOverviewSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
  TError = unknown,
>(
  params?: GetMarketingNewClientOfferOverviewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingNewClientOfferOverviewQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>> = ({
    signal,
  }) => getMarketingNewClientOfferOverview(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingNewClientOfferOverviewSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>
>;
export type GetMarketingNewClientOfferOverviewSuspenseQueryError = unknown;

export function useGetMarketingNewClientOfferOverviewSuspense<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
  TError = unknown,
>(
  params: undefined | GetMarketingNewClientOfferOverviewParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferOverviewSuspense<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
  TError = unknown,
>(
  params?: GetMarketingNewClientOfferOverviewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferOverviewSuspense<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
  TError = unknown,
>(
  params?: GetMarketingNewClientOfferOverviewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Funnel (signed up → booked → came in) for guests who signed up in the range, sources, cost per new client from ad spend, and who needs a nudge now
 */

export function useGetMarketingNewClientOfferOverviewSuspense<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
  TError = unknown,
>(
  params?: GetMarketingNewClientOfferOverviewParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferOverview>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingNewClientOfferOverviewSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Guests who signed up for the offer, newest first, 50 a page, with per-status counts for the filter chips
 */
export const getMarketingNewClientOfferClaims = (
  params?: GetMarketingNewClientOfferClaimsParams,
  signal?: AbortSignal
) => {
  return customInstance<GetMarketingNewClientOfferClaims200>({
    url: `/marketing/new-client-offer/claims`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMarketingNewClientOfferClaimsInfiniteQueryKey = (
  params?: GetMarketingNewClientOfferClaimsParams
) => {
  return ['infinite', `/marketing/new-client-offer/claims`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingNewClientOfferClaimsQueryKey = (
  params?: GetMarketingNewClientOfferClaimsParams
) => {
  return [`/marketing/new-client-offer/claims`, ...(params ? [params] : [])] as const;
};

export const getGetMarketingNewClientOfferClaimsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>>,
  TError = unknown,
>(
  params?: GetMarketingNewClientOfferClaimsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingNewClientOfferClaimsInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>> = ({
    signal,
  }) => getMarketingNewClientOfferClaims(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingNewClientOfferClaimsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>
>;
export type GetMarketingNewClientOfferClaimsInfiniteQueryError = unknown;

export function useGetMarketingNewClientOfferClaimsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>>,
  TError = unknown,
>(
  params: undefined | GetMarketingNewClientOfferClaimsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
          TError,
          Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferClaimsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>>,
  TError = unknown,
>(
  params?: GetMarketingNewClientOfferClaimsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
          TError,
          Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferClaimsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>>,
  TError = unknown,
>(
  params?: GetMarketingNewClientOfferClaimsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Guests who signed up for the offer, newest first, 50 a page, with per-status counts for the filter chips
 */

export function useGetMarketingNewClientOfferClaimsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>>,
  TError = unknown,
>(
  params?: GetMarketingNewClientOfferClaimsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingNewClientOfferClaimsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingNewClientOfferClaimsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
  TError = unknown,
>(
  params?: GetMarketingNewClientOfferClaimsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingNewClientOfferClaimsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>> = ({
    signal,
  }) => getMarketingNewClientOfferClaims(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingNewClientOfferClaimsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>
>;
export type GetMarketingNewClientOfferClaimsQueryError = unknown;

export function useGetMarketingNewClientOfferClaims<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
  TError = unknown,
>(
  params: undefined | GetMarketingNewClientOfferClaimsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
          TError,
          Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferClaims<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
  TError = unknown,
>(
  params?: GetMarketingNewClientOfferClaimsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
          TError,
          Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferClaims<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
  TError = unknown,
>(
  params?: GetMarketingNewClientOfferClaimsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Guests who signed up for the offer, newest first, 50 a page, with per-status counts for the filter chips
 */

export function useGetMarketingNewClientOfferClaims<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
  TError = unknown,
>(
  params?: GetMarketingNewClientOfferClaimsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingNewClientOfferClaimsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingNewClientOfferClaimsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
  TError = unknown,
>(
  params?: GetMarketingNewClientOfferClaimsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingNewClientOfferClaimsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>> = ({
    signal,
  }) => getMarketingNewClientOfferClaims(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingNewClientOfferClaimsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>
>;
export type GetMarketingNewClientOfferClaimsSuspenseQueryError = unknown;

export function useGetMarketingNewClientOfferClaimsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
  TError = unknown,
>(
  params: undefined | GetMarketingNewClientOfferClaimsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferClaimsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
  TError = unknown,
>(
  params?: GetMarketingNewClientOfferClaimsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferClaimsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
  TError = unknown,
>(
  params?: GetMarketingNewClientOfferClaimsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Guests who signed up for the offer, newest first, 50 a page, with per-status counts for the filter chips
 */

export function useGetMarketingNewClientOfferClaimsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
  TError = unknown,
>(
  params?: GetMarketingNewClientOfferClaimsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferClaims>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingNewClientOfferClaimsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary One guest's offer with the full timeline (texts, bookings, redemption) in plain words
 */
export const getMarketingNewClientOfferClaimsId = (id: string, signal?: AbortSignal) => {
  return customInstance<GetMarketingNewClientOfferClaimsId200>({
    url: `/marketing/new-client-offer/claims/${id}`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingNewClientOfferClaimsIdInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/marketing/new-client-offer/claims/${id}`] as const;
};

export const getGetMarketingNewClientOfferClaimsIdQueryKey = (id?: string) => {
  return [`/marketing/new-client-offer/claims/${id}`] as const;
};

export const getGetMarketingNewClientOfferClaimsIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingNewClientOfferClaimsIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>> = ({
    signal,
  }) => getMarketingNewClientOfferClaimsId(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingNewClientOfferClaimsIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>
>;
export type GetMarketingNewClientOfferClaimsIdInfiniteQueryError = void;

export function useGetMarketingNewClientOfferClaimsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferClaimsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferClaimsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary One guest's offer with the full timeline (texts, bookings, redemption) in plain words
 */

export function useGetMarketingNewClientOfferClaimsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingNewClientOfferClaimsIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingNewClientOfferClaimsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingNewClientOfferClaimsIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>> = ({
    signal,
  }) => getMarketingNewClientOfferClaimsId(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingNewClientOfferClaimsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>
>;
export type GetMarketingNewClientOfferClaimsIdQueryError = void;

export function useGetMarketingNewClientOfferClaimsId<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferClaimsId<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferClaimsId<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary One guest's offer with the full timeline (texts, bookings, redemption) in plain words
 */

export function useGetMarketingNewClientOfferClaimsId<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingNewClientOfferClaimsIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingNewClientOfferClaimsIdSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingNewClientOfferClaimsIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>> = ({
    signal,
  }) => getMarketingNewClientOfferClaimsId(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingNewClientOfferClaimsIdSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>
>;
export type GetMarketingNewClientOfferClaimsIdSuspenseQueryError = void;

export function useGetMarketingNewClientOfferClaimsIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferClaimsIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingNewClientOfferClaimsIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary One guest's offer with the full timeline (texts, bookings, redemption) in plain words
 */

export function useGetMarketingNewClientOfferClaimsIdSuspense<
  TData = Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMarketingNewClientOfferClaimsId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingNewClientOfferClaimsIdSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Live POS client imports (newest first) and how many known clients the New Client Offer recognises
 */
export const getMarketingClientImports = (signal?: AbortSignal) => {
  return customInstance<GetMarketingClientImports200>({
    url: `/marketing/client-imports`,
    method: 'GET',
    signal,
  });
};

export const getGetMarketingClientImportsInfiniteQueryKey = () => {
  return ['infinite', `/marketing/client-imports`] as const;
};

export const getGetMarketingClientImportsQueryKey = () => {
  return [`/marketing/client-imports`] as const;
};

export const getGetMarketingClientImportsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingClientImports>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingClientImports>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingClientImportsInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingClientImports>>> = ({
    signal,
  }) => getMarketingClientImports(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getMarketingClientImports>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingClientImportsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingClientImports>>
>;
export type GetMarketingClientImportsInfiniteQueryError = unknown;

export function useGetMarketingClientImportsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingClientImports>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingClientImports>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingClientImports>>,
          TError,
          Awaited<ReturnType<typeof getMarketingClientImports>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingClientImportsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingClientImports>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingClientImports>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingClientImports>>,
          TError,
          Awaited<ReturnType<typeof getMarketingClientImports>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingClientImportsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingClientImports>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingClientImports>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Live POS client imports (newest first) and how many known clients the New Client Offer recognises
 */

export function useGetMarketingClientImportsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getMarketingClientImports>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMarketingClientImports>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingClientImportsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingClientImportsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingClientImports>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMarketingClientImports>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingClientImportsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingClientImports>>> = ({
    signal,
  }) => getMarketingClientImports(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingClientImports>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingClientImportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingClientImports>>
>;
export type GetMarketingClientImportsQueryError = unknown;

export function useGetMarketingClientImports<
  TData = Awaited<ReturnType<typeof getMarketingClientImports>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingClientImports>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingClientImports>>,
          TError,
          Awaited<ReturnType<typeof getMarketingClientImports>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingClientImports<
  TData = Awaited<ReturnType<typeof getMarketingClientImports>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingClientImports>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingClientImports>>,
          TError,
          Awaited<ReturnType<typeof getMarketingClientImports>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingClientImports<
  TData = Awaited<ReturnType<typeof getMarketingClientImports>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingClientImports>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Live POS client imports (newest first) and how many known clients the New Client Offer recognises
 */

export function useGetMarketingClientImports<
  TData = Awaited<ReturnType<typeof getMarketingClientImports>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMarketingClientImports>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingClientImportsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetMarketingClientImportsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingClientImports>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingClientImports>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMarketingClientImportsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingClientImports>>> = ({
    signal,
  }) => getMarketingClientImports(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMarketingClientImports>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMarketingClientImportsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingClientImports>>
>;
export type GetMarketingClientImportsSuspenseQueryError = unknown;

export function useGetMarketingClientImportsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingClientImports>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingClientImports>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingClientImportsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingClientImports>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingClientImports>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMarketingClientImportsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingClientImports>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingClientImports>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Live POS client imports (newest first) and how many known clients the New Client Offer recognises
 */

export function useGetMarketingClientImportsSuspense<
  TData = Awaited<ReturnType<typeof getMarketingClientImports>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMarketingClientImports>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMarketingClientImportsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Start an import (one per uploaded file). Rows follow in chunks, then complete.
 */
export const postMarketingClientImports = (
  postMarketingClientImportsBody: PostMarketingClientImportsBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingClientImports201>({
    url: `/marketing/client-imports`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingClientImportsBody,
    signal,
  });
};

export const getPostMarketingClientImportsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingClientImports>>,
    TError,
    { data: PostMarketingClientImportsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingClientImports>>,
  TError,
  { data: PostMarketingClientImportsBody },
  TContext
> => {
  const mutationKey = ['postMarketingClientImports'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingClientImports>>,
    { data: PostMarketingClientImportsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postMarketingClientImports(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingClientImportsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingClientImports>>
>;
export type PostMarketingClientImportsMutationBody = PostMarketingClientImportsBody;
export type PostMarketingClientImportsMutationError = unknown;

/**
 * @summary Start an import (one per uploaded file). Rows follow in chunks, then complete.
 */
export const usePostMarketingClientImports = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingClientImports>>,
      TError,
      { data: PostMarketingClientImportsBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingClientImports>>,
  TError,
  { data: PostMarketingClientImportsBody },
  TContext
> => {
  const mutationOptions = getPostMarketingClientImportsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Upload up to 1,000 normalised rows starting at `offset`. Each phone is re-validated (US only) and upserted per salon, keeping the latest last visit and highest visit count. A chunk already received is acknowledged (replayed) without counting it again. 400 BATCH_ROW_LIMIT past 50,000 rows; 409 BATCH_COMPLETED / OFFSET_MISMATCH.
 */
export const postMarketingClientImportsBatchIdRows = (
  batchId: string,
  postMarketingClientImportsBatchIdRowsBody: PostMarketingClientImportsBatchIdRowsBody,
  signal?: AbortSignal
) => {
  return customInstance<PostMarketingClientImportsBatchIdRows200>({
    url: `/marketing/client-imports/${batchId}/rows`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingClientImportsBatchIdRowsBody,
    signal,
  });
};

export const getPostMarketingClientImportsBatchIdRowsMutationOptions = <
  TError =
    | PostMarketingClientImportsBatchIdRows400
    | void
    | PostMarketingClientImportsBatchIdRows409,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingClientImportsBatchIdRows>>,
    TError,
    { batchId: string; data: PostMarketingClientImportsBatchIdRowsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingClientImportsBatchIdRows>>,
  TError,
  { batchId: string; data: PostMarketingClientImportsBatchIdRowsBody },
  TContext
> => {
  const mutationKey = ['postMarketingClientImportsBatchIdRows'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingClientImportsBatchIdRows>>,
    { batchId: string; data: PostMarketingClientImportsBatchIdRowsBody }
  > = (props) => {
    const { batchId, data } = props ?? {};

    return postMarketingClientImportsBatchIdRows(batchId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingClientImportsBatchIdRowsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingClientImportsBatchIdRows>>
>;
export type PostMarketingClientImportsBatchIdRowsMutationBody =
  PostMarketingClientImportsBatchIdRowsBody;
export type PostMarketingClientImportsBatchIdRowsMutationError =
  | PostMarketingClientImportsBatchIdRows400
  | void
  | PostMarketingClientImportsBatchIdRows409;

/**
 * @summary Upload up to 1,000 normalised rows starting at `offset`. Each phone is re-validated (US only) and upserted per salon, keeping the latest last visit and highest visit count. A chunk already received is acknowledged (replayed) without counting it again. 400 BATCH_ROW_LIMIT past 50,000 rows; 409 BATCH_COMPLETED / OFFSET_MISMATCH.
 */
export const usePostMarketingClientImportsBatchIdRows = <
  TError =
    | PostMarketingClientImportsBatchIdRows400
    | void
    | PostMarketingClientImportsBatchIdRows409,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingClientImportsBatchIdRows>>,
      TError,
      { batchId: string; data: PostMarketingClientImportsBatchIdRowsBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingClientImportsBatchIdRows>>,
  TError,
  { batchId: string; data: PostMarketingClientImportsBatchIdRowsBody },
  TContext
> => {
  const mutationOptions = getPostMarketingClientImportsBatchIdRowsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Finish an import, adding the rows the browser skipped to its skipped count (idempotent).
 */
export const postMarketingClientImportsBatchIdComplete = (
  batchId: string,
  postMarketingClientImportsBatchIdCompleteBody: PostMarketingClientImportsBatchIdCompleteBody,
  signal?: AbortSignal
) => {
  return customInstance<void>({
    url: `/marketing/client-imports/${batchId}/complete`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postMarketingClientImportsBatchIdCompleteBody,
    signal,
  });
};

export const getPostMarketingClientImportsBatchIdCompleteMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postMarketingClientImportsBatchIdComplete>>,
    TError,
    { batchId: string; data: PostMarketingClientImportsBatchIdCompleteBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postMarketingClientImportsBatchIdComplete>>,
  TError,
  { batchId: string; data: PostMarketingClientImportsBatchIdCompleteBody },
  TContext
> => {
  const mutationKey = ['postMarketingClientImportsBatchIdComplete'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postMarketingClientImportsBatchIdComplete>>,
    { batchId: string; data: PostMarketingClientImportsBatchIdCompleteBody }
  > = (props) => {
    const { batchId, data } = props ?? {};

    return postMarketingClientImportsBatchIdComplete(batchId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostMarketingClientImportsBatchIdCompleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof postMarketingClientImportsBatchIdComplete>>
>;
export type PostMarketingClientImportsBatchIdCompleteMutationBody =
  PostMarketingClientImportsBatchIdCompleteBody;
export type PostMarketingClientImportsBatchIdCompleteMutationError = void;

/**
 * @summary Finish an import, adding the rows the browser skipped to its skipped count (idempotent).
 */
export const usePostMarketingClientImportsBatchIdComplete = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postMarketingClientImportsBatchIdComplete>>,
      TError,
      { batchId: string; data: PostMarketingClientImportsBatchIdCompleteBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postMarketingClientImportsBatchIdComplete>>,
  TError,
  { batchId: string; data: PostMarketingClientImportsBatchIdCompleteBody },
  TContext
> => {
  const mutationOptions = getPostMarketingClientImportsBatchIdCompleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Remove an import: the phones it last imported count as new guests again.
 */
export const deleteMarketingClientImportsBatchId = (batchId: string) => {
  return customInstance<void>({ url: `/marketing/client-imports/${batchId}`, method: 'DELETE' });
};

export const getDeleteMarketingClientImportsBatchIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMarketingClientImportsBatchId>>,
    TError,
    { batchId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMarketingClientImportsBatchId>>,
  TError,
  { batchId: string },
  TContext
> => {
  const mutationKey = ['deleteMarketingClientImportsBatchId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMarketingClientImportsBatchId>>,
    { batchId: string }
  > = (props) => {
    const { batchId } = props ?? {};

    return deleteMarketingClientImportsBatchId(batchId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMarketingClientImportsBatchIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMarketingClientImportsBatchId>>
>;

export type DeleteMarketingClientImportsBatchIdMutationError = void;

/**
 * @summary Remove an import: the phones it last imported count as new guests again.
 */
export const useDeleteMarketingClientImportsBatchId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMarketingClientImportsBatchId>>,
      TError,
      { batchId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMarketingClientImportsBatchId>>,
  TError,
  { batchId: string },
  TContext
> => {
  const mutationOptions = getDeleteMarketingClientImportsBatchIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
